/**
 * Generated by orval v8.1.0 🍺
 * Do not edit manually.
 * GkTech.Api
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AMLProviderDtoBody,
  AddDocumentCardRequest,
  AgreementAssignLoanAndCustomerDto,
  AlertDto,
  AssignCustomerToCollectionCompanyMultipleDto,
  AttachAffilatesRequestDtoBody,
  AutoCommentDto,
  AutoIssueCheckRequestDto,
  AutoLinkSqsDto,
  AutomationDecisionSqsDtoBody,
  AutomationQueueItemInsertDto,
  BankScraperGetAccountBulkAccoundidsBody,
  BankScraperNotifySmsValueBody,
  BizumPayLoanRequestDto,
  BlockedRepayTokenResponseDto,
  BulkCardValidateForInvalidDto,
  BulkCustomerCommentRequestDto,
  BulkEmailDtoBody,
  BulkSendLetterDto,
  BulkSmsMarketingSameContentRequestDto,
  BusinessOperationPermissionRequestDto,
  CalculateDesistContractPlannedAmountRequestDto,
  CalculateFutureCloseAmountRequestDto,
  CalculateInstallmentPaymentAmountsTestEndpointRequestDto,
  CalculateNewLimitRequestDto,
  CallCreditLimitDecisionRequestDto,
  CallTypeDto,
  CamWorkDaysDto,
  CancelTransactionDto,
  CancelTransferStatusDto,
  CardMockerRequestDto,
  CardResponseCodeErrorDto,
  CardResponseDto,
  CardUniversalPayNotificationURLDtoBody,
  CardViaIVRRequestDto,
  ChangeAdminPasswordRequestDto,
  ChangeLoanStatusDto,
  ChangeLoanToAccountDto,
  ChangePasswordDto,
  ChangeTelemarketingStatusDto,
  ChatMessageContent,
  ChatymeFileUploadWebhookPayload,
  ChatymeOcrDocumentDto,
  CheckCustomerRequestDto,
  CheckMemberPinTryCount,
  CheckPhoneDNIRequest,
  ChecklistDto,
  ChooseCallTimeForCustomerRequestDto,
  CollectionConfigDto,
  CollectionDto,
  CollectionRequestDto,
  CollectionSearchResponseDto,
  CollectionSqsDtoArrayBody,
  CollectionSqsDtoBody,
  CommMarketingUnSubscribeDto,
  CommentUpdateDto,
  CommunicationDtoBody,
  CommunicationPaymentModel,
  CommunicationPhoneLogDto,
  CommunicationPhoneLogRequestDto,
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  CompanySftpConfigRequestDto,
  CompanySftpDto,
  CompanySftpForMailConfigDto,
  CompanySftpMailRequest,
  ComprehensiveLoanReportDto,
  ConektaCheckoutStartRequestDto,
  ConektaStartRequestDto,
  ContactDto,
  CreateAndValidateCardDto,
  CreateCardDto,
  CreateChargebackCsvRequestDto,
  CreateCommunicationRequestDtoBody,
  CreateCustomerBankAccountDto,
  CreateCustomerCriteriaValidationDto,
  CreateCustomerRequestDtoBody,
  CreateCustomerTokenReadDto,
  CreateLoanImpedimentRequestDtoBody,
  CreateNewTemplateDto,
  CreatePaymentHistoryExcelRequestBody,
  CreatePaymentLinkDto,
  CreateReviewLinkDto,
  CreateSessionDto,
  CreateSignatureAuditLogRequestDto,
  CreateTicketMessageRequestDto,
  CreateTicketRequestDto,
  CreateUnnaxCallbackRequestDto,
  CreditInformation,
  CreditLimitDto,
  CredoraxChargebackDto,
  CredoraxChargebackRequestDto,
  CustomerAccountDetailRequestDto,
  CustomerAddressRequestDtoBody,
  CustomerCallTimingDefDto,
  CustomerCommunicationDto,
  CustomerFullStoryDto,
  CustomerIntentLogDtoBody,
  CustomerLegalCompanyInfoQueueDto,
  CustomerPhoneUpdateRequestDto,
  CustomerRefundCallsRequestDto,
  DateBasedCostModelDto,
  DeceasedCustomersImportDto,
  DeleteApiLoanHollidayParams,
  DeleteApiTelemarketingDeleteParams,
  DeleteApiTodoDeleteToDoItemParams,
  DeleteAutomationIVRDto,
  DevengoMockCallbackRequestDto,
  DeydeThoroughfareEncodingDto,
  DiscordWebHookMsgDto,
  DoInstantPetitionRequestDto,
  EmailBouncedRequestDto,
  FTBAutoIssueAfterAgreementAssignFTBProcessDto,
  ForgotPinRequestDtoBody,
  FrontLogModel,
  GenerateTemplateDto,
  GetApiBankscraperCardPriorityListParams,
  GetApiBankscraperGetAccountParams,
  GetApiBankscraperGetAccountWithBankDetailsParams,
  GetApiBankscraperGetClabeAccountsParams,
  GetApiBankscraperGetCustomerBestTokensParams,
  GetApiBankscraperGetLastLafvaPreviousDataParams,
  GetApiBankscraperGetScrapeCustomerInfoParams,
  GetApiBankscraperGetSessionResultJsonAsTxt200One,
  GetApiBankscraperGetSessionResultJsonAsTxt200Two,
  GetApiBankscraperGetSessionResultJsonAsTxtParams,
  GetApiBankscraperRandomIbanParams,
  GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  GetApiCardBizumDataParams,
  GetApiCardBizumRedirectBack200One,
  GetApiCardBizumRedirectBack200Two,
  GetApiCardBizumRedirectBackParams,
  GetApiCardCallBack3dsFlow200One,
  GetApiCardCallBack3dsFlow200Two,
  GetApiCardCardPrivilegesParams,
  GetApiCardCheckCardProviderTokenParams,
  GetApiCardConektaRedirectBack200One,
  GetApiCardConektaRedirectBack200Two,
  GetApiCardConektaRedirectBackParams,
  GetApiCardGetBinCodeFromRedisParams,
  GetApiCardTestMitSaleParams,
  GetApiCardThreeDsStateParams,
  GetApiCommunicationCustomerPermissionsParams,
  GetApiCommunicationDeleteMarketingScheduledParams,
  GetApiCommunicationDeleteSegmentParams,
  GetApiCommunicationDocumentCountParams,
  GetApiCommunicationDocumentListParams,
  GetApiCommunicationEmailMoveBucketToBucketParams,
  GetApiCommunicationFeedback200One,
  GetApiCommunicationFeedback200Two,
  GetApiCommunicationFeedbackParams,
  GetApiCommunicationGetCustomerDocumentsByLoanParams,
  GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  GetApiCommunicationGetMarketingScheduledByIdParams,
  GetApiCommunicationGetSegmentByIdParams,
  GetApiCommunicationGmailGetLastGmailMessageIdParams,
  GetApiCommunicationIsTemplateSendTodayParams,
  GetApiCommunicationLeadsbridgeParams,
  GetApiCommunicationLoanAgreementParams,
  GetApiCommunicationNcpPermissionHistoryParams,
  GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  GetApiCommunicationOurMailServerCallbackS3200One,
  GetApiCommunicationOurMailServerCallbackS3200Two,
  GetApiCommunicationOurMailServerCallbackS3Params,
  GetApiCommunicationPermissionHistoryParams,
  GetApiCommunicationReceiveOtpViaComApi200One,
  GetApiCommunicationReceiveOtpViaComApi200Two,
  GetApiCommunicationReceiveOtpViaComApiParams,
  GetApiCommunicationReceiveOtpViaNexmo200One,
  GetApiCommunicationReceiveOtpViaNexmo200Two,
  GetApiCommunicationReceiveOtpViaNexmoParams,
  GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  GetApiCommunicationS3Download200One,
  GetApiCommunicationS3Download200Two,
  GetApiCommunicationS3DownloadParams,
  GetApiCommunicationSmsSmsIdMarkasread200One,
  GetApiCommunicationSmsSmsIdMarkasread200Two,
  GetApiCommunicationSupportEmailAttachmentCheckParams,
  GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  GetApiCommunicationSupportEmailGetAttachmentParams,
  GetApiCommunicationTemplateByNameParams,
  GetApiCommunicationTemplateGetParams,
  GetApiCustomerAffilateConversionStepProcessParams,
  GetApiCustomerCustomerForLoginRedirectionParams,
  GetApiCustomerCustomerParams,
  GetApiCustomerCustomerSummaryForChatbot200One,
  GetApiCustomerCustomerSummaryForChatbot200Two,
  GetApiCustomerCustomerSummaryForChatbotParams,
  GetApiCustomerGetComplaintsCaseHistoryParams,
  GetApiCustomerGetComplaintsCasesParams,
  GetApiCustomerGetCustomerAffilatesParams,
  GetApiCustomerGetCustomerIntentLogParams,
  GetApiCustomerGetCustomersByEmailParams,
  GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  GetApiCustomerIsCustomerInformationMatchedParams,
  GetApiCustomerIsInEquifaxReportingExtractionListParams,
  GetApiCustomerSuspectedLoginRelatedUsersParams,
  GetApiCustomerValidateDniParams,
  GetApiCustomerVerifyEmailParams,
  GetApiDecisionDecisionApiParams,
  GetApiDecisionFullFlowTestParams,
  GetApiDecisionGetCheckListParams,
  GetApiHealthcheck200One,
  GetApiHealthcheck200Two,
  GetApiHealthcheckConfig200One,
  GetApiHealthcheckConfig200Two,
  GetApiHealthcheckFail200One,
  GetApiHealthcheckFail200Two,
  GetApiHealthcheckVersion200One,
  GetApiHealthcheckVersion200Two,
  GetApiKycEquifaxInterConnectResponseParams,
  GetApiKycGeolocationParams,
  GetApiKycIdhubGetCustomeResultParams,
  GetApiKycIdhubGetCustomerAllResultsParams,
  GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  GetApiLambdaCollectionForceReleaseLockParams,
  GetApiLambdaCollectionRolloverDatesParams,
  GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  GetApiLiveChatAgentCreateParams,
  GetApiLiveChatAgentGetParams,
  GetApiLiveChatDataInitializeParams,
  GetApiLiveChatSessionAssignParams,
  GetApiLiveChatSessionGetParams,
  GetApiLiveChatUserGetHistorySessionsParams,
  GetApiLoanAgreementSentParams,
  GetApiLoanAnotherBankAccountWidgetInitParams,
  GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  GetApiLoanCreateChargebackResponseFileParams,
  GetApiLoanCreateLoanSignParams,
  GetApiLoanCreditJourney200One,
  GetApiLoanCreditJourney200Two,
  GetApiLoanCreditJourneyParams,
  GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  GetApiLoanCustomerLoansByStatusParams,
  GetApiLoanDiscountParams,
  GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  GetApiLoanGetLatestActiveLoanForChatbot200One,
  GetApiLoanGetLatestActiveLoanForChatbot200Two,
  GetApiLoanGetLatestActiveLoanForChatbotParams,
  GetApiLoanIcHistoryParams,
  GetApiLoanLoanAgreementAsPdfParams,
  GetApiLoanLoanAgreementDataParams,
  GetApiLoanLoanHookAfterPaymentParams,
  GetApiLoanLoanParams,
  GetApiLoanLoanagreementDownload200One,
  GetApiLoanLoanagreementDownload200Two,
  GetApiLoanLoanagreementDownloadParams,
  GetApiLoanLoanagreementParams,
  GetApiLoanOcrOSIRParams,
  GetApiLoanOtpCheckLoanSignParams,
  GetApiLoanRolloverAvailableDatesParams,
  GetApiLoanRolloverCalculateParams,
  GetApiLoanRtbWidgetInitParams,
  GetApiLoanSendOtpLoanSignParams,
  GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  GetApiLoanSetissuedTestParams,
  GetApiLoanTestMailWithInstallmentParams,
  GetApiLoanWidgetInitParams,
  GetApiMembershipCheckPasswordFlagParams,
  GetApiMembershipCheckSuspectedLoginsParams,
  GetApiMembershipEmailLoginVerify200One,
  GetApiMembershipEmailLoginVerify200Two,
  GetApiMembershipEmailLoginVerifyParams,
  GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  GetApiMembershipMemberSuspectedLoginsParams,
  GetApiMiscAzureEnvironmentVariablesParams,
  GetApiMiscLogParams,
  GetApiMiscScamalyticsParams,
  GetApiMiscTranslationParams,
  GetApiMiscTranslationsByCultureAndKeyParams,
  GetApiMoneytransferGetSourceAccountTransactionParams,
  GetApiMoneytransferMockerUnnaxPendingParams,
  GetApiMoneytransferMockerUnnaxRefundParams,
  GetApiMoneytransferRetryHistoryParams,
  GetApiQueueRemarketingOurOldCustomerParams,
  GetApiReportingGetEkomiReviewsParams,
  GetApiTelemarketingCheckParams,
  GetApiTelemarketingGetParams,
  GetApiTelemarketingInactiveRtbListParams,
  GetApiTelemarketingStatusHistoryByCustomerParams,
  GetApiTicketWorkingHourParams,
  GetApiTodoGetToDoItemParams,
  GetCallCreditSearchResultDto,
  GetCamTicketsRequest,
  GetIVRCallReportRequestDto,
  GetPreSignedUploadUrlsDto,
  GetUnissuedTicketsRequest,
  HollidayDtoBody,
  IVRCallCheckDto,
  IdHubConnectDTO,
  IdHubFindConfigProcessDTO,
  IdHubPersonalDetailDTO,
  IggLegalReportSendMailRequestDto,
  ImpedimentStatusDto,
  InboundAttachmentMessage,
  InsertIncomingEmailResponse,
  InsertLoanWarningRequestDto,
  KeyValuePairInt64Boolean,
  KeyValuePairInt64NullableBoolean,
  KontomatikCallbackDto,
  LafvaPreviousData,
  LeadBasedCostModelDto,
  LegalCollectionDocumentsMailDtoBody,
  LightRegisterEmailOtpValidateRequestDto,
  LightRegisterRequestDto,
  LightUpdateCustomerAddressRequestDto,
  LoanApplicationScreensDto,
  LoanApplyRequestDto,
  LoanArrangementRequestDto,
  LoanCalculatorLogRequestDto,
  LoanCanGetMultipleLoanDecisionTestCustomeridBody,
  LoanDefinitionDtoBody,
  LoanDto,
  LoanDtoBody,
  LoanImpedimentRequestDto,
  LoanSignDto,
  LoginRequestDto,
  LoginWithRepayTokenDto,
  MailgunCallbackDto,
  MailjetCallbackDto,
  MakeLoanApplicationDTOBody,
  ManualPaymentApprovalSearchDto,
  MarketingScheduledDto,
  MarketingSegmentDto,
  MessenteBulkSmsDto,
  MessenteCallbackDto,
  MoneyTransferMockerRequestDto,
  MultipleValidateRequestDto,
  NCPPermissionDtoBody,
  NameMatchWithFullNameRequestDtoArrayBody,
  NameMatchWithSeparateNamesRequestDtoArrayBody,
  NameSurnameValidationDto,
  NewDelphiExecuteInteractiveRequestDTO,
  NewEmailOtpValidateRequestDtoBody,
  NotifyDto,
  OutboundTicketDto,
  PageViewInsertDto,
  PagedSearchResultCommTicketDto,
  ParameterDtoBaseBody,
  ParameterDtoBody,
  ParameterHistoryRequestDto,
  PartnerHandoverLoginOtpRequestDto,
  PayLoanAndRestructureRequestDto,
  PayLoanRequestDtoBody,
  PaymentPlanRequestDto,
  PaymentStateDtoBody,
  PaynopainChargebackMockRequestDto,
  PaynopainChargebackRequestDto,
  PekiWebHookRequestBody,
  PinValidModel,
  PinValidRequestDto,
  PopulateLoanBasedDocumentsRequestDto,
  PostApiBankscraperChangeResetScrapeFlagParams,
  PostApiBankscraperFindLinkedAccountIdParams,
  PostApiBankscraperGetEligibleBankAccountParams,
  PostApiBankscraperLoantransfermanagerReset200One,
  PostApiBankscraperLoantransfermanagerReset200Two,
  PostApiBankscraperNotifysms200One,
  PostApiBankscraperNotifysms200Two,
  PostApiBankscraperTokenScrapeParams,
  PostApiBankscraperValidatecustomerInfoParams,
  PostApiCardCheckCardValidationForLoanApplicationParams,
  PostApiCardConekta3dsNotification200One,
  PostApiCardConekta3dsNotification200Two,
  PostApiCardCredoraxCallbackTest200One,
  PostApiCardCredoraxCallbackTest200Two,
  PostApiCardCredoraxNotification200One,
  PostApiCardCredoraxNotification200Two,
  PostApiCardCredoraxNotificationFromSNS200One,
  PostApiCardCredoraxNotificationFromSNS200Two,
  PostApiCardDfpCallback200One,
  PostApiCardDfpCallback200Two,
  PostApiCardNeedToCardForFTBParams,
  PostApiCardPaynopainNotification200One,
  PostApiCardPaynopainNotification200Two,
  PostApiCardPaynopainOrderEventsEventNameTrackId200One,
  PostApiCardPaynopainOrderEventsEventNameTrackId200Two,
  PostApiCommunicationBulkSmsParams,
  PostApiCommunicationChange3CXStatusParams,
  PostApiCommunicationCommContentViewParams,
  PostApiCommunicationCustomerUnansweredCallAssignToCamParams,
  PostApiCommunicationGenerate200One,
  PostApiCommunicationGenerate200Two,
  PostApiCommunicationGenerateShortLinkParams,
  PostApiCommunicationGetAllMarketingScheduledParams,
  PostApiCommunicationGetAllSegmentsParams,
  PostApiCommunicationGetPreSignedUploadUrlParams,
  PostApiCommunicationLeadsbridge200One,
  PostApiCommunicationLeadsbridge200Two,
  PostApiCommunicationMailgunCallback200One,
  PostApiCommunicationMailgunCallback200Two,
  PostApiCommunicationMailjetCallback200One,
  PostApiCommunicationMailjetCallback200Two,
  PostApiCommunicationMessagereceiveBounce200One,
  PostApiCommunicationMessagereceiveBounce200Two,
  PostApiCommunicationMessagereceiveBulkemailnotifications200One,
  PostApiCommunicationMessagereceiveBulkemailnotifications200Two,
  PostApiCommunicationMessagereceiveComplaint200One,
  PostApiCommunicationMessagereceiveComplaint200Two,
  PostApiCommunicationMessagereceiveDelivery200One,
  PostApiCommunicationMessagereceiveDelivery200Two,
  PostApiCommunicationMessagereceiveNotifications200One,
  PostApiCommunicationMessagereceiveNotifications200Two,
  PostApiCommunicationMessenteDLR200One,
  PostApiCommunicationMessenteDLR200Two,
  PostApiCommunicationOcrAutoCheckResultParams,
  PostApiCommunicationOurMailServerCallback200One,
  PostApiCommunicationOurMailServerCallback200Two,
  PostApiCommunicationReloadIVRIntegrationCacheParams,
  PostApiCommunicationRemoveNCPPermissionParams,
  PostApiCommunicationSetCustomerUnansweredCallStatusParams,
  PostApiCommunicationSeverDocumentCardParams,
  PostApiCommunicationSupportEmailGetCustomerTicketsParams,
  PostApiCommunicationTemplate200One,
  PostApiCommunicationTemplate200Two,
  PostApiCommunicationTemplate399TestParams,
  PostApiCommunicationThrowExceptionForJobParams,
  PostApiCommunicationTwiliocallback200One,
  PostApiCommunicationTwiliocallback200Two,
  PostApiCommunicationValidateCaptchaParams,
  PostApiCustomerAutoLegalCollectionDocumentsUploadParams,
  PostApiCustomerBulkStatusParams,
  PostApiCustomerChangeComplaintsCaseStatusParams,
  PostApiCustomerCheckLoanAssignToCamParams,
  PostApiCustomerCheckNewPhoneNumberParams,
  PostApiCustomerCommentPinParams,
  PostApiCustomerCommentUnpinParams,
  PostApiCustomerCustomerIdPekiWebhook200One,
  PostApiCustomerCustomerIdPekiWebhook200Two,
  PostApiCustomerCustomerSubStatusListParams,
  PostApiCustomerCustomerSummaryForChatbot200One,
  PostApiCustomerCustomerSummaryForChatbot200Two,
  PostApiCustomerCustomerSummaryForChatbotParams,
  PostApiCustomerEquifaxDeleteReportingExtractionParams,
  PostApiCustomerEquifaxInsertReportingExtractionParams,
  PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams,
  PostApiCustomerGetPartnerEgressLinkParams,
  PostApiCustomerHandoverLoginParams,
  PostApiCustomerHandoverSmsControlParams,
  PostApiCustomerMxAddessGetPostalParams,
  PostApiCustomerMxAddessMunicipalityListParams,
  PostApiCustomerMxAddessMxColiniaListParams,
  PostApiCustomerMxAddessPostalCodeParams,
  PostApiCustomerNamematchEsComplexParams,
  PostApiCustomerNamematchEsParams,
  PostApiCustomerReclamationExcelAssign200One,
  PostApiCustomerReclamationExcelAssign200Two,
  PostApiCustomerResetCustomersRepayTokenParams,
  PostApiCustomerSetCustomersBlacklistParams,
  PostApiCustomerStartDengageSyncJob200One,
  PostApiCustomerStartDengageSyncJob200Two,
  PostApiCustomerUpdateCommentParams,
  PostApiDecisionCardDecisionResponsesParams,
  PostApiDecisionCustomerDecisionDtoParams,
  PostApiDecisionDecisionApiParams,
  PostApiDecisionTestLimitDecisionAfterPaymentParams,
  PostApiDecisionTestLimitUpdateAfterPaymentV2Params,
  PostApiDecisionTestLoanBasicDecisionParams,
  PostApiInboundpaymentItnCallback200One,
  PostApiInboundpaymentItnCallback200Two,
  PostApiKycAmlProviderListParams,
  PostApiKycIncofisaPetitionEnqueueParams,
  PostApiKycSetAMLCheckActiveParams,
  PostApiLambdaAutomationDecisionTriggerParams,
  PostApiLambdaAutomationIvrSetBodyOneItem,
  PostApiLambdaAutomationIvrSetBodyThreeItem,
  PostApiLambdaAutomationIvrSetBodyTwoItem,
  PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams,
  PostApiLambdaCheckDengageEmailStatusParams,
  PostApiLambdaCommunicationAutoSetCollectionCallsParams,
  PostApiLambdaCommunicationAutoSetWelcomeCallsParams,
  PostApiLambdaCommunicationCheckCustomerCallHistoryParams,
  PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams,
  PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams,
  PostApiLambdaCommunicationProcessBepiSftpDocumentsParams,
  PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams,
  PostApiLambdaCommunicationS3DocumentSyncParams,
  PostApiLambdaContentGeneratorBodyOne,
  PostApiLambdaContentGeneratorBodyThree,
  PostApiLambdaContentGeneratorBodyTwo,
  PostApiLambdaCustomerSendLegalTemplateParams,
  PostApiLambdaDecisionManageDecisionResultMatchParams,
  PostApiLambdaDengageStartPassiveStatusCustomersJob200One,
  PostApiLambdaDengageStartPassiveStatusCustomersJob200Two,
  PostApiLambdaDengageStartSixMonthsJob200One,
  PostApiLambdaDengageStartSixMonthsJob200Two,
  PostApiLambdaLoanArrangedLoansDailyCheckParams,
  PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams,
  PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams,
  PostApiLambdaLoanCheckDueForFreeInterestParams,
  PostApiLambdaLoanInstallmentReportParams,
  PostApiLambdaLoanMissingDocumentNotifierParams,
  PostApiLambdaLoanNcpPaymentReminderParams,
  PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams,
  PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams,
  PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams,
  PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams,
  PostApiLambdaMoneytransferSatScrapeParams,
  PostApiLambdaReScrapeForDeclineParams,
  PostApiLambdaUnnaxReScrapeV2Params,
  PostApiLambdaUpdateCustomerNonExistRiskScoreParams,
  PostApiLiveChatMessageCreateParams,
  PostApiLiveChatSessionStartParams,
  PostApiLiveChatSessionStopParams,
  PostApiLoanAgreementAsTypeParams,
  PostApiLoanAgreementParametersParams,
  PostApiLoanAgreementParams,
  PostApiLoanAssignAgreementAfterForRtbParams,
  PostApiLoanAssignAgreementParams,
  PostApiLoanBulkDebitV2Params,
  PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params,
  PostApiLoanCheckstatusParams,
  PostApiLoanCreatePaymentHistoryPdf200One,
  PostApiLoanCreatePaymentHistoryPdf200Two,
  PostApiLoanCreditJourney200One,
  PostApiLoanCreditJourney200Two,
  PostApiLoanCreditJourneyParams,
  PostApiLoanExternalFeeCalculationErrorFixParams,
  PostApiLoanForceTakingExternalCollectionFeeParams,
  PostApiLoanGetEligibleProductsOfCustomersParams,
  PostApiLoanGetLatestActiveLoanForChatbot200One,
  PostApiLoanGetLatestActiveLoanForChatbot200Two,
  PostApiLoanGetLatestActiveLoanForChatbotParams,
  PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot200One,
  PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot200Two,
  PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams,
  PostApiLoanGetPaymentOptionsParams,
  PostApiLoanPrescrapeParams,
  PostApiLoanRequestLoanParams,
  PostApiLoanSetLoanAccountIdParams,
  PostApiLoanSetLoanIssuedParams,
  PostApiLoanTest123Params,
  PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams,
  PostApiLoanUpdateIssuedDateOfLoanParams,
  PostApiLoanUploadCalculationExcel200One,
  PostApiLoanUploadCalculationExcel200Two,
  PostApiLoanUploadLoansAgreementS3JobParams,
  PostApiMembershipResetCamPasswordParams,
  PostApiMembershipSetAvailabilityForTicketAssignParams,
  PostApiMiscAzureRemoveOldBranchesParams,
  PostApiMiscIpLocationsBody,
  PostApiMiscMockStatusCode200One,
  PostApiMiscMockStatusCode200Two,
  PostApiMiscScamalyticsListBodyOneItem,
  PostApiMiscScamalyticsListBodyThreeItem,
  PostApiMiscScamalyticsListBodyTwoItem,
  PostApiMoneytransferCancelTransferParams,
  PostApiMoneytransferDeleteSourceAccountTransactionParams,
  PostApiMoneytransferExportMoneyTransferCSV200One,
  PostApiMoneytransferExportMoneyTransferCSV200Two,
  PostApiMoneytransferRetryTransferParams,
  PostApiQueueAddToIVRQueueParams,
  PostApiQueueMessenteBulkSmsParams,
  PostApiQueueMoneyTransferParams,
  PostApiQueueMoneyTransferRealParams,
  PostApiTelemarketingUnassignCamsTelemarketingParams,
  PostApiTodoAutoInsertCallTimingDefinationParams,
  PostApiTodoChooseCallTimeForCustomerParams,
  PostApiTodoRemoveCallTimingDefinationByIdParams,
  PostApiUnnaxCallbackCollectionTriggerTestParams,
  PostApiUnnaxReScrapeCustomersRejectedByDecisionParams,
  PostNewThreadInfoDto,
  PostRegisterDecisionDto,
  PreScrapeViewModel,
  PreSignedUploadUrlCallbackForCustomerBucketDto,
  ProcessEmailIdentityDocumentsRequestDto,
  PromotionDataQueueItem,
  PromotionRequestDto,
  PutApiCustomerCommunicationPhoneLogParams,
  PutApiLoanEventParams,
  PutApiLoanFtbEventParams,
  PutApiLoanRtbEventParams,
  RawTicketEmailDtoBody,
  RejectedCustomersByUnnaxDto,
  RescrapeDecisionRequestDto,
  ResendVerificationMailRequestDto,
  RestructurePaymentPlanRequestDtoBody,
  Result,
  ResultAMLProviderDto,
  ResultAccountDto,
  ResultArrangementHistoryListDto,
  ResultAutoIssueCheckResponseDto,
  ResultAutomatedCallsNotificationResponseDto,
  ResultBizumIntegrationRequestDto,
  ResultBizumPayloanResponseDto,
  ResultBoolean,
  ResultBulkBlacklistResponseDto,
  ResultBusinessOperationPermissionDto,
  ResultCalculateDesistContractPlannedAmountResponseDto,
  ResultCalculateFutureCloseAmountResponseDto,
  ResultCanGetMultipleLoanDecisionResultDto,
  ResultCancelTransactionReturnDto,
  ResultCancelTransferResponseDto,
  ResultCaptchaResultDto,
  ResultCard3dsFlowDto,
  ResultCardLoanAggregationDto,
  ResultCardResponseDto,
  ResultChangeAdminPasswordResponseDto,
  ResultCheckPhoneDNIResponse,
  ResultChecklistDto,
  ResultCommunicationPermissionContentDto,
  ResultConektaStartResponseDto,
  ResultCreateCustomerResponseDto,
  ResultCustomerAccountDetailResponseDto,
  ResultCustomerDetailDto,
  ResultCustomerForLoginRedirectionResponseDto,
  ResultCustomerIntentLogResponseDto,
  ResultCustomerLimitDto,
  ResultCustomerLoansDto,
  ResultCustomerLoansLightResponseDto,
  ResultCustomerPhoneUpdateResponseDto,
  ResultCustomerProfitabilityDto,
  ResultCustomerScrapePersonalInfoDto,
  ResultDateTime,
  ResultDecimal,
  ResultDecisionApiResponseDto,
  ResultDecisionDto,
  ResultDecisionResult,
  ResultDeclineFlagHistoryDto,
  ResultDeydeThoroughfareEncodingResponseDto,
  ResultDictionaryInt64Boolean,
  ResultDictionaryInt64Decimal,
  ResultDictionaryInt64ListAutoDeclineLoanDto,
  ResultDictionaryInt64String,
  ResultDictionarySocketKeyListWebSocket,
  ResultDictionaryStringBoolean,
  ResultDictionaryStringDictionaryInt64Object,
  ResultDictionaryStringDictionaryStringString,
  ResultDictionaryStringObject,
  ResultDiscountDto,
  ResultDiscountHistoryListDto,
  ResultEligibleBankAccountResponseDto,
  ResultEmailDateIdDto,
  ResultEquifaxInterConnectResponseDTO,
  ResultGeoLocationDto,
  ResultGetFinancialInfoResponseDto,
  ResultGrupoIncofisaPetitionResultDto,
  ResultHashSetOnlineUserDto,
  ResultIListScraperPerformanceResult,
  ResultIListServerDto,
  ResultIdHubConnectResponseDTO,
  ResultIdHubExecuteRequestResponseDTO,
  ResultIdHubFindConfigProcessResponseDTO,
  ResultIdentityCheckResultModel,
  ResultIdentityRecognitionResultDto,
  ResultInsertIncomingEmailResponse,
  ResultInt32,
  ResultInt64,
  ResultInt64Array,
  ResultIvrIntegrationDto,
  ResultKontomatikLoginStatusDto,
  ResultLeadsBridgeResponseDto,
  ResultLightValidateEmailOtpResponseDto,
  ResultLimitUpdateAfterPaymentReturnDto,
  ResultListAMLProviderDto,
  ResultListAbc,
  ResultListAccountDto,
  ResultListAlertDto,
  ResultListCalculateInstallmentPaymentAmountsResponseDto,
  ResultListCalculateNewLimitResponseDto,
  ResultListCardDecisionResponseDto,
  ResultListCardPriorityDto,
  ResultListCardPrivilegeDto,
  ResultListCardResponseDto,
  ResultListCardStatusHistoryDto,
  ResultListClabeAccountDto,
  ResultListCommunicationPaymentResponseModel,
  ResultListCommunicationPermissionDto,
  ResultListCommunicationRequestDto,
  ResultListComplaintsCaseResponseDto,
  ResultListComplaintsCaseStatusDto,
  ResultListComprehensiveLoanReportResponseDto,
  ResultListCreateLoanImpedimentRequestDto,
  ResultListCreateSessionResponseDto,
  ResultListCustomerAddressRequestDto,
  ResultListCustomerAffilateDto,
  ResultListCustomerBestTokenDto,
  ResultListCustomerCallHistoryDto,
  ResultListCustomerCallTimingDefDto,
  ResultListCustomerCollectionCompanyHistoryDto,
  ResultListCustomerCreditTypeDto,
  ResultListCustomerLoansDto,
  ResultListCustomerResponseDto,
  ResultListDateTime,
  ResultListDeletedSourceAccountTransactionsResponseDto,
  ResultListDocumentDto,
  ResultListEkomiReviewsDto,
  ResultListExistingCustomerResponseDto,
  ResultListGeneratedFileDto,
  ResultListGetDateBasedCostHistoryByCampaignCodeResDto,
  ResultListGetMemberFullNamesDto,
  ResultListGetTransactionsOfCardReturnDto,
  ResultListIRestResponse,
  ResultListIdHubExecuteRequestResponseDTO,
  ResultListInt64,
  ResultListInternalCollectionDto,
  ResultListLegalProcessReportDto,
  ResultListLoanAgreementDto,
  ResultListLoanApplicationDetailDto,
  ResultListLoanApplicationFlowValidationNameMatchResponseDto,
  ResultListLoanCalculatorLogDto,
  ResultListLoanDto,
  ResultListLoanReasonDto,
  ResultListLoanStatusDto,
  ResultListLoginInfoDto,
  ResultListManageDuplicateDto,
  ResultListMarketingScheduledDto,
  ResultListMarketingSegmentDto,
  ResultListMemberDto,
  ResultListMexicoPostalCodeDto,
  ResultListMultipleValidateCardResponseDto,
  ResultListNCPPermissionDto,
  ResultListNewDelphiExecuteInteractiveResponseDTO,
  ResultListOptionalPaymentDto,
  ResultListParameterHistoryDto,
  ResultListS3DocumentDto,
  ResultListS3PreSignedUrlDto,
  ResultListScamalyticsResult,
  ResultListScrapeProviderDto,
  ResultListSocketDetailedResultDto,
  ResultListSortedListInt64String,
  ResultListSourceAccountTransactionAbbrDto,
  ResultListString,
  ResultListStringMatchDetailedResult,
  ResultListSubStatusDto,
  ResultListSuspectedLoginMemberRelationHistoryDto,
  ResultListSuspectedLoginRelatedUsersResultDto,
  ResultListTelemarketingDto,
  ResultListTelemarketingStatusDto,
  ResultListTicketEmailDto,
  ResultListTinkCreateSession,
  ResultListTranslationDto,
  ResultListUnnaxInboundOrderResponseDto,
  ResultListWorkCalendarDto,
  ResultLiveChatAgentArray,
  ResultLiveChatMessage,
  ResultLiveChatMessageResponse,
  ResultLiveChatSession,
  ResultLiveChatSessionArray,
  ResultLoanAgreementData,
  ResultLoanAgreementDto,
  ResultLoanDefinationPurpose,
  ResultLoanDetailedDecisionDTO,
  ResultLoanDto,
  ResultLoanTransferState,
  ResultLoginResultDto,
  ResultMakeLoanApplicationResultDTO,
  ResultMakeLoanJourneyDto,
  ResultMarketingScheduledDto,
  ResultMarketingSegmentDto,
  ResultMemberDto,
  ResultMexicoPostalCodeDto,
  ResultMoneyTransferRetryHistoryDto,
  ResultNameSurnameValidationResponseDto,
  ResultNewDelphiExecuteInteractiveResponseDTO,
  ResultNullableBoolean,
  ResultNullableMemberOtpRegister,
  ResultObject,
  ResultOcrFlowResultDto,
  ResultOfThreeDsLoanDto,
  ResultPagedSearchResultBusinessOperationPermissionDto,
  ResultPagedSearchResultCommunicationPhoneLogResponseDto,
  ResultPagedSearchResultFrontLogModel,
  ResultPagedSearchResultGetTransferMoneyDto,
  ResultPagedSearchResultLoanImpedimentResponseDto,
  ResultPagedSearchResultManualPaymentApprovalDto,
  ResultParameterDto,
  ResultPartnerHandoverLoginEndpointResponseDto,
  ResultPartnerHandoverSmsInfoDto,
  ResultPayLoanAndRestructureResponseDto,
  ResultPopulateLoanBasedDocumentsResponseDto,
  ResultPreSignedUploadUrlCallbackDto,
  ResultRTBFurtherBankAccountScrapeResultDto,
  ResultResendVerificationMailResultDto,
  ResultS3DocumentDto,
  ResultS3DocumentInfoDto,
  ResultS3PreSignedUrlDto,
  ResultSaleReturnDto,
  ResultScamalyticsResult,
  ResultScoreForLimitUpdateAfterPaymentV2Dto,
  ResultScrapeConsentStatusDto,
  ResultScrapeProviderDto,
  ResultScrapeResultDto,
  ResultSearchCardReturnDto,
  ResultSearchMLResponseDto,
  ResultShouldRedirectToCardUploadResponseDto,
  ResultSignatureAuditLogResponseDto,
  ResultSortedListInt64String,
  ResultSourceAccountTransactionReadDto,
  ResultSourceAccountUpdateCallbackDto,
  ResultString,
  ResultStringArray,
  ResultTelemarketingDto,
  ResultTemplateResponseDto,
  ResultTestTemplateResponseDto,
  ResultTicketDto,
  ResultTicketEmailAutoResponseDecisionDto,
  ResultToDoItemResponseDto,
  ResultTokenizedScrapeResponseDto,
  ResultTranslationDto,
  ResultUnnaxCallbackDto,
  ResultUnnaxCallbackResultDto,
  ResultUnnaxInboundInitResponseDto,
  ResultUnnaxPendingCallbackDto,
  ResultUnnaxRefundCallbackDto,
  ResultUnnaxWidgetDto,
  ResultUpdateInstallmentReportResult,
  ResultUserConversationHistoryDto,
  ResultValidateCardReturnDto,
  ResultValidateClabeResponseDto,
  ResultValidatePinResponseDto,
  ResultWithActionInfoBoolean,
  ResultWorkBankInformationForGroupALoanDto,
  ResultWorkCalendarDto,
  RetrySmsSendRequestDtoBody,
  RolloverLoanResponseDto,
  RolloverRequestDtoBody,
  RunDecisionModelRemotelyResponse,
  S3DocumentInfoCallbackDto,
  S3DocumentInfoDtoBody,
  S3LoanAgreementDto,
  SalaryCalculationSurrogateDTO,
  SaleDto,
  ScamalyticsResult,
  ScheduleBulkCardValidatorDto,
  ScrapeProviderDtoBody,
  ScraperPerformanceRequest,
  SearchCardReturnDto,
  SearchMoneyTransferRequestBody,
  SendEmailBulkDto,
  SendEmailSingleDto,
  SendMoneyRealDto,
  SendNewPinRequestDto,
  SendSmsBulkDto,
  SetIVRCallDto,
  SmsExcludeAddDto,
  SmsExcludeRemoveDto,
  SmsUnreachedRequestDto,
  SourceAccountTransactionDto,
  SourceAccountUpdateCallbackMockerDto,
  SpecificMessageDtoArrayBody,
  TelemarketingDto,
  TestAutomationDtoBody,
  TestTemplateDto,
  TicketEmailAutoResponseRequestBody,
  TierBasedCostModelDto,
  TinkAggregationCerticateDto,
  TinkCreateSession,
  TinkIframeEventRequestDto,
  TokenValidModel,
  TokenizedScrapeResponseDto,
  TransferCreatedCallbackDto,
  TransferMoneyRequestDto,
  TransferProcessedCallbackDto,
  TranslationGetDto,
  TruliooCallbackDto,
  UnavailableBankScrapeRequestDto,
  UnnaxAccountCardMockRequestDtoBody,
  UnnaxBulkReceiptsRequest,
  UnnaxCallbackDto,
  UnnaxEventAggregationStatusDto,
  UnnaxInboundInitRequestDto,
  UnnaxMockerRequestDto,
  UnnaxPendingCallbackDto,
  UnnaxRefundCallbackDto,
  UnnaxRequestDto,
  UpdateBasicCustomerDto,
  UpdateCommunicationPermissionDto,
  UpdateSignatureAuditOtpRequestDto,
  UpdateTemplateDto,
  UploadCCFilesToFtpServerRequestDto,
  UserClickHistoryInsertDto,
  ValidateAndChangePasswordDto,
  ValidateCardDto,
  ValidateCardReturnDto,
  ValidateClabeRequestDto,
  ValidatePinRequestDto,
  ValidateScrapeOtpRequestDto,
  WelcomeAndSalesCallDto,
  WorkBankInformationForGroupALoanDto,
  WorkCalendarDtoBody,
} from "./generated-api.schemas";

import { customInstance } from "../services/ApiClient";

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
  T
>() => T extends Y ? 1 : 2
  ? A
  : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
      [P in keyof Writable<T>]: T[P] extends object
        ? NonReadonly<NonNullable<T[P]>>
        : T[P];
    }
  : DistributeReadOnlyOverUnions<T>;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getApiBankscraperServiceUrl = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    { url: `/api/bankscraper/ServiceUrl`, method: "GET", signal },
    options
  );
};

export const getGetApiBankscraperServiceUrlQueryKey = () => {
  return [`/api/bankscraper/ServiceUrl`] as const;
};

export const getGetApiBankscraperServiceUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiBankscraperServiceUrlQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>
  > = ({ signal }) => getApiBankscraperServiceUrl(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperServiceUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>
>;
export type GetApiBankscraperServiceUrlQueryError = unknown;

export function useGetApiBankscraperServiceUrl<
  TData = Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperServiceUrl<
  TData = Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperServiceUrl<
  TData = Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperServiceUrl<
  TData = Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperServiceUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperServiceUrlQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiBankscraperValidatecustomerInfo = (
  params: PostApiBankscraperValidatecustomerInfoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIdentityCheckResultModel>(
    {
      url: `/api/bankscraper/validatecustomerInfo`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperValidatecustomerInfoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>,
    TError,
    { params: PostApiBankscraperValidatecustomerInfoParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>,
  TError,
  { params: PostApiBankscraperValidatecustomerInfoParams },
  TContext
> => {
  const mutationKey = ["postApiBankscraperValidatecustomerInfo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>,
    { params: PostApiBankscraperValidatecustomerInfoParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiBankscraperValidatecustomerInfo(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperValidatecustomerInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>
>;

export type PostApiBankscraperValidatecustomerInfoMutationError = unknown;

export const usePostApiBankscraperValidatecustomerInfo = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>,
      TError,
      { params: PostApiBankscraperValidatecustomerInfoParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperValidatecustomerInfo>>,
  TError,
  { params: PostApiBankscraperValidatecustomerInfoParams },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperValidatecustomerInfoMutationOptions(options),
    queryClient
  );
};

export const getApiBankscraperDetermineApplicationFlowPath = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/bankscraper/determineApplicationFlowPath`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiBankscraperDetermineApplicationFlowPathQueryKey = () => {
  return [`/api/bankscraper/determineApplicationFlowPath`] as const;
};

export const getGetApiBankscraperDetermineApplicationFlowPathQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperDetermineApplicationFlowPathQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>>
  > = ({ signal }) =>
    getApiBankscraperDetermineApplicationFlowPath(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperDetermineApplicationFlowPathQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>>
  >;
export type GetApiBankscraperDetermineApplicationFlowPathQueryError = unknown;

export function useGetApiBankscraperDetermineApplicationFlowPath<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperDetermineApplicationFlowPath<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperDetermineApplicationFlowPath<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperDetermineApplicationFlowPath<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperDetermineApplicationFlowPath>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperDetermineApplicationFlowPathQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperLoantransfermanagerState = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanTransferState>(
    {
      url: `/api/bankscraper/loantransfermanager/state`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiBankscraperLoantransfermanagerStateQueryKey = () => {
  return [`/api/bankscraper/loantransfermanager/state`] as const;
};

export const getGetApiBankscraperLoantransfermanagerStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperLoantransfermanagerStateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>
  > = ({ signal }) =>
    getApiBankscraperLoantransfermanagerState(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperLoantransfermanagerStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>
>;
export type GetApiBankscraperLoantransfermanagerStateQueryError = unknown;

export function useGetApiBankscraperLoantransfermanagerState<
  TData = Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperLoantransfermanagerState<
  TData = Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperLoantransfermanagerState<
  TData = Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperLoantransfermanagerState<
  TData = Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperLoantransfermanagerState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperLoantransfermanagerStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiBankscraperFindLinkedAccountId = (
  params: PostApiBankscraperFindLinkedAccountIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt64>(
    {
      url: `/api/bankscraper/findLinkedAccountId`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperFindLinkedAccountIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>,
    TError,
    { params: PostApiBankscraperFindLinkedAccountIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>,
  TError,
  { params: PostApiBankscraperFindLinkedAccountIdParams },
  TContext
> => {
  const mutationKey = ["postApiBankscraperFindLinkedAccountId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>,
    { params: PostApiBankscraperFindLinkedAccountIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiBankscraperFindLinkedAccountId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperFindLinkedAccountIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>
>;

export type PostApiBankscraperFindLinkedAccountIdMutationError = unknown;

export const usePostApiBankscraperFindLinkedAccountId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>,
      TError,
      { params: PostApiBankscraperFindLinkedAccountIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperFindLinkedAccountId>>,
  TError,
  { params: PostApiBankscraperFindLinkedAccountIdParams },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperFindLinkedAccountIdMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperLoantransfermanagerReset = (
  boolean: boolean,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiBankscraperLoantransfermanagerReset200One
    | PostApiBankscraperLoantransfermanagerReset200Two
    | Blob
  >(
    {
      url: `/api/bankscraper/loantransfermanager/reset`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: boolean,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperLoantransfermanagerResetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>,
    TError,
    { data: boolean },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>,
  TError,
  { data: boolean },
  TContext
> => {
  const mutationKey = ["postApiBankscraperLoantransfermanagerReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>,
    { data: boolean }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperLoantransfermanagerReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperLoantransfermanagerResetMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>
  >;
export type PostApiBankscraperLoantransfermanagerResetMutationBody = boolean;
export type PostApiBankscraperLoantransfermanagerResetMutationError = unknown;

export const usePostApiBankscraperLoantransfermanagerReset = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>,
      TError,
      { data: boolean },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperLoantransfermanagerReset>>,
  TError,
  { data: boolean },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperLoantransfermanagerResetMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperNotifysms = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    PostApiBankscraperNotifysms200One | PostApiBankscraperNotifysms200Two | Blob
  >(
    {
      url: `/api/bankscraper/notifysms`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperNotifysmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperNotifysms>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperNotifysms>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiBankscraperNotifysms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperNotifysms>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperNotifysms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperNotifysmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperNotifysms>>
>;
export type PostApiBankscraperNotifysmsMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiBankscraperNotifysmsMutationError = unknown;

export const usePostApiBankscraperNotifysms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperNotifysms>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperNotifysms>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperNotifysmsMutationOptions(options),
    queryClient
  );
};

export const getApiBankscraperGetScrapeCustomerInfo = (
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerScrapePersonalInfoDto>(
    {
      url: `/api/bankscraper/getScrapeCustomerInfo`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperGetScrapeCustomerInfoQueryKey = (
  params?: GetApiBankscraperGetScrapeCustomerInfoParams
) => {
  return [
    `/api/bankscraper/getScrapeCustomerInfo`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetScrapeCustomerInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
  TError = unknown
>(
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetScrapeCustomerInfoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>
  > = ({ signal }) =>
    getApiBankscraperGetScrapeCustomerInfo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetScrapeCustomerInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>
>;
export type GetApiBankscraperGetScrapeCustomerInfoQueryError = unknown;

export function useGetApiBankscraperGetScrapeCustomerInfo<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
  TError = unknown
>(
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetScrapeCustomerInfo<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
  TError = unknown
>(
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetScrapeCustomerInfo<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
  TError = unknown
>(
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetScrapeCustomerInfo<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
  TError = unknown
>(
  params: GetApiBankscraperGetScrapeCustomerInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetScrapeCustomerInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperGetScrapeCustomerInfoQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperGetAccountWithBankDetails = (
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAccountDto>(
    {
      url: `/api/bankscraper/getAccountWithBankDetails`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperGetAccountWithBankDetailsQueryKey = (
  params?: GetApiBankscraperGetAccountWithBankDetailsParams
) => {
  return [
    `/api/bankscraper/getAccountWithBankDetails`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetAccountWithBankDetailsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetAccountWithBankDetailsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>
  > = ({ signal }) =>
    getApiBankscraperGetAccountWithBankDetails(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetAccountWithBankDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>
>;
export type GetApiBankscraperGetAccountWithBankDetailsQueryError = unknown;

export function useGetApiBankscraperGetAccountWithBankDetails<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
          >,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetAccountWithBankDetails<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
          >,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetAccountWithBankDetails<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetAccountWithBankDetails<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountWithBankDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccountWithBankDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperGetAccountWithBankDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiBankscraperScraperPerformance = (
  scraperPerformanceRequest: ScraperPerformanceRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIListScraperPerformanceResult>(
    {
      url: `/api/bankscraper/scraperPerformance`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: scraperPerformanceRequest,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperScraperPerformanceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>,
    TError,
    { data: ScraperPerformanceRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>,
  TError,
  { data: ScraperPerformanceRequest },
  TContext
> => {
  const mutationKey = ["postApiBankscraperScraperPerformance"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>,
    { data: ScraperPerformanceRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperScraperPerformance(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperScraperPerformanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>
>;
export type PostApiBankscraperScraperPerformanceMutationBody =
  ScraperPerformanceRequest;
export type PostApiBankscraperScraperPerformanceMutationError = unknown;

export const usePostApiBankscraperScraperPerformance = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>,
      TError,
      { data: ScraperPerformanceRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperScraperPerformance>>,
  TError,
  { data: ScraperPerformanceRequest },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperScraperPerformanceMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperAddCustomerBankAccountManually = (
  createCustomerBankAccountDto: CreateCustomerBankAccountDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt64>(
    {
      url: `/api/bankscraper/addCustomerBankAccountManually`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerBankAccountDto,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperAddCustomerBankAccountManuallyMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>
      >,
      TError,
      { data: CreateCustomerBankAccountDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>
    >,
    TError,
    { data: CreateCustomerBankAccountDto },
    TContext
  > => {
    const mutationKey = ["postApiBankscraperAddCustomerBankAccountManually"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>
      >,
      { data: CreateCustomerBankAccountDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiBankscraperAddCustomerBankAccountManually(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiBankscraperAddCustomerBankAccountManuallyMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>>
  >;
export type PostApiBankscraperAddCustomerBankAccountManuallyMutationBody =
  CreateCustomerBankAccountDto;
export type PostApiBankscraperAddCustomerBankAccountManuallyMutationError =
  unknown;

export const usePostApiBankscraperAddCustomerBankAccountManually = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>
      >,
      TError,
      { data: CreateCustomerBankAccountDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperAddCustomerBankAccountManually>>,
  TError,
  { data: CreateCustomerBankAccountDto },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperAddCustomerBankAccountManuallyMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperValidateClabe = (
  validateClabeRequestDto: ValidateClabeRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultValidateClabeResponseDto>(
    {
      url: `/api/bankscraper/validateClabe`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validateClabeRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperValidateClabeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>,
    TError,
    { data: ValidateClabeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>,
  TError,
  { data: ValidateClabeRequestDto },
  TContext
> => {
  const mutationKey = ["postApiBankscraperValidateClabe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>,
    { data: ValidateClabeRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperValidateClabe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperValidateClabeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>
>;
export type PostApiBankscraperValidateClabeMutationBody =
  ValidateClabeRequestDto;
export type PostApiBankscraperValidateClabeMutationError = unknown;

export const usePostApiBankscraperValidateClabe = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>,
      TError,
      { data: ValidateClabeRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperValidateClabe>>,
  TError,
  { data: ValidateClabeRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperValidateClabeMutationOptions(options),
    queryClient
  );
};

export const getApiBankscraperGetClabeAccounts = (
  params: GetApiBankscraperGetClabeAccountsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListClabeAccountDto>(
    { url: `/api/bankscraper/getClabeAccounts`, method: "GET", params, signal },
    options
  );
};

export const getGetApiBankscraperGetClabeAccountsQueryKey = (
  params?: GetApiBankscraperGetClabeAccountsParams
) => {
  return [
    `/api/bankscraper/getClabeAccounts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetClabeAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
  TError = unknown
>(
  params: GetApiBankscraperGetClabeAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetClabeAccountsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>
  > = ({ signal }) =>
    getApiBankscraperGetClabeAccounts(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetClabeAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>
>;
export type GetApiBankscraperGetClabeAccountsQueryError = unknown;

export function useGetApiBankscraperGetClabeAccounts<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
  TError = unknown
>(
  params: GetApiBankscraperGetClabeAccountsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetClabeAccounts<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
  TError = unknown
>(
  params: GetApiBankscraperGetClabeAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetClabeAccounts<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
  TError = unknown
>(
  params: GetApiBankscraperGetClabeAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetClabeAccounts<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
  TError = unknown
>(
  params: GetApiBankscraperGetClabeAccountsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetClabeAccounts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperGetClabeAccountsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperGetAccount = (
  params: GetApiBankscraperGetAccountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAccountDto>(
    { url: `/api/bankscraper/GetAccount`, method: "GET", params, signal },
    options
  );
};

export const getGetApiBankscraperGetAccountQueryKey = (
  params?: GetApiBankscraperGetAccountParams
) => {
  return [`/api/bankscraper/GetAccount`, ...(params ? [params] : [])] as const;
};

export const getGetApiBankscraperGetAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiBankscraperGetAccountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetAccount>>
  > = ({ signal }) =>
    getApiBankscraperGetAccount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetAccount>>
>;
export type GetApiBankscraperGetAccountQueryError = unknown;

export function useGetApiBankscraperGetAccount<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetAccount<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetAccount<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetAccount<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
  TError = unknown
>(
  params: GetApiBankscraperGetAccountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperGetAccountQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperTestBlindShotLastsessionFeature = (
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/bankscraper/TestBlindShotLastsessionFeature`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperTestBlindShotLastsessionFeatureQueryKey = (
  params?: GetApiBankscraperTestBlindShotLastsessionFeatureParams
) => {
  return [
    `/api/bankscraper/TestBlindShotLastsessionFeature`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperTestBlindShotLastsessionFeatureQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
  >,
  TError = unknown
>(
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperTestBlindShotLastsessionFeatureQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>>
  > = ({ signal }) =>
    getApiBankscraperTestBlindShotLastsessionFeature(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperTestBlindShotLastsessionFeatureQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>>
  >;
export type GetApiBankscraperTestBlindShotLastsessionFeatureQueryError =
  unknown;

export function useGetApiBankscraperTestBlindShotLastsessionFeature<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
  >,
  TError = unknown
>(
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperTestBlindShotLastsessionFeature<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
  >,
  TError = unknown
>(
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperTestBlindShotLastsessionFeature<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
  >,
  TError = unknown
>(
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperTestBlindShotLastsessionFeature<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
  >,
  TError = unknown
>(
  params: GetApiBankscraperTestBlindShotLastsessionFeatureParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiBankscraperTestBlindShotLastsessionFeature>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperTestBlindShotLastsessionFeatureQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperCardPriorityList = (
  params: GetApiBankscraperCardPriorityListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardPriorityDto>(
    { url: `/api/bankscraper/cardPriorityList`, method: "GET", params, signal },
    options
  );
};

export const getGetApiBankscraperCardPriorityListQueryKey = (
  params?: GetApiBankscraperCardPriorityListParams
) => {
  return [
    `/api/bankscraper/cardPriorityList`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperCardPriorityListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
  TError = unknown
>(
  params: GetApiBankscraperCardPriorityListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperCardPriorityListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>
  > = ({ signal }) =>
    getApiBankscraperCardPriorityList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperCardPriorityListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>
>;
export type GetApiBankscraperCardPriorityListQueryError = unknown;

export function useGetApiBankscraperCardPriorityList<
  TData = Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
  TError = unknown
>(
  params: GetApiBankscraperCardPriorityListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperCardPriorityList<
  TData = Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
  TError = unknown
>(
  params: GetApiBankscraperCardPriorityListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperCardPriorityList<
  TData = Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
  TError = unknown
>(
  params: GetApiBankscraperCardPriorityListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperCardPriorityList<
  TData = Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
  TError = unknown
>(
  params: GetApiBankscraperCardPriorityListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperCardPriorityList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperCardPriorityListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperActiveScrapeProvider = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/bankscraper/activeScrapeProvider`, method: "GET", signal },
    options
  );
};

export const getGetApiBankscraperActiveScrapeProviderQueryKey = () => {
  return [`/api/bankscraper/activeScrapeProvider`] as const;
};

export const getGetApiBankscraperActiveScrapeProviderQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperActiveScrapeProviderQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>
  > = ({ signal }) =>
    getApiBankscraperActiveScrapeProvider(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperActiveScrapeProviderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>
>;
export type GetApiBankscraperActiveScrapeProviderQueryError = unknown;

export function useGetApiBankscraperActiveScrapeProvider<
  TData = Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperActiveScrapeProvider<
  TData = Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperActiveScrapeProvider<
  TData = Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperActiveScrapeProvider<
  TData = Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperActiveScrapeProvider>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperActiveScrapeProviderQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiBankscraperTokenScrape = (
  params: PostApiBankscraperTokenScrapeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTokenizedScrapeResponseDto>(
    { url: `/api/bankscraper/tokenScrape`, method: "POST", params, signal },
    options
  );
};

export const getPostApiBankscraperTokenScrapeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>,
    TError,
    { params: PostApiBankscraperTokenScrapeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>,
  TError,
  { params: PostApiBankscraperTokenScrapeParams },
  TContext
> => {
  const mutationKey = ["postApiBankscraperTokenScrape"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>,
    { params: PostApiBankscraperTokenScrapeParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiBankscraperTokenScrape(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperTokenScrapeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>
>;

export type PostApiBankscraperTokenScrapeMutationError = unknown;

export const usePostApiBankscraperTokenScrape = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>,
      TError,
      { params: PostApiBankscraperTokenScrapeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperTokenScrape>>,
  TError,
  { params: PostApiBankscraperTokenScrapeParams },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperTokenScrapeMutationOptions(options),
    queryClient
  );
};

export const getApiBankscraperGetCustomerBestTokens = (
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerBestTokenDto>(
    {
      url: `/api/bankscraper/GetCustomerBestTokens`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperGetCustomerBestTokensQueryKey = (
  params?: GetApiBankscraperGetCustomerBestTokensParams
) => {
  return [
    `/api/bankscraper/GetCustomerBestTokens`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetCustomerBestTokensQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
  TError = unknown
>(
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetCustomerBestTokensQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>
  > = ({ signal }) =>
    getApiBankscraperGetCustomerBestTokens(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetCustomerBestTokensQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>
>;
export type GetApiBankscraperGetCustomerBestTokensQueryError = unknown;

export function useGetApiBankscraperGetCustomerBestTokens<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
  TError = unknown
>(
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetCustomerBestTokens<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
  TError = unknown
>(
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetCustomerBestTokens<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
  TError = unknown
>(
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetCustomerBestTokens<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
  TError = unknown
>(
  params: GetApiBankscraperGetCustomerBestTokensParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetCustomerBestTokens>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperGetCustomerBestTokensQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperGetSessionResultJsonAsTxt = (
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiBankscraperGetSessionResultJsonAsTxt200One
    | GetApiBankscraperGetSessionResultJsonAsTxt200Two
    | Blob
  >(
    {
      url: `/api/bankscraper/getSessionResultJsonAsTxt`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperGetSessionResultJsonAsTxtQueryKey = (
  params?: GetApiBankscraperGetSessionResultJsonAsTxtParams
) => {
  return [
    `/api/bankscraper/getSessionResultJsonAsTxt`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetSessionResultJsonAsTxtQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetSessionResultJsonAsTxtQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>
  > = ({ signal }) =>
    getApiBankscraperGetSessionResultJsonAsTxt(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetSessionResultJsonAsTxtQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>
>;
export type GetApiBankscraperGetSessionResultJsonAsTxtQueryError = unknown;

export function useGetApiBankscraperGetSessionResultJsonAsTxt<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
          >,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetSessionResultJsonAsTxt<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
          >,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetSessionResultJsonAsTxt<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetSessionResultJsonAsTxt<
  TData = Awaited<
    ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>
  >,
  TError = unknown
>(
  params: GetApiBankscraperGetSessionResultJsonAsTxtParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetSessionResultJsonAsTxt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiBankscraperGetSessionResultJsonAsTxtQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiBankscraperRandomIban = (
  params: GetApiBankscraperRandomIbanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/bankscraper/randomIban`, method: "GET", params, signal },
    options
  );
};

export const getGetApiBankscraperRandomIbanQueryKey = (
  params?: GetApiBankscraperRandomIbanParams
) => {
  return [`/api/bankscraper/randomIban`, ...(params ? [params] : [])] as const;
};

export const getGetApiBankscraperRandomIbanQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
  TError = unknown
>(
  params: GetApiBankscraperRandomIbanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiBankscraperRandomIbanQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperRandomIban>>
  > = ({ signal }) =>
    getApiBankscraperRandomIban(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperRandomIbanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperRandomIban>>
>;
export type GetApiBankscraperRandomIbanQueryError = unknown;

export function useGetApiBankscraperRandomIban<
  TData = Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
  TError = unknown
>(
  params: GetApiBankscraperRandomIbanParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperRandomIban>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperRandomIban<
  TData = Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
  TError = unknown
>(
  params: GetApiBankscraperRandomIbanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperRandomIban>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperRandomIban<
  TData = Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
  TError = unknown
>(
  params: GetApiBankscraperRandomIbanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperRandomIban<
  TData = Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
  TError = unknown
>(
  params: GetApiBankscraperRandomIbanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperRandomIban>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperRandomIbanQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiBankscraperFixCustomerAccountSessionHistoryData = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/bankscraper/fixCustomerAccountSessionHistoryData`,
      method: "PUT",
      signal,
    },
    options
  );
};

export const getPutApiBankscraperFixCustomerAccountSessionHistoryDataMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "putApiBankscraperFixCustomerAccountSessionHistoryData",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
      >,
      void
    > = () => {
      return putApiBankscraperFixCustomerAccountSessionHistoryData(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PutApiBankscraperFixCustomerAccountSessionHistoryDataMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
    >
  >;

export type PutApiBankscraperFixCustomerAccountSessionHistoryDataMutationError =
  unknown;

export const usePutApiBankscraperFixCustomerAccountSessionHistoryData = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof putApiBankscraperFixCustomerAccountSessionHistoryData>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiBankscraperFixCustomerAccountSessionHistoryDataMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiBankscraperGetEligibleBankAccount = (
  params: PostApiBankscraperGetEligibleBankAccountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultEligibleBankAccountResponseDto>(
    {
      url: `/api/bankscraper/getEligibleBankAccount`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperGetEligibleBankAccountMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>,
    TError,
    { params: PostApiBankscraperGetEligibleBankAccountParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>,
  TError,
  { params: PostApiBankscraperGetEligibleBankAccountParams },
  TContext
> => {
  const mutationKey = ["postApiBankscraperGetEligibleBankAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>,
    { params: PostApiBankscraperGetEligibleBankAccountParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiBankscraperGetEligibleBankAccount(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperGetEligibleBankAccountMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>
  >;

export type PostApiBankscraperGetEligibleBankAccountMutationError = unknown;

export const usePostApiBankscraperGetEligibleBankAccount = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>,
      TError,
      { params: PostApiBankscraperGetEligibleBankAccountParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperGetEligibleBankAccount>>,
  TError,
  { params: PostApiBankscraperGetEligibleBankAccountParams },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperGetEligibleBankAccountMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperChangeResetScrapeFlag = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiBankscraperChangeResetScrapeFlagParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/bankscraper/ChangeResetScrapeFlag`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperChangeResetScrapeFlagMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiBankscraperChangeResetScrapeFlagParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiBankscraperChangeResetScrapeFlagParams;
  },
  TContext
> => {
  const mutationKey = ["postApiBankscraperChangeResetScrapeFlag"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiBankscraperChangeResetScrapeFlagParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiBankscraperChangeResetScrapeFlag(
      data,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperChangeResetScrapeFlagMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>
>;
export type PostApiBankscraperChangeResetScrapeFlagMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiBankscraperChangeResetScrapeFlagMutationError = unknown;

export const usePostApiBankscraperChangeResetScrapeFlag = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiBankscraperChangeResetScrapeFlagParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperChangeResetScrapeFlag>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiBankscraperChangeResetScrapeFlagParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperChangeResetScrapeFlagMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperAaaa = (
  unnaxAccountCardMockRequestDtoBody: UnnaxAccountCardMockRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/bankscraper/aaaa`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxAccountCardMockRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperAaaaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperAaaa>>,
    TError,
    { data: UnnaxAccountCardMockRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperAaaa>>,
  TError,
  { data: UnnaxAccountCardMockRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiBankscraperAaaa"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperAaaa>>,
    { data: UnnaxAccountCardMockRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperAaaa(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperAaaaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperAaaa>>
>;
export type PostApiBankscraperAaaaMutationBody =
  UnnaxAccountCardMockRequestDtoBody;
export type PostApiBankscraperAaaaMutationError = unknown;

export const usePostApiBankscraperAaaa = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperAaaa>>,
      TError,
      { data: UnnaxAccountCardMockRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperAaaa>>,
  TError,
  { data: UnnaxAccountCardMockRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperAaaaMutationOptions(options),
    queryClient
  );
};

export const getApiBankscraperGetLastLafvaPreviousData = (
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<LafvaPreviousData>(
    {
      url: `/api/bankscraper/GetLastLafvaPreviousData`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiBankscraperGetLastLafvaPreviousDataQueryKey = (
  params?: GetApiBankscraperGetLastLafvaPreviousDataParams
) => {
  return [
    `/api/bankscraper/GetLastLafvaPreviousData`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiBankscraperGetLastLafvaPreviousDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
  TError = unknown
>(
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiBankscraperGetLastLafvaPreviousDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>
  > = ({ signal }) =>
    getApiBankscraperGetLastLafvaPreviousData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiBankscraperGetLastLafvaPreviousDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>
>;
export type GetApiBankscraperGetLastLafvaPreviousDataQueryError = unknown;

export function useGetApiBankscraperGetLastLafvaPreviousData<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
  TError = unknown
>(
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetLastLafvaPreviousData<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
  TError = unknown
>(
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
          TError,
          Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiBankscraperGetLastLafvaPreviousData<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
  TError = unknown
>(
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiBankscraperGetLastLafvaPreviousData<
  TData = Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
  TError = unknown
>(
  params: GetApiBankscraperGetLastLafvaPreviousDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiBankscraperGetLastLafvaPreviousData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiBankscraperGetLastLafvaPreviousDataQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiBankscraperScrapeConsentOtp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeConsentStatusDto>(
    { url: `/api/bankscraper/ScrapeConsent/otp`, method: "POST", signal },
    options
  );
};

export const getPostApiBankscraperScrapeConsentOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiBankscraperScrapeConsentOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>,
    void
  > = () => {
    return postApiBankscraperScrapeConsentOtp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperScrapeConsentOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>
>;

export type PostApiBankscraperScrapeConsentOtpMutationError = unknown;

export const usePostApiBankscraperScrapeConsentOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtp>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiBankscraperScrapeConsentOtpMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperScrapeConsentOtpValidate = (
  validateScrapeOtpRequestDto: ValidateScrapeOtpRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeConsentStatusDto>(
    {
      url: `/api/bankscraper/ScrapeConsent/otp/validate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validateScrapeOtpRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperScrapeConsentOtpValidateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>,
    TError,
    { data: ValidateScrapeOtpRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>,
  TError,
  { data: ValidateScrapeOtpRequestDto },
  TContext
> => {
  const mutationKey = ["postApiBankscraperScrapeConsentOtpValidate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>,
    { data: ValidateScrapeOtpRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperScrapeConsentOtpValidate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperScrapeConsentOtpValidateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>
  >;
export type PostApiBankscraperScrapeConsentOtpValidateMutationBody =
  ValidateScrapeOtpRequestDto;
export type PostApiBankscraperScrapeConsentOtpValidateMutationError = unknown;

export const usePostApiBankscraperScrapeConsentOtpValidate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>,
      TError,
      { data: ValidateScrapeOtpRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperScrapeConsentOtpValidate>>,
  TError,
  { data: ValidateScrapeOtpRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperScrapeConsentOtpValidateMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperGetCustomerAccountDetail = (
  customerAccountDetailRequestDto: CustomerAccountDetailRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerAccountDetailResponseDto>(
    {
      url: `/api/bankscraper/getCustomerAccountDetail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerAccountDetailRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperGetCustomerAccountDetailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>,
    TError,
    { data: CustomerAccountDetailRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>,
  TError,
  { data: CustomerAccountDetailRequestDto },
  TContext
> => {
  const mutationKey = ["postApiBankscraperGetCustomerAccountDetail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>,
    { data: CustomerAccountDetailRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperGetCustomerAccountDetail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperGetCustomerAccountDetailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>
  >;
export type PostApiBankscraperGetCustomerAccountDetailMutationBody =
  CustomerAccountDetailRequestDto;
export type PostApiBankscraperGetCustomerAccountDetailMutationError = unknown;

export const usePostApiBankscraperGetCustomerAccountDetail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>,
      TError,
      { data: CustomerAccountDetailRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperGetCustomerAccountDetail>>,
  TError,
  { data: CustomerAccountDetailRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperGetCustomerAccountDetailMutationOptions(options),
    queryClient
  );
};

export const putApiBankscraperScrapeProvider = (
  scrapeProviderDtoBody: ScrapeProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeProviderDto>(
    {
      url: `/api/bankscraper/ScrapeProvider`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: scrapeProviderDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiBankscraperScrapeProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>,
    TError,
    { data: ScrapeProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  const mutationKey = ["putApiBankscraperScrapeProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>,
    { data: ScrapeProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiBankscraperScrapeProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiBankscraperScrapeProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>
>;
export type PutApiBankscraperScrapeProviderMutationBody = ScrapeProviderDtoBody;
export type PutApiBankscraperScrapeProviderMutationError = unknown;

export const usePutApiBankscraperScrapeProvider = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>,
      TError,
      { data: ScrapeProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiBankscraperScrapeProviderMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperScrapeProvider = (
  scrapeProviderDtoBody: ScrapeProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeProviderDto>(
    {
      url: `/api/bankscraper/ScrapeProvider`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: scrapeProviderDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiBankscraperScrapeProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>,
    TError,
    { data: ScrapeProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  const mutationKey = ["postApiBankscraperScrapeProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>,
    { data: ScrapeProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiBankscraperScrapeProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperScrapeProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>
>;
export type PostApiBankscraperScrapeProviderMutationBody =
  ScrapeProviderDtoBody;
export type PostApiBankscraperScrapeProviderMutationError = unknown;

export const usePostApiBankscraperScrapeProvider = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>,
      TError,
      { data: ScrapeProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiBankscraperScrapeProviderMutationOptions(options),
    queryClient
  );
};

export const deleteApiBankscraperScrapeProvider = (
  scrapeProviderDtoBody: ScrapeProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeProviderDto>(
    {
      url: `/api/bankscraper/ScrapeProvider`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: scrapeProviderDtoBody,
      signal,
    },
    options
  );
};

export const getDeleteApiBankscraperScrapeProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>,
    TError,
    { data: ScrapeProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  const mutationKey = ["deleteApiBankscraperScrapeProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>,
    { data: ScrapeProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteApiBankscraperScrapeProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiBankscraperScrapeProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>
>;
export type DeleteApiBankscraperScrapeProviderMutationBody =
  ScrapeProviderDtoBody;
export type DeleteApiBankscraperScrapeProviderMutationError = unknown;

export const useDeleteApiBankscraperScrapeProvider = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>,
      TError,
      { data: ScrapeProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiBankscraperScrapeProvider>>,
  TError,
  { data: ScrapeProviderDtoBody },
  TContext
> => {
  return useMutation(
    getDeleteApiBankscraperScrapeProviderMutationOptions(options),
    queryClient
  );
};

export const postApiBankscraperScrapeProviderList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListScrapeProviderDto>(
    { url: `/api/bankscraper/ScrapeProviderList`, method: "POST", signal },
    options
  );
};

export const getPostApiBankscraperScrapeProviderListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiBankscraperScrapeProviderList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>,
    void
  > = () => {
    return postApiBankscraperScrapeProviderList(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiBankscraperScrapeProviderListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>
>;

export type PostApiBankscraperScrapeProviderListMutationError = unknown;

export const usePostApiBankscraperScrapeProviderList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiBankscraperScrapeProviderList>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiBankscraperScrapeProviderListMutationOptions(options),
    queryClient
  );
};

export const postApiCardTransactionCancel = (
  cancelTransactionDto: CancelTransactionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCancelTransactionReturnDto>(
    {
      url: `/api/card/transaction/cancel`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelTransactionDto,
      signal,
    },
    options
  );
};

export const getPostApiCardTransactionCancelMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardTransactionCancel>>,
    TError,
    { data: CancelTransactionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardTransactionCancel>>,
  TError,
  { data: CancelTransactionDto },
  TContext
> => {
  const mutationKey = ["postApiCardTransactionCancel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardTransactionCancel>>,
    { data: CancelTransactionDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardTransactionCancel(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardTransactionCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardTransactionCancel>>
>;
export type PostApiCardTransactionCancelMutationBody = CancelTransactionDto;
export type PostApiCardTransactionCancelMutationError = unknown;

export const usePostApiCardTransactionCancel = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardTransactionCancel>>,
      TError,
      { data: CancelTransactionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardTransactionCancel>>,
  TError,
  { data: CancelTransactionDto },
  TContext
> => {
  return useMutation(
    getPostApiCardTransactionCancelMutationOptions(options),
    queryClient
  );
};

export const postApiCardCreate = (
  createCardDto: CreateCardDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultValidateCardReturnDto>(
    {
      url: `/api/card/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCardDto,
      signal,
    },
    options
  );
};

export const getPostApiCardCreateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCreate>>,
    TError,
    { data: CreateCardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCreate>>,
  TError,
  { data: CreateCardDto },
  TContext
> => {
  const mutationKey = ["postApiCardCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCreate>>,
    { data: CreateCardDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCreate>>
>;
export type PostApiCardCreateMutationBody = CreateCardDto;
export type PostApiCardCreateMutationError = unknown;

export const usePostApiCardCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCreate>>,
      TError,
      { data: CreateCardDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCreate>>,
  TError,
  { data: CreateCardDto },
  TContext
> => {
  return useMutation(getPostApiCardCreateMutationOptions(options), queryClient);
};

export const getApiCardCustomer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSearchCardReturnDto>(
    { url: `/api/card/customer`, method: "GET", signal },
    options
  );
};

export const getGetApiCardCustomerQueryKey = () => {
  return [`/api/card/customer`] as const;
};

export const getGetApiCardCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCustomer>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCustomer>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCardCustomerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCustomer>>
  > = ({ signal }) => getApiCardCustomer(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCustomer>>
>;
export type GetApiCardCustomerQueryError = unknown;

export function useGetApiCardCustomer<
  TData = Awaited<ReturnType<typeof getApiCardCustomer>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomer<
  TData = Awaited<ReturnType<typeof getApiCardCustomer>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomer<
  TData = Awaited<ReturnType<typeof getApiCardCustomer>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCustomer<
  TData = Awaited<ReturnType<typeof getApiCardCustomer>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCustomerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardCustomerOrdered = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardResponseDto>(
    { url: `/api/card/customer/ordered`, method: "GET", signal },
    options
  );
};

export const getGetApiCardCustomerOrderedQueryKey = () => {
  return [`/api/card/customer/ordered`] as const;
};

export const getGetApiCardCustomerOrderedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCustomerOrderedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCustomerOrdered>>
  > = ({ signal }) => getApiCardCustomerOrdered(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCustomerOrderedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCustomerOrdered>>
>;
export type GetApiCardCustomerOrderedQueryError = unknown;

export function useGetApiCardCustomerOrdered<
  TData = Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerOrdered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerOrdered<
  TData = Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerOrdered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerOrdered<
  TData = Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCustomerOrdered<
  TData = Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerOrdered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCustomerOrderedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardCustomerMini = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardResponseDto>(
    { url: `/api/card/customer/mini`, method: "GET", signal },
    options
  );
};

export const getGetApiCardCustomerMiniQueryKey = () => {
  return [`/api/card/customer/mini`] as const;
};

export const getGetApiCardCustomerMiniQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCustomerMini>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCustomerMini>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCustomerMiniQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCustomerMini>>
  > = ({ signal }) => getApiCardCustomerMini(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCustomerMini>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCustomerMiniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCustomerMini>>
>;
export type GetApiCardCustomerMiniQueryError = unknown;

export function useGetApiCardCustomerMini<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMini>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMini>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerMini>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerMini>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerMini<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMini>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMini>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerMini>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerMini>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerMini<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMini>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMini>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCustomerMini<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMini>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMini>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCustomerMiniQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardCustomerMiniHavingToken = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardResponseDto>(
    { url: `/api/card/customer/miniHavingToken`, method: "GET", signal },
    options
  );
};

export const getGetApiCardCustomerMiniHavingTokenQueryKey = () => {
  return [`/api/card/customer/miniHavingToken`] as const;
};

export const getGetApiCardCustomerMiniHavingTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCustomerMiniHavingTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>
  > = ({ signal }) => getApiCardCustomerMiniHavingToken(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCustomerMiniHavingTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>
>;
export type GetApiCardCustomerMiniHavingTokenQueryError = unknown;

export function useGetApiCardCustomerMiniHavingToken<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerMiniHavingToken<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerMiniHavingToken<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCustomerMiniHavingToken<
  TData = Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerMiniHavingToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCardCustomerMiniHavingTokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardGetCardsWithTokenToken = (
  token: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardResponseDto>(
    { url: `/api/card/getCardsWithToken/${token}`, method: "POST", signal },
    options
  );
};

export const getPostApiCardGetCardsWithTokenTokenMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["postApiCardGetCardsWithTokenToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return postApiCardGetCardsWithTokenToken(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardGetCardsWithTokenTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>
>;

export type PostApiCardGetCardsWithTokenTokenMutationError = unknown;

export const usePostApiCardGetCardsWithTokenToken = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>,
      TError,
      { token: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardGetCardsWithTokenToken>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(
    getPostApiCardGetCardsWithTokenTokenMutationOptions(options),
    queryClient
  );
};

export const getApiCardCustomerLatest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCardResponseDto>(
    { url: `/api/card/customer/latest`, method: "GET", signal },
    options
  );
};

export const getGetApiCardCustomerLatestQueryKey = () => {
  return [`/api/card/customer/latest`] as const;
};

export const getGetApiCardCustomerLatestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCustomerLatestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCustomerLatest>>
  > = ({ signal }) => getApiCardCustomerLatest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCustomerLatestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCustomerLatest>>
>;
export type GetApiCardCustomerLatestQueryError = unknown;

export function useGetApiCardCustomerLatest<
  TData = Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerLatest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerLatest<
  TData = Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCustomerLatest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCustomerLatest<
  TData = Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCustomerLatest<
  TData = Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCustomerLatest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCustomerLatestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardSale = (
  saleDto: SaleDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSaleReturnDto>(
    {
      url: `/api/card/sale`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saleDto,
      signal,
    },
    options
  );
};

export const getPostApiCardSaleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardSale>>,
    TError,
    { data: SaleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardSale>>,
  TError,
  { data: SaleDto },
  TContext
> => {
  const mutationKey = ["postApiCardSale"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardSale>>,
    { data: SaleDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardSale(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardSaleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardSale>>
>;
export type PostApiCardSaleMutationBody = SaleDto;
export type PostApiCardSaleMutationError = unknown;

export const usePostApiCardSale = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardSale>>,
      TError,
      { data: SaleDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardSale>>,
  TError,
  { data: SaleDto },
  TContext
> => {
  return useMutation(getPostApiCardSaleMutationOptions(options), queryClient);
};

export const getApiCardTransactionsCardId = (
  cardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListGetTransactionsOfCardReturnDto>(
    { url: `/api/card/transactions/${cardId}`, method: "GET", signal },
    options
  );
};

export const getGetApiCardTransactionsCardIdQueryKey = (cardId: number) => {
  return [`/api/card/transactions/${cardId}`] as const;
};

export const getGetApiCardTransactionsCardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardTransactionsCardIdQueryKey(cardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardTransactionsCardId>>
  > = ({ signal }) =>
    getApiCardTransactionsCardId(cardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!cardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardTransactionsCardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardTransactionsCardId>>
>;
export type GetApiCardTransactionsCardIdQueryError = unknown;

export function useGetApiCardTransactionsCardId<
  TData = Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
  TError = unknown
>(
  cardId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
          TError,
          Awaited<ReturnType<typeof getApiCardTransactionsCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardTransactionsCardId<
  TData = Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
          TError,
          Awaited<ReturnType<typeof getApiCardTransactionsCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardTransactionsCardId<
  TData = Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardTransactionsCardId<
  TData = Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTransactionsCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardTransactionsCardIdQueryOptions(
    cardId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardMocker = (
  cardMockerRequestDto: CardMockerRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/card/mocker`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardMockerRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCardMockerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardMocker>>,
    TError,
    { data: CardMockerRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardMocker>>,
  TError,
  { data: CardMockerRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCardMocker"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardMocker>>,
    { data: CardMockerRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardMocker(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardMockerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardMocker>>
>;
export type PostApiCardMockerMutationBody = CardMockerRequestDto;
export type PostApiCardMockerMutationError = unknown;

export const usePostApiCardMocker = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardMocker>>,
      TError,
      { data: CardMockerRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardMocker>>,
  TError,
  { data: CardMockerRequestDto },
  TContext
> => {
  return useMutation(getPostApiCardMockerMutationOptions(options), queryClient);
};

export const getApiCardCardPrivileges = (
  params: GetApiCardCardPrivilegesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardPrivilegeDto>(
    { url: `/api/card/cardPrivileges`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardCardPrivilegesQueryKey = (
  params?: GetApiCardCardPrivilegesParams
) => {
  return [`/api/card/cardPrivileges`, ...(params ? [params] : [])] as const;
};

export const getGetApiCardCardPrivilegesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
  TError = unknown
>(
  params: GetApiCardCardPrivilegesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCardPrivilegesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCardPrivileges>>
  > = ({ signal }) => getApiCardCardPrivileges(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCardPrivilegesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCardPrivileges>>
>;
export type GetApiCardCardPrivilegesQueryError = unknown;

export function useGetApiCardCardPrivileges<
  TData = Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
  TError = unknown
>(
  params: GetApiCardCardPrivilegesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCardPrivileges>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCardPrivileges<
  TData = Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
  TError = unknown
>(
  params: GetApiCardCardPrivilegesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCardPrivileges>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCardPrivileges<
  TData = Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
  TError = unknown
>(
  params: GetApiCardCardPrivilegesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCardPrivileges<
  TData = Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
  TError = unknown
>(
  params: GetApiCardCardPrivilegesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCardPrivileges>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCardPrivilegesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardStatusHistoryCardId = (
  cardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardStatusHistoryDto>(
    { url: `/api/card/statusHistory/${cardId}`, method: "GET", signal },
    options
  );
};

export const getGetApiCardStatusHistoryCardIdQueryKey = (cardId: number) => {
  return [`/api/card/statusHistory/${cardId}`] as const;
};

export const getGetApiCardStatusHistoryCardIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardStatusHistoryCardIdQueryKey(cardId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>
  > = ({ signal }) =>
    getApiCardStatusHistoryCardId(cardId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!cardId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardStatusHistoryCardIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>
>;
export type GetApiCardStatusHistoryCardIdQueryError = unknown;

export function useGetApiCardStatusHistoryCardId<
  TData = Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
  TError = unknown
>(
  cardId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
          TError,
          Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardStatusHistoryCardId<
  TData = Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
          TError,
          Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardStatusHistoryCardId<
  TData = Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardStatusHistoryCardId<
  TData = Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
  TError = unknown
>(
  cardId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardStatusHistoryCardId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardStatusHistoryCardIdQueryOptions(
    cardId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiCardActiveCardId = (
  cardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/active/${cardId}`, method: "PUT", signal },
    options
  );
};

export const getPutApiCardActiveCardIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCardActiveCardId>>,
    TError,
    { cardId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCardActiveCardId>>,
  TError,
  { cardId: number },
  TContext
> => {
  const mutationKey = ["putApiCardActiveCardId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCardActiveCardId>>,
    { cardId: number }
  > = (props) => {
    const { cardId } = props ?? {};

    return putApiCardActiveCardId(cardId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCardActiveCardIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCardActiveCardId>>
>;

export type PutApiCardActiveCardIdMutationError = unknown;

export const usePutApiCardActiveCardId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCardActiveCardId>>,
      TError,
      { cardId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCardActiveCardId>>,
  TError,
  { cardId: number },
  TContext
> => {
  return useMutation(
    getPutApiCardActiveCardIdMutationOptions(options),
    queryClient
  );
};

export const postApiCardCreateAndValidate = (
  createAndValidateCardDto: CreateAndValidateCardDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanApplicationResultDTO>(
    {
      url: `/api/card/createAndValidate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createAndValidateCardDto,
      signal,
    },
    options
  );
};

export const getPostApiCardCreateAndValidateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCreateAndValidate>>,
    TError,
    { data: CreateAndValidateCardDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCreateAndValidate>>,
  TError,
  { data: CreateAndValidateCardDto },
  TContext
> => {
  const mutationKey = ["postApiCardCreateAndValidate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCreateAndValidate>>,
    { data: CreateAndValidateCardDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardCreateAndValidate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCreateAndValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCreateAndValidate>>
>;
export type PostApiCardCreateAndValidateMutationBody = CreateAndValidateCardDto;
export type PostApiCardCreateAndValidateMutationError = unknown;

export const usePostApiCardCreateAndValidate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCreateAndValidate>>,
      TError,
      { data: CreateAndValidateCardDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCreateAndValidate>>,
  TError,
  { data: CreateAndValidateCardDto },
  TContext
> => {
  return useMutation(
    getPostApiCardCreateAndValidateMutationOptions(options),
    queryClient
  );
};

export const postApiCardThrowCardResponseCodeError = (
  cardResponseCodeErrorDto: CardResponseCodeErrorDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/card/throwCardResponseCodeError`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardResponseCodeErrorDto,
      signal,
    },
    options
  );
};

export const getPostApiCardThrowCardResponseCodeErrorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>,
    TError,
    { data: CardResponseCodeErrorDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>,
  TError,
  { data: CardResponseCodeErrorDto },
  TContext
> => {
  const mutationKey = ["postApiCardThrowCardResponseCodeError"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>,
    { data: CardResponseCodeErrorDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardThrowCardResponseCodeError(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardThrowCardResponseCodeErrorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>
>;
export type PostApiCardThrowCardResponseCodeErrorMutationBody =
  CardResponseCodeErrorDto;
export type PostApiCardThrowCardResponseCodeErrorMutationError = unknown;

export const usePostApiCardThrowCardResponseCodeError = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>,
      TError,
      { data: CardResponseCodeErrorDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardThrowCardResponseCodeError>>,
  TError,
  { data: CardResponseCodeErrorDto },
  TContext
> => {
  return useMutation(
    getPostApiCardThrowCardResponseCodeErrorMutationOptions(options),
    queryClient
  );
};

export const postApiCardValidateMultiple = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMultipleValidateCardResponseDto>(
    {
      url: `/api/card/validate/multiple`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCardValidateMultipleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardValidateMultiple>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardValidateMultiple>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCardValidateMultiple"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardValidateMultiple>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardValidateMultiple(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardValidateMultipleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardValidateMultiple>>
>;
export type PostApiCardValidateMultipleMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCardValidateMultipleMutationError = unknown;

export const usePostApiCardValidateMultiple = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardValidateMultiple>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardValidateMultiple>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCardValidateMultipleMutationOptions(options),
    queryClient
  );
};

export const postApiCardBulkCardValidateForInvalid = (
  bulkCardValidateForInvalidDto: BulkCardValidateForInvalidDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSortedListInt64String>(
    {
      url: `/api/card/bulkCardValidateForInvalid`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkCardValidateForInvalidDto,
      signal,
    },
    options
  );
};

export const getPostApiCardBulkCardValidateForInvalidMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>,
    TError,
    { data: BulkCardValidateForInvalidDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>,
  TError,
  { data: BulkCardValidateForInvalidDto },
  TContext
> => {
  const mutationKey = ["postApiCardBulkCardValidateForInvalid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>,
    { data: BulkCardValidateForInvalidDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardBulkCardValidateForInvalid(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardBulkCardValidateForInvalidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>
>;
export type PostApiCardBulkCardValidateForInvalidMutationBody =
  BulkCardValidateForInvalidDto;
export type PostApiCardBulkCardValidateForInvalidMutationError = unknown;

export const usePostApiCardBulkCardValidateForInvalid = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>,
      TError,
      { data: BulkCardValidateForInvalidDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardBulkCardValidateForInvalid>>,
  TError,
  { data: BulkCardValidateForInvalidDto },
  TContext
> => {
  return useMutation(
    getPostApiCardBulkCardValidateForInvalidMutationOptions(options),
    queryClient
  );
};

export const postApiCardUniversalPayNotificationURL = (
  cardUniversalPayNotificationURLDtoBody: CardUniversalPayNotificationURLDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/card/UniversalPayNotificationURL`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardUniversalPayNotificationURLDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCardUniversalPayNotificationURLMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>,
    TError,
    { data: CardUniversalPayNotificationURLDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCardUniversalPayNotificationURL"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>,
    { data: CardUniversalPayNotificationURLDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardUniversalPayNotificationURL(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardUniversalPayNotificationURLMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>
>;
export type PostApiCardUniversalPayNotificationURLMutationBody =
  CardUniversalPayNotificationURLDtoBody;
export type PostApiCardUniversalPayNotificationURLMutationError = unknown;

export const usePostApiCardUniversalPayNotificationURL = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>,
      TError,
      { data: CardUniversalPayNotificationURLDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardUniversalPayNotificationURL>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCardUniversalPayNotificationURLMutationOptions(options),
    queryClient
  );
};

export const postApiCardSetInMemoryCardBinDataToRedis = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/setInMemoryCardBinDataToRedis`, method: "POST", signal },
    options
  );
};

export const getPostApiCardSetInMemoryCardBinDataToRedisMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardSetInMemoryCardBinDataToRedis"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>,
    void
  > = () => {
    return postApiCardSetInMemoryCardBinDataToRedis(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardSetInMemoryCardBinDataToRedisMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>
  >;

export type PostApiCardSetInMemoryCardBinDataToRedisMutationError = unknown;

export const usePostApiCardSetInMemoryCardBinDataToRedis = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardSetInMemoryCardBinDataToRedis>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardSetInMemoryCardBinDataToRedisMutationOptions(options),
    queryClient
  );
};

export const postApiCardNoCardButLoanCustomersValidateRequest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSortedListInt64String>(
    {
      url: `/api/card/NoCardButLoanCustomersValidateRequest`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCardNoCardButLoanCustomersValidateRequestMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiCardNoCardButLoanCustomersValidateRequest"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>
      >,
      void
    > = () => {
      return postApiCardNoCardButLoanCustomersValidateRequest(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCardNoCardButLoanCustomersValidateRequestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>>
  >;

export type PostApiCardNoCardButLoanCustomersValidateRequestMutationError =
  unknown;

export const usePostApiCardNoCardButLoanCustomersValidateRequest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardNoCardButLoanCustomersValidateRequest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardNoCardButLoanCustomersValidateRequestMutationOptions(options),
    queryClient
  );
};

export const getApiCardGetBinCodeFromRedis = (
  params: GetApiCardGetBinCodeFromRedisParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/card/getBinCodeFromRedis`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardGetBinCodeFromRedisQueryKey = (
  params?: GetApiCardGetBinCodeFromRedisParams
) => {
  return [
    `/api/card/getBinCodeFromRedis`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCardGetBinCodeFromRedisQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
  TError = unknown
>(
  params: GetApiCardGetBinCodeFromRedisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardGetBinCodeFromRedisQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>
  > = ({ signal }) =>
    getApiCardGetBinCodeFromRedis(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardGetBinCodeFromRedisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>
>;
export type GetApiCardGetBinCodeFromRedisQueryError = unknown;

export function useGetApiCardGetBinCodeFromRedis<
  TData = Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
  TError = unknown
>(
  params: GetApiCardGetBinCodeFromRedisParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
          TError,
          Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardGetBinCodeFromRedis<
  TData = Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
  TError = unknown
>(
  params: GetApiCardGetBinCodeFromRedisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
          TError,
          Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardGetBinCodeFromRedis<
  TData = Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
  TError = unknown
>(
  params: GetApiCardGetBinCodeFromRedisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardGetBinCodeFromRedis<
  TData = Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
  TError = unknown
>(
  params: GetApiCardGetBinCodeFromRedisParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetBinCodeFromRedis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardGetBinCodeFromRedisQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardNeedToCardForFTB = (
  params: PostApiCardNeedToCardForFTBParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/NeedToCardForFTB`, method: "POST", params, signal },
    options
  );
};

export const getPostApiCardNeedToCardForFTBMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>,
    TError,
    { params: PostApiCardNeedToCardForFTBParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>,
  TError,
  { params: PostApiCardNeedToCardForFTBParams },
  TContext
> => {
  const mutationKey = ["postApiCardNeedToCardForFTB"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>,
    { params: PostApiCardNeedToCardForFTBParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCardNeedToCardForFTB(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardNeedToCardForFTBMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>
>;

export type PostApiCardNeedToCardForFTBMutationError = unknown;

export const usePostApiCardNeedToCardForFTB = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>,
      TError,
      { params: PostApiCardNeedToCardForFTBParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardNeedToCardForFTB>>,
  TError,
  { params: PostApiCardNeedToCardForFTBParams },
  TContext
> => {
  return useMutation(
    getPostApiCardNeedToCardForFTBMutationOptions(options),
    queryClient
  );
};

export const getApiCardCheckCardProviderToken = (
  params: GetApiCardCheckCardProviderTokenParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/checkCardProviderToken`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardCheckCardProviderTokenQueryKey = (
  params?: GetApiCardCheckCardProviderTokenParams
) => {
  return [
    `/api/card/checkCardProviderToken`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCardCheckCardProviderTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
  TError = unknown
>(
  params: GetApiCardCheckCardProviderTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCardCheckCardProviderTokenQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>
  > = ({ signal }) =>
    getApiCardCheckCardProviderToken(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCheckCardProviderTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>
>;
export type GetApiCardCheckCardProviderTokenQueryError = unknown;

export function useGetApiCardCheckCardProviderToken<
  TData = Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
  TError = unknown
>(
  params: GetApiCardCheckCardProviderTokenParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCheckCardProviderToken<
  TData = Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
  TError = unknown
>(
  params: GetApiCardCheckCardProviderTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCheckCardProviderToken<
  TData = Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
  TError = unknown
>(
  params: GetApiCardCheckCardProviderTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCheckCardProviderToken<
  TData = Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
  TError = unknown
>(
  params: GetApiCardCheckCardProviderTokenParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCheckCardProviderToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCheckCardProviderTokenQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardCallBack3dsFlow = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiCardCallBack3dsFlow200One | GetApiCardCallBack3dsFlow200Two | Blob
  >({ url: `/api/card/callBack3dsFlow`, method: "GET", signal }, options);
};

export const getGetApiCardCallBack3dsFlowQueryKey = () => {
  return [`/api/card/callBack3dsFlow`] as const;
};

export const getGetApiCardCallBack3dsFlowQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardCallBack3dsFlowQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>
  > = ({ signal }) => getApiCardCallBack3dsFlow(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardCallBack3dsFlowQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>
>;
export type GetApiCardCallBack3dsFlowQueryError = unknown;

export function useGetApiCardCallBack3dsFlow<
  TData = Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCallBack3dsFlow<
  TData = Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
          TError,
          Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardCallBack3dsFlow<
  TData = Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardCallBack3dsFlow<
  TData = Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardCallBack3dsFlow>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardCallBack3dsFlowQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardCredoraxNotification = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardCredoraxNotification200One
    | PostApiCardCredoraxNotification200Two
    | Blob
  >({ url: `/api/card/credoraxNotification`, method: "POST", signal }, options);
};

export const getPostApiCardCredoraxNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCredoraxNotification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCredoraxNotification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardCredoraxNotification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCredoraxNotification>>,
    void
  > = () => {
    return postApiCardCredoraxNotification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCredoraxNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCredoraxNotification>>
>;

export type PostApiCardCredoraxNotificationMutationError = unknown;

export const usePostApiCardCredoraxNotification = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCredoraxNotification>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCredoraxNotification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardCredoraxNotificationMutationOptions(options),
    queryClient
  );
};

export const postApiCardCredoraxNotificationFromSNS = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardCredoraxNotificationFromSNS200One
    | PostApiCardCredoraxNotificationFromSNS200Two
    | Blob
  >(
    { url: `/api/card/credoraxNotificationFromSNS`, method: "POST", signal },
    options
  );
};

export const getPostApiCardCredoraxNotificationFromSNSMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardCredoraxNotificationFromSNS"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>,
    void
  > = () => {
    return postApiCardCredoraxNotificationFromSNS(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCredoraxNotificationFromSNSMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>
>;

export type PostApiCardCredoraxNotificationFromSNSMutationError = unknown;

export const usePostApiCardCredoraxNotificationFromSNS = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCredoraxNotificationFromSNS>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardCredoraxNotificationFromSNSMutationOptions(options),
    queryClient
  );
};

export const postApiCardPaynopainNotification = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardPaynopainNotification200One
    | PostApiCardPaynopainNotification200Two
    | Blob
  >(
    { url: `/api/card/paynopain/notification`, method: "POST", signal },
    options
  );
};

export const getPostApiCardPaynopainNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardPaynopainNotification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardPaynopainNotification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardPaynopainNotification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardPaynopainNotification>>,
    void
  > = () => {
    return postApiCardPaynopainNotification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardPaynopainNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardPaynopainNotification>>
>;

export type PostApiCardPaynopainNotificationMutationError = unknown;

export const usePostApiCardPaynopainNotification = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardPaynopainNotification>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardPaynopainNotification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardPaynopainNotificationMutationOptions(options),
    queryClient
  );
};

export const postApiCardDfpCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    PostApiCardDfpCallback200One | PostApiCardDfpCallback200Two | Blob
  >({ url: `/api/card/dfpCallback`, method: "POST", signal }, options);
};

export const getPostApiCardDfpCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardDfpCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardDfpCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardDfpCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardDfpCallback>>,
    void
  > = () => {
    return postApiCardDfpCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardDfpCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardDfpCallback>>
>;

export type PostApiCardDfpCallbackMutationError = unknown;

export const usePostApiCardDfpCallback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardDfpCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardDfpCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardDfpCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiCardIframeCallBack = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/iframeCallBack`, method: "GET", signal },
    options
  );
};

export const getGetApiCardIframeCallBackQueryKey = () => {
  return [`/api/card/iframeCallBack`] as const;
};

export const getGetApiCardIframeCallBackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardIframeCallBackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardIframeCallBack>>
  > = ({ signal }) => getApiCardIframeCallBack(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardIframeCallBackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardIframeCallBack>>
>;
export type GetApiCardIframeCallBackQueryError = unknown;

export function useGetApiCardIframeCallBack<
  TData = Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardIframeCallBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardIframeCallBack<
  TData = Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardIframeCallBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardIframeCallBack<
  TData = Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardIframeCallBack<
  TData = Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardIframeCallBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardIframeCallBackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardThreeDsState = (
  params: GetApiCardThreeDsStateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCard3dsFlowDto>(
    { url: `/api/card/threeDsState`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardThreeDsStateQueryKey = (
  params?: GetApiCardThreeDsStateParams
) => {
  return [`/api/card/threeDsState`, ...(params ? [params] : [])] as const;
};

export const getGetApiCardThreeDsStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardThreeDsState>>,
  TError = unknown
>(
  params: GetApiCardThreeDsStateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardThreeDsState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardThreeDsStateQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardThreeDsState>>
  > = ({ signal }) => getApiCardThreeDsState(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardThreeDsState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardThreeDsStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardThreeDsState>>
>;
export type GetApiCardThreeDsStateQueryError = unknown;

export function useGetApiCardThreeDsState<
  TData = Awaited<ReturnType<typeof getApiCardThreeDsState>>,
  TError = unknown
>(
  params: GetApiCardThreeDsStateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardThreeDsState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardThreeDsState>>,
          TError,
          Awaited<ReturnType<typeof getApiCardThreeDsState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardThreeDsState<
  TData = Awaited<ReturnType<typeof getApiCardThreeDsState>>,
  TError = unknown
>(
  params: GetApiCardThreeDsStateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardThreeDsState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardThreeDsState>>,
          TError,
          Awaited<ReturnType<typeof getApiCardThreeDsState>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardThreeDsState<
  TData = Awaited<ReturnType<typeof getApiCardThreeDsState>>,
  TError = unknown
>(
  params: GetApiCardThreeDsStateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardThreeDsState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardThreeDsState<
  TData = Awaited<ReturnType<typeof getApiCardThreeDsState>>,
  TError = unknown
>(
  params: GetApiCardThreeDsStateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardThreeDsState>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardThreeDsStateQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardPaynopainOrderEventsEventNameTrackId = (
  eventName: string,
  trackId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardPaynopainOrderEventsEventNameTrackId200One
    | PostApiCardPaynopainOrderEventsEventNameTrackId200Two
    | Blob
  >(
    {
      url: `/api/card/paynopain/orderEvents/${eventName}/${trackId}`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCardPaynopainOrderEventsEventNameTrackIdMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>
      >,
      TError,
      { eventName: string; trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>>,
    TError,
    { eventName: string; trackId: string },
    TContext
  > => {
    const mutationKey = ["postApiCardPaynopainOrderEventsEventNameTrackId"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>
      >,
      { eventName: string; trackId: string }
    > = (props) => {
      const { eventName, trackId } = props ?? {};

      return postApiCardPaynopainOrderEventsEventNameTrackId(
        eventName,
        trackId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCardPaynopainOrderEventsEventNameTrackIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>>
  >;

export type PostApiCardPaynopainOrderEventsEventNameTrackIdMutationError =
  unknown;

export const usePostApiCardPaynopainOrderEventsEventNameTrackId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>
      >,
      TError,
      { eventName: string; trackId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardPaynopainOrderEventsEventNameTrackId>>,
  TError,
  { eventName: string; trackId: string },
  TContext
> => {
  return useMutation(
    getPostApiCardPaynopainOrderEventsEventNameTrackIdMutationOptions(options),
    queryClient
  );
};

export const getApiCardPaynopainSuccess = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/paynopain/success`, method: "GET", signal },
    options
  );
};

export const getGetApiCardPaynopainSuccessQueryKey = () => {
  return [`/api/card/paynopain/success`] as const;
};

export const getGetApiCardPaynopainSuccessQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardPaynopainSuccessQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>
  > = ({ signal }) => getApiCardPaynopainSuccess(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardPaynopainSuccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>
>;
export type GetApiCardPaynopainSuccessQueryError = unknown;

export function useGetApiCardPaynopainSuccess<
  TData = Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
          TError,
          Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardPaynopainSuccess<
  TData = Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
          TError,
          Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardPaynopainSuccess<
  TData = Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardPaynopainSuccess<
  TData = Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardPaynopainSuccess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardPaynopainSuccessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardPaynopainError = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/paynopain/error`, method: "POST", signal },
    options
  );
};

export const getPostApiCardPaynopainErrorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardPaynopainError>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardPaynopainError>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardPaynopainError"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardPaynopainError>>,
    void
  > = () => {
    return postApiCardPaynopainError(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardPaynopainErrorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardPaynopainError>>
>;

export type PostApiCardPaynopainErrorMutationError = unknown;

export const usePostApiCardPaynopainError = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardPaynopainError>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardPaynopainError>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardPaynopainErrorMutationOptions(options),
    queryClient
  );
};

export const postApiCardCheckCardValidationForLoanApplication = (
  params: PostApiCardCheckCardValidationForLoanApplicationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardResponseDto>(
    {
      url: `/api/card/checkCardValidationForLoanApplication`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCardCheckCardValidationForLoanApplicationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>
      >,
      TError,
      { params: PostApiCardCheckCardValidationForLoanApplicationParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>
    >,
    TError,
    { params: PostApiCardCheckCardValidationForLoanApplicationParams },
    TContext
  > => {
    const mutationKey = ["postApiCardCheckCardValidationForLoanApplication"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>
      >,
      { params: PostApiCardCheckCardValidationForLoanApplicationParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCardCheckCardValidationForLoanApplication(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCardCheckCardValidationForLoanApplicationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>>
  >;

export type PostApiCardCheckCardValidationForLoanApplicationMutationError =
  unknown;

export const usePostApiCardCheckCardValidationForLoanApplication = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>
      >,
      TError,
      { params: PostApiCardCheckCardValidationForLoanApplicationParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCheckCardValidationForLoanApplication>>,
  TError,
  { params: PostApiCardCheckCardValidationForLoanApplicationParams },
  TContext
> => {
  return useMutation(
    getPostApiCardCheckCardValidationForLoanApplicationMutationOptions(options),
    queryClient
  );
};

export const postApiCardCredoraxCallbackTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardCredoraxCallbackTest200One
    | PostApiCardCredoraxCallbackTest200Two
    | Blob
  >({ url: `/api/card/credoraxCallbackTest`, method: "POST", signal }, options);
};

export const getPostApiCardCredoraxCallbackTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardCredoraxCallbackTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>,
    void
  > = () => {
    return postApiCardCredoraxCallbackTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCredoraxCallbackTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>
>;

export type PostApiCardCredoraxCallbackTestMutationError = unknown;

export const usePostApiCardCredoraxCallbackTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCredoraxCallbackTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardCredoraxCallbackTestMutationOptions(options),
    queryClient
  );
};

export const postApiCardCallbackBizum = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/card/callback/bizum`, method: "POST", signal },
    options
  );
};

export const getPostApiCardCallbackBizumMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCallbackBizum>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCallbackBizum>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardCallbackBizum"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCallbackBizum>>,
    void
  > = () => {
    return postApiCardCallbackBizum(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCallbackBizumMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCallbackBizum>>
>;

export type PostApiCardCallbackBizumMutationError = unknown;

export const usePostApiCardCallbackBizum = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCallbackBizum>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCallbackBizum>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardCallbackBizumMutationOptions(options),
    queryClient
  );
};

export const postApiCardBizumStart = (
  bizumPayLoanRequestDto: BizumPayLoanRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBizumPayloanResponseDto>(
    {
      url: `/api/card/bizum-start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bizumPayLoanRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCardBizumStartMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardBizumStart>>,
    TError,
    { data: BizumPayLoanRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardBizumStart>>,
  TError,
  { data: BizumPayLoanRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCardBizumStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardBizumStart>>,
    { data: BizumPayLoanRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardBizumStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardBizumStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardBizumStart>>
>;
export type PostApiCardBizumStartMutationBody = BizumPayLoanRequestDto;
export type PostApiCardBizumStartMutationError = unknown;

export const usePostApiCardBizumStart = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardBizumStart>>,
      TError,
      { data: BizumPayLoanRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardBizumStart>>,
  TError,
  { data: BizumPayLoanRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCardBizumStartMutationOptions(options),
    queryClient
  );
};

export const getApiCardBizumRedirectBack = (
  params: GetApiCardBizumRedirectBackParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiCardBizumRedirectBack200One | GetApiCardBizumRedirectBack200Two | Blob
  >(
    { url: `/api/card/bizum-redirect-back`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardBizumRedirectBackQueryKey = (
  params?: GetApiCardBizumRedirectBackParams
) => {
  return [
    `/api/card/bizum-redirect-back`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCardBizumRedirectBackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardBizumRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardBizumRedirectBackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>
  > = ({ signal }) =>
    getApiCardBizumRedirectBack(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardBizumRedirectBackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>
>;
export type GetApiCardBizumRedirectBackQueryError = unknown;

export function useGetApiCardBizumRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardBizumRedirectBackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardBizumRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardBizumRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardBizumRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardBizumRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardBizumRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardBizumRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardBizumRedirectBackQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardBizumData = (
  params: GetApiCardBizumDataParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBizumIntegrationRequestDto>(
    { url: `/api/card/bizum-data`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardBizumDataQueryKey = (
  params?: GetApiCardBizumDataParams
) => {
  return [`/api/card/bizum-data`, ...(params ? [params] : [])] as const;
};

export const getGetApiCardBizumDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardBizumData>>,
  TError = unknown
>(
  params: GetApiCardBizumDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardBizumDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardBizumData>>
  > = ({ signal }) => getApiCardBizumData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardBizumData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardBizumDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardBizumData>>
>;
export type GetApiCardBizumDataQueryError = unknown;

export function useGetApiCardBizumData<
  TData = Awaited<ReturnType<typeof getApiCardBizumData>>,
  TError = unknown
>(
  params: GetApiCardBizumDataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardBizumData>>,
          TError,
          Awaited<ReturnType<typeof getApiCardBizumData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardBizumData<
  TData = Awaited<ReturnType<typeof getApiCardBizumData>>,
  TError = unknown
>(
  params: GetApiCardBizumDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardBizumData>>,
          TError,
          Awaited<ReturnType<typeof getApiCardBizumData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardBizumData<
  TData = Awaited<ReturnType<typeof getApiCardBizumData>>,
  TError = unknown
>(
  params: GetApiCardBizumDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardBizumData<
  TData = Awaited<ReturnType<typeof getApiCardBizumData>>,
  TError = unknown
>(
  params: GetApiCardBizumDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardBizumData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardBizumDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardConektaCardStart = (
  conektaStartRequestDto: ConektaStartRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultConektaStartResponseDto>(
    {
      url: `/api/card/conekta-card-start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: conektaStartRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCardConektaCardStartMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardConektaCardStart>>,
    TError,
    { data: ConektaStartRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardConektaCardStart>>,
  TError,
  { data: ConektaStartRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCardConektaCardStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardConektaCardStart>>,
    { data: ConektaStartRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardConektaCardStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardConektaCardStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardConektaCardStart>>
>;
export type PostApiCardConektaCardStartMutationBody = ConektaStartRequestDto;
export type PostApiCardConektaCardStartMutationError = unknown;

export const usePostApiCardConektaCardStart = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardConektaCardStart>>,
      TError,
      { data: ConektaStartRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardConektaCardStart>>,
  TError,
  { data: ConektaStartRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCardConektaCardStartMutationOptions(options),
    queryClient
  );
};

export const postApiCardConektaStart = (
  conektaCheckoutStartRequestDto: ConektaCheckoutStartRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultConektaStartResponseDto>(
    {
      url: `/api/card/conekta-start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: conektaCheckoutStartRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCardConektaStartMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardConektaStart>>,
    TError,
    { data: ConektaCheckoutStartRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardConektaStart>>,
  TError,
  { data: ConektaCheckoutStartRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCardConektaStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardConektaStart>>,
    { data: ConektaCheckoutStartRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardConektaStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardConektaStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardConektaStart>>
>;
export type PostApiCardConektaStartMutationBody =
  ConektaCheckoutStartRequestDto;
export type PostApiCardConektaStartMutationError = unknown;

export const usePostApiCardConektaStart = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardConektaStart>>,
      TError,
      { data: ConektaCheckoutStartRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardConektaStart>>,
  TError,
  { data: ConektaCheckoutStartRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCardConektaStartMutationOptions(options),
    queryClient
  );
};

export const getApiCardConektaRedirectBack = (
  params: GetApiCardConektaRedirectBackParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCardConektaRedirectBack200One
    | GetApiCardConektaRedirectBack200Two
    | Blob
  >(
    { url: `/api/card/conekta-redirect-back`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardConektaRedirectBackQueryKey = (
  params?: GetApiCardConektaRedirectBackParams
) => {
  return [
    `/api/card/conekta-redirect-back`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCardConektaRedirectBackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardConektaRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardConektaRedirectBackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>
  > = ({ signal }) =>
    getApiCardConektaRedirectBack(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardConektaRedirectBackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>
>;
export type GetApiCardConektaRedirectBackQueryError = unknown;

export function useGetApiCardConektaRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardConektaRedirectBackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardConektaRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardConektaRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
          TError,
          Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardConektaRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardConektaRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardConektaRedirectBack<
  TData = Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
  TError = unknown
>(
  params: GetApiCardConektaRedirectBackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardConektaRedirectBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardConektaRedirectBackQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardCardViaIVR = (
  cardViaIVRRequestDto: CardViaIVRRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/card/CardViaIVR`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardViaIVRRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCardCardViaIVRMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardCardViaIVR>>,
    TError,
    { data: CardViaIVRRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardCardViaIVR>>,
  TError,
  { data: CardViaIVRRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCardCardViaIVR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardCardViaIVR>>,
    { data: CardViaIVRRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCardCardViaIVR(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardCardViaIVRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardCardViaIVR>>
>;
export type PostApiCardCardViaIVRMutationBody = CardViaIVRRequestDto;
export type PostApiCardCardViaIVRMutationError = unknown;

export const usePostApiCardCardViaIVR = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardCardViaIVR>>,
      TError,
      { data: CardViaIVRRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardCardViaIVR>>,
  TError,
  { data: CardViaIVRRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCardCardViaIVRMutationOptions(options),
    queryClient
  );
};

export const getApiCardShouldRedirectToCardUpload = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultShouldRedirectToCardUploadResponseDto>(
    { url: `/api/card/ShouldRedirectToCardUpload`, method: "GET", signal },
    options
  );
};

export const getGetApiCardShouldRedirectToCardUploadQueryKey = () => {
  return [`/api/card/ShouldRedirectToCardUpload`] as const;
};

export const getGetApiCardShouldRedirectToCardUploadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardShouldRedirectToCardUploadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>
  > = ({ signal }) =>
    getApiCardShouldRedirectToCardUpload(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardShouldRedirectToCardUploadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>
>;
export type GetApiCardShouldRedirectToCardUploadQueryError = unknown;

export function useGetApiCardShouldRedirectToCardUpload<
  TData = Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
          TError,
          Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardShouldRedirectToCardUpload<
  TData = Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
          TError,
          Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardShouldRedirectToCardUpload<
  TData = Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardShouldRedirectToCardUpload<
  TData = Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardShouldRedirectToCardUpload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCardShouldRedirectToCardUploadQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardGetExceptionCardIdsBy3DsSale = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/card/GetExceptionCardIdsBy3DsSale`, method: "GET", signal },
    options
  );
};

export const getGetApiCardGetExceptionCardIdsBy3DsSaleQueryKey = () => {
  return [`/api/card/GetExceptionCardIdsBy3DsSale`] as const;
};

export const getGetApiCardGetExceptionCardIdsBy3DsSaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCardGetExceptionCardIdsBy3DsSaleQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>
  > = ({ signal }) =>
    getApiCardGetExceptionCardIdsBy3DsSale(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardGetExceptionCardIdsBy3DsSaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>
>;
export type GetApiCardGetExceptionCardIdsBy3DsSaleQueryError = unknown;

export function useGetApiCardGetExceptionCardIdsBy3DsSale<
  TData = Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
          TError,
          Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardGetExceptionCardIdsBy3DsSale<
  TData = Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
          TError,
          Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardGetExceptionCardIdsBy3DsSale<
  TData = Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardGetExceptionCardIdsBy3DsSale<
  TData = Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardGetExceptionCardIdsBy3DsSale>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCardGetExceptionCardIdsBy3DsSaleQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCardTestMitSale = (
  params: GetApiCardTestMitSaleParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/card/testMitSale`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCardTestMitSaleQueryKey = (
  params?: GetApiCardTestMitSaleParams
) => {
  return [`/api/card/testMitSale`, ...(params ? [params] : [])] as const;
};

export const getGetApiCardTestMitSaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCardTestMitSale>>,
  TError = unknown
>(
  params: GetApiCardTestMitSaleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTestMitSale>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCardTestMitSaleQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCardTestMitSale>>
  > = ({ signal }) => getApiCardTestMitSale(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCardTestMitSale>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCardTestMitSaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCardTestMitSale>>
>;
export type GetApiCardTestMitSaleQueryError = unknown;

export function useGetApiCardTestMitSale<
  TData = Awaited<ReturnType<typeof getApiCardTestMitSale>>,
  TError = unknown
>(
  params: GetApiCardTestMitSaleParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTestMitSale>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardTestMitSale>>,
          TError,
          Awaited<ReturnType<typeof getApiCardTestMitSale>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardTestMitSale<
  TData = Awaited<ReturnType<typeof getApiCardTestMitSale>>,
  TError = unknown
>(
  params: GetApiCardTestMitSaleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTestMitSale>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCardTestMitSale>>,
          TError,
          Awaited<ReturnType<typeof getApiCardTestMitSale>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCardTestMitSale<
  TData = Awaited<ReturnType<typeof getApiCardTestMitSale>>,
  TError = unknown
>(
  params: GetApiCardTestMitSaleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTestMitSale>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCardTestMitSale<
  TData = Awaited<ReturnType<typeof getApiCardTestMitSale>>,
  TError = unknown
>(
  params: GetApiCardTestMitSaleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCardTestMitSale>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCardTestMitSaleQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCardConekta3dsNotification = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCardConekta3dsNotification200One
    | PostApiCardConekta3dsNotification200Two
    | Blob
  >(
    { url: `/api/card/conekta/3dsNotification`, method: "POST", signal },
    options
  );
};

export const getPostApiCardConekta3dsNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCardConekta3dsNotification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>,
    void
  > = () => {
    return postApiCardConekta3dsNotification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCardConekta3dsNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>
>;

export type PostApiCardConekta3dsNotificationMutationError = unknown;

export const usePostApiCardConekta3dsNotification = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCardConekta3dsNotification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCardConekta3dsNotificationMutationOptions(options),
    queryClient
  );
};

export const postApiChatymeFileUploadWebhook = (
  chatymeFileUploadWebhookPayload: ChatymeFileUploadWebhookPayload,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/chatyme/fileUploadWebhook`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: chatymeFileUploadWebhookPayload,
      signal,
    },
    options
  );
};

export const getPostApiChatymeFileUploadWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>,
    TError,
    { data: ChatymeFileUploadWebhookPayload },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>,
  TError,
  { data: ChatymeFileUploadWebhookPayload },
  TContext
> => {
  const mutationKey = ["postApiChatymeFileUploadWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>,
    { data: ChatymeFileUploadWebhookPayload }
  > = (props) => {
    const { data } = props ?? {};

    return postApiChatymeFileUploadWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiChatymeFileUploadWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>
>;
export type PostApiChatymeFileUploadWebhookMutationBody =
  ChatymeFileUploadWebhookPayload;
export type PostApiChatymeFileUploadWebhookMutationError = unknown;

export const usePostApiChatymeFileUploadWebhook = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>,
      TError,
      { data: ChatymeFileUploadWebhookPayload },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiChatymeFileUploadWebhook>>,
  TError,
  { data: ChatymeFileUploadWebhookPayload },
  TContext
> => {
  return useMutation(
    getPostApiChatymeFileUploadWebhookMutationOptions(options),
    queryClient
  );
};

export const postApiChatymeRunOcrFlow = (
  chatymeOcrDocumentDto: ChatymeOcrDocumentDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultOcrFlowResultDto>(
    {
      url: `/api/chatyme/runOcrFlow`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: chatymeOcrDocumentDto,
      signal,
    },
    options
  );
};

export const getPostApiChatymeRunOcrFlowMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>,
    TError,
    { data: ChatymeOcrDocumentDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>,
  TError,
  { data: ChatymeOcrDocumentDto[] },
  TContext
> => {
  const mutationKey = ["postApiChatymeRunOcrFlow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>,
    { data: ChatymeOcrDocumentDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiChatymeRunOcrFlow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiChatymeRunOcrFlowMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>
>;
export type PostApiChatymeRunOcrFlowMutationBody = ChatymeOcrDocumentDto[];
export type PostApiChatymeRunOcrFlowMutationError = unknown;

export const usePostApiChatymeRunOcrFlow = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>,
      TError,
      { data: ChatymeOcrDocumentDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiChatymeRunOcrFlow>>,
  TError,
  { data: ChatymeOcrDocumentDto[] },
  TContext
> => {
  return useMutation(
    getPostApiChatymeRunOcrFlowMutationOptions(options),
    queryClient
  );
};

export const getApiCommonTime = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDateTime>(
    { url: `/api/common/time`, method: "GET", signal },
    options
  );
};

export const getGetApiCommonTimeQueryKey = () => {
  return [`/api/common/time`] as const;
};

export const getGetApiCommonTimeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommonTime>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiCommonTime>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCommonTimeQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommonTime>>
  > = ({ signal }) => getApiCommonTime(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommonTime>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommonTimeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommonTime>>
>;
export type GetApiCommonTimeQueryError = unknown;

export function useGetApiCommonTime<
  TData = Awaited<ReturnType<typeof getApiCommonTime>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommonTime>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommonTime>>,
          TError,
          Awaited<ReturnType<typeof getApiCommonTime>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommonTime<
  TData = Awaited<ReturnType<typeof getApiCommonTime>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommonTime>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommonTime>>,
          TError,
          Awaited<ReturnType<typeof getApiCommonTime>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommonTime<
  TData = Awaited<ReturnType<typeof getApiCommonTime>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommonTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommonTime<
  TData = Awaited<ReturnType<typeof getApiCommonTime>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommonTime>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommonTimeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationInsertAutomationQueueItem = (
  automationQueueItemInsertDto: AutomationQueueItemInsertDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/insertAutomationQueueItem`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: automationQueueItemInsertDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationInsertAutomationQueueItemMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>,
    TError,
    { data: AutomationQueueItemInsertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>,
  TError,
  { data: AutomationQueueItemInsertDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationInsertAutomationQueueItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>,
    { data: AutomationQueueItemInsertDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationInsertAutomationQueueItem(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationInsertAutomationQueueItemMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>
  >;
export type PostApiCommunicationInsertAutomationQueueItemMutationBody =
  AutomationQueueItemInsertDto;
export type PostApiCommunicationInsertAutomationQueueItemMutationError =
  unknown;

export const usePostApiCommunicationInsertAutomationQueueItem = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>,
      TError,
      { data: AutomationQueueItemInsertDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationInsertAutomationQueueItem>>,
  TError,
  { data: AutomationQueueItemInsertDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationInsertAutomationQueueItemMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationGetOpenAiRequestDto = (
  ticketEmailAutoResponseRequestBody: TicketEmailAutoResponseRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTicketEmailAutoResponseDecisionDto>(
    {
      url: `/api/communication/GetOpenAiRequestDto`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: ticketEmailAutoResponseRequestBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetOpenAiRequestDtoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>,
    TError,
    { data: TicketEmailAutoResponseRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>,
  TError,
  { data: TicketEmailAutoResponseRequestBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGetOpenAiRequestDto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>,
    { data: TicketEmailAutoResponseRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationGetOpenAiRequestDto(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGetOpenAiRequestDtoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>
>;
export type PostApiCommunicationGetOpenAiRequestDtoMutationBody =
  TicketEmailAutoResponseRequestBody;
export type PostApiCommunicationGetOpenAiRequestDtoMutationError = unknown;

export const usePostApiCommunicationGetOpenAiRequestDto = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>,
      TError,
      { data: TicketEmailAutoResponseRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGetOpenAiRequestDto>>,
  TError,
  { data: TicketEmailAutoResponseRequestBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetOpenAiRequestDtoMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationTest423 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/communication/test423`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationTest423QueryKey = () => {
  return [`/api/communication/test423`] as const;
};

export const getGetApiCommunicationTest423QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationTest423>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationTest423>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationTest423QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationTest423>>
  > = ({ signal }) => getApiCommunicationTest423(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationTest423>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationTest423QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationTest423>>
>;
export type GetApiCommunicationTest423QueryError = unknown;

export function useGetApiCommunicationTest423<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest423>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest423>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTest423>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTest423>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTest423<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest423>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest423>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTest423>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTest423>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTest423<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest423>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest423>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationTest423<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest423>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest423>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationTest423QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationProcessEmailIdentityDocuments = (
  processEmailIdentityDocumentsRequestDto: ProcessEmailIdentityDocumentsRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/ProcessEmailIdentityDocuments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: processEmailIdentityDocumentsRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationProcessEmailIdentityDocumentsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>
      >,
      TError,
      { data: ProcessEmailIdentityDocumentsRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>
    >,
    TError,
    { data: ProcessEmailIdentityDocumentsRequestDto },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationProcessEmailIdentityDocuments"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>
      >,
      { data: ProcessEmailIdentityDocumentsRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationProcessEmailIdentityDocuments(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationProcessEmailIdentityDocumentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>
    >
  >;
export type PostApiCommunicationProcessEmailIdentityDocumentsMutationBody =
  ProcessEmailIdentityDocumentsRequestDto;
export type PostApiCommunicationProcessEmailIdentityDocumentsMutationError =
  unknown;

export const usePostApiCommunicationProcessEmailIdentityDocuments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>
      >,
      TError,
      { data: ProcessEmailIdentityDocumentsRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationProcessEmailIdentityDocuments>>,
  TError,
  { data: ProcessEmailIdentityDocumentsRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationProcessEmailIdentityDocumentsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationAddNCPPermission = (
  nCPPermissionDtoBody: NCPPermissionDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/addNCPPermission`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nCPPermissionDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationAddNCPPermissionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>,
    TError,
    { data: NCPPermissionDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>,
  TError,
  { data: NCPPermissionDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationAddNCPPermission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>,
    { data: NCPPermissionDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationAddNCPPermission(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationAddNCPPermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>
>;
export type PostApiCommunicationAddNCPPermissionMutationBody =
  NCPPermissionDtoBody;
export type PostApiCommunicationAddNCPPermissionMutationError = unknown;

export const usePostApiCommunicationAddNCPPermission = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>,
      TError,
      { data: NCPPermissionDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationAddNCPPermission>>,
  TError,
  { data: NCPPermissionDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationAddNCPPermissionMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationUpdateNCPPermission = (
  nCPPermissionDtoBody: NCPPermissionDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/updateNCPPermission`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nCPPermissionDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationUpdateNCPPermissionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>,
    TError,
    { data: NCPPermissionDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>,
  TError,
  { data: NCPPermissionDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationUpdateNCPPermission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>,
    { data: NCPPermissionDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationUpdateNCPPermission(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationUpdateNCPPermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>
>;
export type PostApiCommunicationUpdateNCPPermissionMutationBody =
  NCPPermissionDtoBody;
export type PostApiCommunicationUpdateNCPPermissionMutationError = unknown;

export const usePostApiCommunicationUpdateNCPPermission = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>,
      TError,
      { data: NCPPermissionDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationUpdateNCPPermission>>,
  TError,
  { data: NCPPermissionDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationUpdateNCPPermissionMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGetConstRefsNCPPermission = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/communication/getConstRefsNCPPermission`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGetConstRefsNCPPermissionQueryKey = () => {
  return [`/api/communication/getConstRefsNCPPermission`] as const;
};

export const getGetApiCommunicationGetConstRefsNCPPermissionQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetConstRefsNCPPermissionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>>
  > = ({ signal }) =>
    getApiCommunicationGetConstRefsNCPPermission(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetConstRefsNCPPermissionQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>>
  >;
export type GetApiCommunicationGetConstRefsNCPPermissionQueryError = unknown;

export function useGetApiCommunicationGetConstRefsNCPPermission<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetConstRefsNCPPermission<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetConstRefsNCPPermission<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetConstRefsNCPPermission<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetConstRefsNCPPermission>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetConstRefsNCPPermissionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationGetTemplatesNameDistinct = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/communication/getTemplatesNameDistinct`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGetTemplatesNameDistinctQueryKey = () => {
  return [`/api/communication/getTemplatesNameDistinct`] as const;
};

export const getGetApiCommunicationGetTemplatesNameDistinctQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetTemplatesNameDistinctQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>
  > = ({ signal }) =>
    getApiCommunicationGetTemplatesNameDistinct(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetTemplatesNameDistinctQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>
  >;
export type GetApiCommunicationGetTemplatesNameDistinctQueryError = unknown;

export function useGetApiCommunicationGetTemplatesNameDistinct<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetTemplatesNameDistinct<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetTemplatesNameDistinct<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetTemplatesNameDistinct<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetTemplatesNameDistinct>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetTemplatesNameDistinctQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationMessenteDLR = (
  messenteCallbackDto: MessenteCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessenteDLR200One
    | PostApiCommunicationMessenteDLR200Two
    | Blob
  >(
    {
      url: `/api/communication/messenteDLR`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: messenteCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessenteDLRMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>,
    TError,
    { data: MessenteCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>,
  TError,
  { data: MessenteCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMessenteDLR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>,
    { data: MessenteCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMessenteDLR(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMessenteDLRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>
>;
export type PostApiCommunicationMessenteDLRMutationBody = MessenteCallbackDto;
export type PostApiCommunicationMessenteDLRMutationError = unknown;

export const usePostApiCommunicationMessenteDLR = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>,
      TError,
      { data: MessenteCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessenteDLR>>,
  TError,
  { data: MessenteCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessenteDLRMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMessenteSpecialBulkSms = (
  messenteBulkSmsDto: MessenteBulkSmsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/messenteSpecialBulkSms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: messenteBulkSmsDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessenteSpecialBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>,
    TError,
    { data: MessenteBulkSmsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>,
  TError,
  { data: MessenteBulkSmsDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMessenteSpecialBulkSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>,
    { data: MessenteBulkSmsDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMessenteSpecialBulkSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMessenteSpecialBulkSmsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>
  >;
export type PostApiCommunicationMessenteSpecialBulkSmsMutationBody =
  MessenteBulkSmsDto;
export type PostApiCommunicationMessenteSpecialBulkSmsMutationError = unknown;

export const usePostApiCommunicationMessenteSpecialBulkSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>,
      TError,
      { data: MessenteBulkSmsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessenteSpecialBulkSms>>,
  TError,
  { data: MessenteBulkSmsDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessenteSpecialBulkSmsMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGmailGetLastGmailMessageId = (
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultEmailDateIdDto>(
    {
      url: `/api/communication/gmail/getLastGmailMessageId`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGmailGetLastGmailMessageIdQueryKey = (
  params?: GetApiCommunicationGmailGetLastGmailMessageIdParams
) => {
  return [
    `/api/communication/gmail/getLastGmailMessageId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationGmailGetLastGmailMessageIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGmailGetLastGmailMessageIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>>
  > = ({ signal }) =>
    getApiCommunicationGmailGetLastGmailMessageId(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGmailGetLastGmailMessageIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>>
  >;
export type GetApiCommunicationGmailGetLastGmailMessageIdQueryError = unknown;

export function useGetApiCommunicationGmailGetLastGmailMessageId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGmailGetLastGmailMessageId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGmailGetLastGmailMessageId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGmailGetLastGmailMessageId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGmailGetLastGmailMessageIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGmailGetLastGmailMessageId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGmailGetLastGmailMessageIdQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationCommMarketingUnsubscribe = (
  commMarketingUnSubscribeDto: CommMarketingUnSubscribeDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/commMarketingUnsubscribe`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: commMarketingUnSubscribeDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCommMarketingUnsubscribeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>,
    TError,
    { data: CommMarketingUnSubscribeDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>,
  TError,
  { data: CommMarketingUnSubscribeDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCommMarketingUnsubscribe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>,
    { data: CommMarketingUnSubscribeDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCommMarketingUnsubscribe(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCommMarketingUnsubscribeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>
  >;
export type PostApiCommunicationCommMarketingUnsubscribeMutationBody =
  CommMarketingUnSubscribeDto;
export type PostApiCommunicationCommMarketingUnsubscribeMutationError = unknown;

export const usePostApiCommunicationCommMarketingUnsubscribe = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>,
      TError,
      { data: CommMarketingUnSubscribeDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCommMarketingUnsubscribe>>,
  TError,
  { data: CommMarketingUnSubscribeDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCommMarketingUnsubscribeMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationOurMailServerCallback = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationOurMailServerCallback200One
    | PostApiCommunicationOurMailServerCallback200Two
    | Blob
  >(
    {
      url: `/api/communication/ourMailServerCallback`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationOurMailServerCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationOurMailServerCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationOurMailServerCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationOurMailServerCallbackMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>
  >;
export type PostApiCommunicationOurMailServerCallbackMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationOurMailServerCallbackMutationError = unknown;

export const usePostApiCommunicationOurMailServerCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationOurMailServerCallback>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationOurMailServerCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationOurMailServerCallbackS3 = (
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCommunicationOurMailServerCallbackS3200One
    | GetApiCommunicationOurMailServerCallbackS3200Two
    | Blob
  >(
    {
      url: `/api/communication/ourMailServerCallbackS3`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationOurMailServerCallbackS3QueryKey = (
  params?: GetApiCommunicationOurMailServerCallbackS3Params
) => {
  return [
    `/api/communication/ourMailServerCallbackS3`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationOurMailServerCallbackS3QueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
  >,
  TError = unknown
>(
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationOurMailServerCallbackS3QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>
  > = ({ signal }) =>
    getApiCommunicationOurMailServerCallbackS3(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationOurMailServerCallbackS3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>
>;
export type GetApiCommunicationOurMailServerCallbackS3QueryError = unknown;

export function useGetApiCommunicationOurMailServerCallbackS3<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
  >,
  TError = unknown
>(
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationOurMailServerCallbackS3<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
  >,
  TError = unknown
>(
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationOurMailServerCallbackS3<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
  >,
  TError = unknown
>(
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationOurMailServerCallbackS3<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>
  >,
  TError = unknown
>(
  params: GetApiCommunicationOurMailServerCallbackS3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOurMailServerCallbackS3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationOurMailServerCallbackS3QueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationCommContentView = (
  params: PostApiCommunicationCommContentViewParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/communication/commContentView`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCommContentViewMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCommContentView>>,
    TError,
    { params: PostApiCommunicationCommContentViewParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCommContentView>>,
  TError,
  { params: PostApiCommunicationCommContentViewParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCommContentView"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCommContentView>>,
    { params: PostApiCommunicationCommContentViewParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationCommContentView(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCommContentViewMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationCommContentView>>
>;

export type PostApiCommunicationCommContentViewMutationError = unknown;

export const usePostApiCommunicationCommContentView = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCommContentView>>,
      TError,
      { params: PostApiCommunicationCommContentViewParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCommContentView>>,
  TError,
  { params: PostApiCommunicationCommContentViewParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCommContentViewMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSetCustomerUnansweredCallStatus = (
  params: PostApiCommunicationSetCustomerUnansweredCallStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/setCustomerUnansweredCallStatus`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSetCustomerUnansweredCallStatusMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
      >,
      TError,
      { params: PostApiCommunicationSetCustomerUnansweredCallStatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
    >,
    TError,
    { params: PostApiCommunicationSetCustomerUnansweredCallStatusParams },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationSetCustomerUnansweredCallStatus"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
      >,
      { params: PostApiCommunicationSetCustomerUnansweredCallStatusParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCommunicationSetCustomerUnansweredCallStatus(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationSetCustomerUnansweredCallStatusMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
    >
  >;

export type PostApiCommunicationSetCustomerUnansweredCallStatusMutationError =
  unknown;

export const usePostApiCommunicationSetCustomerUnansweredCallStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
      >,
      TError,
      { params: PostApiCommunicationSetCustomerUnansweredCallStatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationSetCustomerUnansweredCallStatus>
  >,
  TError,
  { params: PostApiCommunicationSetCustomerUnansweredCallStatusParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSetCustomerUnansweredCallStatusMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiCommunicationLeadsbridge = (
  params: GetApiCommunicationLeadsbridgeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLeadsBridgeResponseDto>(
    { url: `/api/communication/leadsbridge`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationLeadsbridgeQueryKey = (
  params?: GetApiCommunicationLeadsbridgeParams
) => {
  return [
    `/api/communication/leadsbridge`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationLeadsbridgeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
  TError = unknown
>(
  params: GetApiCommunicationLeadsbridgeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationLeadsbridgeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>
  > = ({ signal }) =>
    getApiCommunicationLeadsbridge(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationLeadsbridgeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>
>;
export type GetApiCommunicationLeadsbridgeQueryError = unknown;

export function useGetApiCommunicationLeadsbridge<
  TData = Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
  TError = unknown
>(
  params: GetApiCommunicationLeadsbridgeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationLeadsbridge<
  TData = Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
  TError = unknown
>(
  params: GetApiCommunicationLeadsbridgeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationLeadsbridge<
  TData = Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
  TError = unknown
>(
  params: GetApiCommunicationLeadsbridgeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationLeadsbridge<
  TData = Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
  TError = unknown
>(
  params: GetApiCommunicationLeadsbridgeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLeadsbridge>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationLeadsbridgeQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationLeadsbridge = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationLeadsbridge200One
    | PostApiCommunicationLeadsbridge200Two
    | Blob
  >(
    {
      url: `/api/communication/leadsbridge`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationLeadsbridgeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationLeadsbridge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationLeadsbridge(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationLeadsbridgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>
>;
export type PostApiCommunicationLeadsbridgeMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationLeadsbridgeMutationError = unknown;

export const usePostApiCommunicationLeadsbridge = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationLeadsbridge>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationLeadsbridgeMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationCustomerUnansweredCallAssignToCam = (
  params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/customerUnansweredCallAssignToCam`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCustomerUnansweredCallAssignToCamMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
      >,
      TError,
      { params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
    >,
    TError,
    { params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams },
    TContext
  > => {
    const mutationKey = [
      "postApiCommunicationCustomerUnansweredCallAssignToCam",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
      >,
      { params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCommunicationCustomerUnansweredCallAssignToCam(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationCustomerUnansweredCallAssignToCamMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
    >
  >;

export type PostApiCommunicationCustomerUnansweredCallAssignToCamMutationError =
  unknown;

export const usePostApiCommunicationCustomerUnansweredCallAssignToCam = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
      >,
      TError,
      { params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationCustomerUnansweredCallAssignToCam>
  >,
  TError,
  { params: PostApiCommunicationCustomerUnansweredCallAssignToCamParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCustomerUnansweredCallAssignToCamMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationCreateCustomerReviewLink = (
  createReviewLinkDto: CreateReviewLinkDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/communication/createCustomerReviewLink`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createReviewLinkDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCreateCustomerReviewLinkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>,
    TError,
    { data: CreateReviewLinkDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>,
  TError,
  { data: CreateReviewLinkDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCreateCustomerReviewLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>,
    { data: CreateReviewLinkDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCreateCustomerReviewLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCreateCustomerReviewLinkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>
  >;
export type PostApiCommunicationCreateCustomerReviewLinkMutationBody =
  CreateReviewLinkDto;
export type PostApiCommunicationCreateCustomerReviewLinkMutationError = unknown;

export const usePostApiCommunicationCreateCustomerReviewLink = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>,
      TError,
      { data: CreateReviewLinkDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCreateCustomerReviewLink>>,
  TError,
  { data: CreateReviewLinkDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCreateCustomerReviewLinkMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGetCustomerReviewLinkByLoanId = (
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/communication/getCustomerReviewLinkByLoanId`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGetCustomerReviewLinkByLoanIdQueryKey = (
  params?: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams
) => {
  return [
    `/api/communication/getCustomerReviewLinkByLoanId`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationGetCustomerReviewLinkByLoanIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetCustomerReviewLinkByLoanIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>>
  > = ({ signal }) =>
    getApiCommunicationGetCustomerReviewLinkByLoanId(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetCustomerReviewLinkByLoanIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>>
  >;
export type GetApiCommunicationGetCustomerReviewLinkByLoanIdQueryError =
  unknown;

export function useGetApiCommunicationGetCustomerReviewLinkByLoanId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetCustomerReviewLinkByLoanId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetCustomerReviewLinkByLoanId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetCustomerReviewLinkByLoanId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerReviewLinkByLoanIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerReviewLinkByLoanId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetCustomerReviewLinkByLoanIdQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationRunReviewFeedBacksReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/runReviewFeedBacksReport`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationRunReviewFeedBacksReportQueryKey = () => {
  return [`/api/communication/runReviewFeedBacksReport`] as const;
};

export const getGetApiCommunicationRunReviewFeedBacksReportQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationRunReviewFeedBacksReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>
  > = ({ signal }) =>
    getApiCommunicationRunReviewFeedBacksReport(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationRunReviewFeedBacksReportQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>
  >;
export type GetApiCommunicationRunReviewFeedBacksReportQueryError = unknown;

export function useGetApiCommunicationRunReviewFeedBacksReport<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationRunReviewFeedBacksReport<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationRunReviewFeedBacksReport<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationRunReviewFeedBacksReport<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationRunReviewFeedBacksReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationRunReviewFeedBacksReportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationSupportEmailAttachmentCheck = (
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/supportEmail/attachment/check`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationSupportEmailAttachmentCheckQueryKey = (
  params?: GetApiCommunicationSupportEmailAttachmentCheckParams
) => {
  return [
    `/api/communication/supportEmail/attachment/check`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationSupportEmailAttachmentCheckQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationSupportEmailAttachmentCheckQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>>
  > = ({ signal }) =>
    getApiCommunicationSupportEmailAttachmentCheck(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationSupportEmailAttachmentCheckQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>>
  >;
export type GetApiCommunicationSupportEmailAttachmentCheckQueryError = unknown;

export function useGetApiCommunicationSupportEmailAttachmentCheck<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailAttachmentCheck<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailAttachmentCheck<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationSupportEmailAttachmentCheck<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailAttachmentCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailAttachmentCheck>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationSupportEmailAttachmentCheckQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationSupportEmailReply = (
  outboundTicketDto: NonReadonly<OutboundTicketDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/supportEmail/reply`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: outboundTicketDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSupportEmailReplyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>,
    TError,
    { data: NonReadonly<OutboundTicketDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>,
  TError,
  { data: NonReadonly<OutboundTicketDto> },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSupportEmailReply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>,
    { data: NonReadonly<OutboundTicketDto> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSupportEmailReply(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSupportEmailReplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>
>;
export type PostApiCommunicationSupportEmailReplyMutationBody =
  NonReadonly<OutboundTicketDto>;
export type PostApiCommunicationSupportEmailReplyMutationError = unknown;

export const usePostApiCommunicationSupportEmailReply = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>,
      TError,
      { data: NonReadonly<OutboundTicketDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailReply>>,
  TError,
  { data: NonReadonly<OutboundTicketDto> },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSupportEmailReplyMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSupportEmailPostThreadId = (
  postNewThreadInfoDto: PostNewThreadInfoDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/supportEmail/postThreadId`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postNewThreadInfoDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSupportEmailPostThreadIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>,
    TError,
    { data: PostNewThreadInfoDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>,
  TError,
  { data: PostNewThreadInfoDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSupportEmailPostThreadId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>,
    { data: PostNewThreadInfoDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSupportEmailPostThreadId(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSupportEmailPostThreadIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>
  >;
export type PostApiCommunicationSupportEmailPostThreadIdMutationBody =
  PostNewThreadInfoDto;
export type PostApiCommunicationSupportEmailPostThreadIdMutationError = unknown;

export const usePostApiCommunicationSupportEmailPostThreadId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>,
      TError,
      { data: PostNewThreadInfoDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailPostThreadId>>,
  TError,
  { data: PostNewThreadInfoDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSupportEmailPostThreadIdMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSupportEmailGetCustomerTickets = (
  params: PostApiCommunicationSupportEmailGetCustomerTicketsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTicketEmailDto>(
    {
      url: `/api/communication/supportEmail/getCustomerTickets`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSupportEmailGetCustomerTicketsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
      >,
      TError,
      { params: PostApiCommunicationSupportEmailGetCustomerTicketsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
    >,
    TError,
    { params: PostApiCommunicationSupportEmailGetCustomerTicketsParams },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationSupportEmailGetCustomerTickets"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
      >,
      { params: PostApiCommunicationSupportEmailGetCustomerTicketsParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCommunicationSupportEmailGetCustomerTickets(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationSupportEmailGetCustomerTicketsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
    >
  >;

export type PostApiCommunicationSupportEmailGetCustomerTicketsMutationError =
  unknown;

export const usePostApiCommunicationSupportEmailGetCustomerTickets = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
      >,
      TError,
      { params: PostApiCommunicationSupportEmailGetCustomerTicketsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationSupportEmailGetCustomerTickets>
  >,
  TError,
  { params: PostApiCommunicationSupportEmailGetCustomerTicketsParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSupportEmailGetCustomerTicketsMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiCommunicationSupportEmailGetAllAttachments = (
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListS3DocumentDto>(
    {
      url: `/api/communication/supportEmail/getAllAttachments`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationSupportEmailGetAllAttachmentsQueryKey = (
  params?: GetApiCommunicationSupportEmailGetAllAttachmentsParams
) => {
  return [
    `/api/communication/supportEmail/getAllAttachments`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationSupportEmailGetAllAttachmentsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationSupportEmailGetAllAttachmentsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>>
  > = ({ signal }) =>
    getApiCommunicationSupportEmailGetAllAttachments(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationSupportEmailGetAllAttachmentsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>>
  >;
export type GetApiCommunicationSupportEmailGetAllAttachmentsQueryError =
  unknown;

export function useGetApiCommunicationSupportEmailGetAllAttachments<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailGetAllAttachments<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailGetAllAttachments<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationSupportEmailGetAllAttachments<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAllAttachmentsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAllAttachments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationSupportEmailGetAllAttachmentsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationSupportEmailGetAttachment = (
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultS3DocumentDto>(
    {
      url: `/api/communication/supportEmail/getAttachment`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationSupportEmailGetAttachmentQueryKey = (
  params?: GetApiCommunicationSupportEmailGetAttachmentParams
) => {
  return [
    `/api/communication/supportEmail/getAttachment`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationSupportEmailGetAttachmentQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationSupportEmailGetAttachmentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>>
  > = ({ signal }) =>
    getApiCommunicationSupportEmailGetAttachment(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationSupportEmailGetAttachmentQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>>
  >;
export type GetApiCommunicationSupportEmailGetAttachmentQueryError = unknown;

export function useGetApiCommunicationSupportEmailGetAttachment<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailGetAttachment<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSupportEmailGetAttachment<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationSupportEmailGetAttachment<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
  >,
  TError = unknown
>(
  params: GetApiCommunicationSupportEmailGetAttachmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationSupportEmailGetAttachment>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationSupportEmailGetAttachmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationGenerateShortLink = (
  params: PostApiCommunicationGenerateShortLinkParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    {
      url: `/api/communication/generateShortLink`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGenerateShortLinkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>,
    TError,
    { params: PostApiCommunicationGenerateShortLinkParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>,
  TError,
  { params: PostApiCommunicationGenerateShortLinkParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGenerateShortLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>,
    { params: PostApiCommunicationGenerateShortLinkParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationGenerateShortLink(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGenerateShortLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>
>;

export type PostApiCommunicationGenerateShortLinkMutationError = unknown;

export const usePostApiCommunicationGenerateShortLink = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>,
      TError,
      { params: PostApiCommunicationGenerateShortLinkParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGenerateShortLink>>,
  TError,
  { params: PostApiCommunicationGenerateShortLinkParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGenerateShortLinkMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSupportEmailCamOpenTickets = (
  getCamTicketsRequest: GetCamTicketsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PagedSearchResultCommTicketDto>(
    {
      url: `/api/communication/supportEmail/camOpenTickets`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getCamTicketsRequest,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSupportEmailCamOpenTicketsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>
      >,
      TError,
      { data: GetCamTicketsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>>,
    TError,
    { data: GetCamTicketsRequest },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationSupportEmailCamOpenTickets"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>
      >,
      { data: GetCamTicketsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationSupportEmailCamOpenTickets(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationSupportEmailCamOpenTicketsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>>
  >;
export type PostApiCommunicationSupportEmailCamOpenTicketsMutationBody =
  GetCamTicketsRequest;
export type PostApiCommunicationSupportEmailCamOpenTicketsMutationError =
  unknown;

export const usePostApiCommunicationSupportEmailCamOpenTickets = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>
      >,
      TError,
      { data: GetCamTicketsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSupportEmailCamOpenTickets>>,
  TError,
  { data: GetCamTicketsRequest },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSupportEmailCamOpenTicketsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSupportEmailCamUnissuedTickets = (
  getUnissuedTicketsRequest: GetUnissuedTicketsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PagedSearchResultCommTicketDto>(
    {
      url: `/api/communication/supportEmail/camUnissuedTickets`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getUnissuedTicketsRequest,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSupportEmailCamUnissuedTicketsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
      >,
      TError,
      { data: GetUnissuedTicketsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
    >,
    TError,
    { data: GetUnissuedTicketsRequest },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationSupportEmailCamUnissuedTickets"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
      >,
      { data: GetUnissuedTicketsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationSupportEmailCamUnissuedTickets(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationSupportEmailCamUnissuedTicketsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
    >
  >;
export type PostApiCommunicationSupportEmailCamUnissuedTicketsMutationBody =
  GetUnissuedTicketsRequest;
export type PostApiCommunicationSupportEmailCamUnissuedTicketsMutationError =
  unknown;

export const usePostApiCommunicationSupportEmailCamUnissuedTickets = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
      >,
      TError,
      { data: GetUnissuedTicketsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationSupportEmailCamUnissuedTickets>
  >,
  TError,
  { data: GetUnissuedTicketsRequest },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSupportEmailCamUnissuedTicketsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationGetAllSegments = (
  params: PostApiCommunicationGetAllSegmentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMarketingSegmentDto>(
    {
      url: `/api/communication/getAllSegments`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetAllSegmentsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>,
    TError,
    { params: PostApiCommunicationGetAllSegmentsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>,
  TError,
  { params: PostApiCommunicationGetAllSegmentsParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGetAllSegments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>,
    { params: PostApiCommunicationGetAllSegmentsParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationGetAllSegments(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGetAllSegmentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>
>;

export type PostApiCommunicationGetAllSegmentsMutationError = unknown;

export const usePostApiCommunicationGetAllSegments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>,
      TError,
      { params: PostApiCommunicationGetAllSegmentsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGetAllSegments>>,
  TError,
  { params: PostApiCommunicationGetAllSegmentsParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetAllSegmentsMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGetSegmentById = (
  params: GetApiCommunicationGetSegmentByIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMarketingSegmentDto>(
    { url: `/api/communication/getSegmentById`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationGetSegmentByIdQueryKey = (
  params?: GetApiCommunicationGetSegmentByIdParams
) => {
  return [
    `/api/communication/getSegmentById`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationGetSegmentByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
  TError = unknown
>(
  params: GetApiCommunicationGetSegmentByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetSegmentByIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>
  > = ({ signal }) =>
    getApiCommunicationGetSegmentById(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetSegmentByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>
>;
export type GetApiCommunicationGetSegmentByIdQueryError = unknown;

export function useGetApiCommunicationGetSegmentById<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
  TError = unknown
>(
  params: GetApiCommunicationGetSegmentByIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetSegmentById<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
  TError = unknown
>(
  params: GetApiCommunicationGetSegmentByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetSegmentById<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
  TError = unknown
>(
  params: GetApiCommunicationGetSegmentByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetSegmentById<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
  TError = unknown
>(
  params: GetApiCommunicationGetSegmentByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetSegmentById>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationGetSegmentByIdQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationDeleteSegment = (
  params: GetApiCommunicationDeleteSegmentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/communication/deleteSegment`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationDeleteSegmentQueryKey = (
  params?: GetApiCommunicationDeleteSegmentParams
) => {
  return [
    `/api/communication/deleteSegment`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationDeleteSegmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
  TError = unknown
>(
  params: GetApiCommunicationDeleteSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationDeleteSegmentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>
  > = ({ signal }) =>
    getApiCommunicationDeleteSegment(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationDeleteSegmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>
>;
export type GetApiCommunicationDeleteSegmentQueryError = unknown;

export function useGetApiCommunicationDeleteSegment<
  TData = Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
  TError = unknown
>(
  params: GetApiCommunicationDeleteSegmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteSegment<
  TData = Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
  TError = unknown
>(
  params: GetApiCommunicationDeleteSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteSegment<
  TData = Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
  TError = unknown
>(
  params: GetApiCommunicationDeleteSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationDeleteSegment<
  TData = Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
  TError = unknown
>(
  params: GetApiCommunicationDeleteSegmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteSegment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationDeleteSegmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationInsertSegment = (
  marketingSegmentDto: MarketingSegmentDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/insertSegment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: marketingSegmentDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationInsertSegmentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>,
    TError,
    { data: MarketingSegmentDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>,
  TError,
  { data: MarketingSegmentDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationInsertSegment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>,
    { data: MarketingSegmentDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationInsertSegment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationInsertSegmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>
>;
export type PostApiCommunicationInsertSegmentMutationBody = MarketingSegmentDto;
export type PostApiCommunicationInsertSegmentMutationError = unknown;

export const usePostApiCommunicationInsertSegment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>,
      TError,
      { data: MarketingSegmentDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationInsertSegment>>,
  TError,
  { data: MarketingSegmentDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationInsertSegmentMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationGetAllMarketingScheduled = (
  params: PostApiCommunicationGetAllMarketingScheduledParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMarketingScheduledDto>(
    {
      url: `/api/communication/getAllMarketingScheduled`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetAllMarketingScheduledMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>,
    TError,
    { params: PostApiCommunicationGetAllMarketingScheduledParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>,
  TError,
  { params: PostApiCommunicationGetAllMarketingScheduledParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGetAllMarketingScheduled"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>,
    { params: PostApiCommunicationGetAllMarketingScheduledParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationGetAllMarketingScheduled(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGetAllMarketingScheduledMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>
  >;

export type PostApiCommunicationGetAllMarketingScheduledMutationError = unknown;

export const usePostApiCommunicationGetAllMarketingScheduled = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>,
      TError,
      { params: PostApiCommunicationGetAllMarketingScheduledParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGetAllMarketingScheduled>>,
  TError,
  { params: PostApiCommunicationGetAllMarketingScheduledParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetAllMarketingScheduledMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGetMarketingScheduledById = (
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMarketingScheduledDto>(
    {
      url: `/api/communication/getMarketingScheduledById`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGetMarketingScheduledByIdQueryKey = (
  params?: GetApiCommunicationGetMarketingScheduledByIdParams
) => {
  return [
    `/api/communication/getMarketingScheduledById`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationGetMarketingScheduledByIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetMarketingScheduledByIdQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetMarketingScheduledById>>
  > = ({ signal }) =>
    getApiCommunicationGetMarketingScheduledById(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetMarketingScheduledById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetMarketingScheduledByIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGetMarketingScheduledById>>
  >;
export type GetApiCommunicationGetMarketingScheduledByIdQueryError = unknown;

export function useGetApiCommunicationGetMarketingScheduledById<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetMarketingScheduledById<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetMarketingScheduledById<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetMarketingScheduledById<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetMarketingScheduledByIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetMarketingScheduledById>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetMarketingScheduledByIdQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationDeleteMarketingScheduled = (
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/deleteMarketingScheduled`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationDeleteMarketingScheduledQueryKey = (
  params?: GetApiCommunicationDeleteMarketingScheduledParams
) => {
  return [
    `/api/communication/deleteMarketingScheduled`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationDeleteMarketingScheduledQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
  >,
  TError = unknown
>(
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationDeleteMarketingScheduledQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>
  > = ({ signal }) =>
    getApiCommunicationDeleteMarketingScheduled(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationDeleteMarketingScheduledQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>
  >;
export type GetApiCommunicationDeleteMarketingScheduledQueryError = unknown;

export function useGetApiCommunicationDeleteMarketingScheduled<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
  >,
  TError = unknown
>(
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteMarketingScheduled<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
  >,
  TError = unknown
>(
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteMarketingScheduled<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
  >,
  TError = unknown
>(
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationDeleteMarketingScheduled<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>
  >,
  TError = unknown
>(
  params: GetApiCommunicationDeleteMarketingScheduledParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDeleteMarketingScheduled>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationDeleteMarketingScheduledQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationInsertMarketingScheduled = (
  marketingScheduledDto: MarketingScheduledDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/insertMarketingScheduled`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: marketingScheduledDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationInsertMarketingScheduledMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>,
    TError,
    { data: MarketingScheduledDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>,
  TError,
  { data: MarketingScheduledDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationInsertMarketingScheduled"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>,
    { data: MarketingScheduledDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationInsertMarketingScheduled(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationInsertMarketingScheduledMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>
  >;
export type PostApiCommunicationInsertMarketingScheduledMutationBody =
  MarketingScheduledDto;
export type PostApiCommunicationInsertMarketingScheduledMutationError = unknown;

export const usePostApiCommunicationInsertMarketingScheduled = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>,
      TError,
      { data: MarketingScheduledDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationInsertMarketingScheduled>>,
  TError,
  { data: MarketingScheduledDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationInsertMarketingScheduledMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationDiscordWebHookSendMsg = (
  discordWebHookMsgDto: DiscordWebHookMsgDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/discordWebHookSendMsg`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: discordWebHookMsgDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationDiscordWebHookSendMsgMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>,
    TError,
    { data: DiscordWebHookMsgDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>,
  TError,
  { data: DiscordWebHookMsgDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationDiscordWebHookSendMsg"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>,
    { data: DiscordWebHookMsgDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationDiscordWebHookSendMsg(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationDiscordWebHookSendMsgMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>
  >;
export type PostApiCommunicationDiscordWebHookSendMsgMutationBody =
  DiscordWebHookMsgDto;
export type PostApiCommunicationDiscordWebHookSendMsgMutationError = unknown;

export const usePostApiCommunicationDiscordWebHookSendMsg = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>,
      TError,
      { data: DiscordWebHookMsgDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationDiscordWebHookSendMsg>>,
  TError,
  { data: DiscordWebHookMsgDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationDiscordWebHookSendMsgMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationGetIvrIntegrationMapByCallType = (
  callTypeDto: CallTypeDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIvrIntegrationDto>(
    {
      url: `/api/communication/getIvrIntegrationMapByCallType`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: callTypeDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetIvrIntegrationMapByCallTypeMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
      >,
      TError,
      { data: CallTypeDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
    >,
    TError,
    { data: CallTypeDto },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationGetIvrIntegrationMapByCallType"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
      >,
      { data: CallTypeDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationGetIvrIntegrationMapByCallType(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationGetIvrIntegrationMapByCallTypeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
    >
  >;
export type PostApiCommunicationGetIvrIntegrationMapByCallTypeMutationBody =
  CallTypeDto;
export type PostApiCommunicationGetIvrIntegrationMapByCallTypeMutationError =
  unknown;

export const usePostApiCommunicationGetIvrIntegrationMapByCallType = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
      >,
      TError,
      { data: CallTypeDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationGetIvrIntegrationMapByCallType>
  >,
  TError,
  { data: CallTypeDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetIvrIntegrationMapByCallTypeMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiCommunicationEmailMoveBucketToBucket = (
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/emailMoveBucketToBucket`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationEmailMoveBucketToBucketQueryKey = (
  params?: GetApiCommunicationEmailMoveBucketToBucketParams
) => {
  return [
    `/api/communication/emailMoveBucketToBucket`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationEmailMoveBucketToBucketQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
  >,
  TError = unknown
>(
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationEmailMoveBucketToBucketQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>
  > = ({ signal }) =>
    getApiCommunicationEmailMoveBucketToBucket(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationEmailMoveBucketToBucketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>
>;
export type GetApiCommunicationEmailMoveBucketToBucketQueryError = unknown;

export function useGetApiCommunicationEmailMoveBucketToBucket<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
  >,
  TError = unknown
>(
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationEmailMoveBucketToBucket<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
  >,
  TError = unknown
>(
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationEmailMoveBucketToBucket<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
  >,
  TError = unknown
>(
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationEmailMoveBucketToBucket<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>
  >,
  TError = unknown
>(
  params: GetApiCommunicationEmailMoveBucketToBucketParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationEmailMoveBucketToBucket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationEmailMoveBucketToBucketQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/runAgainVoiscopeCallReportErrorsByIds`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationRunAgainVoiscopeCallReportErrorsByIdsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds
        >
      >,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds
      >
    >,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  > => {
    const mutationKey = [
      "postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds
        >
      >,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationRunAgainVoiscopeCallReportErrorsByIdsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds
      >
    >
  >;
export type PostApiCommunicationRunAgainVoiscopeCallReportErrorsByIdsMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiCommunicationRunAgainVoiscopeCallReportErrorsByIdsMutationError =
  unknown;

export const usePostApiCommunicationRunAgainVoiscopeCallReportErrorsByIds = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds
        >
      >,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationRunAgainVoiscopeCallReportErrorsByIds>
  >,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationRunAgainVoiscopeCallReportErrorsByIdsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationSmsExcludeAdd = (
  smsExcludeAddDto: SmsExcludeAddDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/smsExcludeAdd`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smsExcludeAddDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSmsExcludeAddMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>,
    TError,
    { data: SmsExcludeAddDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>,
  TError,
  { data: SmsExcludeAddDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSmsExcludeAdd"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>,
    { data: SmsExcludeAddDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSmsExcludeAdd(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSmsExcludeAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>
>;
export type PostApiCommunicationSmsExcludeAddMutationBody = SmsExcludeAddDto;
export type PostApiCommunicationSmsExcludeAddMutationError = unknown;

export const usePostApiCommunicationSmsExcludeAdd = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>,
      TError,
      { data: SmsExcludeAddDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeAdd>>,
  TError,
  { data: SmsExcludeAddDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSmsExcludeAddMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSmsExcludeRemove = (
  smsExcludeRemoveDto: SmsExcludeRemoveDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/smsExcludeRemove`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smsExcludeRemoveDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSmsExcludeRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>,
    TError,
    { data: SmsExcludeRemoveDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>,
  TError,
  { data: SmsExcludeRemoveDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSmsExcludeRemove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>,
    { data: SmsExcludeRemoveDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSmsExcludeRemove(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSmsExcludeRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>
>;
export type PostApiCommunicationSmsExcludeRemoveMutationBody =
  SmsExcludeRemoveDto;
export type PostApiCommunicationSmsExcludeRemoveMutationError = unknown;

export const usePostApiCommunicationSmsExcludeRemove = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>,
      TError,
      { data: SmsExcludeRemoveDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSmsExcludeRemove>>,
  TError,
  { data: SmsExcludeRemoveDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSmsExcludeRemoveMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationReloadIVRIntegrationCache = (
  params: PostApiCommunicationReloadIVRIntegrationCacheParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/ReloadIVRIntegrationCache`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationReloadIVRIntegrationCacheMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>,
    TError,
    { params: PostApiCommunicationReloadIVRIntegrationCacheParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>,
  TError,
  { params: PostApiCommunicationReloadIVRIntegrationCacheParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationReloadIVRIntegrationCache"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>,
    { params: PostApiCommunicationReloadIVRIntegrationCacheParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationReloadIVRIntegrationCache(
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationReloadIVRIntegrationCacheMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>
  >;

export type PostApiCommunicationReloadIVRIntegrationCacheMutationError =
  unknown;

export const usePostApiCommunicationReloadIVRIntegrationCache = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>,
      TError,
      { params: PostApiCommunicationReloadIVRIntegrationCacheParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationReloadIVRIntegrationCache>>,
  TError,
  { params: PostApiCommunicationReloadIVRIntegrationCacheParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationReloadIVRIntegrationCacheMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationTemplate399Test = (
  params: PostApiCommunicationTemplate399TestParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/template399Test`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationTemplate399TestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>,
    TError,
    { params: PostApiCommunicationTemplate399TestParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>,
  TError,
  { params: PostApiCommunicationTemplate399TestParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationTemplate399Test"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>,
    { params: PostApiCommunicationTemplate399TestParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationTemplate399Test(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTemplate399TestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>
>;

export type PostApiCommunicationTemplate399TestMutationError = unknown;

export const usePostApiCommunicationTemplate399Test = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>,
      TError,
      { params: PostApiCommunicationTemplate399TestParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTemplate399Test>>,
  TError,
  { params: PostApiCommunicationTemplate399TestParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTemplate399TestMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendSmsViaVoiscopeCall = (
  welcomeAndSalesCallDto: WelcomeAndSalesCallDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/sendSmsViaVoiscopeCall`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: welcomeAndSalesCallDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendSmsViaVoiscopeCallMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>,
    TError,
    { data: WelcomeAndSalesCallDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>,
  TError,
  { data: WelcomeAndSalesCallDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendSmsViaVoiscopeCall"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>,
    { data: WelcomeAndSalesCallDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendSmsViaVoiscopeCall(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendSmsViaVoiscopeCallMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>
  >;
export type PostApiCommunicationSendSmsViaVoiscopeCallMutationBody =
  WelcomeAndSalesCallDto;
export type PostApiCommunicationSendSmsViaVoiscopeCallMutationError = unknown;

export const usePostApiCommunicationSendSmsViaVoiscopeCall = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>,
      TError,
      { data: WelcomeAndSalesCallDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendSmsViaVoiscopeCall>>,
  TError,
  { data: WelcomeAndSalesCallDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendSmsViaVoiscopeCallMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationAutomationIVR = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/communication/automation/IVR`, method: "POST", signal },
    options
  );
};

export const getPostApiCommunicationAutomationIVRMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCommunicationAutomationIVR"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>,
    void
  > = () => {
    return postApiCommunicationAutomationIVR(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationAutomationIVRMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>
>;

export type PostApiCommunicationAutomationIVRMutationError = unknown;

export const usePostApiCommunicationAutomationIVR = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationAutomationIVR>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCommunicationAutomationIVRMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationTestAutomationIVRDelete = (
  deleteAutomationIVRDto: DeleteAutomationIVRDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/testAutomationIVRDelete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteAutomationIVRDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationTestAutomationIVRDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>,
    TError,
    { data: DeleteAutomationIVRDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>,
  TError,
  { data: DeleteAutomationIVRDto[] },
  TContext
> => {
  const mutationKey = ["postApiCommunicationTestAutomationIVRDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>,
    { data: DeleteAutomationIVRDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationTestAutomationIVRDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTestAutomationIVRDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>
  >;
export type PostApiCommunicationTestAutomationIVRDeleteMutationBody =
  DeleteAutomationIVRDto[];
export type PostApiCommunicationTestAutomationIVRDeleteMutationError = unknown;

export const usePostApiCommunicationTestAutomationIVRDelete = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>,
      TError,
      { data: DeleteAutomationIVRDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTestAutomationIVRDelete>>,
  TError,
  { data: DeleteAutomationIVRDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTestAutomationIVRDeleteMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationIvrCallCheck = (
  iVRCallCheckDto: IVRCallCheckDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryStringBoolean>(
    {
      url: `/api/communication/ivrCallCheck`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: iVRCallCheckDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationIvrCallCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>,
    TError,
    { data: IVRCallCheckDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>,
  TError,
  { data: IVRCallCheckDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationIvrCallCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>,
    { data: IVRCallCheckDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationIvrCallCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationIvrCallCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>
>;
export type PostApiCommunicationIvrCallCheckMutationBody = IVRCallCheckDto;
export type PostApiCommunicationIvrCallCheckMutationError = unknown;

export const usePostApiCommunicationIvrCallCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>,
      TError,
      { data: IVRCallCheckDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationIvrCallCheck>>,
  TError,
  { data: IVRCallCheckDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationIvrCallCheckMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationRefundcalls = (
  customerRefundCallsRequestDto: CustomerRefundCallsRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/Refundcalls`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerRefundCallsRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationRefundcallsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>,
    TError,
    { data: CustomerRefundCallsRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>,
  TError,
  { data: CustomerRefundCallsRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationRefundcalls"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>,
    { data: CustomerRefundCallsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationRefundcalls(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationRefundcallsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>
>;
export type PostApiCommunicationRefundcallsMutationBody =
  CustomerRefundCallsRequestDto;
export type PostApiCommunicationRefundcallsMutationError = unknown;

export const usePostApiCommunicationRefundcalls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>,
      TError,
      { data: CustomerRefundCallsRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationRefundcalls>>,
  TError,
  { data: CustomerRefundCallsRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationRefundcallsMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/communication/test`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationTestQueryKey = () => {
  return [`/api/communication/test`] as const;
};

export const getGetApiCommunicationTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationTest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationTest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationTestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationTest>>
  > = ({ signal }) => getApiCommunicationTest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationTest>>
>;
export type GetApiCommunicationTestQueryError = unknown;

export function useGetApiCommunicationTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationOcrTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/communication/OcrTest`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationOcrTestQueryKey = () => {
  return [`/api/communication/OcrTest`] as const;
};

export const getGetApiCommunicationOcrTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationOcrTestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationOcrTest>>
  > = ({ signal }) => getApiCommunicationOcrTest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationOcrTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationOcrTest>>
>;
export type GetApiCommunicationOcrTestQueryError = unknown;

export function useGetApiCommunicationOcrTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationOcrTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationOcrTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationOcrTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationOcrTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationOcrTest<
  TData = Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationOcrTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationOcrTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationSendGmailSyncMails = (
  insertIncomingEmailResponse: InsertIncomingEmailResponse[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/SendGmailSyncMails`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: insertIncomingEmailResponse,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendGmailSyncMailsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>,
    TError,
    { data: InsertIncomingEmailResponse[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>,
  TError,
  { data: InsertIncomingEmailResponse[] },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendGmailSyncMails"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>,
    { data: InsertIncomingEmailResponse[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendGmailSyncMails(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendGmailSyncMailsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>
>;
export type PostApiCommunicationSendGmailSyncMailsMutationBody =
  InsertIncomingEmailResponse[];
export type PostApiCommunicationSendGmailSyncMailsMutationError = unknown;

export const usePostApiCommunicationSendGmailSyncMails = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>,
      TError,
      { data: InsertIncomingEmailResponse[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendGmailSyncMails>>,
  TError,
  { data: InsertIncomingEmailResponse[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendGmailSyncMailsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationTwiliocallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationTwiliocallback200One
    | PostApiCommunicationTwiliocallback200Two
    | Blob
  >(
    { url: `/api/communication/twiliocallback`, method: "POST", signal },
    options
  );
};

export const getPostApiCommunicationTwiliocallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCommunicationTwiliocallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>,
    void
  > = () => {
    return postApiCommunicationTwiliocallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTwiliocallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>
>;

export type PostApiCommunicationTwiliocallbackMutationError = unknown;

export const usePostApiCommunicationTwiliocallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTwiliocallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTwiliocallbackMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationGenerate = (
  notifyDto: NotifyDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationGenerate200One
    | PostApiCommunicationGenerate200Two
    | Blob
  >(
    {
      url: `/api/communication/generate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: notifyDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGenerateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGenerate>>,
    TError,
    { data: NotifyDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGenerate>>,
  TError,
  { data: NotifyDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGenerate>>,
    { data: NotifyDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationGenerate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationGenerate>>
>;
export type PostApiCommunicationGenerateMutationBody = NotifyDto;
export type PostApiCommunicationGenerateMutationError = unknown;

export const usePostApiCommunicationGenerate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGenerate>>,
      TError,
      { data: NotifyDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGenerate>>,
  TError,
  { data: NotifyDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGenerateMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationLetter = (
  bulkSendLetterDto: BulkSendLetterDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/letter`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkSendLetterDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationLetterMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationLetter>>,
    TError,
    { data: BulkSendLetterDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationLetter>>,
  TError,
  { data: BulkSendLetterDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationLetter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationLetter>>,
    { data: BulkSendLetterDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationLetter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationLetterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationLetter>>
>;
export type PostApiCommunicationLetterMutationBody = BulkSendLetterDto;
export type PostApiCommunicationLetterMutationError = unknown;

export const usePostApiCommunicationLetter = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationLetter>>,
      TError,
      { data: BulkSendLetterDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationLetter>>,
  TError,
  { data: BulkSendLetterDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationLetterMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMessagereceiveNotifications = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessagereceiveNotifications200One
    | PostApiCommunicationMessagereceiveNotifications200Two
    | Blob
  >(
    {
      url: `/api/communication/messagereceive/notifications`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessagereceiveNotificationsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationMessagereceiveNotifications>
      >,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveNotifications>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationMessagereceiveNotifications"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationMessagereceiveNotifications>
      >,
      { data: BankScraperNotifySmsValueBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationMessagereceiveNotifications(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationMessagereceiveNotificationsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveNotifications>>
  >;
export type PostApiCommunicationMessagereceiveNotificationsMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationMessagereceiveNotificationsMutationError =
  unknown;

export const usePostApiCommunicationMessagereceiveNotifications = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationMessagereceiveNotifications>
      >,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveNotifications>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessagereceiveNotificationsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMessagereceiveBulkemailnotifications = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessagereceiveBulkemailnotifications200One
    | PostApiCommunicationMessagereceiveBulkemailnotifications200Two
    | Blob
  >(
    {
      url: `/api/communication/messagereceive/bulkemailnotifications`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessagereceiveBulkemailnotificationsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCommunicationMessagereceiveBulkemailnotifications
        >
      >,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiCommunicationMessagereceiveBulkemailnotifications
      >
    >,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  > => {
    const mutationKey = [
      "postApiCommunicationMessagereceiveBulkemailnotifications",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiCommunicationMessagereceiveBulkemailnotifications
        >
      >,
      { data: BankScraperNotifySmsValueBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationMessagereceiveBulkemailnotifications(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationMessagereceiveBulkemailnotificationsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiCommunicationMessagereceiveBulkemailnotifications
      >
    >
  >;
export type PostApiCommunicationMessagereceiveBulkemailnotificationsMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationMessagereceiveBulkemailnotificationsMutationError =
  unknown;

export const usePostApiCommunicationMessagereceiveBulkemailnotifications = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCommunicationMessagereceiveBulkemailnotifications
        >
      >,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationMessagereceiveBulkemailnotifications>
  >,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessagereceiveBulkemailnotificationsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationNotifymismatchCustomerId = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/notifymismatch/${customerId}`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCommunicationNotifymismatchCustomerIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>,
    TError,
    { customerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>,
  TError,
  { customerId: number },
  TContext
> => {
  const mutationKey = ["postApiCommunicationNotifymismatchCustomerId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>,
    { customerId: number }
  > = (props) => {
    const { customerId } = props ?? {};

    return postApiCommunicationNotifymismatchCustomerId(
      customerId,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationNotifymismatchCustomerIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>
  >;

export type PostApiCommunicationNotifymismatchCustomerIdMutationError = unknown;

export const usePostApiCommunicationNotifymismatchCustomerId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>,
      TError,
      { customerId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationNotifymismatchCustomerId>>,
  TError,
  { customerId: number },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationNotifymismatchCustomerIdMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationSmsSmsIdMarkasread = (
  smsId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCommunicationSmsSmsIdMarkasread200One
    | GetApiCommunicationSmsSmsIdMarkasread200Two
    | Blob
  >(
    {
      url: `/api/communication/sms/${smsId}/markasread`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationSmsSmsIdMarkasreadQueryKey = (
  smsId: number
) => {
  return [`/api/communication/sms/${smsId}/markasread`] as const;
};

export const getGetApiCommunicationSmsSmsIdMarkasreadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
  TError = unknown
>(
  smsId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationSmsSmsIdMarkasreadQueryKey(smsId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>
  > = ({ signal }) =>
    getApiCommunicationSmsSmsIdMarkasread(smsId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!smsId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationSmsSmsIdMarkasreadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>
>;
export type GetApiCommunicationSmsSmsIdMarkasreadQueryError = unknown;

export function useGetApiCommunicationSmsSmsIdMarkasread<
  TData = Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
  TError = unknown
>(
  smsId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSmsSmsIdMarkasread<
  TData = Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
  TError = unknown
>(
  smsId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationSmsSmsIdMarkasread<
  TData = Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
  TError = unknown
>(
  smsId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationSmsSmsIdMarkasread<
  TData = Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
  TError = unknown
>(
  smsId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationSmsSmsIdMarkasread>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationSmsSmsIdMarkasreadQueryOptions(
    smsId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationMessagereceiveBounce = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessagereceiveBounce200One
    | PostApiCommunicationMessagereceiveBounce200Two
    | Blob
  >(
    {
      url: `/api/communication/messagereceive/bounce`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessagereceiveBounceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMessagereceiveBounce"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMessagereceiveBounce(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMessagereceiveBounceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>
  >;
export type PostApiCommunicationMessagereceiveBounceMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationMessagereceiveBounceMutationError = unknown;

export const usePostApiCommunicationMessagereceiveBounce = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveBounce>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessagereceiveBounceMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMessagereceiveComplaint = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessagereceiveComplaint200One
    | PostApiCommunicationMessagereceiveComplaint200Two
    | Blob
  >(
    {
      url: `/api/communication/messagereceive/complaint`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessagereceiveComplaintMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMessagereceiveComplaint"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMessagereceiveComplaint(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMessagereceiveComplaintMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>
  >;
export type PostApiCommunicationMessagereceiveComplaintMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationMessagereceiveComplaintMutationError = unknown;

export const usePostApiCommunicationMessagereceiveComplaint = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveComplaint>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessagereceiveComplaintMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMessagereceiveDelivery = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMessagereceiveDelivery200One
    | PostApiCommunicationMessagereceiveDelivery200Two
    | Blob
  >(
    {
      url: `/api/communication/messagereceive/delivery`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMessagereceiveDeliveryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMessagereceiveDelivery"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMessagereceiveDelivery(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMessagereceiveDeliveryMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>
  >;
export type PostApiCommunicationMessagereceiveDeliveryMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiCommunicationMessagereceiveDeliveryMutationError = unknown;

export const usePostApiCommunicationMessagereceiveDelivery = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMessagereceiveDelivery>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMessagereceiveDeliveryMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendEmailSms = (
  communicationDtoBody: CommunicationDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/sendEmailSms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendEmailSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>,
    TError,
    { data: CommunicationDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>,
  TError,
  { data: CommunicationDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendEmailSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>,
    { data: CommunicationDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendEmailSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendEmailSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>
>;
export type PostApiCommunicationSendEmailSmsMutationBody = CommunicationDtoBody;
export type PostApiCommunicationSendEmailSmsMutationError = unknown;

export const usePostApiCommunicationSendEmailSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>,
      TError,
      { data: CommunicationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSms>>,
  TError,
  { data: CommunicationDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendEmailSmsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationInsertIncomingEmail = (
  rawTicketEmailDtoBody: RawTicketEmailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInsertIncomingEmailResponse>(
    {
      url: `/api/communication/InsertIncomingEmail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rawTicketEmailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationInsertIncomingEmailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>,
    TError,
    { data: RawTicketEmailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>,
  TError,
  { data: RawTicketEmailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationInsertIncomingEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>,
    { data: RawTicketEmailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationInsertIncomingEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationInsertIncomingEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>
>;
export type PostApiCommunicationInsertIncomingEmailMutationBody =
  RawTicketEmailDtoBody;
export type PostApiCommunicationInsertIncomingEmailMutationError = unknown;

export const usePostApiCommunicationInsertIncomingEmail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>,
      TError,
      { data: RawTicketEmailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationInsertIncomingEmail>>,
  TError,
  { data: RawTicketEmailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationInsertIncomingEmailMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationTemplate = (
  generateTemplateDto: GenerateTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationTemplate200One
    | PostApiCommunicationTemplate200Two
    | Blob
  >(
    {
      url: `/api/communication/template`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: generateTemplateDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTemplate>>,
    TError,
    { data: GenerateTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTemplate>>,
  TError,
  { data: GenerateTemplateDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTemplate>>,
    { data: GenerateTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationTemplate>>
>;
export type PostApiCommunicationTemplateMutationBody = GenerateTemplateDto;
export type PostApiCommunicationTemplateMutationError = unknown;

export const usePostApiCommunicationTemplate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTemplate>>,
      TError,
      { data: GenerateTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTemplate>>,
  TError,
  { data: GenerateTemplateDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTemplateMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationTemplateTest = (
  testTemplateDto: TestTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTestTemplateResponseDto>(
    {
      url: `/api/communication/template/test`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: testTemplateDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationTemplateTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>,
    TError,
    { data: TestTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>,
  TError,
  { data: TestTemplateDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationTemplateTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>,
    { data: TestTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationTemplateTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTemplateTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>
>;
export type PostApiCommunicationTemplateTestMutationBody = TestTemplateDto;
export type PostApiCommunicationTemplateTestMutationError = unknown;

export const usePostApiCommunicationTemplateTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>,
      TError,
      { data: TestTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTemplateTest>>,
  TError,
  { data: TestTemplateDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTemplateTestMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationIsTemplateSendToday = (
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/isTemplateSendToday`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationIsTemplateSendTodayQueryKey = (
  params?: GetApiCommunicationIsTemplateSendTodayParams
) => {
  return [
    `/api/communication/isTemplateSendToday`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationIsTemplateSendTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
  TError = unknown
>(
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationIsTemplateSendTodayQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>
  > = ({ signal }) =>
    getApiCommunicationIsTemplateSendToday(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationIsTemplateSendTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>
>;
export type GetApiCommunicationIsTemplateSendTodayQueryError = unknown;

export function useGetApiCommunicationIsTemplateSendToday<
  TData = Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
  TError = unknown
>(
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationIsTemplateSendToday<
  TData = Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
  TError = unknown
>(
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationIsTemplateSendToday<
  TData = Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
  TError = unknown
>(
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationIsTemplateSendToday<
  TData = Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
  TError = unknown
>(
  params: GetApiCommunicationIsTemplateSendTodayParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationIsTemplateSendToday>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationIsTemplateSendTodayQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationFeedback = (
  params: GetApiCommunicationFeedbackParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiCommunicationFeedback200One | GetApiCommunicationFeedback200Two | Blob
  >(
    { url: `/api/communication/feedback`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationFeedbackQueryKey = (
  params?: GetApiCommunicationFeedbackParams
) => {
  return [`/api/communication/feedback`, ...(params ? [params] : [])] as const;
};

export const getGetApiCommunicationFeedbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
  TError = unknown
>(
  params: GetApiCommunicationFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationFeedbackQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationFeedback>>
  > = ({ signal }) =>
    getApiCommunicationFeedback(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationFeedbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationFeedback>>
>;
export type GetApiCommunicationFeedbackQueryError = unknown;

export function useGetApiCommunicationFeedback<
  TData = Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
  TError = unknown
>(
  params: GetApiCommunicationFeedbackParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationFeedback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationFeedback<
  TData = Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
  TError = unknown
>(
  params: GetApiCommunicationFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationFeedback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationFeedback<
  TData = Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
  TError = unknown
>(
  params: GetApiCommunicationFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationFeedback<
  TData = Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
  TError = unknown
>(
  params: GetApiCommunicationFeedbackParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationFeedback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationFeedbackQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationReceiveOtpViaNexmo = (
  params?: GetApiCommunicationReceiveOtpViaNexmoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCommunicationReceiveOtpViaNexmo200One
    | GetApiCommunicationReceiveOtpViaNexmo200Two
    | Blob
  >(
    {
      url: `/api/communication/receiveOtpViaNexmo`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationReceiveOtpViaNexmoQueryKey = (
  params?: GetApiCommunicationReceiveOtpViaNexmoParams
) => {
  return [
    `/api/communication/receiveOtpViaNexmo`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationReceiveOtpViaNexmoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaNexmoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationReceiveOtpViaNexmoQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>
  > = ({ signal }) =>
    getApiCommunicationReceiveOtpViaNexmo(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationReceiveOtpViaNexmoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>
>;
export type GetApiCommunicationReceiveOtpViaNexmoQueryError = unknown;

export function useGetApiCommunicationReceiveOtpViaNexmo<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
  TError = unknown
>(
  params: undefined | GetApiCommunicationReceiveOtpViaNexmoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationReceiveOtpViaNexmo<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaNexmoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationReceiveOtpViaNexmo<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaNexmoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationReceiveOtpViaNexmo<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaNexmoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaNexmo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationReceiveOtpViaNexmoQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationReceiveOtpViaComApi = (
  params?: GetApiCommunicationReceiveOtpViaComApiParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCommunicationReceiveOtpViaComApi200One
    | GetApiCommunicationReceiveOtpViaComApi200Two
    | Blob
  >(
    {
      url: `/api/communication/receiveOtpViaComApi`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationReceiveOtpViaComApiQueryKey = (
  params?: GetApiCommunicationReceiveOtpViaComApiParams
) => {
  return [
    `/api/communication/receiveOtpViaComApi`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationReceiveOtpViaComApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaComApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationReceiveOtpViaComApiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>
  > = ({ signal }) =>
    getApiCommunicationReceiveOtpViaComApi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationReceiveOtpViaComApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>
>;
export type GetApiCommunicationReceiveOtpViaComApiQueryError = unknown;

export function useGetApiCommunicationReceiveOtpViaComApi<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
  TError = unknown
>(
  params: undefined | GetApiCommunicationReceiveOtpViaComApiParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationReceiveOtpViaComApi<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaComApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationReceiveOtpViaComApi<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaComApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationReceiveOtpViaComApi<
  TData = Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
  TError = unknown
>(
  params?: GetApiCommunicationReceiveOtpViaComApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationReceiveOtpViaComApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationReceiveOtpViaComApiQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationTemplateGet = (
  params: GetApiCommunicationTemplateGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/communication/template/get`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationTemplateGetQueryKey = (
  params?: GetApiCommunicationTemplateGetParams
) => {
  return [
    `/api/communication/template/get`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationTemplateGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationTemplateGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>
  > = ({ signal }) =>
    getApiCommunicationTemplateGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationTemplateGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>
>;
export type GetApiCommunicationTemplateGetQueryError = unknown;

export function useGetApiCommunicationTemplateGet<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTemplateGet<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTemplateGet<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationTemplateGet<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationTemplateGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationCreateNewTemplate = (
  createNewTemplateDto: CreateNewTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTemplateResponseDto>(
    {
      url: `/api/communication/createNewTemplate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createNewTemplateDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCreateNewTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>,
    TError,
    { data: CreateNewTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>,
  TError,
  { data: CreateNewTemplateDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCreateNewTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>,
    { data: CreateNewTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCreateNewTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCreateNewTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>
>;
export type PostApiCommunicationCreateNewTemplateMutationBody =
  CreateNewTemplateDto;
export type PostApiCommunicationCreateNewTemplateMutationError = unknown;

export const usePostApiCommunicationCreateNewTemplate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>,
      TError,
      { data: CreateNewTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCreateNewTemplate>>,
  TError,
  { data: CreateNewTemplateDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCreateNewTemplateMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationDeleteTemplateByIdTemplateId = (
  templateId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/deleteTemplateById/${templateId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationDeleteTemplateByIdTemplateIdQueryKey = (
  templateId: number
) => {
  return [`/api/communication/deleteTemplateById/${templateId}`] as const;
};

export const getGetApiCommunicationDeleteTemplateByIdTemplateIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
  >,
  TError = unknown
>(
  templateId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationDeleteTemplateByIdTemplateIdQueryKey(templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>>
  > = ({ signal }) =>
    getApiCommunicationDeleteTemplateByIdTemplateId(
      templateId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!templateId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationDeleteTemplateByIdTemplateIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>>
  >;
export type GetApiCommunicationDeleteTemplateByIdTemplateIdQueryError = unknown;

export function useGetApiCommunicationDeleteTemplateByIdTemplateId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
  >,
  TError = unknown
>(
  templateId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteTemplateByIdTemplateId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
  >,
  TError = unknown
>(
  templateId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDeleteTemplateByIdTemplateId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
  >,
  TError = unknown
>(
  templateId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationDeleteTemplateByIdTemplateId<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
  >,
  TError = unknown
>(
  templateId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationDeleteTemplateByIdTemplateId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationDeleteTemplateByIdTemplateIdQueryOptions(
      templateId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationUpdateTemplate = (
  updateTemplateDto: UpdateTemplateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/updateTemplate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateTemplateDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationUpdateTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>,
    TError,
    { data: UpdateTemplateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>,
  TError,
  { data: UpdateTemplateDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationUpdateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>,
    { data: UpdateTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationUpdateTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationUpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>
>;
export type PostApiCommunicationUpdateTemplateMutationBody = UpdateTemplateDto;
export type PostApiCommunicationUpdateTemplateMutationError = unknown;

export const usePostApiCommunicationUpdateTemplate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>,
      TError,
      { data: UpdateTemplateDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationUpdateTemplate>>,
  TError,
  { data: UpdateTemplateDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationUpdateTemplateMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationBulkSms = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiCommunicationBulkSmsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/bulkSms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationBulkSms>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCommunicationBulkSmsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationBulkSms>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCommunicationBulkSmsParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCommunicationBulkSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationBulkSms>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCommunicationBulkSmsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCommunicationBulkSms(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationBulkSms>>
>;
export type PostApiCommunicationBulkSmsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationBulkSmsMutationError = unknown;

export const usePostApiCommunicationBulkSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationBulkSms>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiCommunicationBulkSmsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationBulkSms>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCommunicationBulkSmsParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationBulkSmsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationBulkEmail = (
  bulkEmailDtoBody: BulkEmailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/bulkEmail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkEmailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationBulkEmailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>,
    TError,
    { data: BulkEmailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>,
  TError,
  { data: BulkEmailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationBulkEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>,
    { data: BulkEmailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationBulkEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationBulkEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>
>;
export type PostApiCommunicationBulkEmailMutationBody = BulkEmailDtoBody;
export type PostApiCommunicationBulkEmailMutationError = unknown;

export const usePostApiCommunicationBulkEmail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>,
      TError,
      { data: BulkEmailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationBulkEmail>>,
  TError,
  { data: BulkEmailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationBulkEmailMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationContact = (
  contactDto: NonReadonly<ContactDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/contact`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contactDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationContactMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationContact>>,
    TError,
    { data: NonReadonly<ContactDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationContact>>,
  TError,
  { data: NonReadonly<ContactDto> },
  TContext
> => {
  const mutationKey = ["postApiCommunicationContact"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationContact>>,
    { data: NonReadonly<ContactDto> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationContact(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationContactMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationContact>>
>;
export type PostApiCommunicationContactMutationBody = NonReadonly<ContactDto>;
export type PostApiCommunicationContactMutationError = unknown;

export const usePostApiCommunicationContact = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationContact>>,
      TError,
      { data: NonReadonly<ContactDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationContact>>,
  TError,
  { data: NonReadonly<ContactDto> },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationContactMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationGetPublicCaptchaKey = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/communication/GetPublicCaptchaKey`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationGetPublicCaptchaKeyQueryKey = () => {
  return [`/api/communication/GetPublicCaptchaKey`] as const;
};

export const getGetApiCommunicationGetPublicCaptchaKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetPublicCaptchaKeyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>
  > = ({ signal }) =>
    getApiCommunicationGetPublicCaptchaKey(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetPublicCaptchaKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>
>;
export type GetApiCommunicationGetPublicCaptchaKeyQueryError = unknown;

export function useGetApiCommunicationGetPublicCaptchaKey<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetPublicCaptchaKey<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetPublicCaptchaKey<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetPublicCaptchaKey<
  TData = Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationGetPublicCaptchaKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetPublicCaptchaKeyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationValidateCaptcha = (
  params: PostApiCommunicationValidateCaptchaParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCaptchaResultDto>(
    {
      url: `/api/communication/ValidateCaptcha`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationValidateCaptchaMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>,
    TError,
    { params: PostApiCommunicationValidateCaptchaParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>,
  TError,
  { params: PostApiCommunicationValidateCaptchaParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationValidateCaptcha"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>,
    { params: PostApiCommunicationValidateCaptchaParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationValidateCaptcha(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationValidateCaptchaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>
>;

export type PostApiCommunicationValidateCaptchaMutationError = unknown;

export const usePostApiCommunicationValidateCaptcha = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>,
      TError,
      { params: PostApiCommunicationValidateCaptchaParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationValidateCaptcha>>,
  TError,
  { params: PostApiCommunicationValidateCaptchaParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationValidateCaptchaMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationRemindersmsforinactivecustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/remindersmsforinactivecustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCommunicationRemindersmsforinactivecustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiCommunicationRemindersmsforinactivecustomers"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
      >,
      void
    > = () => {
      return postApiCommunicationRemindersmsforinactivecustomers(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationRemindersmsforinactivecustomersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
    >
  >;

export type PostApiCommunicationRemindersmsforinactivecustomersMutationError =
  unknown;

export const usePostApiCommunicationRemindersmsforinactivecustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCommunicationRemindersmsforinactivecustomers>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCommunicationRemindersmsforinactivecustomersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationTwilioTest = (
  communicationDtoBody: CommunicationDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/twilioTest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationTwilioTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>,
    TError,
    { data: CommunicationDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>,
  TError,
  { data: CommunicationDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationTwilioTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>,
    { data: CommunicationDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationTwilioTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationTwilioTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>
>;
export type PostApiCommunicationTwilioTestMutationBody = CommunicationDtoBody;
export type PostApiCommunicationTwilioTestMutationError = unknown;

export const usePostApiCommunicationTwilioTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>,
      TError,
      { data: CommunicationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationTwilioTest>>,
  TError,
  { data: CommunicationDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationTwilioTestMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendSpecificSms = (
  specificMessageDtoArrayBody: SpecificMessageDtoArrayBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/sendSpecificSms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: specificMessageDtoArrayBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendSpecificSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>,
    TError,
    { data: SpecificMessageDtoArrayBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>,
  TError,
  { data: SpecificMessageDtoArrayBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendSpecificSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>,
    { data: SpecificMessageDtoArrayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendSpecificSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendSpecificSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>
>;
export type PostApiCommunicationSendSpecificSmsMutationBody =
  SpecificMessageDtoArrayBody;
export type PostApiCommunicationSendSpecificSmsMutationError = unknown;

export const usePostApiCommunicationSendSpecificSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>,
      TError,
      { data: SpecificMessageDtoArrayBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendSpecificSms>>,
  TError,
  { data: SpecificMessageDtoArrayBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendSpecificSmsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMailjetCallback = (
  mailjetCallbackDto: MailjetCallbackDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMailjetCallback200One
    | PostApiCommunicationMailjetCallback200Two
    | Blob
  >(
    {
      url: `/api/communication/mailjetCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mailjetCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMailjetCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>,
    TError,
    { data: MailjetCallbackDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>,
  TError,
  { data: MailjetCallbackDto[] },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMailjetCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>,
    { data: MailjetCallbackDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMailjetCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMailjetCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>
>;
export type PostApiCommunicationMailjetCallbackMutationBody =
  MailjetCallbackDto[];
export type PostApiCommunicationMailjetCallbackMutationError = unknown;

export const usePostApiCommunicationMailjetCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>,
      TError,
      { data: MailjetCallbackDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMailjetCallback>>,
  TError,
  { data: MailjetCallbackDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMailjetCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendEmailMailjet = (
  bulkEmailDtoBody: BulkEmailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/sendEmailMailjet`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkEmailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendEmailMailjetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>,
    TError,
    { data: BulkEmailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>,
  TError,
  { data: BulkEmailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendEmailMailjet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>,
    { data: BulkEmailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendEmailMailjet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendEmailMailjetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>
>;
export type PostApiCommunicationSendEmailMailjetMutationBody = BulkEmailDtoBody;
export type PostApiCommunicationSendEmailMailjetMutationError = unknown;

export const usePostApiCommunicationSendEmailMailjet = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>,
      TError,
      { data: BulkEmailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailMailjet>>,
  TError,
  { data: BulkEmailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendEmailMailjetMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendEmailSingle = (
  sendEmailSingleDto: SendEmailSingleDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/SendEmailSingle`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendEmailSingleDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendEmailSingleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>,
    TError,
    { data: SendEmailSingleDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>,
  TError,
  { data: SendEmailSingleDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendEmailSingle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>,
    { data: SendEmailSingleDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendEmailSingle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendEmailSingleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>
>;
export type PostApiCommunicationSendEmailSingleMutationBody =
  SendEmailSingleDto;
export type PostApiCommunicationSendEmailSingleMutationError = unknown;

export const usePostApiCommunicationSendEmailSingle = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>,
      TError,
      { data: SendEmailSingleDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailSingle>>,
  TError,
  { data: SendEmailSingleDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendEmailSingleMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendEmailBulk = (
  sendEmailBulkDto: SendEmailBulkDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/SendEmailBulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendEmailBulkDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendEmailBulkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>,
    TError,
    { data: SendEmailBulkDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>,
  TError,
  { data: SendEmailBulkDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendEmailBulk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>,
    { data: SendEmailBulkDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendEmailBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendEmailBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>
>;
export type PostApiCommunicationSendEmailBulkMutationBody = SendEmailBulkDto;
export type PostApiCommunicationSendEmailBulkMutationError = unknown;

export const usePostApiCommunicationSendEmailBulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>,
      TError,
      { data: SendEmailBulkDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendEmailBulk>>,
  TError,
  { data: SendEmailBulkDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendEmailBulkMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationSendSmsBulk = (
  sendSmsBulkDto: SendSmsBulkDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/SendSmsBulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendSmsBulkDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSendSmsBulkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>,
    TError,
    { data: SendSmsBulkDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>,
  TError,
  { data: SendSmsBulkDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSendSmsBulk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>,
    { data: SendSmsBulkDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationSendSmsBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSendSmsBulkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>
>;
export type PostApiCommunicationSendSmsBulkMutationBody = SendSmsBulkDto;
export type PostApiCommunicationSendSmsBulkMutationError = unknown;

export const usePostApiCommunicationSendSmsBulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>,
      TError,
      { data: SendSmsBulkDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSendSmsBulk>>,
  TError,
  { data: SendSmsBulkDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSendSmsBulkMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationChange3CXStatus = (
  params: PostApiCommunicationChange3CXStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/change3CXStatus`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationChange3CXStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>,
    TError,
    { params: PostApiCommunicationChange3CXStatusParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>,
  TError,
  { params: PostApiCommunicationChange3CXStatusParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationChange3CXStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>,
    { params: PostApiCommunicationChange3CXStatusParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationChange3CXStatus(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationChange3CXStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>
>;

export type PostApiCommunicationChange3CXStatusMutationError = unknown;

export const usePostApiCommunicationChange3CXStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>,
      TError,
      { params: PostApiCommunicationChange3CXStatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationChange3CXStatus>>,
  TError,
  { params: PostApiCommunicationChange3CXStatusParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationChange3CXStatusMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationCallRequestedLoans = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/communication/callRequestedLoans`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationCallRequestedLoansQueryKey = () => {
  return [`/api/communication/callRequestedLoans`] as const;
};

export const getGetApiCommunicationCallRequestedLoansQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationCallRequestedLoansQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>
  > = ({ signal }) =>
    getApiCommunicationCallRequestedLoans(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationCallRequestedLoansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>
>;
export type GetApiCommunicationCallRequestedLoansQueryError = unknown;

export function useGetApiCommunicationCallRequestedLoans<
  TData = Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationCallRequestedLoans<
  TData = Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationCallRequestedLoans<
  TData = Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationCallRequestedLoans<
  TData = Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCallRequestedLoans>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationCallRequestedLoansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationDeleteExcludedCustomersTo3CX = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/deleteExcludedCustomersTo3CX`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationDeleteExcludedCustomersTo3CXMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>
    >,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationDeleteExcludedCustomersTo3CX"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationDeleteExcludedCustomersTo3CX(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationDeleteExcludedCustomersTo3CXMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>>
  >;
export type PostApiCommunicationDeleteExcludedCustomersTo3CXMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationDeleteExcludedCustomersTo3CXMutationError =
  unknown;

export const usePostApiCommunicationDeleteExcludedCustomersTo3CX = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationDeleteExcludedCustomersTo3CX>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationDeleteExcludedCustomersTo3CXMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationAddExcludedCustomersTo3CX = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/addExcludedCustomersTo3CX`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationAddExcludedCustomersTo3CXMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationAddExcludedCustomersTo3CX"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationAddExcludedCustomersTo3CX(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationAddExcludedCustomersTo3CXMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>
  >;
export type PostApiCommunicationAddExcludedCustomersTo3CXMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationAddExcludedCustomersTo3CXMutationError =
  unknown;

export const usePostApiCommunicationAddExcludedCustomersTo3CX = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationAddExcludedCustomersTo3CX>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationAddExcludedCustomersTo3CXMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationAutomatedWelcomeCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/communication/automatedWelcomeCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationAutomatedWelcomeCallsQueryKey = () => {
  return [`/api/communication/automatedWelcomeCalls`] as const;
};

export const getGetApiCommunicationAutomatedWelcomeCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationAutomatedWelcomeCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>
  > = ({ signal }) =>
    getApiCommunicationAutomatedWelcomeCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationAutomatedWelcomeCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>
>;
export type GetApiCommunicationAutomatedWelcomeCallsQueryError = unknown;

export function useGetApiCommunicationAutomatedWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationAutomatedWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationAutomatedWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationAutomatedWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedWelcomeCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationAutomatedWelcomeCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationAutomatedUnansweredCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/automatedUnansweredCalls`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCommunicationAutomatedUnansweredCallsQueryKey = () => {
  return [`/api/communication/automatedUnansweredCalls`] as const;
};

export const getGetApiCommunicationAutomatedUnansweredCallsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationAutomatedUnansweredCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>
  > = ({ signal }) =>
    getApiCommunicationAutomatedUnansweredCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationAutomatedUnansweredCallsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>
  >;
export type GetApiCommunicationAutomatedUnansweredCallsQueryError = unknown;

export function useGetApiCommunicationAutomatedUnansweredCalls<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationAutomatedUnansweredCalls<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationAutomatedUnansweredCalls<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationAutomatedUnansweredCalls<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationAutomatedUnansweredCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationAutomatedUnansweredCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNotifyWelcomeCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutomatedCallsNotificationResponseDto>(
    { url: `/api/communication/notifyWelcomeCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationNotifyWelcomeCallsQueryKey = () => {
  return [`/api/communication/notifyWelcomeCalls`] as const;
};

export const getGetApiCommunicationNotifyWelcomeCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationNotifyWelcomeCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>
  > = ({ signal }) =>
    getApiCommunicationNotifyWelcomeCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNotifyWelcomeCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>
>;
export type GetApiCommunicationNotifyWelcomeCallsQueryError = unknown;

export function useGetApiCommunicationNotifyWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifyWelcomeCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyWelcomeCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifyWelcomeCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNotifyUnansweredCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutomatedCallsNotificationResponseDto>(
    { url: `/api/communication/notifyUnansweredCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationNotifyUnansweredCallsQueryKey = () => {
  return [`/api/communication/notifyUnansweredCalls`] as const;
};

export const getGetApiCommunicationNotifyUnansweredCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationNotifyUnansweredCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>
  > = ({ signal }) =>
    getApiCommunicationNotifyUnansweredCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNotifyUnansweredCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>
>;
export type GetApiCommunicationNotifyUnansweredCallsQueryError = unknown;

export function useGetApiCommunicationNotifyUnansweredCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyUnansweredCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyUnansweredCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifyUnansweredCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyUnansweredCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifyUnansweredCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNotifyCollectionCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutomatedCallsNotificationResponseDto>(
    { url: `/api/communication/notifyCollectionCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationNotifyCollectionCallsQueryKey = () => {
  return [`/api/communication/notifyCollectionCalls`] as const;
};

export const getGetApiCommunicationNotifyCollectionCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationNotifyCollectionCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>
  > = ({ signal }) =>
    getApiCommunicationNotifyCollectionCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNotifyCollectionCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>
>;
export type GetApiCommunicationNotifyCollectionCallsQueryError = unknown;

export function useGetApiCommunicationNotifyCollectionCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyCollectionCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyCollectionCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifyCollectionCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyCollectionCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifyCollectionCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNotifyPaymentCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutomatedCallsNotificationResponseDto>(
    { url: `/api/communication/notifyPaymentCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationNotifyPaymentCallsQueryKey = () => {
  return [`/api/communication/notifyPaymentCalls`] as const;
};

export const getGetApiCommunicationNotifyPaymentCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationNotifyPaymentCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>
  > = ({ signal }) =>
    getApiCommunicationNotifyPaymentCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNotifyPaymentCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>
>;
export type GetApiCommunicationNotifyPaymentCallsQueryError = unknown;

export function useGetApiCommunicationNotifyPaymentCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyPaymentCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyPaymentCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifyPaymentCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifyPaymentCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifyPaymentCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNotifySaleCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutomatedCallsNotificationResponseDto>(
    { url: `/api/communication/notifySaleCalls`, method: "GET", signal },
    options
  );
};

export const getGetApiCommunicationNotifySaleCallsQueryKey = () => {
  return [`/api/communication/notifySaleCalls`] as const;
};

export const getGetApiCommunicationNotifySaleCallsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationNotifySaleCallsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>
  > = ({ signal }) =>
    getApiCommunicationNotifySaleCalls(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNotifySaleCallsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>
>;
export type GetApiCommunicationNotifySaleCallsQueryError = unknown;

export function useGetApiCommunicationNotifySaleCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifySaleCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifySaleCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifySaleCalls<
  TData = Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNotifySaleCalls>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifySaleCallsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationAddToMyCalls = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/AddToMyCalls`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationAddToMyCallsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationAddToMyCalls"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationAddToMyCalls(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationAddToMyCallsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>
>;
export type PostApiCommunicationAddToMyCallsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationAddToMyCallsMutationError = unknown;

export const usePostApiCommunicationAddToMyCalls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationAddToMyCalls>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationAddToMyCallsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationMailgunCallback = (
  mailgunCallbackDto: MailgunCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCommunicationMailgunCallback200One
    | PostApiCommunicationMailgunCallback200Two
    | Blob
  >(
    {
      url: `/api/communication/mailgunCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: mailgunCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationMailgunCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>,
    TError,
    { data: MailgunCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>,
  TError,
  { data: MailgunCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiCommunicationMailgunCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>,
    { data: MailgunCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationMailgunCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationMailgunCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>
>;
export type PostApiCommunicationMailgunCallbackMutationBody =
  MailgunCallbackDto;
export type PostApiCommunicationMailgunCallbackMutationError = unknown;

export const usePostApiCommunicationMailgunCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>,
      TError,
      { data: MailgunCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationMailgunCallback>>,
  TError,
  { data: MailgunCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationMailgunCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationTemplateByName = (
  params: GetApiCommunicationTemplateByNameParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/communication/templateByName`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationTemplateByNameQueryKey = (
  params?: GetApiCommunicationTemplateByNameParams
) => {
  return [
    `/api/communication/templateByName`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationTemplateByNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationTemplateByNameQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>
  > = ({ signal }) =>
    getApiCommunicationTemplateByName(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationTemplateByNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>
>;
export type GetApiCommunicationTemplateByNameQueryError = unknown;

export function useGetApiCommunicationTemplateByName<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateByNameParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTemplateByName<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationTemplateByName<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationTemplateByName<
  TData = Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
  TError = unknown
>(
  params: GetApiCommunicationTemplateByNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationTemplateByName>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationTemplateByNameQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationCreateS3DocumentInfo = (
  s3DocumentInfoDtoBody: S3DocumentInfoDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultS3DocumentInfoDto>(
    {
      url: `/api/communication/CreateS3DocumentInfo`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: s3DocumentInfoDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCreateS3DocumentInfoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>,
    TError,
    { data: S3DocumentInfoDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>,
  TError,
  { data: S3DocumentInfoDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCreateS3DocumentInfo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>,
    { data: S3DocumentInfoDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCreateS3DocumentInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCreateS3DocumentInfoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>
  >;
export type PostApiCommunicationCreateS3DocumentInfoMutationBody =
  S3DocumentInfoDtoBody;
export type PostApiCommunicationCreateS3DocumentInfoMutationError = unknown;

export const usePostApiCommunicationCreateS3DocumentInfo = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>,
      TError,
      { data: S3DocumentInfoDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCreateS3DocumentInfo>>,
  TError,
  { data: S3DocumentInfoDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCreateS3DocumentInfoMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationNotifyOnlineUsersForS3Document = (
  params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/NotifyOnlineUsersForS3Document`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationNotifyOnlineUsersForS3DocumentQueryKey = (
  params?: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams
) => {
  return [
    `/api/communication/NotifyOnlineUsersForS3Document`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationNotifyOnlineUsersForS3DocumentQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
    >,
    TError = unknown
  >(
    params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiCommunicationNotifyOnlineUsersForS3DocumentQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
      >
    > = ({ signal }) =>
      getApiCommunicationNotifyOnlineUsersForS3Document(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiCommunicationNotifyOnlineUsersForS3DocumentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
    >
  >;
export type GetApiCommunicationNotifyOnlineUsersForS3DocumentQueryError =
  unknown;

export function useGetApiCommunicationNotifyOnlineUsersForS3Document<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
  >,
  TError = unknown
>(
  params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyOnlineUsersForS3Document<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
  >,
  TError = unknown
>(
  params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNotifyOnlineUsersForS3Document<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
  >,
  TError = unknown
>(
  params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNotifyOnlineUsersForS3Document<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
  >,
  TError = unknown
>(
  params: GetApiCommunicationNotifyOnlineUsersForS3DocumentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationNotifyOnlineUsersForS3Document>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationNotifyOnlineUsersForS3DocumentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationDocumentList = (
  params: GetApiCommunicationDocumentListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListS3DocumentDto>(
    { url: `/api/communication/documentList`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationDocumentListQueryKey = (
  params?: GetApiCommunicationDocumentListParams
) => {
  return [
    `/api/communication/documentList`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationDocumentListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationDocumentListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationDocumentList>>
  > = ({ signal }) =>
    getApiCommunicationDocumentList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationDocumentListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationDocumentList>>
>;
export type GetApiCommunicationDocumentListQueryError = unknown;

export function useGetApiCommunicationDocumentList<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDocumentList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDocumentList<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDocumentList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDocumentList<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationDocumentList<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationDocumentListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationDocumentCount = (
  params: GetApiCommunicationDocumentCountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt32>(
    { url: `/api/communication/documentCount`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationDocumentCountQueryKey = (
  params?: GetApiCommunicationDocumentCountParams
) => {
  return [
    `/api/communication/documentCount`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationDocumentCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationDocumentCountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>
  > = ({ signal }) =>
    getApiCommunicationDocumentCount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationDocumentCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>
>;
export type GetApiCommunicationDocumentCountQueryError = unknown;

export function useGetApiCommunicationDocumentCount<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentCountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDocumentCount<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationDocumentCount<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationDocumentCount<
  TData = Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
  TError = unknown
>(
  params: GetApiCommunicationDocumentCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationDocumentCount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationDocumentCountQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationGetCustomerDocumentsByLoan = (
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultS3DocumentInfoDto>(
    {
      url: `/api/communication/GetCustomerDocumentsByLoan`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationGetCustomerDocumentsByLoanQueryKey = (
  params?: GetApiCommunicationGetCustomerDocumentsByLoanParams
) => {
  return [
    `/api/communication/GetCustomerDocumentsByLoan`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationGetCustomerDocumentsByLoanQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationGetCustomerDocumentsByLoanQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>>
  > = ({ signal }) =>
    getApiCommunicationGetCustomerDocumentsByLoan(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationGetCustomerDocumentsByLoanQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>>
  >;
export type GetApiCommunicationGetCustomerDocumentsByLoanQueryError = unknown;

export function useGetApiCommunicationGetCustomerDocumentsByLoan<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetCustomerDocumentsByLoan<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationGetCustomerDocumentsByLoan<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationGetCustomerDocumentsByLoan<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
  >,
  TError = unknown
>(
  params: GetApiCommunicationGetCustomerDocumentsByLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCommunicationGetCustomerDocumentsByLoan>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationGetCustomerDocumentsByLoanQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationS3Download = (
  params: GetApiCommunicationS3DownloadParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCommunicationS3Download200One
    | GetApiCommunicationS3Download200Two
    | Blob
  >(
    { url: `/api/communication/s3Download`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationS3DownloadQueryKey = (
  params?: GetApiCommunicationS3DownloadParams
) => {
  return [
    `/api/communication/s3Download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationS3DownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
  TError = unknown
>(
  params: GetApiCommunicationS3DownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCommunicationS3DownloadQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationS3Download>>
  > = ({ signal }) =>
    getApiCommunicationS3Download(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationS3DownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationS3Download>>
>;
export type GetApiCommunicationS3DownloadQueryError = unknown;

export function useGetApiCommunicationS3Download<
  TData = Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
  TError = unknown
>(
  params: GetApiCommunicationS3DownloadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationS3Download>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationS3Download<
  TData = Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
  TError = unknown
>(
  params: GetApiCommunicationS3DownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationS3Download>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationS3Download<
  TData = Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
  TError = unknown
>(
  params: GetApiCommunicationS3DownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationS3Download<
  TData = Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
  TError = unknown
>(
  params: GetApiCommunicationS3DownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationS3Download>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationS3DownloadQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationGetPreSignedUploadUrl = (
  params: PostApiCommunicationGetPreSignedUploadUrlParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultS3PreSignedUrlDto>(
    {
      url: `/api/communication/getPreSignedUploadUrl`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetPreSignedUploadUrlMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>,
    TError,
    { params: PostApiCommunicationGetPreSignedUploadUrlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>,
  TError,
  { params: PostApiCommunicationGetPreSignedUploadUrlParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGetPreSignedUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>,
    { params: PostApiCommunicationGetPreSignedUploadUrlParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationGetPreSignedUploadUrl(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGetPreSignedUploadUrlMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>
  >;

export type PostApiCommunicationGetPreSignedUploadUrlMutationError = unknown;

export const usePostApiCommunicationGetPreSignedUploadUrl = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>,
      TError,
      { params: PostApiCommunicationGetPreSignedUploadUrlParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrl>>,
  TError,
  { params: PostApiCommunicationGetPreSignedUploadUrlParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetPreSignedUploadUrlMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationGetPreSignedUploadUrls = (
  getPreSignedUploadUrlsDto: GetPreSignedUploadUrlsDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListS3PreSignedUrlDto>(
    {
      url: `/api/communication/getPreSignedUploadUrls`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getPreSignedUploadUrlsDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationGetPreSignedUploadUrlsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>,
    TError,
    { data: GetPreSignedUploadUrlsDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>,
  TError,
  { data: GetPreSignedUploadUrlsDto[] },
  TContext
> => {
  const mutationKey = ["postApiCommunicationGetPreSignedUploadUrls"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>,
    { data: GetPreSignedUploadUrlsDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationGetPreSignedUploadUrls(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationGetPreSignedUploadUrlsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>
  >;
export type PostApiCommunicationGetPreSignedUploadUrlsMutationBody =
  GetPreSignedUploadUrlsDto[];
export type PostApiCommunicationGetPreSignedUploadUrlsMutationError = unknown;

export const usePostApiCommunicationGetPreSignedUploadUrls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>,
      TError,
      { data: GetPreSignedUploadUrlsDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationGetPreSignedUploadUrls>>,
  TError,
  { data: GetPreSignedUploadUrlsDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationGetPreSignedUploadUrlsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationPreSignedUploadUrlCallbacks = (
  preSignedUploadUrlCallbackForCustomerBucketDto: PreSignedUploadUrlCallbackForCustomerBucketDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPreSignedUploadUrlCallbackDto>(
    {
      url: `/api/communication/PreSignedUploadUrlCallbacks`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: preSignedUploadUrlCallbackForCustomerBucketDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationPreSignedUploadUrlCallbacksMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>
      >,
      TError,
      { data: PreSignedUploadUrlCallbackForCustomerBucketDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>>,
    TError,
    { data: PreSignedUploadUrlCallbackForCustomerBucketDto[] },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationPreSignedUploadUrlCallbacks"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>
      >,
      { data: PreSignedUploadUrlCallbackForCustomerBucketDto[] }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationPreSignedUploadUrlCallbacks(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationPreSignedUploadUrlCallbacksMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>>
  >;
export type PostApiCommunicationPreSignedUploadUrlCallbacksMutationBody =
  PreSignedUploadUrlCallbackForCustomerBucketDto[];
export type PostApiCommunicationPreSignedUploadUrlCallbacksMutationError =
  unknown;

export const usePostApiCommunicationPreSignedUploadUrlCallbacks = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>
      >,
      TError,
      { data: PreSignedUploadUrlCallbackForCustomerBucketDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationPreSignedUploadUrlCallbacks>>,
  TError,
  { data: PreSignedUploadUrlCallbackForCustomerBucketDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationPreSignedUploadUrlCallbacksMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationOcrAutoCheckResult = (
  params: PostApiCommunicationOcrAutoCheckResultParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIdentityRecognitionResultDto>(
    {
      url: `/api/communication/OcrAutoCheckResult`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationOcrAutoCheckResultMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>,
    TError,
    { params: PostApiCommunicationOcrAutoCheckResultParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>,
  TError,
  { params: PostApiCommunicationOcrAutoCheckResultParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationOcrAutoCheckResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>,
    { params: PostApiCommunicationOcrAutoCheckResultParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationOcrAutoCheckResult(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationOcrAutoCheckResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>
>;

export type PostApiCommunicationOcrAutoCheckResultMutationError = unknown;

export const usePostApiCommunicationOcrAutoCheckResult = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>,
      TError,
      { params: PostApiCommunicationOcrAutoCheckResultParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheckResult>>,
  TError,
  { params: PostApiCommunicationOcrAutoCheckResultParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationOcrAutoCheckResultMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationOcrAutoCheck = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/OcrAutoCheck`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationOcrAutoCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationOcrAutoCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationOcrAutoCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationOcrAutoCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>
>;
export type PostApiCommunicationOcrAutoCheckMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationOcrAutoCheckMutationError = unknown;

export const usePostApiCommunicationOcrAutoCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationOcrAutoCheck>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationOcrAutoCheckMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationThrowExceptionForJob = (
  params: PostApiCommunicationThrowExceptionForJobParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Result>(
    {
      url: `/api/communication/ThrowExceptionForJob`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationThrowExceptionForJobMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>,
    TError,
    { params: PostApiCommunicationThrowExceptionForJobParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>,
  TError,
  { params: PostApiCommunicationThrowExceptionForJobParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationThrowExceptionForJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>,
    { params: PostApiCommunicationThrowExceptionForJobParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationThrowExceptionForJob(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationThrowExceptionForJobMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>
  >;

export type PostApiCommunicationThrowExceptionForJobMutationError = unknown;

export const usePostApiCommunicationThrowExceptionForJob = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>,
      TError,
      { params: PostApiCommunicationThrowExceptionForJobParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationThrowExceptionForJob>>,
  TError,
  { params: PostApiCommunicationThrowExceptionForJobParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationThrowExceptionForJobMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationS3Upload = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListDocumentDto>(
    { url: `/api/communication/s3Upload`, method: "POST", signal },
    options
  );
};

export const getPostApiCommunicationS3UploadMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationS3Upload>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationS3Upload>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCommunicationS3Upload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationS3Upload>>,
    void
  > = () => {
    return postApiCommunicationS3Upload(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationS3UploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationS3Upload>>
>;

export type PostApiCommunicationS3UploadMutationError = unknown;

export const usePostApiCommunicationS3Upload = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationS3Upload>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationS3Upload>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCommunicationS3UploadMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationRemoveS3DocumentByCustomerAndFile = (
  params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/RemoveS3DocumentByCustomerAndFile`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryKey = (
  params?: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams
) => {
  return [
    `/api/communication/RemoveS3DocumentByCustomerAndFile`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
    >,
    TError = unknown
  >(
    params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
      >
    > = ({ signal }) =>
      getApiCommunicationRemoveS3DocumentByCustomerAndFile(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
    >
  >;
export type GetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryError =
  unknown;

export function useGetApiCommunicationRemoveS3DocumentByCustomerAndFile<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
  >,
  TError = unknown
>(
  params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationRemoveS3DocumentByCustomerAndFile<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
  >,
  TError = unknown
>(
  params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationRemoveS3DocumentByCustomerAndFile<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
  >,
  TError = unknown
>(
  params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationRemoveS3DocumentByCustomerAndFile<
  TData = Awaited<
    ReturnType<typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile>
  >,
  TError = unknown
>(
  params: GetApiCommunicationRemoveS3DocumentByCustomerAndFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiCommunicationRemoveS3DocumentByCustomerAndFile
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCommunicationRemoveS3DocumentByCustomerAndFileQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationSeverDocumentCard = (
  params: PostApiCommunicationSeverDocumentCardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/severDocumentCard`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationSeverDocumentCardMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>,
    TError,
    { params: PostApiCommunicationSeverDocumentCardParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>,
  TError,
  { params: PostApiCommunicationSeverDocumentCardParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationSeverDocumentCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>,
    { params: PostApiCommunicationSeverDocumentCardParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationSeverDocumentCard(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationSeverDocumentCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>
>;

export type PostApiCommunicationSeverDocumentCardMutationError = unknown;

export const usePostApiCommunicationSeverDocumentCard = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>,
      TError,
      { params: PostApiCommunicationSeverDocumentCardParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationSeverDocumentCard>>,
  TError,
  { params: PostApiCommunicationSeverDocumentCardParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationSeverDocumentCardMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationAddCardToDocument = (
  addDocumentCardRequest: AddDocumentCardRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/addCardToDocument`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: addDocumentCardRequest,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationAddCardToDocumentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>,
    TError,
    { data: AddDocumentCardRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>,
  TError,
  { data: AddDocumentCardRequest },
  TContext
> => {
  const mutationKey = ["postApiCommunicationAddCardToDocument"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>,
    { data: AddDocumentCardRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationAddCardToDocument(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationAddCardToDocumentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>
>;
export type PostApiCommunicationAddCardToDocumentMutationBody =
  AddDocumentCardRequest;
export type PostApiCommunicationAddCardToDocumentMutationError = unknown;

export const usePostApiCommunicationAddCardToDocument = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>,
      TError,
      { data: AddDocumentCardRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationAddCardToDocument>>,
  TError,
  { data: AddDocumentCardRequest },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationAddCardToDocumentMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationCallbackS3DocumentInfo = (
  s3DocumentInfoCallbackDto: S3DocumentInfoCallbackDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt32>(
    {
      url: `/api/communication/callback/S3DocumentInfo`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: s3DocumentInfoCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCallbackS3DocumentInfoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>,
    TError,
    { data: S3DocumentInfoCallbackDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>,
  TError,
  { data: S3DocumentInfoCallbackDto[] },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCallbackS3DocumentInfo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>,
    { data: S3DocumentInfoCallbackDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCallbackS3DocumentInfo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCallbackS3DocumentInfoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>
  >;
export type PostApiCommunicationCallbackS3DocumentInfoMutationBody =
  S3DocumentInfoCallbackDto[];
export type PostApiCommunicationCallbackS3DocumentInfoMutationError = unknown;

export const usePostApiCommunicationCallbackS3DocumentInfo = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>,
      TError,
      { data: S3DocumentInfoCallbackDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCallbackS3DocumentInfo>>,
  TError,
  { data: S3DocumentInfoCallbackDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCallbackS3DocumentInfoMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationReadCustomerDNIs = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64String>(
    {
      url: `/api/communication/readCustomerDNIs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationReadCustomerDNIsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationReadCustomerDNIs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationReadCustomerDNIs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationReadCustomerDNIsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>
>;
export type PostApiCommunicationReadCustomerDNIsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationReadCustomerDNIsMutationError = unknown;

export const usePostApiCommunicationReadCustomerDNIs = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIs>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationReadCustomerDNIsMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationReadCustomerDNIJob = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/communication/readCustomerDNIJob`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationReadCustomerDNIJobMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationReadCustomerDNIJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationReadCustomerDNIJob(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationReadCustomerDNIJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>
>;
export type PostApiCommunicationReadCustomerDNIJobMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationReadCustomerDNIJobMutationError = unknown;

export const usePostApiCommunicationReadCustomerDNIJob = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationReadCustomerDNIJob>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationReadCustomerDNIJobMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationPostCustomerS3DocumentInfo = (
  s3DocumentInfoDtoBody: S3DocumentInfoDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/postCustomerS3DocumentInfo`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: s3DocumentInfoDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationPostCustomerS3DocumentInfoMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>
      >,
      TError,
      { data: S3DocumentInfoDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>>,
    TError,
    { data: S3DocumentInfoDtoBody },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationPostCustomerS3DocumentInfo"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>
      >,
      { data: S3DocumentInfoDtoBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationPostCustomerS3DocumentInfo(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationPostCustomerS3DocumentInfoMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>>
  >;
export type PostApiCommunicationPostCustomerS3DocumentInfoMutationBody =
  S3DocumentInfoDtoBody;
export type PostApiCommunicationPostCustomerS3DocumentInfoMutationError =
  unknown;

export const usePostApiCommunicationPostCustomerS3DocumentInfo = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>
      >,
      TError,
      { data: S3DocumentInfoDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationPostCustomerS3DocumentInfo>>,
  TError,
  { data: S3DocumentInfoDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationPostCustomerS3DocumentInfoMutationOptions(options),
    queryClient
  );
};

export const postApiCommunicationUploadLoanAgreement = (
  s3LoanAgreementDto: NonReadonly<S3LoanAgreementDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/uploadLoanAgreement`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: s3LoanAgreementDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationUploadLoanAgreementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>,
    TError,
    { data: NonReadonly<S3LoanAgreementDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>,
  TError,
  { data: NonReadonly<S3LoanAgreementDto> },
  TContext
> => {
  const mutationKey = ["postApiCommunicationUploadLoanAgreement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>,
    { data: NonReadonly<S3LoanAgreementDto> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationUploadLoanAgreement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationUploadLoanAgreementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>
>;
export type PostApiCommunicationUploadLoanAgreementMutationBody =
  NonReadonly<S3LoanAgreementDto>;
export type PostApiCommunicationUploadLoanAgreementMutationError = unknown;

export const usePostApiCommunicationUploadLoanAgreement = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>,
      TError,
      { data: NonReadonly<S3LoanAgreementDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationUploadLoanAgreement>>,
  TError,
  { data: NonReadonly<S3LoanAgreementDto> },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationUploadLoanAgreementMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationLoanAgreement = (
  params: GetApiCommunicationLoanAgreementParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListS3DocumentDto>(
    { url: `/api/communication/loanAgreement`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCommunicationLoanAgreementQueryKey = (
  params?: GetApiCommunicationLoanAgreementParams
) => {
  return [
    `/api/communication/loanAgreement`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationLoanAgreementQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
  TError = unknown
>(
  params: GetApiCommunicationLoanAgreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationLoanAgreementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>
  > = ({ signal }) =>
    getApiCommunicationLoanAgreement(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationLoanAgreementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>
>;
export type GetApiCommunicationLoanAgreementQueryError = unknown;

export function useGetApiCommunicationLoanAgreement<
  TData = Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
  TError = unknown
>(
  params: GetApiCommunicationLoanAgreementParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationLoanAgreement<
  TData = Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
  TError = unknown
>(
  params: GetApiCommunicationLoanAgreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationLoanAgreement<
  TData = Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
  TError = unknown
>(
  params: GetApiCommunicationLoanAgreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationLoanAgreement<
  TData = Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
  TError = unknown
>(
  params: GetApiCommunicationLoanAgreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationLoanAgreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationLoanAgreementQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationCustomerPermissions = (
  params: GetApiCommunicationCustomerPermissionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCommunicationPermissionContentDto>(
    {
      url: `/api/communication/customerPermissions`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationCustomerPermissionsQueryKey = (
  params?: GetApiCommunicationCustomerPermissionsParams
) => {
  return [
    `/api/communication/customerPermissions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationCustomerPermissionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
  TError = unknown
>(
  params: GetApiCommunicationCustomerPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationCustomerPermissionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>
  > = ({ signal }) =>
    getApiCommunicationCustomerPermissions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationCustomerPermissionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>
>;
export type GetApiCommunicationCustomerPermissionsQueryError = unknown;

export function useGetApiCommunicationCustomerPermissions<
  TData = Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
  TError = unknown
>(
  params: GetApiCommunicationCustomerPermissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationCustomerPermissions<
  TData = Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
  TError = unknown
>(
  params: GetApiCommunicationCustomerPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationCustomerPermissions<
  TData = Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
  TError = unknown
>(
  params: GetApiCommunicationCustomerPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationCustomerPermissions<
  TData = Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
  TError = unknown
>(
  params: GetApiCommunicationCustomerPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationCustomerPermissions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationCustomerPermissionsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationUpdateCommunicationPermission = (
  updateCommunicationPermissionDto: UpdateCommunicationPermissionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/updateCommunicationPermission`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateCommunicationPermissionDto,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationUpdateCommunicationPermissionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>
      >,
      TError,
      { data: UpdateCommunicationPermissionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>
    >,
    TError,
    { data: UpdateCommunicationPermissionDto },
    TContext
  > => {
    const mutationKey = ["postApiCommunicationUpdateCommunicationPermission"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>
      >,
      { data: UpdateCommunicationPermissionDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCommunicationUpdateCommunicationPermission(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCommunicationUpdateCommunicationPermissionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>
    >
  >;
export type PostApiCommunicationUpdateCommunicationPermissionMutationBody =
  UpdateCommunicationPermissionDto;
export type PostApiCommunicationUpdateCommunicationPermissionMutationError =
  unknown;

export const usePostApiCommunicationUpdateCommunicationPermission = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>
      >,
      TError,
      { data: UpdateCommunicationPermissionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationUpdateCommunicationPermission>>,
  TError,
  { data: UpdateCommunicationPermissionDto },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationUpdateCommunicationPermissionMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCommunicationCheckPermissions = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCommunicationPermissionDto>(
    {
      url: `/api/communication/checkPermissions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationCheckPermissionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCommunicationCheckPermissions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCommunicationCheckPermissions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationCheckPermissionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>
>;
export type PostApiCommunicationCheckPermissionsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCommunicationCheckPermissionsMutationError = unknown;

export const usePostApiCommunicationCheckPermissions = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationCheckPermissions>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationCheckPermissionsMutationOptions(options),
    queryClient
  );
};

export const getApiCommunicationPermissionHistory = (
  params: GetApiCommunicationPermissionHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCommunicationPermissionDto>(
    {
      url: `/api/communication/permissionHistory`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationPermissionHistoryQueryKey = (
  params?: GetApiCommunicationPermissionHistoryParams
) => {
  return [
    `/api/communication/permissionHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationPermissionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationPermissionHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>
  > = ({ signal }) =>
    getApiCommunicationPermissionHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationPermissionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>
>;
export type GetApiCommunicationPermissionHistoryQueryError = unknown;

export function useGetApiCommunicationPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationPermissionHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationPermissionHistoryQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCommunicationNcpPermissionHistory = (
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListNCPPermissionDto>(
    {
      url: `/api/communication/ncpPermissionHistory`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCommunicationNcpPermissionHistoryQueryKey = (
  params?: GetApiCommunicationNcpPermissionHistoryParams
) => {
  return [
    `/api/communication/ncpPermissionHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCommunicationNcpPermissionHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCommunicationNcpPermissionHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>
  > = ({ signal }) =>
    getApiCommunicationNcpPermissionHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCommunicationNcpPermissionHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>
>;
export type GetApiCommunicationNcpPermissionHistoryQueryError = unknown;

export function useGetApiCommunicationNcpPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNcpPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCommunicationNcpPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCommunicationNcpPermissionHistory<
  TData = Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
  TError = unknown
>(
  params: GetApiCommunicationNcpPermissionHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCommunicationNcpPermissionHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCommunicationNcpPermissionHistoryQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCommunicationRemoveNCPPermission = (
  params: PostApiCommunicationRemoveNCPPermissionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/communication/removeNCPPermission`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCommunicationRemoveNCPPermissionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>,
    TError,
    { params: PostApiCommunicationRemoveNCPPermissionParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>,
  TError,
  { params: PostApiCommunicationRemoveNCPPermissionParams },
  TContext
> => {
  const mutationKey = ["postApiCommunicationRemoveNCPPermission"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>,
    { params: PostApiCommunicationRemoveNCPPermissionParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCommunicationRemoveNCPPermission(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCommunicationRemoveNCPPermissionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>
>;

export type PostApiCommunicationRemoveNCPPermissionMutationError = unknown;

export const usePostApiCommunicationRemoveNCPPermission = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>,
      TError,
      { params: PostApiCommunicationRemoveNCPPermissionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCommunicationRemoveNCPPermission>>,
  TError,
  { params: PostApiCommunicationRemoveNCPPermissionParams },
  TContext
> => {
  return useMutation(
    getPostApiCommunicationRemoveNCPPermissionMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerNamematchEsComplex = (
  nameMatchWithFullNameRequestDtoArrayBody: NameMatchWithFullNameRequestDtoArrayBody,
  params: PostApiCustomerNamematchEsComplexParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListStringMatchDetailedResult>(
    {
      url: `/api/customer/namematch/esComplex`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nameMatchWithFullNameRequestDtoArrayBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerNamematchEsComplexMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>,
    TError,
    {
      data: NameMatchWithFullNameRequestDtoArrayBody;
      params: PostApiCustomerNamematchEsComplexParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>,
  TError,
  {
    data: NameMatchWithFullNameRequestDtoArrayBody;
    params: PostApiCustomerNamematchEsComplexParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCustomerNamematchEsComplex"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>,
    {
      data: NameMatchWithFullNameRequestDtoArrayBody;
      params: PostApiCustomerNamematchEsComplexParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerNamematchEsComplex(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerNamematchEsComplexMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>
>;
export type PostApiCustomerNamematchEsComplexMutationBody =
  NameMatchWithFullNameRequestDtoArrayBody;
export type PostApiCustomerNamematchEsComplexMutationError = unknown;

export const usePostApiCustomerNamematchEsComplex = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>,
      TError,
      {
        data: NameMatchWithFullNameRequestDtoArrayBody;
        params: PostApiCustomerNamematchEsComplexParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerNamematchEsComplex>>,
  TError,
  {
    data: NameMatchWithFullNameRequestDtoArrayBody;
    params: PostApiCustomerNamematchEsComplexParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCustomerNamematchEsComplexMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerNamematchDecision = (
  nameMatchWithSeparateNamesRequestDtoArrayBody: NameMatchWithSeparateNamesRequestDtoArrayBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanApplicationFlowValidationNameMatchResponseDto>(
    {
      url: `/api/customer/namematch/decision`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nameMatchWithSeparateNamesRequestDtoArrayBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerNamematchDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>,
    TError,
    { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>,
  TError,
  { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerNamematchDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>,
    { data: NameMatchWithSeparateNamesRequestDtoArrayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerNamematchDecision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerNamematchDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>
>;
export type PostApiCustomerNamematchDecisionMutationBody =
  NameMatchWithSeparateNamesRequestDtoArrayBody;
export type PostApiCustomerNamematchDecisionMutationError = unknown;

export const usePostApiCustomerNamematchDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>,
      TError,
      { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerNamematchDecision>>,
  TError,
  { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerNamematchDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerFindBlockedRepayTokens = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<BlockedRepayTokenResponseDto[]>(
    {
      url: `/api/customer/findBlockedRepayTokens`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerFindBlockedRepayTokensMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerFindBlockedRepayTokens"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerFindBlockedRepayTokens(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerFindBlockedRepayTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>
>;
export type PostApiCustomerFindBlockedRepayTokensMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiCustomerFindBlockedRepayTokensMutationError = unknown;

export const usePostApiCustomerFindBlockedRepayTokens = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerFindBlockedRepayTokens>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerFindBlockedRepayTokensMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetCustomersByEmail = (
  params: GetApiCustomerGetCustomersByEmailParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerResponseDto>(
    { url: `/api/customer/GetCustomersByEmail`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCustomerGetCustomersByEmailQueryKey = (
  params?: GetApiCustomerGetCustomersByEmailParams
) => {
  return [
    `/api/customer/GetCustomersByEmail`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetCustomersByEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomersByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetCustomersByEmailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>
  > = ({ signal }) =>
    getApiCustomerGetCustomersByEmail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetCustomersByEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>
>;
export type GetApiCustomerGetCustomersByEmailQueryError = unknown;

export function useGetApiCustomerGetCustomersByEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomersByEmailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomersByEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomersByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomersByEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomersByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetCustomersByEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomersByEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomersByEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetCustomersByEmailQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerFilteredCommunicationPhoneLogs = (
  communicationPhoneLogRequestDto: CommunicationPhoneLogRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultCommunicationPhoneLogResponseDto>(
    {
      url: `/api/customer/filteredCommunicationPhoneLogs`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationPhoneLogRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerFilteredCommunicationPhoneLogsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>,
    TError,
    { data: CommunicationPhoneLogRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>,
  TError,
  { data: CommunicationPhoneLogRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerFilteredCommunicationPhoneLogs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>,
    { data: CommunicationPhoneLogRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerFilteredCommunicationPhoneLogs(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerFilteredCommunicationPhoneLogsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>
  >;
export type PostApiCustomerFilteredCommunicationPhoneLogsMutationBody =
  CommunicationPhoneLogRequestDto;
export type PostApiCustomerFilteredCommunicationPhoneLogsMutationError =
  unknown;

export const usePostApiCustomerFilteredCommunicationPhoneLogs = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>,
      TError,
      { data: CommunicationPhoneLogRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerFilteredCommunicationPhoneLogs>>,
  TError,
  { data: CommunicationPhoneLogRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerFilteredCommunicationPhoneLogsMutationOptions(options),
    queryClient
  );
};

export const putApiCustomerCommunicationPhoneLog = (
  params: PutApiCustomerCommunicationPhoneLogParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/communicationPhoneLog`,
      method: "PUT",
      params,
      signal,
    },
    options
  );
};

export const getPutApiCustomerCommunicationPhoneLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>,
    TError,
    { params: PutApiCustomerCommunicationPhoneLogParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>,
  TError,
  { params: PutApiCustomerCommunicationPhoneLogParams },
  TContext
> => {
  const mutationKey = ["putApiCustomerCommunicationPhoneLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>,
    { params: PutApiCustomerCommunicationPhoneLogParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiCustomerCommunicationPhoneLog(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerCommunicationPhoneLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>
>;

export type PutApiCustomerCommunicationPhoneLogMutationError = unknown;

export const usePutApiCustomerCommunicationPhoneLog = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>,
      TError,
      { params: PutApiCustomerCommunicationPhoneLogParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerCommunicationPhoneLog>>,
  TError,
  { params: PutApiCustomerCommunicationPhoneLogParams },
  TContext
> => {
  return useMutation(
    getPutApiCustomerCommunicationPhoneLogMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCommunicationPhoneLog = (
  communicationPhoneLogDto: CommunicationPhoneLogDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/communicationPhoneLog`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationPhoneLogDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCommunicationPhoneLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>,
    TError,
    { data: CommunicationPhoneLogDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>,
  TError,
  { data: CommunicationPhoneLogDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerCommunicationPhoneLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>,
    { data: CommunicationPhoneLogDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCommunicationPhoneLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCommunicationPhoneLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>
>;
export type PostApiCustomerCommunicationPhoneLogMutationBody =
  CommunicationPhoneLogDto;
export type PostApiCustomerCommunicationPhoneLogMutationError = unknown;

export const usePostApiCustomerCommunicationPhoneLog = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>,
      TError,
      { data: CommunicationPhoneLogDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCommunicationPhoneLog>>,
  TError,
  { data: CommunicationPhoneLogDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCommunicationPhoneLogMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerUpdateCustomerAndStatusForAutomationTesting = (
  testAutomationDtoBody: TestAutomationDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/updateCustomerAndStatusForAutomationTesting`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: testAutomationDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerUpdateCustomerAndStatusForAutomationTestingMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
        >
      >,
      TError,
      { data: TestAutomationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
      >
    >,
    TError,
    { data: TestAutomationDtoBody },
    TContext
  > => {
    const mutationKey = [
      "postApiCustomerUpdateCustomerAndStatusForAutomationTesting",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
        >
      >,
      { data: TestAutomationDtoBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerUpdateCustomerAndStatusForAutomationTesting(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerUpdateCustomerAndStatusForAutomationTestingMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
      >
    >
  >;
export type PostApiCustomerUpdateCustomerAndStatusForAutomationTestingMutationBody =
  TestAutomationDtoBody;
export type PostApiCustomerUpdateCustomerAndStatusForAutomationTestingMutationError =
  unknown;

export const usePostApiCustomerUpdateCustomerAndStatusForAutomationTesting = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
        >
      >,
      TError,
      { data: TestAutomationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiCustomerUpdateCustomerAndStatusForAutomationTesting
    >
  >,
  TError,
  { data: TestAutomationDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerUpdateCustomerAndStatusForAutomationTestingMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCustomerGetPartnerEgressLink = (
  params: PostApiCustomerGetPartnerEgressLinkParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/getPartnerEgressLink`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerGetPartnerEgressLinkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>,
    TError,
    { params: PostApiCustomerGetPartnerEgressLinkParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>,
  TError,
  { params: PostApiCustomerGetPartnerEgressLinkParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerGetPartnerEgressLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>,
    { params: PostApiCustomerGetPartnerEgressLinkParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerGetPartnerEgressLink(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerGetPartnerEgressLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>
>;

export type PostApiCustomerGetPartnerEgressLinkMutationError = unknown;

export const usePostApiCustomerGetPartnerEgressLink = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>,
      TError,
      { params: PostApiCustomerGetPartnerEgressLinkParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerGetPartnerEgressLink>>,
  TError,
  { params: PostApiCustomerGetPartnerEgressLinkParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerGetPartnerEgressLinkMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerBulkStatus = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiCustomerBulkStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/customer/bulk/status`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerBulkStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerBulkStatus>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCustomerBulkStatusParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerBulkStatus>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCustomerBulkStatusParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCustomerBulkStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerBulkStatus>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCustomerBulkStatusParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerBulkStatus(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerBulkStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerBulkStatus>>
>;
export type PostApiCustomerBulkStatusMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerBulkStatusMutationError = unknown;

export const usePostApiCustomerBulkStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerBulkStatus>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiCustomerBulkStatusParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerBulkStatus>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCustomerBulkStatusParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCustomerBulkStatusMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerReclamationDocuments = (
  legalCollectionDocumentsMailDtoBody: LegalCollectionDocumentsMailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/customer/reclamationDocuments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalCollectionDocumentsMailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerReclamationDocumentsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>,
    TError,
    { data: LegalCollectionDocumentsMailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerReclamationDocuments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>,
    { data: LegalCollectionDocumentsMailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerReclamationDocuments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerReclamationDocumentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>
>;
export type PostApiCustomerReclamationDocumentsMutationBody =
  LegalCollectionDocumentsMailDtoBody;
export type PostApiCustomerReclamationDocumentsMutationError = unknown;

export const usePostApiCustomerReclamationDocuments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>,
      TError,
      { data: LegalCollectionDocumentsMailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerReclamationDocuments>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerReclamationDocumentsMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerReclamationExcelAssign = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCustomerReclamationExcelAssign200One
    | PostApiCustomerReclamationExcelAssign200Two
    | Blob
  >(
    { url: `/api/customer/reclamation/excelAssign`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerReclamationExcelAssignMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerReclamationExcelAssign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>,
    void
  > = () => {
    return postApiCustomerReclamationExcelAssign(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerReclamationExcelAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>
>;

export type PostApiCustomerReclamationExcelAssignMutationError = unknown;

export const usePostApiCustomerReclamationExcelAssign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerReclamationExcelAssign>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerReclamationExcelAssignMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCustomerDemandBODocumentsOne = (
  legalCollectionDocumentsMailDtoBody: LegalCollectionDocumentsMailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/customer/customerDemandBODocumentsOne`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalCollectionDocumentsMailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerDemandBODocumentsOneMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>,
    TError,
    { data: LegalCollectionDocumentsMailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerDemandBODocumentsOne"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>,
    { data: LegalCollectionDocumentsMailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCustomerDemandBODocumentsOne(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerDemandBODocumentsOneMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>
  >;
export type PostApiCustomerCustomerDemandBODocumentsOneMutationBody =
  LegalCollectionDocumentsMailDtoBody;
export type PostApiCustomerCustomerDemandBODocumentsOneMutationError = unknown;

export const usePostApiCustomerCustomerDemandBODocumentsOne = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>,
      TError,
      { data: LegalCollectionDocumentsMailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerDemandBODocumentsOne>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerDemandBODocumentsOneMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetCustomerAffilates = (
  params: GetApiCustomerGetCustomerAffilatesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerAffilateDto>(
    {
      url: `/api/customer/getCustomerAffilates`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetCustomerAffilatesQueryKey = (
  params?: GetApiCustomerGetCustomerAffilatesParams
) => {
  return [
    `/api/customer/getCustomerAffilates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetCustomerAffilatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerAffilatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetCustomerAffilatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>
  > = ({ signal }) =>
    getApiCustomerGetCustomerAffilates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetCustomerAffilatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>
>;
export type GetApiCustomerGetCustomerAffilatesQueryError = unknown;

export function useGetApiCustomerGetCustomerAffilates<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerAffilatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomerAffilates<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerAffilatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomerAffilates<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerAffilatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetCustomerAffilates<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerAffilatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerAffilates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetCustomerAffilatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCheckNewPhoneNumber = (
  params: PostApiCustomerCheckNewPhoneNumberParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerPhoneUpdateResponseDto>(
    {
      url: `/api/customer/CheckNewPhoneNumber`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCheckNewPhoneNumberMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>,
    TError,
    { params: PostApiCustomerCheckNewPhoneNumberParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>,
  TError,
  { params: PostApiCustomerCheckNewPhoneNumberParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerCheckNewPhoneNumber"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>,
    { params: PostApiCustomerCheckNewPhoneNumberParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerCheckNewPhoneNumber(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCheckNewPhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>
>;

export type PostApiCustomerCheckNewPhoneNumberMutationError = unknown;

export const usePostApiCustomerCheckNewPhoneNumber = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>,
      TError,
      { params: PostApiCustomerCheckNewPhoneNumberParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCheckNewPhoneNumber>>,
  TError,
  { params: PostApiCustomerCheckNewPhoneNumberParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCheckNewPhoneNumberMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerUpdatePhoneNumber = (
  customerPhoneUpdateRequestDto: CustomerPhoneUpdateRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/UpdatePhoneNumber`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerPhoneUpdateRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerUpdatePhoneNumberMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>,
    TError,
    { data: CustomerPhoneUpdateRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>,
  TError,
  { data: CustomerPhoneUpdateRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerUpdatePhoneNumber"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>,
    { data: CustomerPhoneUpdateRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerUpdatePhoneNumber(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerUpdatePhoneNumberMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>
>;
export type PostApiCustomerUpdatePhoneNumberMutationBody =
  CustomerPhoneUpdateRequestDto;
export type PostApiCustomerUpdatePhoneNumberMutationError = unknown;

export const usePostApiCustomerUpdatePhoneNumber = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>,
      TError,
      { data: CustomerPhoneUpdateRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerUpdatePhoneNumber>>,
  TError,
  { data: CustomerPhoneUpdateRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerUpdatePhoneNumberMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLegalCompanyInfoUploadExcel = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/legalCompanyInfo/uploadExcel`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCustomerLegalCompanyInfoUploadExcelMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerLegalCompanyInfoUploadExcel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>,
    void
  > = () => {
    return postApiCustomerLegalCompanyInfoUploadExcel(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLegalCompanyInfoUploadExcelMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>
  >;

export type PostApiCustomerLegalCompanyInfoUploadExcelMutationError = unknown;

export const usePostApiCustomerLegalCompanyInfoUploadExcel = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLegalCompanyInfoUploadExcel>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerLegalCompanyInfoUploadExcelMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetScrapedBankAccountByCustomer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListAccountDto>(
    {
      url: `/api/customer/getScrapedBankAccountByCustomer`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetScrapedBankAccountByCustomerQueryKey = () => {
  return [`/api/customer/getScrapedBankAccountByCustomer`] as const;
};

export const getGetApiCustomerGetScrapedBankAccountByCustomerQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetScrapedBankAccountByCustomerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>>
  > = ({ signal }) =>
    getApiCustomerGetScrapedBankAccountByCustomer(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetScrapedBankAccountByCustomerQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>>
  >;
export type GetApiCustomerGetScrapedBankAccountByCustomerQueryError = unknown;

export function useGetApiCustomerGetScrapedBankAccountByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedBankAccountByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedBankAccountByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetScrapedBankAccountByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountByCustomer>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerGetScrapedBankAccountByCustomerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerGetScrapedBankAccountHistorical = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListAccountDto>(
    {
      url: `/api/customer/getScrapedBankAccountHistorical`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetScrapedBankAccountHistoricalQueryKey = () => {
  return [`/api/customer/getScrapedBankAccountHistorical`] as const;
};

export const getGetApiCustomerGetScrapedBankAccountHistoricalQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetScrapedBankAccountHistoricalQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>>
  > = ({ signal }) =>
    getApiCustomerGetScrapedBankAccountHistorical(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetScrapedBankAccountHistoricalQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>>
  >;
export type GetApiCustomerGetScrapedBankAccountHistoricalQueryError = unknown;

export function useGetApiCustomerGetScrapedBankAccountHistorical<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedBankAccountHistorical<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedBankAccountHistorical<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetScrapedBankAccountHistorical<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetScrapedBankAccountHistorical>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerGetScrapedBankAccountHistoricalQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerUploadReceipts = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/customer/uploadReceipts`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerUploadReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerUploadReceipts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>,
    void
  > = () => {
    return postApiCustomerUploadReceipts(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerUploadReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>
>;

export type PostApiCustomerUploadReceiptsMutationError = unknown;

export const usePostApiCustomerUploadReceipts = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerUploadReceipts>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerUploadReceiptsMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetCustomerIntentLog = (
  params: GetApiCustomerGetCustomerIntentLogParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerIntentLogResponseDto>(
    {
      url: `/api/customer/GetCustomerIntentLog`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetCustomerIntentLogQueryKey = (
  params?: GetApiCustomerGetCustomerIntentLogParams
) => {
  return [
    `/api/customer/GetCustomerIntentLog`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetCustomerIntentLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerIntentLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetCustomerIntentLogQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>
  > = ({ signal }) =>
    getApiCustomerGetCustomerIntentLog(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetCustomerIntentLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>
>;
export type GetApiCustomerGetCustomerIntentLogQueryError = unknown;

export function useGetApiCustomerGetCustomerIntentLog<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerIntentLogParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomerIntentLog<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerIntentLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetCustomerIntentLog<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerIntentLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetCustomerIntentLog<
  TData = Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
  TError = unknown
>(
  params: GetApiCustomerGetCustomerIntentLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetCustomerIntentLog>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetCustomerIntentLogQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerInsertCustomerIntentLog = (
  customerIntentLogDtoBody: CustomerIntentLogDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/InsertCustomerIntentLog`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerIntentLogDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerInsertCustomerIntentLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>,
    TError,
    { data: CustomerIntentLogDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>,
  TError,
  { data: CustomerIntentLogDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerInsertCustomerIntentLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>,
    { data: CustomerIntentLogDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerInsertCustomerIntentLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerInsertCustomerIntentLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>
>;
export type PostApiCustomerInsertCustomerIntentLogMutationBody =
  CustomerIntentLogDtoBody;
export type PostApiCustomerInsertCustomerIntentLogMutationError = unknown;

export const usePostApiCustomerInsertCustomerIntentLog = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>,
      TError,
      { data: CustomerIntentLogDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerInsertCustomerIntentLog>>,
  TError,
  { data: CustomerIntentLogDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerInsertCustomerIntentLogMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerUpdateCustomerIntentLog = (
  customerIntentLogDtoBody: CustomerIntentLogDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/UpdateCustomerIntentLog`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerIntentLogDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerUpdateCustomerIntentLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>,
    TError,
    { data: CustomerIntentLogDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>,
  TError,
  { data: CustomerIntentLogDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerUpdateCustomerIntentLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>,
    { data: CustomerIntentLogDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerUpdateCustomerIntentLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerUpdateCustomerIntentLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>
>;
export type PostApiCustomerUpdateCustomerIntentLogMutationBody =
  CustomerIntentLogDtoBody;
export type PostApiCustomerUpdateCustomerIntentLogMutationError = unknown;

export const usePostApiCustomerUpdateCustomerIntentLog = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>,
      TError,
      { data: CustomerIntentLogDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerUpdateCustomerIntentLog>>,
  TError,
  { data: CustomerIntentLogDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerUpdateCustomerIntentLogMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetDeclineFlag = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDeclineFlagHistoryDto>(
    { url: `/api/customer/GetDeclineFlag`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerGetDeclineFlagQueryKey = () => {
  return [`/api/customer/GetDeclineFlag`] as const;
};

export const getGetApiCustomerGetDeclineFlagQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerGetDeclineFlagQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>
  > = ({ signal }) => getApiCustomerGetDeclineFlag(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetDeclineFlagQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>
>;
export type GetApiCustomerGetDeclineFlagQueryError = unknown;

export function useGetApiCustomerGetDeclineFlag<
  TData = Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetDeclineFlag<
  TData = Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetDeclineFlag<
  TData = Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetDeclineFlag<
  TData = Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetDeclineFlag>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetDeclineFlagQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerSignatureAudit = (
  createSignatureAuditLogRequestDto: CreateSignatureAuditLogRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSignatureAuditLogResponseDto>(
    {
      url: `/api/customer/signature-audit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSignatureAuditLogRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSignatureAuditMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>,
    TError,
    { data: CreateSignatureAuditLogRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>,
  TError,
  { data: CreateSignatureAuditLogRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerSignatureAudit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>,
    { data: CreateSignatureAuditLogRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerSignatureAudit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSignatureAuditMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>
>;
export type PostApiCustomerSignatureAuditMutationBody =
  CreateSignatureAuditLogRequestDto;
export type PostApiCustomerSignatureAuditMutationError = unknown;

export const usePostApiCustomerSignatureAudit = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>,
      TError,
      { data: CreateSignatureAuditLogRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSignatureAudit>>,
  TError,
  { data: CreateSignatureAuditLogRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSignatureAuditMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerSignatureAuditOtp = (
  updateSignatureAuditOtpRequestDto: UpdateSignatureAuditOtpRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSignatureAuditLogResponseDto>(
    {
      url: `/api/customer/signature-audit/otp`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: updateSignatureAuditOtpRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSignatureAuditOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>,
    TError,
    { data: UpdateSignatureAuditOtpRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>,
  TError,
  { data: UpdateSignatureAuditOtpRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerSignatureAuditOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>,
    { data: UpdateSignatureAuditOtpRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerSignatureAuditOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSignatureAuditOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>
>;
export type PostApiCustomerSignatureAuditOtpMutationBody =
  UpdateSignatureAuditOtpRequestDto;
export type PostApiCustomerSignatureAuditOtpMutationError = unknown;

export const usePostApiCustomerSignatureAuditOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>,
      TError,
      { data: UpdateSignatureAuditOtpRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditOtp>>,
  TError,
  { data: UpdateSignatureAuditOtpRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSignatureAuditOtpMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerSignatureAuditStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSignatureAuditLogResponseDto>(
    { url: `/api/customer/signature-audit/status`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerSignatureAuditStatusQueryKey = () => {
  return [`/api/customer/signature-audit/status`] as const;
};

export const getGetApiCustomerSignatureAuditStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerSignatureAuditStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>
  > = ({ signal }) =>
    getApiCustomerSignatureAuditStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerSignatureAuditStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>
>;
export type GetApiCustomerSignatureAuditStatusQueryError = unknown;

export function useGetApiCustomerSignatureAuditStatus<
  TData = Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerSignatureAuditStatus<
  TData = Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerSignatureAuditStatus<
  TData = Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerSignatureAuditStatus<
  TData = Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSignatureAuditStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerSignatureAuditStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerSignatureAuditResendOtp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSignatureAuditLogResponseDto>(
    { url: `/api/customer/signature-audit/resend-otp`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerSignatureAuditResendOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerSignatureAuditResendOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>,
    void
  > = () => {
    return postApiCustomerSignatureAuditResendOtp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSignatureAuditResendOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>
>;

export type PostApiCustomerSignatureAuditResendOtpMutationError = unknown;

export const usePostApiCustomerSignatureAuditResendOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSignatureAuditResendOtp>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerSignatureAuditResendOtpMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerMxAddessPostalCode = (
  params: PostApiCustomerMxAddessPostalCodeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMexicoPostalCodeDto>(
    {
      url: `/api/customer/mxAddess/postalCode`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerMxAddessPostalCodeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>,
    TError,
    { params: PostApiCustomerMxAddessPostalCodeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>,
  TError,
  { params: PostApiCustomerMxAddessPostalCodeParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerMxAddessPostalCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>,
    { params: PostApiCustomerMxAddessPostalCodeParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerMxAddessPostalCode(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerMxAddessPostalCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>
>;

export type PostApiCustomerMxAddessPostalCodeMutationError = unknown;

export const usePostApiCustomerMxAddessPostalCode = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>,
      TError,
      { params: PostApiCustomerMxAddessPostalCodeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerMxAddessPostalCode>>,
  TError,
  { params: PostApiCustomerMxAddessPostalCodeParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerMxAddessPostalCodeMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerMxAddessStateList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/customer/mxAddess/stateList`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerMxAddessStateListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerMxAddessStateList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>,
    void
  > = () => {
    return postApiCustomerMxAddessStateList(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerMxAddessStateListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>
>;

export type PostApiCustomerMxAddessStateListMutationError = unknown;

export const usePostApiCustomerMxAddessStateList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerMxAddessStateList>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerMxAddessStateListMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerMxAddessMunicipalityList = (
  params: PostApiCustomerMxAddessMunicipalityListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/customer/mxAddess/municipalityList`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerMxAddessMunicipalityListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>,
    TError,
    { params: PostApiCustomerMxAddessMunicipalityListParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>,
  TError,
  { params: PostApiCustomerMxAddessMunicipalityListParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerMxAddessMunicipalityList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>,
    { params: PostApiCustomerMxAddessMunicipalityListParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerMxAddessMunicipalityList(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerMxAddessMunicipalityListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>
>;

export type PostApiCustomerMxAddessMunicipalityListMutationError = unknown;

export const usePostApiCustomerMxAddessMunicipalityList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>,
      TError,
      { params: PostApiCustomerMxAddessMunicipalityListParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMunicipalityList>>,
  TError,
  { params: PostApiCustomerMxAddessMunicipalityListParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerMxAddessMunicipalityListMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerMxAddessMxColiniaList = (
  params: PostApiCustomerMxAddessMxColiniaListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/customer/mxAddess/MxColiniaList`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerMxAddessMxColiniaListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>,
    TError,
    { params: PostApiCustomerMxAddessMxColiniaListParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>,
  TError,
  { params: PostApiCustomerMxAddessMxColiniaListParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerMxAddessMxColiniaList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>,
    { params: PostApiCustomerMxAddessMxColiniaListParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerMxAddessMxColiniaList(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerMxAddessMxColiniaListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>
>;

export type PostApiCustomerMxAddessMxColiniaListMutationError = unknown;

export const usePostApiCustomerMxAddessMxColiniaList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>,
      TError,
      { params: PostApiCustomerMxAddessMxColiniaListParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerMxAddessMxColiniaList>>,
  TError,
  { params: PostApiCustomerMxAddessMxColiniaListParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerMxAddessMxColiniaListMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerMxAddessGetPostal = (
  params: PostApiCustomerMxAddessGetPostalParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMexicoPostalCodeDto>(
    { url: `/api/customer/mxAddess/getPostal`, method: "POST", params, signal },
    options
  );
};

export const getPostApiCustomerMxAddessGetPostalMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>,
    TError,
    { params: PostApiCustomerMxAddessGetPostalParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>,
  TError,
  { params: PostApiCustomerMxAddessGetPostalParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerMxAddessGetPostal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>,
    { params: PostApiCustomerMxAddessGetPostalParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerMxAddessGetPostal(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerMxAddessGetPostalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>
>;

export type PostApiCustomerMxAddessGetPostalMutationError = unknown;

export const usePostApiCustomerMxAddessGetPostal = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>,
      TError,
      { params: PostApiCustomerMxAddessGetPostalParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerMxAddessGetPostal>>,
  TError,
  { params: PostApiCustomerMxAddessGetPostalParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerMxAddessGetPostalMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightSendOtpNewEmailAddress = (
  newEmailOtpValidateRequestDtoBody: NewEmailOtpValidateRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/light/SendOtpNewEmailAddress`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: newEmailOtpValidateRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLightSendOtpNewEmailAddressMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>,
    TError,
    { data: NewEmailOtpValidateRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>,
  TError,
  { data: NewEmailOtpValidateRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerLightSendOtpNewEmailAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>,
    { data: NewEmailOtpValidateRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLightSendOtpNewEmailAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightSendOtpNewEmailAddressMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>
  >;
export type PostApiCustomerLightSendOtpNewEmailAddressMutationBody =
  NewEmailOtpValidateRequestDtoBody;
export type PostApiCustomerLightSendOtpNewEmailAddressMutationError = unknown;

export const usePostApiCustomerLightSendOtpNewEmailAddress = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>,
      TError,
      { data: NewEmailOtpValidateRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightSendOtpNewEmailAddress>>,
  TError,
  { data: NewEmailOtpValidateRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightSendOtpNewEmailAddressMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightValidateNewEmailOtp = (
  newEmailOtpValidateRequestDtoBody: NewEmailOtpValidateRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLightValidateEmailOtpResponseDto>(
    {
      url: `/api/customer/light/validateNewEmailOtp`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: newEmailOtpValidateRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLightValidateNewEmailOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>,
    TError,
    { data: NewEmailOtpValidateRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>,
  TError,
  { data: NewEmailOtpValidateRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerLightValidateNewEmailOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>,
    { data: NewEmailOtpValidateRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLightValidateNewEmailOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightValidateNewEmailOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>
>;
export type PostApiCustomerLightValidateNewEmailOtpMutationBody =
  NewEmailOtpValidateRequestDtoBody;
export type PostApiCustomerLightValidateNewEmailOtpMutationError = unknown;

export const usePostApiCustomerLightValidateNewEmailOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>,
      TError,
      { data: NewEmailOtpValidateRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightValidateNewEmailOtp>>,
  TError,
  { data: NewEmailOtpValidateRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightValidateNewEmailOtpMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCheckTinkLogin = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultNullableBoolean>(
    { url: `/api/customer/checkTinkLogin`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerCheckTinkLoginQueryKey = () => {
  return [`/api/customer/checkTinkLogin`] as const;
};

export const getGetApiCustomerCheckTinkLoginQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerCheckTinkLoginQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>
  > = ({ signal }) => getApiCustomerCheckTinkLogin(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCheckTinkLoginQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>
>;
export type GetApiCustomerCheckTinkLoginQueryError = unknown;

export function useGetApiCustomerCheckTinkLogin<
  TData = Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCheckTinkLogin<
  TData = Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCheckTinkLogin<
  TData = Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCheckTinkLogin<
  TData = Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCheckTinkLogin>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCheckTinkLoginQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerDengageTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/dengage-test`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerDengageTestQueryKey = () => {
  return [`/api/customer/dengage-test`] as const;
};

export const getGetApiCustomerDengageTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerDengageTestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerDengageTest>>
  > = ({ signal }) => getApiCustomerDengageTest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerDengageTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerDengageTest>>
>;
export type GetApiCustomerDengageTestQueryError = unknown;

export function useGetApiCustomerDengageTest<
  TData = Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerDengageTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerDengageTest<
  TData = Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerDengageTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerDengageTest<
  TData = Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerDengageTest<
  TData = Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerDengageTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerDengageTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerLevel1 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/level1`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerLevel1QueryKey = () => {
  return [`/api/customer/level1`] as const;
};

export const getGetApiCustomerLevel1QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerLevel1>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerLevel1>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCustomerLevel1QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerLevel1>>
  > = ({ signal }) => getApiCustomerLevel1(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerLevel1>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerLevel1QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerLevel1>>
>;
export type GetApiCustomerLevel1QueryError = unknown;

export function useGetApiCustomerLevel1<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel1>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel1>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel1>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel1>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel1<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel1>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel1>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel1>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel1>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel1<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel1>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerLevel1<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel1>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel1>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerLevel1QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerLevel2 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/level2`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerLevel2QueryKey = () => {
  return [`/api/customer/level2`] as const;
};

export const getGetApiCustomerLevel2QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerLevel2>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerLevel2>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCustomerLevel2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerLevel2>>
  > = ({ signal }) => getApiCustomerLevel2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerLevel2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerLevel2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerLevel2>>
>;
export type GetApiCustomerLevel2QueryError = unknown;

export function useGetApiCustomerLevel2<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel2>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel2>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel2<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel2>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel2>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel2>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel2<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel2>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerLevel2<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel2>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel2>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerLevel2QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerLevel3 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/level3`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerLevel3QueryKey = () => {
  return [`/api/customer/level3`] as const;
};

export const getGetApiCustomerLevel3QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerLevel3>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerLevel3>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCustomerLevel3QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerLevel3>>
  > = ({ signal }) => getApiCustomerLevel3(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerLevel3>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerLevel3QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerLevel3>>
>;
export type GetApiCustomerLevel3QueryError = unknown;

export function useGetApiCustomerLevel3<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel3>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel3>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel3>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel3<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel3>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel3>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerLevel3>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerLevel3>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerLevel3<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel3>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerLevel3<
  TData = Awaited<ReturnType<typeof getApiCustomerLevel3>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerLevel3>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerLevel3QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCustomerIdPekiWebhook = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCustomerCustomerIdPekiWebhook200One
    | PostApiCustomerCustomerIdPekiWebhook200Two
    | Blob
  >(
    { url: `/api/customer/${customerId}/PekiWebhook`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerCustomerIdPekiWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>,
    TError,
    { customerId: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>,
  TError,
  { customerId: number },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerIdPekiWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>,
    { customerId: number }
  > = (props) => {
    const { customerId } = props ?? {};

    return postApiCustomerCustomerIdPekiWebhook(customerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerIdPekiWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>
>;

export type PostApiCustomerCustomerIdPekiWebhookMutationError = unknown;

export const usePostApiCustomerCustomerIdPekiWebhook = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>,
      TError,
      { customerId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerIdPekiWebhook>>,
  TError,
  { customerId: number },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerIdPekiWebhookMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightRegister = (
  lightRegisterRequestDto: LightRegisterRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCreateCustomerResponseDto>(
    {
      url: `/api/customer/light/register`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lightRegisterRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLightRegisterMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightRegister>>,
    TError,
    { data: LightRegisterRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightRegister>>,
  TError,
  { data: LightRegisterRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerLightRegister"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightRegister>>,
    { data: LightRegisterRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLightRegister(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightRegisterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightRegister>>
>;
export type PostApiCustomerLightRegisterMutationBody = LightRegisterRequestDto;
export type PostApiCustomerLightRegisterMutationError = unknown;

export const usePostApiCustomerLightRegister = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightRegister>>,
      TError,
      { data: LightRegisterRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightRegister>>,
  TError,
  { data: LightRegisterRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightRegisterMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCheckPhoneDNI = (
  checkPhoneDNIRequest: CheckPhoneDNIRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCheckPhoneDNIResponse>(
    {
      url: `/api/customer/CheckPhoneDNI`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkPhoneDNIRequest,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCheckPhoneDNIMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>,
    TError,
    { data: CheckPhoneDNIRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>,
  TError,
  { data: CheckPhoneDNIRequest },
  TContext
> => {
  const mutationKey = ["postApiCustomerCheckPhoneDNI"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>,
    { data: CheckPhoneDNIRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCheckPhoneDNI(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCheckPhoneDNIMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>
>;
export type PostApiCustomerCheckPhoneDNIMutationBody = CheckPhoneDNIRequest;
export type PostApiCustomerCheckPhoneDNIMutationError = unknown;

export const usePostApiCustomerCheckPhoneDNI = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>,
      TError,
      { data: CheckPhoneDNIRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCheckPhoneDNI>>,
  TError,
  { data: CheckPhoneDNIRequest },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCheckPhoneDNIMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightValidateEmailOtp = (
  lightRegisterEmailOtpValidateRequestDto: LightRegisterEmailOtpValidateRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/light/validateEmailOtp`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: lightRegisterEmailOtpValidateRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLightValidateEmailOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>,
    TError,
    { data: LightRegisterEmailOtpValidateRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>,
  TError,
  { data: LightRegisterEmailOtpValidateRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerLightValidateEmailOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>,
    { data: LightRegisterEmailOtpValidateRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLightValidateEmailOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightValidateEmailOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>
>;
export type PostApiCustomerLightValidateEmailOtpMutationBody =
  LightRegisterEmailOtpValidateRequestDto;
export type PostApiCustomerLightValidateEmailOtpMutationError = unknown;

export const usePostApiCustomerLightValidateEmailOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>,
      TError,
      { data: LightRegisterEmailOtpValidateRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightValidateEmailOtp>>,
  TError,
  { data: LightRegisterEmailOtpValidateRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightValidateEmailOtpMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightResendEmailOtp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/light/resendEmailOtp`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerLightResendEmailOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerLightResendEmailOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>,
    void
  > = () => {
    return postApiCustomerLightResendEmailOtp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightResendEmailOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>
>;

export type PostApiCustomerLightResendEmailOtpMutationError = unknown;

export const usePostApiCustomerLightResendEmailOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightResendEmailOtp>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightResendEmailOtpMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightSendRegisterOtp = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/light/sendRegisterOtp`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerLightSendRegisterOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerLightSendRegisterOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>,
    void
  > = () => {
    return postApiCustomerLightSendRegisterOtp(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightSendRegisterOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>
>;

export type PostApiCustomerLightSendRegisterOtpMutationError = unknown;

export const usePostApiCustomerLightSendRegisterOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightSendRegisterOtp>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightSendRegisterOtpMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerLightPinValidate = (
  validatePinRequestDto: ValidatePinRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/light/pinValidate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validatePinRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLightPinValidateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>,
    TError,
    { data: ValidatePinRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>,
  TError,
  { data: ValidatePinRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerLightPinValidate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>,
    { data: ValidatePinRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLightPinValidate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLightPinValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>
>;
export type PostApiCustomerLightPinValidateMutationBody = ValidatePinRequestDto;
export type PostApiCustomerLightPinValidateMutationError = unknown;

export const usePostApiCustomerLightPinValidate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>,
      TError,
      { data: ValidatePinRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLightPinValidate>>,
  TError,
  { data: ValidatePinRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLightPinValidateMutationOptions(options),
    queryClient
  );
};

export const putApiCustomerLightSaveAddress = (
  lightUpdateCustomerAddressRequestDto: LightUpdateCustomerAddressRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/light/saveAddress`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: lightUpdateCustomerAddressRequestDto,
      signal,
    },
    options
  );
};

export const getPutApiCustomerLightSaveAddressMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>,
    TError,
    { data: LightUpdateCustomerAddressRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>,
  TError,
  { data: LightUpdateCustomerAddressRequestDto },
  TContext
> => {
  const mutationKey = ["putApiCustomerLightSaveAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>,
    { data: LightUpdateCustomerAddressRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return putApiCustomerLightSaveAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerLightSaveAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>
>;
export type PutApiCustomerLightSaveAddressMutationBody =
  LightUpdateCustomerAddressRequestDto;
export type PutApiCustomerLightSaveAddressMutationError = unknown;

export const usePutApiCustomerLightSaveAddress = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>,
      TError,
      { data: LightUpdateCustomerAddressRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerLightSaveAddress>>,
  TError,
  { data: LightUpdateCustomerAddressRequestDto },
  TContext
> => {
  return useMutation(
    getPutApiCustomerLightSaveAddressMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCommentPin = (
  params: PostApiCustomerCommentPinParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/comment/pin`, method: "POST", params, signal },
    options
  );
};

export const getPostApiCustomerCommentPinMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCommentPin>>,
    TError,
    { params: PostApiCustomerCommentPinParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCommentPin>>,
  TError,
  { params: PostApiCustomerCommentPinParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerCommentPin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCommentPin>>,
    { params: PostApiCustomerCommentPinParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerCommentPin(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCommentPinMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCommentPin>>
>;

export type PostApiCustomerCommentPinMutationError = unknown;

export const usePostApiCustomerCommentPin = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCommentPin>>,
      TError,
      { params: PostApiCustomerCommentPinParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCommentPin>>,
  TError,
  { params: PostApiCustomerCommentPinParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCommentPinMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCommentUnpin = (
  params: PostApiCustomerCommentUnpinParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/comment/unpin`, method: "POST", params, signal },
    options
  );
};

export const getPostApiCustomerCommentUnpinMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>,
    TError,
    { params: PostApiCustomerCommentUnpinParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>,
  TError,
  { params: PostApiCustomerCommentUnpinParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerCommentUnpin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>,
    { params: PostApiCustomerCommentUnpinParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerCommentUnpin(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCommentUnpinMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>
>;

export type PostApiCustomerCommentUnpinMutationError = unknown;

export const usePostApiCustomerCommentUnpin = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>,
      TError,
      { params: PostApiCustomerCommentUnpinParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCommentUnpin>>,
  TError,
  { params: PostApiCustomerCommentUnpinParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCommentUnpinMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCustomer = (
  params: GetApiCustomerCustomerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerDetailDto>(
    { url: `/api/customer/customer`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCustomerCustomerQueryKey = (
  params?: GetApiCustomerCustomerParams
) => {
  return [`/api/customer/customer`, ...(params ? [params] : [])] as const;
};

export const getGetApiCustomerCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCustomer>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerCustomerQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCustomer>>
  > = ({ signal }) => getApiCustomerCustomer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCustomer>>
>;
export type GetApiCustomerCustomerQueryError = unknown;

export function useGetApiCustomerCustomer<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomer>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomer<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomer>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomer<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomer>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCustomer<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomer>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCustomerQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiCustomerCustomer = (
  updateBasicCustomerDto: UpdateBasicCustomerDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/customer`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateBasicCustomerDto,
      signal,
    },
    options
  );
};

export const getPutApiCustomerCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerCustomer>>,
    TError,
    { data: UpdateBasicCustomerDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerCustomer>>,
  TError,
  { data: UpdateBasicCustomerDto },
  TContext
> => {
  const mutationKey = ["putApiCustomerCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerCustomer>>,
    { data: UpdateBasicCustomerDto }
  > = (props) => {
    const { data } = props ?? {};

    return putApiCustomerCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCustomerCustomer>>
>;
export type PutApiCustomerCustomerMutationBody = UpdateBasicCustomerDto;
export type PutApiCustomerCustomerMutationError = unknown;

export const usePutApiCustomerCustomer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerCustomer>>,
      TError,
      { data: UpdateBasicCustomerDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerCustomer>>,
  TError,
  { data: UpdateBasicCustomerDto },
  TContext
> => {
  return useMutation(
    getPutApiCustomerCustomerMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCustomer = (
  createCustomerRequestDtoBody: CreateCustomerRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCreateCustomerResponseDto>(
    {
      url: `/api/customer/customer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomer>>,
    TError,
    { data: CreateCustomerRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomer>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomer>>,
    { data: CreateCustomerRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCustomer>>
>;
export type PostApiCustomerCustomerMutationBody = CreateCustomerRequestDtoBody;
export type PostApiCustomerCustomerMutationError = unknown;

export const usePostApiCustomerCustomer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomer>>,
      TError,
      { data: CreateCustomerRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomer>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCreditlimit = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerLimitDto>(
    { url: `/api/customer/creditlimit`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerCreditlimitQueryKey = () => {
  return [`/api/customer/creditlimit`] as const;
};

export const getGetApiCustomerCreditlimitQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerCreditlimitQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCreditlimit>>
  > = ({ signal }) => getApiCustomerCreditlimit(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCreditlimitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCreditlimit>>
>;
export type GetApiCustomerCreditlimitQueryError = unknown;

export function useGetApiCustomerCreditlimit<
  TData = Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCreditlimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCreditlimit<
  TData = Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCreditlimit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCreditlimit<
  TData = Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCreditlimit<
  TData = Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCreditlimit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCreditlimitQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCreditlimit = (
  creditLimitDto: CreditLimitDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/creditlimit`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: creditLimitDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCreditlimitMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCreditlimit>>,
    TError,
    { data: CreditLimitDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCreditlimit>>,
  TError,
  { data: CreditLimitDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerCreditlimit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCreditlimit>>,
    { data: CreditLimitDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCreditlimit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCreditlimitMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCreditlimit>>
>;
export type PostApiCustomerCreditlimitMutationBody = CreditLimitDto;
export type PostApiCustomerCreditlimitMutationError = unknown;

export const usePostApiCustomerCreditlimit = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCreditlimit>>,
      TError,
      { data: CreditLimitDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCreditlimit>>,
  TError,
  { data: CreditLimitDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCreditlimitMutationOptions(options),
    queryClient
  );
};

export const putApiCustomerUpdateLimitWithSimulatedLimit = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/updateLimitWithSimulatedLimit`,
      method: "PUT",
      signal,
    },
    options
  );
};

export const getPutApiCustomerUpdateLimitWithSimulatedLimitMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["putApiCustomerUpdateLimitWithSimulatedLimit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>,
    void
  > = () => {
    return putApiCustomerUpdateLimitWithSimulatedLimit(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerUpdateLimitWithSimulatedLimitMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>
  >;

export type PutApiCustomerUpdateLimitWithSimulatedLimitMutationError = unknown;

export const usePutApiCustomerUpdateLimitWithSimulatedLimit = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerUpdateLimitWithSimulatedLimit>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPutApiCustomerUpdateLimitWithSimulatedLimitMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetFinancialInfo = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultGetFinancialInfoResponseDto>(
    { url: `/api/customer/getFinancialInfo`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerGetFinancialInfoQueryKey = () => {
  return [`/api/customer/getFinancialInfo`] as const;
};

export const getGetApiCustomerGetFinancialInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerGetFinancialInfoQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>
  > = ({ signal }) => getApiCustomerGetFinancialInfo(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetFinancialInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>
>;
export type GetApiCustomerGetFinancialInfoQueryError = unknown;

export function useGetApiCustomerGetFinancialInfo<
  TData = Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetFinancialInfo<
  TData = Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetFinancialInfo<
  TData = Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetFinancialInfo<
  TData = Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetFinancialInfo>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetFinancialInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerIsCustomerInformationMatched = (
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/IsCustomerInformationMatched`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerIsCustomerInformationMatchedQueryKey = (
  params?: GetApiCustomerIsCustomerInformationMatchedParams
) => {
  return [
    `/api/customer/IsCustomerInformationMatched`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerIsCustomerInformationMatchedQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerIsCustomerInformationMatchedQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>
  > = ({ signal }) =>
    getApiCustomerIsCustomerInformationMatched(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerIsCustomerInformationMatchedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>
>;
export type GetApiCustomerIsCustomerInformationMatchedQueryError = unknown;

export function useGetApiCustomerIsCustomerInformationMatched<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerIsCustomerInformationMatched<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
          >,
          TError,
          Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerIsCustomerInformationMatched<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerIsCustomerInformationMatched<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsCustomerInformationMatched>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsCustomerInformationMatchedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerIsCustomerInformationMatched>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerIsCustomerInformationMatchedQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerGetScrapedAccount = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScrapeResultDto>(
    { url: `/api/customer/getScrapedAccount`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerGetScrapedAccountQueryKey = () => {
  return [`/api/customer/getScrapedAccount`] as const;
};

export const getGetApiCustomerGetScrapedAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerGetScrapedAccountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>
  > = ({ signal }) => getApiCustomerGetScrapedAccount(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetScrapedAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>
>;
export type GetApiCustomerGetScrapedAccountQueryError = unknown;

export function useGetApiCustomerGetScrapedAccount<
  TData = Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedAccount<
  TData = Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetScrapedAccount<
  TData = Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetScrapedAccount<
  TData = Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetScrapedAccount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetScrapedAccountQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerUpdateColectionStatusForPromisedCustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/updateColectionStatusForPromisedCustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCustomerUpdateColectionStatusForPromisedCustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateColectionStatusForPromisedCustomers
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiCustomerUpdateColectionStatusForPromisedCustomers
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiCustomerUpdateColectionStatusForPromisedCustomers",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateColectionStatusForPromisedCustomers
        >
      >,
      void
    > = () => {
      return postApiCustomerUpdateColectionStatusForPromisedCustomers(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerUpdateColectionStatusForPromisedCustomersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiCustomerUpdateColectionStatusForPromisedCustomers
      >
    >
  >;

export type PostApiCustomerUpdateColectionStatusForPromisedCustomersMutationError =
  unknown;

export const usePostApiCustomerUpdateColectionStatusForPromisedCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerUpdateColectionStatusForPromisedCustomers
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCustomerUpdateColectionStatusForPromisedCustomers>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerUpdateColectionStatusForPromisedCustomersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCustomerSetCustomerStatusExternalCollection = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/setCustomerStatusExternalCollection`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSetCustomerStatusExternalCollectionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
    >,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiCustomerSetCustomerStatusExternalCollection"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerSetCustomerStatusExternalCollection(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerSetCustomerStatusExternalCollectionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
    >
  >;
export type PostApiCustomerSetCustomerStatusExternalCollectionMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerSetCustomerStatusExternalCollectionMutationError =
  unknown;

export const usePostApiCustomerSetCustomerStatusExternalCollection = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCustomerSetCustomerStatusExternalCollection>
  >,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSetCustomerStatusExternalCollectionMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCustomerGetlateststatus = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListAbc>(
    {
      url: `/api/customer/getlateststatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerGetlateststatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerGetlateststatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerGetlateststatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerGetlateststatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>
>;
export type PostApiCustomerGetlateststatusMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerGetlateststatusMutationError = unknown;

export const usePostApiCustomerGetlateststatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerGetlateststatus>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerGetlateststatusMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerSendLettersAuto = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/customer/sendLettersAuto`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerSendLettersAutoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerSendLettersAuto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>,
    void
  > = () => {
    return postApiCustomerSendLettersAuto(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSendLettersAutoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>
>;

export type PostApiCustomerSendLettersAutoMutationError = unknown;

export const usePostApiCustomerSendLettersAuto = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSendLettersAuto>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerSendLettersAutoMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerIsInEquifaxReportingExtractionList = (
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/isInEquifaxReportingExtractionList`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerIsInEquifaxReportingExtractionListQueryKey = (
  params?: GetApiCustomerIsInEquifaxReportingExtractionListParams
) => {
  return [
    `/api/customer/isInEquifaxReportingExtractionList`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerIsInEquifaxReportingExtractionListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerIsInEquifaxReportingExtractionListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>>
  > = ({ signal }) =>
    getApiCustomerIsInEquifaxReportingExtractionList(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerIsInEquifaxReportingExtractionListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>>
  >;
export type GetApiCustomerIsInEquifaxReportingExtractionListQueryError =
  unknown;

export function useGetApiCustomerIsInEquifaxReportingExtractionList<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerIsInEquifaxReportingExtractionList<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerIsInEquifaxReportingExtractionList<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerIsInEquifaxReportingExtractionList<
  TData = Awaited<
    ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
  >,
  TError = unknown
>(
  params: GetApiCustomerIsInEquifaxReportingExtractionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerIsInEquifaxReportingExtractionList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerIsInEquifaxReportingExtractionListQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerEquifaxInsertReportingExtraction = (
  params: PostApiCustomerEquifaxInsertReportingExtractionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/equifaxInsertReportingExtraction`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerEquifaxInsertReportingExtractionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>
      >,
      TError,
      { params: PostApiCustomerEquifaxInsertReportingExtractionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>>,
    TError,
    { params: PostApiCustomerEquifaxInsertReportingExtractionParams },
    TContext
  > => {
    const mutationKey = ["postApiCustomerEquifaxInsertReportingExtraction"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>
      >,
      { params: PostApiCustomerEquifaxInsertReportingExtractionParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCustomerEquifaxInsertReportingExtraction(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerEquifaxInsertReportingExtractionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>>
  >;

export type PostApiCustomerEquifaxInsertReportingExtractionMutationError =
  unknown;

export const usePostApiCustomerEquifaxInsertReportingExtraction = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>
      >,
      TError,
      { params: PostApiCustomerEquifaxInsertReportingExtractionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerEquifaxInsertReportingExtraction>>,
  TError,
  { params: PostApiCustomerEquifaxInsertReportingExtractionParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerEquifaxInsertReportingExtractionMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerEquifaxDeleteReportingExtraction = (
  params: PostApiCustomerEquifaxDeleteReportingExtractionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/equifaxDeleteReportingExtraction`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerEquifaxDeleteReportingExtractionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>
      >,
      TError,
      { params: PostApiCustomerEquifaxDeleteReportingExtractionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>>,
    TError,
    { params: PostApiCustomerEquifaxDeleteReportingExtractionParams },
    TContext
  > => {
    const mutationKey = ["postApiCustomerEquifaxDeleteReportingExtraction"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>
      >,
      { params: PostApiCustomerEquifaxDeleteReportingExtractionParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCustomerEquifaxDeleteReportingExtraction(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerEquifaxDeleteReportingExtractionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>>
  >;

export type PostApiCustomerEquifaxDeleteReportingExtractionMutationError =
  unknown;

export const usePostApiCustomerEquifaxDeleteReportingExtraction = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>
      >,
      TError,
      { params: PostApiCustomerEquifaxDeleteReportingExtractionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerEquifaxDeleteReportingExtraction>>,
  TError,
  { params: PostApiCustomerEquifaxDeleteReportingExtractionParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerEquifaxDeleteReportingExtractionMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerVerifyEmail = (
  params: GetApiCustomerVerifyEmailParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/verifyEmail`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCustomerVerifyEmailQueryKey = (
  params?: GetApiCustomerVerifyEmailParams
) => {
  return [`/api/customer/verifyEmail`, ...(params ? [params] : [])] as const;
};

export const getGetApiCustomerVerifyEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
  TError = unknown
>(
  params: GetApiCustomerVerifyEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerVerifyEmailQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>
  > = ({ signal }) => getApiCustomerVerifyEmail(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerVerifyEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>
>;
export type GetApiCustomerVerifyEmailQueryError = unknown;

export function useGetApiCustomerVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
  TError = unknown
>(
  params: GetApiCustomerVerifyEmailParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
  TError = unknown
>(
  params: GetApiCustomerVerifyEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
  TError = unknown
>(
  params: GetApiCustomerVerifyEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerVerifyEmail<
  TData = Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
  TError = unknown
>(
  params: GetApiCustomerVerifyEmailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerVerifyEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerVerifyEmailQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCustomerx = (
  createCustomerRequestDtoBody: CreateCustomerRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCreateCustomerResponseDto>(
    {
      url: `/api/customer/customerx`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerxMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerx>>,
    TError,
    { data: CreateCustomerRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerx>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerx"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerx>>,
    { data: CreateCustomerRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCustomerx(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerxMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCustomerx>>
>;
export type PostApiCustomerCustomerxMutationBody = CreateCustomerRequestDtoBody;
export type PostApiCustomerCustomerxMutationError = unknown;

export const usePostApiCustomerCustomerx = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerx>>,
      TError,
      { data: CreateCustomerRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerx>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerxMutationOptions(options),
    queryClient
  );
};

export const putApiCustomerUpdateCustomerV2 = (
  createCustomerRequestDtoBody: CreateCustomerRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/updateCustomerV2`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: createCustomerRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiCustomerUpdateCustomerV2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>,
    TError,
    { data: CreateCustomerRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  const mutationKey = ["putApiCustomerUpdateCustomerV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>,
    { data: CreateCustomerRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiCustomerUpdateCustomerV2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerUpdateCustomerV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>
>;
export type PutApiCustomerUpdateCustomerV2MutationBody =
  CreateCustomerRequestDtoBody;
export type PutApiCustomerUpdateCustomerV2MutationError = unknown;

export const usePutApiCustomerUpdateCustomerV2 = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>,
      TError,
      { data: CreateCustomerRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerUpdateCustomerV2>>,
  TError,
  { data: CreateCustomerRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiCustomerUpdateCustomerV2MutationOptions(options),
    queryClient
  );
};

export const postApiCustomerHandoverLogin = (
  params: PostApiCustomerHandoverLoginParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPartnerHandoverLoginEndpointResponseDto>(
    { url: `/api/customer/handover/login`, method: "POST", params, signal },
    options
  );
};

export const getPostApiCustomerHandoverLoginMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>,
    TError,
    { params: PostApiCustomerHandoverLoginParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>,
  TError,
  { params: PostApiCustomerHandoverLoginParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerHandoverLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>,
    { params: PostApiCustomerHandoverLoginParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerHandoverLogin(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerHandoverLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>
>;

export type PostApiCustomerHandoverLoginMutationError = unknown;

export const usePostApiCustomerHandoverLogin = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>,
      TError,
      { params: PostApiCustomerHandoverLoginParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerHandoverLogin>>,
  TError,
  { params: PostApiCustomerHandoverLoginParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerHandoverLoginMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerStartDengageSyncJob = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCustomerStartDengageSyncJob200One
    | PostApiCustomerStartDengageSyncJob200Two
    | Blob
  >(
    { url: `/api/customer/startDengageSyncJob`, method: "POST", signal },
    options
  );
};

export const getPostApiCustomerStartDengageSyncJobMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerStartDengageSyncJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>,
    void
  > = () => {
    return postApiCustomerStartDengageSyncJob(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerStartDengageSyncJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>
>;

export type PostApiCustomerStartDengageSyncJobMutationError = unknown;

export const usePostApiCustomerStartDengageSyncJob = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerStartDengageSyncJob>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerStartDengageSyncJobMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerHandoverOtp = (
  partnerHandoverLoginOtpRequestDto: PartnerHandoverLoginOtpRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPartnerHandoverLoginEndpointResponseDto>(
    {
      url: `/api/customer/handover/otp`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: partnerHandoverLoginOtpRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerHandoverOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>,
    TError,
    { data: PartnerHandoverLoginOtpRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>,
  TError,
  { data: PartnerHandoverLoginOtpRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerHandoverOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>,
    { data: PartnerHandoverLoginOtpRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerHandoverOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerHandoverOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>
>;
export type PostApiCustomerHandoverOtpMutationBody =
  PartnerHandoverLoginOtpRequestDto;
export type PostApiCustomerHandoverOtpMutationError = unknown;

export const usePostApiCustomerHandoverOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>,
      TError,
      { data: PartnerHandoverLoginOtpRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerHandoverOtp>>,
  TError,
  { data: PartnerHandoverLoginOtpRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerHandoverOtpMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerHandoverSmsControl = (
  params: PostApiCustomerHandoverSmsControlParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPartnerHandoverSmsInfoDto>(
    {
      url: `/api/customer/handover/smsControl`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerHandoverSmsControlMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>,
    TError,
    { params: PostApiCustomerHandoverSmsControlParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>,
  TError,
  { params: PostApiCustomerHandoverSmsControlParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerHandoverSmsControl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>,
    { params: PostApiCustomerHandoverSmsControlParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerHandoverSmsControl(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerHandoverSmsControlMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>
>;

export type PostApiCustomerHandoverSmsControlMutationError = unknown;

export const usePostApiCustomerHandoverSmsControl = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>,
      TError,
      { params: PostApiCustomerHandoverSmsControlParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerHandoverSmsControl>>,
  TError,
  { params: PostApiCustomerHandoverSmsControlParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerHandoverSmsControlMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCheckLoanAssignToCam = (
  params: PostApiCustomerCheckLoanAssignToCamParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/checkLoanAssignToCam`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCheckLoanAssignToCamMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>,
    TError,
    { params: PostApiCustomerCheckLoanAssignToCamParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>,
  TError,
  { params: PostApiCustomerCheckLoanAssignToCamParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerCheckLoanAssignToCam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>,
    { params: PostApiCustomerCheckLoanAssignToCamParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerCheckLoanAssignToCam(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCheckLoanAssignToCamMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>
>;

export type PostApiCustomerCheckLoanAssignToCamMutationError = unknown;

export const usePostApiCustomerCheckLoanAssignToCam = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>,
      TError,
      { params: PostApiCustomerCheckLoanAssignToCamParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCheckLoanAssignToCam>>,
  TError,
  { params: PostApiCustomerCheckLoanAssignToCamParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCheckLoanAssignToCamMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAttachAffilates = (
  attachAffilatesRequestDtoBody: AttachAffilatesRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/attachAffilates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: attachAffilatesRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAttachAffilatesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>,
    TError,
    { data: AttachAffilatesRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>,
  TError,
  { data: AttachAffilatesRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerAttachAffilates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>,
    { data: AttachAffilatesRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAttachAffilates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAttachAffilatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>
>;
export type PostApiCustomerAttachAffilatesMutationBody =
  AttachAffilatesRequestDtoBody;
export type PostApiCustomerAttachAffilatesMutationError = unknown;

export const usePostApiCustomerAttachAffilates = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>,
      TError,
      { data: AttachAffilatesRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAttachAffilates>>,
  TError,
  { data: AttachAffilatesRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAttachAffilatesMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAffilateClick = (
  attachAffilatesRequestDtoBody: AttachAffilatesRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/affilateClick`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: attachAffilatesRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAffilateClickMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAffilateClick>>,
    TError,
    { data: AttachAffilatesRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAffilateClick>>,
  TError,
  { data: AttachAffilatesRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerAffilateClick"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAffilateClick>>,
    { data: AttachAffilatesRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAffilateClick(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAffilateClickMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAffilateClick>>
>;
export type PostApiCustomerAffilateClickMutationBody =
  AttachAffilatesRequestDtoBody;
export type PostApiCustomerAffilateClickMutationError = unknown;

export const usePostApiCustomerAffilateClick = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAffilateClick>>,
      TError,
      { data: AttachAffilatesRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAffilateClick>>,
  TError,
  { data: AttachAffilatesRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAffilateClickMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerAffilateConversionStepProcess = (
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/affilateConversionStepProcess`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerAffilateConversionStepProcessQueryKey = (
  params?: GetApiCustomerAffilateConversionStepProcessParams
) => {
  return [
    `/api/customer/affilateConversionStepProcess`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerAffilateConversionStepProcessQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
  >,
  TError = unknown
>(
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerAffilateConversionStepProcessQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>
  > = ({ signal }) =>
    getApiCustomerAffilateConversionStepProcess(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerAffilateConversionStepProcessQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>
  >;
export type GetApiCustomerAffilateConversionStepProcessQueryError = unknown;

export function useGetApiCustomerAffilateConversionStepProcess<
  TData = Awaited<
    ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
  >,
  TError = unknown
>(
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAffilateConversionStepProcess<
  TData = Awaited<
    ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
  >,
  TError = unknown
>(
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAffilateConversionStepProcess<
  TData = Awaited<
    ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
  >,
  TError = unknown
>(
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerAffilateConversionStepProcess<
  TData = Awaited<
    ReturnType<typeof getApiCustomerAffilateConversionStepProcess>
  >,
  TError = unknown
>(
  params: GetApiCustomerAffilateConversionStepProcessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAffilateConversionStepProcess>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerAffilateConversionStepProcessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerSetCustomersBlacklist = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiCustomerSetCustomersBlacklistParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBulkBlacklistResponseDto>(
    {
      url: `/api/customer/setCustomersBlacklist`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSetCustomersBlacklistMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCustomerSetCustomersBlacklistParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCustomerSetCustomersBlacklistParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCustomerSetCustomersBlacklist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiCustomerSetCustomersBlacklistParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerSetCustomersBlacklist(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSetCustomersBlacklistMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>
>;
export type PostApiCustomerSetCustomersBlacklistMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerSetCustomersBlacklistMutationError = unknown;

export const usePostApiCustomerSetCustomersBlacklist = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiCustomerSetCustomersBlacklistParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSetCustomersBlacklist>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiCustomerSetCustomersBlacklistParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSetCustomersBlacklistMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerUpdateComment = (
  commentUpdateDto: CommentUpdateDto,
  params: PostApiCustomerUpdateCommentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/updateComment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: commentUpdateDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerUpdateCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerUpdateComment>>,
    TError,
    { data: CommentUpdateDto; params: PostApiCustomerUpdateCommentParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerUpdateComment>>,
  TError,
  { data: CommentUpdateDto; params: PostApiCustomerUpdateCommentParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerUpdateComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerUpdateComment>>,
    { data: CommentUpdateDto; params: PostApiCustomerUpdateCommentParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerUpdateComment(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerUpdateCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerUpdateComment>>
>;
export type PostApiCustomerUpdateCommentMutationBody = CommentUpdateDto;
export type PostApiCustomerUpdateCommentMutationError = unknown;

export const usePostApiCustomerUpdateComment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerUpdateComment>>,
      TError,
      { data: CommentUpdateDto; params: PostApiCustomerUpdateCommentParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerUpdateComment>>,
  TError,
  { data: CommentUpdateDto; params: PostApiCustomerUpdateCommentParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerUpdateCommentMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddOrUpdateAutoCommentBulk = (
  autoCommentDto: AutoCommentDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/addOrUpdateAutoCommentBulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: autoCommentDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddOrUpdateAutoCommentBulkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>,
    TError,
    { data: AutoCommentDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>,
  TError,
  { data: AutoCommentDto[] },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddOrUpdateAutoCommentBulk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>,
    { data: AutoCommentDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddOrUpdateAutoCommentBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddOrUpdateAutoCommentBulkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>
  >;
export type PostApiCustomerAddOrUpdateAutoCommentBulkMutationBody =
  AutoCommentDto[];
export type PostApiCustomerAddOrUpdateAutoCommentBulkMutationError = unknown;

export const usePostApiCustomerAddOrUpdateAutoCommentBulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>,
      TError,
      { data: AutoCommentDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddOrUpdateAutoCommentBulk>>,
  TError,
  { data: AutoCommentDto[] },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddOrUpdateAutoCommentBulkMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAssigncustomertocollectioncompanybulk = (
  assignCustomerToCollectionCompanyMultipleDto: AssignCustomerToCollectionCompanyMultipleDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/assigncustomertocollectioncompanybulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: assignCustomerToCollectionCompanyMultipleDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAssigncustomertocollectioncompanybulkMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
      >,
      TError,
      { data: AssignCustomerToCollectionCompanyMultipleDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
    >,
    TError,
    { data: AssignCustomerToCollectionCompanyMultipleDto },
    TContext
  > => {
    const mutationKey = [
      "postApiCustomerAssigncustomertocollectioncompanybulk",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
      >,
      { data: AssignCustomerToCollectionCompanyMultipleDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerAssigncustomertocollectioncompanybulk(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerAssigncustomertocollectioncompanybulkMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
    >
  >;
export type PostApiCustomerAssigncustomertocollectioncompanybulkMutationBody =
  AssignCustomerToCollectionCompanyMultipleDto;
export type PostApiCustomerAssigncustomertocollectioncompanybulkMutationError =
  unknown;

export const usePostApiCustomerAssigncustomertocollectioncompanybulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
      >,
      TError,
      { data: AssignCustomerToCollectionCompanyMultipleDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCustomerAssigncustomertocollectioncompanybulk>
  >,
  TError,
  { data: AssignCustomerToCollectionCompanyMultipleDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAssigncustomertocollectioncompanybulkMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiCustomerSuspectedLoginRelatedUsers = (
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSuspectedLoginRelatedUsersResultDto>(
    {
      url: `/api/customer/suspectedLoginRelatedUsers`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerSuspectedLoginRelatedUsersQueryKey = (
  params?: GetApiCustomerSuspectedLoginRelatedUsersParams
) => {
  return [
    `/api/customer/suspectedLoginRelatedUsers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerSuspectedLoginRelatedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
  TError = unknown
>(
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerSuspectedLoginRelatedUsersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>
  > = ({ signal }) =>
    getApiCustomerSuspectedLoginRelatedUsers(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerSuspectedLoginRelatedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>
>;
export type GetApiCustomerSuspectedLoginRelatedUsersQueryError = unknown;

export function useGetApiCustomerSuspectedLoginRelatedUsers<
  TData = Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
  TError = unknown
>(
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerSuspectedLoginRelatedUsers<
  TData = Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
  TError = unknown
>(
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerSuspectedLoginRelatedUsers<
  TData = Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
  TError = unknown
>(
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerSuspectedLoginRelatedUsers<
  TData = Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
  TError = unknown
>(
  params: GetApiCustomerSuspectedLoginRelatedUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerSuspectedLoginRelatedUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerSuspectedLoginRelatedUsersQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerResetCustomersRepayToken = (
  params: PostApiCustomerResetCustomersRepayTokenParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64String>(
    {
      url: `/api/customer/resetCustomersRepayToken`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerResetCustomersRepayTokenMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>,
    TError,
    { params: PostApiCustomerResetCustomersRepayTokenParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>,
  TError,
  { params: PostApiCustomerResetCustomersRepayTokenParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerResetCustomersRepayToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>,
    { params: PostApiCustomerResetCustomersRepayTokenParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerResetCustomersRepayToken(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerResetCustomersRepayTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>
>;

export type PostApiCustomerResetCustomersRepayTokenMutationError = unknown;

export const usePostApiCustomerResetCustomersRepayToken = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>,
      TError,
      { params: PostApiCustomerResetCustomersRepayTokenParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerResetCustomersRepayToken>>,
  TError,
  { params: PostApiCustomerResetCustomersRepayTokenParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerResetCustomersRepayTokenMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerResetCustomersRepayTokenWithPhoneNumbers = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/resetCustomersRepayTokenWithPhoneNumbers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerResetCustomersRepayTokenWithPhoneNumbersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers
        >
      >,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers>
    >,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  > => {
    const mutationKey = [
      "postApiCustomerResetCustomersRepayTokenWithPhoneNumbers",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers
        >
      >,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerResetCustomersRepayTokenWithPhoneNumbers(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerResetCustomersRepayTokenWithPhoneNumbersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers>
    >
  >;
export type PostApiCustomerResetCustomersRepayTokenWithPhoneNumbersMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiCustomerResetCustomersRepayTokenWithPhoneNumbersMutationError =
  unknown;

export const usePostApiCustomerResetCustomersRepayTokenWithPhoneNumbers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers
        >
      >,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCustomerResetCustomersRepayTokenWithPhoneNumbers>
  >,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerResetCustomersRepayTokenWithPhoneNumbersMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiCustomerCustomerCreditTypeHistory = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerCreditTypeDto>(
    { url: `/api/customer/customerCreditTypeHistory`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerCustomerCreditTypeHistoryQueryKey = () => {
  return [`/api/customer/customerCreditTypeHistory`] as const;
};

export const getGetApiCustomerCustomerCreditTypeHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerCustomerCreditTypeHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>
  > = ({ signal }) =>
    getApiCustomerCustomerCreditTypeHistory(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCustomerCreditTypeHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>
>;
export type GetApiCustomerCustomerCreditTypeHistoryQueryError = unknown;

export function useGetApiCustomerCustomerCreditTypeHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerCreditTypeHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerCreditTypeHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCustomerCreditTypeHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerCreditTypeHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerCustomerCreditTypeHistoryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerSetCustomerStatusLegalCollection = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/setCustomerStatusLegalCollection`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSetCustomerStatusLegalCollectionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiCustomerSetCustomerStatusLegalCollection"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerSetCustomerStatusLegalCollection(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerSetCustomerStatusLegalCollectionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>>
  >;
export type PostApiCustomerSetCustomerStatusLegalCollectionMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerSetCustomerStatusLegalCollectionMutationError =
  unknown;

export const usePostApiCustomerSetCustomerStatusLegalCollection = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusLegalCollection>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSetCustomerStatusLegalCollectionMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddNewEmail = (
  createCommunicationRequestDtoBody: CreateCommunicationRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/AddNewEmail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCommunicationRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddNewEmailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>,
    TError,
    { data: CreateCommunicationRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddNewEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>,
    { data: CreateCommunicationRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddNewEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddNewEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>
>;
export type PostApiCustomerAddNewEmailMutationBody =
  CreateCommunicationRequestDtoBody;
export type PostApiCustomerAddNewEmailMutationError = unknown;

export const usePostApiCustomerAddNewEmail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>,
      TError,
      { data: CreateCommunicationRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddNewEmail>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddNewEmailMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCollectionCompanyHistory = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerCollectionCompanyHistoryDto>(
    { url: `/api/customer/collectionCompanyHistory`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerCollectionCompanyHistoryQueryKey = () => {
  return [`/api/customer/collectionCompanyHistory`] as const;
};

export const getGetApiCustomerCollectionCompanyHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerCollectionCompanyHistoryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>
  > = ({ signal }) =>
    getApiCustomerCollectionCompanyHistory(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCollectionCompanyHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>
>;
export type GetApiCustomerCollectionCompanyHistoryQueryError = unknown;

export function useGetApiCustomerCollectionCompanyHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCollectionCompanyHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCollectionCompanyHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCollectionCompanyHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCollectionCompanyHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerCollectionCompanyHistoryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerValidateDni = (
  params: GetApiCustomerValidateDniParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/customer/validateDni`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCustomerValidateDniQueryKey = (
  params?: GetApiCustomerValidateDniParams
) => {
  return [`/api/customer/validateDni`, ...(params ? [params] : [])] as const;
};

export const getGetApiCustomerValidateDniQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
  TError = unknown
>(
  params: GetApiCustomerValidateDniParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerValidateDniQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerValidateDni>>
  > = ({ signal }) => getApiCustomerValidateDni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerValidateDniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerValidateDni>>
>;
export type GetApiCustomerValidateDniQueryError = unknown;

export function useGetApiCustomerValidateDni<
  TData = Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
  TError = unknown
>(
  params: GetApiCustomerValidateDniParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerValidateDni>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerValidateDni<
  TData = Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
  TError = unknown
>(
  params: GetApiCustomerValidateDniParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerValidateDni>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerValidateDni<
  TData = Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
  TError = unknown
>(
  params: GetApiCustomerValidateDniParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerValidateDni<
  TData = Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
  TError = unknown
>(
  params: GetApiCustomerValidateDniParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerValidateDni>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerValidateDniQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerCustomerForLoginRedirection = (
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerForLoginRedirectionResponseDto>(
    {
      url: `/api/customer/customerForLoginRedirection`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerCustomerForLoginRedirectionQueryKey = (
  params?: GetApiCustomerCustomerForLoginRedirectionParams
) => {
  return [
    `/api/customer/customerForLoginRedirection`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerCustomerForLoginRedirectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerCustomerForLoginRedirectionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>
  > = ({ signal }) =>
    getApiCustomerCustomerForLoginRedirection(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCustomerForLoginRedirectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>
>;
export type GetApiCustomerCustomerForLoginRedirectionQueryError = unknown;

export function useGetApiCustomerCustomerForLoginRedirection<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerForLoginRedirection<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerForLoginRedirection<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCustomerForLoginRedirection<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerForLoginRedirectionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerForLoginRedirection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCustomerForLoginRedirectionQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerUndeleteCustomers = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/undeleteCustomers`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerUndeleteCustomersMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerUndeleteCustomers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerUndeleteCustomers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerUndeleteCustomersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>
>;
export type PostApiCustomerUndeleteCustomersMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiCustomerUndeleteCustomersMutationError = unknown;

export const usePostApiCustomerUndeleteCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerUndeleteCustomers>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerUndeleteCustomersMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddToCustomerFullStory = (
  customerFullStoryDto: CustomerFullStoryDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/addToCustomerFullStory`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerFullStoryDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddToCustomerFullStoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>,
    TError,
    { data: CustomerFullStoryDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>,
  TError,
  { data: CustomerFullStoryDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddToCustomerFullStory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>,
    { data: CustomerFullStoryDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddToCustomerFullStory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddToCustomerFullStoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>
>;
export type PostApiCustomerAddToCustomerFullStoryMutationBody =
  CustomerFullStoryDto;
export type PostApiCustomerAddToCustomerFullStoryMutationError = unknown;

export const usePostApiCustomerAddToCustomerFullStory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>,
      TError,
      { data: CustomerFullStoryDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddToCustomerFullStory>>,
  TError,
  { data: CustomerFullStoryDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddToCustomerFullStoryMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerAutoIC = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/customer/autoIC`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerAutoICQueryKey = () => {
  return [`/api/customer/autoIC`] as const;
};

export const getGetApiCustomerAutoICQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCustomerAutoICQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerAutoIC>>
  > = ({ signal }) => getApiCustomerAutoIC(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerAutoICQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerAutoIC>>
>;
export type GetApiCustomerAutoICQueryError = unknown;

export function useGetApiCustomerAutoIC<
  TData = Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerAutoIC>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAutoIC<
  TData = Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerAutoIC>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAutoIC<
  TData = Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerAutoIC<
  TData = Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAutoIC>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerAutoICQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerAutoLegalCollectionDocumentsUpload = (
  params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/autoLegalCollectionDocumentsUpload`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAutoLegalCollectionDocumentsUploadMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>
      >,
      TError,
      { params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>
    >,
    TError,
    { params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams },
    TContext
  > => {
    const mutationKey = ["postApiCustomerAutoLegalCollectionDocumentsUpload"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>
      >,
      { params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCustomerAutoLegalCollectionDocumentsUpload(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerAutoLegalCollectionDocumentsUploadMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>
    >
  >;

export type PostApiCustomerAutoLegalCollectionDocumentsUploadMutationError =
  unknown;

export const usePostApiCustomerAutoLegalCollectionDocumentsUpload = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>
      >,
      TError,
      { params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAutoLegalCollectionDocumentsUpload>>,
  TError,
  { params: PostApiCustomerAutoLegalCollectionDocumentsUploadParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAutoLegalCollectionDocumentsUploadMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCustomerLegalCollectionDocumentsMail = (
  legalCollectionDocumentsMailDtoBody: LegalCollectionDocumentsMailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/legalCollectionDocumentsMail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: legalCollectionDocumentsMailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerLegalCollectionDocumentsMailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>,
    TError,
    { data: LegalCollectionDocumentsMailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerLegalCollectionDocumentsMail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>,
    { data: LegalCollectionDocumentsMailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerLegalCollectionDocumentsMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerLegalCollectionDocumentsMailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>
  >;
export type PostApiCustomerLegalCollectionDocumentsMailMutationBody =
  LegalCollectionDocumentsMailDtoBody;
export type PostApiCustomerLegalCollectionDocumentsMailMutationError = unknown;

export const usePostApiCustomerLegalCollectionDocumentsMail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>,
      TError,
      { data: LegalCollectionDocumentsMailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerLegalCollectionDocumentsMail>>,
  TError,
  { data: LegalCollectionDocumentsMailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerLegalCollectionDocumentsMailMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCustomerSummaryForChatbot = (
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiCustomerCustomerSummaryForChatbot200One
    | GetApiCustomerCustomerSummaryForChatbot200Two
    | Blob
  >(
    {
      url: `/api/customer/customerSummaryForChatbot`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerCustomerSummaryForChatbotQueryKey = (
  params?: GetApiCustomerCustomerSummaryForChatbotParams
) => {
  return [
    `/api/customer/customerSummaryForChatbot`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerCustomerSummaryForChatbotQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerCustomerSummaryForChatbotQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>
  > = ({ signal }) =>
    getApiCustomerCustomerSummaryForChatbot(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCustomerSummaryForChatbotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>
>;
export type GetApiCustomerCustomerSummaryForChatbotQueryError = unknown;

export function useGetApiCustomerCustomerSummaryForChatbot<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerSummaryForChatbot<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCustomerSummaryForChatbot<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCustomerSummaryForChatbot<
  TData = Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
  TError = unknown
>(
  params: GetApiCustomerCustomerSummaryForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCustomerSummaryForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCustomerSummaryForChatbotQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCustomerSummaryForChatbot = (
  pekiWebHookRequestBody: PekiWebHookRequestBody,
  params: PostApiCustomerCustomerSummaryForChatbotParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiCustomerCustomerSummaryForChatbot200One
    | PostApiCustomerCustomerSummaryForChatbot200Two
    | Blob
  >(
    {
      url: `/api/customer/customerSummaryForChatbot`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pekiWebHookRequestBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerSummaryForChatbotMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>,
    TError,
    {
      data: PekiWebHookRequestBody;
      params: PostApiCustomerCustomerSummaryForChatbotParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>,
  TError,
  {
    data: PekiWebHookRequestBody;
    params: PostApiCustomerCustomerSummaryForChatbotParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerSummaryForChatbot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>,
    {
      data: PekiWebHookRequestBody;
      params: PostApiCustomerCustomerSummaryForChatbotParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerCustomerSummaryForChatbot(
      data,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerSummaryForChatbotMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>
  >;
export type PostApiCustomerCustomerSummaryForChatbotMutationBody =
  PekiWebHookRequestBody;
export type PostApiCustomerCustomerSummaryForChatbotMutationError = unknown;

export const usePostApiCustomerCustomerSummaryForChatbot = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>,
      TError,
      {
        data: PekiWebHookRequestBody;
        params: PostApiCustomerCustomerSummaryForChatbotParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerSummaryForChatbot>>,
  TError,
  {
    data: PekiWebHookRequestBody;
    params: PostApiCustomerCustomerSummaryForChatbotParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerSummaryForChatbotMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerChangeComplaintsCaseStatus = (
  params: PostApiCustomerChangeComplaintsCaseStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/changeComplaintsCaseStatus`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerChangeComplaintsCaseStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>,
    TError,
    { params: PostApiCustomerChangeComplaintsCaseStatusParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>,
  TError,
  { params: PostApiCustomerChangeComplaintsCaseStatusParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerChangeComplaintsCaseStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>,
    { params: PostApiCustomerChangeComplaintsCaseStatusParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerChangeComplaintsCaseStatus(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerChangeComplaintsCaseStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>
  >;

export type PostApiCustomerChangeComplaintsCaseStatusMutationError = unknown;

export const usePostApiCustomerChangeComplaintsCaseStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>,
      TError,
      { params: PostApiCustomerChangeComplaintsCaseStatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerChangeComplaintsCaseStatus>>,
  TError,
  { params: PostApiCustomerChangeComplaintsCaseStatusParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerChangeComplaintsCaseStatusMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetComplaintsCaseHistory = (
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListComplaintsCaseStatusDto>(
    {
      url: `/api/customer/getComplaintsCaseHistory`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetComplaintsCaseHistoryQueryKey = (
  params?: GetApiCustomerGetComplaintsCaseHistoryParams
) => {
  return [
    `/api/customer/getComplaintsCaseHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetComplaintsCaseHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetComplaintsCaseHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>
  > = ({ signal }) =>
    getApiCustomerGetComplaintsCaseHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetComplaintsCaseHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>
>;
export type GetApiCustomerGetComplaintsCaseHistoryQueryError = unknown;

export function useGetApiCustomerGetComplaintsCaseHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetComplaintsCaseHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetComplaintsCaseHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetComplaintsCaseHistory<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCaseHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCaseHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetComplaintsCaseHistoryQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerGetComplaintsCases = (
  params: GetApiCustomerGetComplaintsCasesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListComplaintsCaseResponseDto>(
    { url: `/api/customer/getComplaintsCases`, method: "GET", params, signal },
    options
  );
};

export const getGetApiCustomerGetComplaintsCasesQueryKey = (
  params?: GetApiCustomerGetComplaintsCasesParams
) => {
  return [
    `/api/customer/getComplaintsCases`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetComplaintsCasesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiCustomerGetComplaintsCasesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>
  > = ({ signal }) =>
    getApiCustomerGetComplaintsCases(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerGetComplaintsCasesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>
>;
export type GetApiCustomerGetComplaintsCasesQueryError = unknown;

export function useGetApiCustomerGetComplaintsCases<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCasesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetComplaintsCases<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetComplaintsCases<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetComplaintsCases<
  TData = Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
  TError = unknown
>(
  params: GetApiCustomerGetComplaintsCasesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerGetComplaintsCases>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerGetComplaintsCasesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerAddLeadBasedCost = (
  leadBasedCostModelDto: LeadBasedCostModelDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/addLeadBasedCost`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: leadBasedCostModelDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddLeadBasedCostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>,
    TError,
    { data: LeadBasedCostModelDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>,
  TError,
  { data: LeadBasedCostModelDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddLeadBasedCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>,
    { data: LeadBasedCostModelDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddLeadBasedCost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddLeadBasedCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>
>;
export type PostApiCustomerAddLeadBasedCostMutationBody = LeadBasedCostModelDto;
export type PostApiCustomerAddLeadBasedCostMutationError = unknown;

export const usePostApiCustomerAddLeadBasedCost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>,
      TError,
      { data: LeadBasedCostModelDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddLeadBasedCost>>,
  TError,
  { data: LeadBasedCostModelDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddLeadBasedCostMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddTierBasedCost = (
  tierBasedCostModelDto: TierBasedCostModelDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/addTierBasedCost`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tierBasedCostModelDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddTierBasedCostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>,
    TError,
    { data: TierBasedCostModelDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>,
  TError,
  { data: TierBasedCostModelDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddTierBasedCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>,
    { data: TierBasedCostModelDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddTierBasedCost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddTierBasedCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>
>;
export type PostApiCustomerAddTierBasedCostMutationBody = TierBasedCostModelDto;
export type PostApiCustomerAddTierBasedCostMutationError = unknown;

export const usePostApiCustomerAddTierBasedCost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>,
      TError,
      { data: TierBasedCostModelDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddTierBasedCost>>,
  TError,
  { data: TierBasedCostModelDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddTierBasedCostMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddDateBasedCost = (
  dateBasedCostModelDto: DateBasedCostModelDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/addDateBasedCost`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: dateBasedCostModelDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddDateBasedCostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>,
    TError,
    { data: DateBasedCostModelDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>,
  TError,
  { data: DateBasedCostModelDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddDateBasedCost"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>,
    { data: DateBasedCostModelDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddDateBasedCost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddDateBasedCostMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>
>;
export type PostApiCustomerAddDateBasedCostMutationBody = DateBasedCostModelDto;
export type PostApiCustomerAddDateBasedCostMutationError = unknown;

export const usePostApiCustomerAddDateBasedCost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>,
      TError,
      { data: DateBasedCostModelDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddDateBasedCost>>,
  TError,
  { data: DateBasedCostModelDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddDateBasedCostMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerGetTotalCostByAffiliateCostModelName = (
  params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecimal>(
    {
      url: `/api/customer/getTotalCostByAffiliateCostModelName`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetTotalCostByAffiliateCostModelNameQueryKey = (
  params?: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams
) => {
  return [
    `/api/customer/getTotalCostByAffiliateCostModelName`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetTotalCostByAffiliateCostModelNameQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
    >,
    TError = unknown
  >(
    params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiCustomerGetTotalCostByAffiliateCostModelName
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiCustomerGetTotalCostByAffiliateCostModelNameQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
      >
    > = ({ signal }) =>
      getApiCustomerGetTotalCostByAffiliateCostModelName(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiCustomerGetTotalCostByAffiliateCostModelNameQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
    >
  >;
export type GetApiCustomerGetTotalCostByAffiliateCostModelNameQueryError =
  unknown;

export function useGetApiCustomerGetTotalCostByAffiliateCostModelName<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiCustomerGetTotalCostByAffiliateCostModelName
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiCustomerGetTotalCostByAffiliateCostModelName
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetTotalCostByAffiliateCostModelName<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiCustomerGetTotalCostByAffiliateCostModelName
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiCustomerGetTotalCostByAffiliateCostModelName
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetTotalCostByAffiliateCostModelName<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetTotalCostByAffiliateCostModelName<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCostModelNameParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCostModelName>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerGetTotalCostByAffiliateCostModelNameQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiCustomerGetTotalCostByAffiliateCampaignCode = (
  params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecimal>(
    {
      url: `/api/customer/getTotalCostByAffiliateCampaignCode`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryKey = (
  params?: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams
) => {
  return [
    `/api/customer/getTotalCostByAffiliateCampaignCode`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
    >,
    TError = unknown
  >(
    params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
      >
    > = ({ signal }) =>
      getApiCustomerGetTotalCostByAffiliateCampaignCode(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
    >
  >;
export type GetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryError =
  unknown;

export function useGetApiCustomerGetTotalCostByAffiliateCampaignCode<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetTotalCostByAffiliateCampaignCode<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerGetTotalCostByAffiliateCampaignCode<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerGetTotalCostByAffiliateCampaignCode<
  TData = Awaited<
    ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
  >,
  TError = unknown
>(
  params: GetApiCustomerGetTotalCostByAffiliateCampaignCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiCustomerGetTotalCostByAffiliateCampaignCode>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiCustomerGetTotalCostByAffiliateCampaignCodeQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerGetDateBasedCostHistoryByCampaignCode = (
  params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListGetDateBasedCostHistoryByCampaignCodeResDto>(
    {
      url: `/api/customer/getDateBasedCostHistoryByCampaignCode`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerGetDateBasedCostHistoryByCampaignCodeMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
      >,
      TError,
      { params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
    >,
    TError,
    { params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams },
    TContext
  > => {
    const mutationKey = [
      "postApiCustomerGetDateBasedCostHistoryByCampaignCode",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
      >,
      { params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiCustomerGetDateBasedCostHistoryByCampaignCode(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerGetDateBasedCostHistoryByCampaignCodeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
    >
  >;

export type PostApiCustomerGetDateBasedCostHistoryByCampaignCodeMutationError =
  unknown;

export const usePostApiCustomerGetDateBasedCostHistoryByCampaignCode = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
      >,
      TError,
      { params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiCustomerGetDateBasedCostHistoryByCampaignCode>
  >,
  TError,
  { params: PostApiCustomerGetDateBasedCostHistoryByCampaignCodeParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerGetDateBasedCostHistoryByCampaignCodeMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiCustomerCustomerSubStatusList = (
  params: PostApiCustomerCustomerSubStatusListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSubStatusDto>(
    {
      url: `/api/customer/customerSubStatusList`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerSubStatusListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>,
    TError,
    { params: PostApiCustomerCustomerSubStatusListParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>,
  TError,
  { params: PostApiCustomerCustomerSubStatusListParams },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerSubStatusList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>,
    { params: PostApiCustomerCustomerSubStatusListParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiCustomerCustomerSubStatusList(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerSubStatusListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>
>;

export type PostApiCustomerCustomerSubStatusListMutationError = unknown;

export const usePostApiCustomerCustomerSubStatusList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>,
      TError,
      { params: PostApiCustomerCustomerSubStatusListParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerSubStatusList>>,
  TError,
  { params: PostApiCustomerCustomerSubStatusListParams },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerSubStatusListMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerNamematchCommon = (
  nameMatchWithSeparateNamesRequestDtoArrayBody: NameMatchWithSeparateNamesRequestDtoArrayBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListStringMatchDetailedResult>(
    {
      url: `/api/customer/namematch/common`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nameMatchWithSeparateNamesRequestDtoArrayBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerNamematchCommonMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>,
    TError,
    { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>,
  TError,
  { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerNamematchCommon"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>,
    { data: NameMatchWithSeparateNamesRequestDtoArrayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerNamematchCommon(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerNamematchCommonMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>
>;
export type PostApiCustomerNamematchCommonMutationBody =
  NameMatchWithSeparateNamesRequestDtoArrayBody;
export type PostApiCustomerNamematchCommonMutationError = unknown;

export const usePostApiCustomerNamematchCommon = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>,
      TError,
      { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerNamematchCommon>>,
  TError,
  { data: NameMatchWithSeparateNamesRequestDtoArrayBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerNamematchCommonMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerNamematchEs = (
  nameMatchWithFullNameRequestDtoArrayBody: NameMatchWithFullNameRequestDtoArrayBody,
  params: PostApiCustomerNamematchEsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListStringMatchDetailedResult>(
    {
      url: `/api/customer/namematch/es`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nameMatchWithFullNameRequestDtoArrayBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiCustomerNamematchEsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerNamematchEs>>,
    TError,
    {
      data: NameMatchWithFullNameRequestDtoArrayBody;
      params: PostApiCustomerNamematchEsParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerNamematchEs>>,
  TError,
  {
    data: NameMatchWithFullNameRequestDtoArrayBody;
    params: PostApiCustomerNamematchEsParams;
  },
  TContext
> => {
  const mutationKey = ["postApiCustomerNamematchEs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerNamematchEs>>,
    {
      data: NameMatchWithFullNameRequestDtoArrayBody;
      params: PostApiCustomerNamematchEsParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiCustomerNamematchEs(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerNamematchEsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerNamematchEs>>
>;
export type PostApiCustomerNamematchEsMutationBody =
  NameMatchWithFullNameRequestDtoArrayBody;
export type PostApiCustomerNamematchEsMutationError = unknown;

export const usePostApiCustomerNamematchEs = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerNamematchEs>>,
      TError,
      {
        data: NameMatchWithFullNameRequestDtoArrayBody;
        params: PostApiCustomerNamematchEsParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerNamematchEs>>,
  TError,
  {
    data: NameMatchWithFullNameRequestDtoArrayBody;
    params: PostApiCustomerNamematchEsParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiCustomerNamematchEsMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerAddress = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerAddressRequestDto>(
    { url: `/api/customer/address`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerAddressQueryKey = () => {
  return [`/api/customer/address`] as const;
};

export const getGetApiCustomerAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerAddress>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerAddress>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiCustomerAddressQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerAddress>>
  > = ({ signal }) => getApiCustomerAddress(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerAddress>>
>;
export type GetApiCustomerAddressQueryError = unknown;

export function useGetApiCustomerAddress<
  TData = Awaited<ReturnType<typeof getApiCustomerAddress>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerAddress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAddress<
  TData = Awaited<ReturnType<typeof getApiCustomerAddress>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerAddress>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerAddress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerAddress<
  TData = Awaited<ReturnType<typeof getApiCustomerAddress>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerAddress<
  TData = Awaited<ReturnType<typeof getApiCustomerAddress>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerAddressQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiCustomerAddress = (
  customerAddressRequestDtoBody: CustomerAddressRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/address`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: customerAddressRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiCustomerAddressMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiCustomerAddress>>,
    TError,
    { data: CustomerAddressRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiCustomerAddress>>,
  TError,
  { data: CustomerAddressRequestDtoBody },
  TContext
> => {
  const mutationKey = ["putApiCustomerAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiCustomerAddress>>,
    { data: CustomerAddressRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiCustomerAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiCustomerAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiCustomerAddress>>
>;
export type PutApiCustomerAddressMutationBody = CustomerAddressRequestDtoBody;
export type PutApiCustomerAddressMutationError = unknown;

export const usePutApiCustomerAddress = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiCustomerAddress>>,
      TError,
      { data: CustomerAddressRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiCustomerAddress>>,
  TError,
  { data: CustomerAddressRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiCustomerAddressMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerAddress = (
  customerAddressRequestDtoBody: CustomerAddressRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/address`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerAddressRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerAddressMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerAddress>>,
    TError,
    { data: CustomerAddressRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerAddress>>,
  TError,
  { data: CustomerAddressRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerAddress"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerAddress>>,
    { data: CustomerAddressRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerAddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerAddress>>
>;
export type PostApiCustomerAddressMutationBody = CustomerAddressRequestDtoBody;
export type PostApiCustomerAddressMutationError = unknown;

export const usePostApiCustomerAddress = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerAddress>>,
      TError,
      { data: CustomerAddressRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerAddress>>,
  TError,
  { data: CustomerAddressRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerAddressMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCommunicationVerifyWithOTP = (
  createCommunicationRequestDtoBody: CreateCommunicationRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/customer/communicationVerifyWithOTP`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCommunicationRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCommunicationVerifyWithOTPMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>,
    TError,
    { data: CreateCommunicationRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCommunicationVerifyWithOTP"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>,
    { data: CreateCommunicationRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCommunicationVerifyWithOTP(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCommunicationVerifyWithOTPMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>
  >;
export type PostApiCustomerCommunicationVerifyWithOTPMutationBody =
  CreateCommunicationRequestDtoBody;
export type PostApiCustomerCommunicationVerifyWithOTPMutationError = unknown;

export const usePostApiCustomerCommunicationVerifyWithOTP = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>,
      TError,
      { data: CreateCommunicationRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCommunicationVerifyWithOTP>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCommunicationVerifyWithOTPMutationOptions(options),
    queryClient
  );
};

export const getApiCustomerCommunication = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCommunicationRequestDto>(
    { url: `/api/customer/communication`, method: "GET", signal },
    options
  );
};

export const getGetApiCustomerCommunicationQueryKey = () => {
  return [`/api/customer/communication`] as const;
};

export const getGetApiCustomerCommunicationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiCustomerCommunication>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiCustomerCommunication>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiCustomerCommunicationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiCustomerCommunication>>
  > = ({ signal }) => getApiCustomerCommunication(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiCustomerCommunication>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiCustomerCommunicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiCustomerCommunication>>
>;
export type GetApiCustomerCommunicationQueryError = unknown;

export function useGetApiCustomerCommunication<
  TData = Awaited<ReturnType<typeof getApiCustomerCommunication>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCommunication>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCommunication>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCommunication>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCommunication<
  TData = Awaited<ReturnType<typeof getApiCustomerCommunication>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCommunication>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCustomerCommunication>>,
          TError,
          Awaited<ReturnType<typeof getApiCustomerCommunication>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiCustomerCommunication<
  TData = Awaited<ReturnType<typeof getApiCustomerCommunication>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCommunication>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiCustomerCommunication<
  TData = Awaited<ReturnType<typeof getApiCustomerCommunication>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiCustomerCommunication>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiCustomerCommunicationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiCustomerCommunication = (
  createCommunicationRequestDtoBody: CreateCommunicationRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/communication`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCommunicationRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCommunicationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCommunication>>,
    TError,
    { data: CreateCommunicationRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCommunication>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCommunication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCommunication>>,
    { data: CreateCommunicationRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCommunication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCommunicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCommunication>>
>;
export type PostApiCustomerCommunicationMutationBody =
  CreateCommunicationRequestDtoBody;
export type PostApiCustomerCommunicationMutationError = unknown;

export const usePostApiCustomerCommunication = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCommunication>>,
      TError,
      { data: CreateCommunicationRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCommunication>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCommunicationMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCheckCustomerExist = (
  checkCustomerRequestDto: CheckCustomerRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListExistingCustomerResponseDto>(
    {
      url: `/api/customer/checkCustomerExist`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkCustomerRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCheckCustomerExistMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>,
    TError,
    { data: CheckCustomerRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>,
  TError,
  { data: CheckCustomerRequestDto },
  TContext
> => {
  const mutationKey = ["postApiCustomerCheckCustomerExist"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>,
    { data: CheckCustomerRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCheckCustomerExist(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCheckCustomerExistMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>
>;
export type PostApiCustomerCheckCustomerExistMutationBody =
  CheckCustomerRequestDto;
export type PostApiCustomerCheckCustomerExistMutationError = unknown;

export const usePostApiCustomerCheckCustomerExist = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>,
      TError,
      { data: CheckCustomerRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCheckCustomerExist>>,
  TError,
  { data: CheckCustomerRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCheckCustomerExistMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerSetCustomerStatusToPreRegistered = (
  pinValidRequestDto: PinValidRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/setCustomerStatusToPreRegistered`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pinValidRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiCustomerSetCustomerStatusToPreRegisteredMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>
      >,
      TError,
      { data: PinValidRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>>,
    TError,
    { data: PinValidRequestDto },
    TContext
  > => {
    const mutationKey = ["postApiCustomerSetCustomerStatusToPreRegistered"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>
      >,
      { data: PinValidRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiCustomerSetCustomerStatusToPreRegistered(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiCustomerSetCustomerStatusToPreRegisteredMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>>
  >;
export type PostApiCustomerSetCustomerStatusToPreRegisteredMutationBody =
  PinValidRequestDto;
export type PostApiCustomerSetCustomerStatusToPreRegisteredMutationError =
  unknown;

export const usePostApiCustomerSetCustomerStatusToPreRegistered = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>
      >,
      TError,
      { data: PinValidRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToPreRegistered>>,
  TError,
  { data: PinValidRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiCustomerSetCustomerStatusToPreRegisteredMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerSetCustomerStatusToRegistered = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/setCustomerStatusToRegistered`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiCustomerSetCustomerStatusToRegisteredMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiCustomerSetCustomerStatusToRegistered"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>,
    void
  > = () => {
    return postApiCustomerSetCustomerStatusToRegistered(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerSetCustomerStatusToRegisteredMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>
  >;

export type PostApiCustomerSetCustomerStatusToRegisteredMutationError = unknown;

export const usePostApiCustomerSetCustomerStatusToRegistered = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerSetCustomerStatusToRegistered>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiCustomerSetCustomerStatusToRegisteredMutationOptions(options),
    queryClient
  );
};

export const postApiCustomerCustomerSendOtp = (
  createCommunicationRequestDtoBody: CreateCommunicationRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/customer/customer/sendOtp`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCommunicationRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiCustomerCustomerSendOtpMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>,
    TError,
    { data: CreateCommunicationRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiCustomerCustomerSendOtp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>,
    { data: CreateCommunicationRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiCustomerCustomerSendOtp(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiCustomerCustomerSendOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>
>;
export type PostApiCustomerCustomerSendOtpMutationBody =
  CreateCommunicationRequestDtoBody;
export type PostApiCustomerCustomerSendOtpMutationError = unknown;

export const usePostApiCustomerCustomerSendOtp = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>,
      TError,
      { data: CreateCommunicationRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiCustomerCustomerSendOtp>>,
  TError,
  { data: CreateCommunicationRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiCustomerCustomerSendOtpMutationOptions(options),
    queryClient
  );
};

export const postApiPromotionInsert = (
  promotionRequestDto: PromotionRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/promotion/insert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: promotionRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiPromotionInsertMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPromotionInsert>>,
    TError,
    { data: PromotionRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPromotionInsert>>,
  TError,
  { data: PromotionRequestDto },
  TContext
> => {
  const mutationKey = ["postApiPromotionInsert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPromotionInsert>>,
    { data: PromotionRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiPromotionInsert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiPromotionInsertMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiPromotionInsert>>
>;
export type PostApiPromotionInsertMutationBody = PromotionRequestDto;
export type PostApiPromotionInsertMutationError = unknown;

export const usePostApiPromotionInsert = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiPromotionInsert>>,
      TError,
      { data: PromotionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiPromotionInsert>>,
  TError,
  { data: PromotionRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiPromotionInsertMutationOptions(options),
    queryClient
  );
};

export const getApiDecisionDecisionApi = (
  params: GetApiDecisionDecisionApiParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecisionApiResponseDto>(
    { url: `/api/decision/decisionApi`, method: "GET", params, signal },
    options
  );
};

export const getGetApiDecisionDecisionApiQueryKey = (
  params?: GetApiDecisionDecisionApiParams
) => {
  return [`/api/decision/decisionApi`, ...(params ? [params] : [])] as const;
};

export const getGetApiDecisionDecisionApiQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
  TError = unknown
>(
  params: GetApiDecisionDecisionApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDecisionDecisionApiQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDecisionDecisionApi>>
  > = ({ signal }) => getApiDecisionDecisionApi(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDecisionDecisionApiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDecisionDecisionApi>>
>;
export type GetApiDecisionDecisionApiQueryError = unknown;

export function useGetApiDecisionDecisionApi<
  TData = Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
  TError = unknown
>(
  params: GetApiDecisionDecisionApiParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionDecisionApi>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionDecisionApi<
  TData = Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
  TError = unknown
>(
  params: GetApiDecisionDecisionApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionDecisionApi>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionDecisionApi<
  TData = Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
  TError = unknown
>(
  params: GetApiDecisionDecisionApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDecisionDecisionApi<
  TData = Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
  TError = unknown
>(
  params: GetApiDecisionDecisionApiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionDecisionApi>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiDecisionDecisionApiQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiDecisionDecisionApi = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  params: PostApiDecisionDecisionApiParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecisionApiResponseDto>(
    {
      url: `/api/decision/decisionApi`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionDecisionApiMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionDecisionApi>>,
    TError,
    {
      data: BankScraperNotifySmsValueBody;
      params: PostApiDecisionDecisionApiParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionDecisionApi>>,
  TError,
  {
    data: BankScraperNotifySmsValueBody;
    params: PostApiDecisionDecisionApiParams;
  },
  TContext
> => {
  const mutationKey = ["postApiDecisionDecisionApi"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionDecisionApi>>,
    {
      data: BankScraperNotifySmsValueBody;
      params: PostApiDecisionDecisionApiParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiDecisionDecisionApi(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionDecisionApiMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionDecisionApi>>
>;
export type PostApiDecisionDecisionApiMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiDecisionDecisionApiMutationError = unknown;

export const usePostApiDecisionDecisionApi = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionDecisionApi>>,
      TError,
      {
        data: BankScraperNotifySmsValueBody;
        params: PostApiDecisionDecisionApiParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionDecisionApi>>,
  TError,
  {
    data: BankScraperNotifySmsValueBody;
    params: PostApiDecisionDecisionApiParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiDecisionDecisionApiMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestLimitDecision = (
  callCreditLimitDecisionRequestDto: CallCreditLimitDecisionRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    {
      url: `/api/decision/testLimitDecision`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: callCreditLimitDecisionRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestLimitDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>,
    TError,
    { data: CallCreditLimitDecisionRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>,
  TError,
  { data: CallCreditLimitDecisionRequestDto },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestLimitDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>,
    { data: CallCreditLimitDecisionRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiDecisionTestLimitDecision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestLimitDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>
>;
export type PostApiDecisionTestLimitDecisionMutationBody =
  CallCreditLimitDecisionRequestDto;
export type PostApiDecisionTestLimitDecisionMutationError = unknown;

export const usePostApiDecisionTestLimitDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>,
      TError,
      { data: CallCreditLimitDecisionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestLimitDecision>>,
  TError,
  { data: CallCreditLimitDecisionRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestLimitDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestAutoApprovalDecision = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/decision/testAutoApprovalDecision`, method: "POST", signal },
    options
  );
};

export const getPostApiDecisionTestAutoApprovalDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiDecisionTestAutoApprovalDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>,
    void
  > = () => {
    return postApiDecisionTestAutoApprovalDecision(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestAutoApprovalDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>
>;

export type PostApiDecisionTestAutoApprovalDecisionMutationError = unknown;

export const usePostApiDecisionTestAutoApprovalDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestAutoApprovalDecision>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestAutoApprovalDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestLoanBasicDecision = (
  params: PostApiDecisionTestLoanBasicDecisionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/decision/testLoanBasicDecision`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestLoanBasicDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>,
    TError,
    { params: PostApiDecisionTestLoanBasicDecisionParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>,
  TError,
  { params: PostApiDecisionTestLoanBasicDecisionParams },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestLoanBasicDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>,
    { params: PostApiDecisionTestLoanBasicDecisionParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiDecisionTestLoanBasicDecision(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestLoanBasicDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>
>;

export type PostApiDecisionTestLoanBasicDecisionMutationError = unknown;

export const usePostApiDecisionTestLoanBasicDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>,
      TError,
      { params: PostApiDecisionTestLoanBasicDecisionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecision>>,
  TError,
  { params: PostApiDecisionTestLoanBasicDecisionParams },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestLoanBasicDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestLoanBasicDecisionBulk = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64Decimal>(
    {
      url: `/api/decision/testLoanBasicDecisionBulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestLoanBasicDecisionBulkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestLoanBasicDecisionBulk"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiDecisionTestLoanBasicDecisionBulk(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestLoanBasicDecisionBulkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>
  >;
export type PostApiDecisionTestLoanBasicDecisionBulkMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiDecisionTestLoanBasicDecisionBulkMutationError = unknown;

export const usePostApiDecisionTestLoanBasicDecisionBulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestLoanBasicDecisionBulk>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestLoanBasicDecisionBulkMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestLimitDecisionAfterPayment = (
  params: PostApiDecisionTestLimitDecisionAfterPaymentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/decision/testLimitDecisionAfterPayment`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestLimitDecisionAfterPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>,
    TError,
    { params: PostApiDecisionTestLimitDecisionAfterPaymentParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>,
  TError,
  { params: PostApiDecisionTestLimitDecisionAfterPaymentParams },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestLimitDecisionAfterPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>,
    { params: PostApiDecisionTestLimitDecisionAfterPaymentParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiDecisionTestLimitDecisionAfterPayment(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestLimitDecisionAfterPaymentMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>
  >;

export type PostApiDecisionTestLimitDecisionAfterPaymentMutationError = unknown;

export const usePostApiDecisionTestLimitDecisionAfterPayment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>,
      TError,
      { params: PostApiDecisionTestLimitDecisionAfterPaymentParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestLimitDecisionAfterPayment>>,
  TError,
  { params: PostApiDecisionTestLimitDecisionAfterPaymentParams },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestLimitDecisionAfterPaymentMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestSmsReminderForInactiveCustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/decision/testSmsReminderForInactiveCustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestSmsReminderForInactiveCustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiDecisionTestSmsReminderForInactiveCustomers"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
      >,
      void
    > = () => {
      return postApiDecisionTestSmsReminderForInactiveCustomers(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiDecisionTestSmsReminderForInactiveCustomersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
    >
  >;

export type PostApiDecisionTestSmsReminderForInactiveCustomersMutationError =
  unknown;

export const usePostApiDecisionTestSmsReminderForInactiveCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiDecisionTestSmsReminderForInactiveCustomers>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestSmsReminderForInactiveCustomersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiDecisionTestPostRegisterDecision = (
  postRegisterDecisionDto: PostRegisterDecisionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecisionResult>(
    {
      url: `/api/decision/testPostRegisterDecision`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postRegisterDecisionDto,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestPostRegisterDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>,
    TError,
    { data: PostRegisterDecisionDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>,
  TError,
  { data: PostRegisterDecisionDto },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestPostRegisterDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>,
    { data: PostRegisterDecisionDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiDecisionTestPostRegisterDecision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestPostRegisterDecisionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>
>;
export type PostApiDecisionTestPostRegisterDecisionMutationBody =
  PostRegisterDecisionDto;
export type PostApiDecisionTestPostRegisterDecisionMutationError = unknown;

export const usePostApiDecisionTestPostRegisterDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>,
      TError,
      { data: PostRegisterDecisionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestPostRegisterDecision>>,
  TError,
  { data: PostRegisterDecisionDto },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestPostRegisterDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionTestCustomerRegisterCriteriaValidation = (
  createCustomerCriteriaValidationDto: CreateCustomerCriteriaValidationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecisionResult>(
    {
      url: `/api/decision/testCustomerRegisterCriteriaValidation`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerCriteriaValidationDto,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestCustomerRegisterCriteriaValidationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
      >,
      TError,
      { data: CreateCustomerCriteriaValidationDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
    >,
    TError,
    { data: CreateCustomerCriteriaValidationDto },
    TContext
  > => {
    const mutationKey = [
      "postApiDecisionTestCustomerRegisterCriteriaValidation",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
      >,
      { data: CreateCustomerCriteriaValidationDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiDecisionTestCustomerRegisterCriteriaValidation(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiDecisionTestCustomerRegisterCriteriaValidationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
    >
  >;
export type PostApiDecisionTestCustomerRegisterCriteriaValidationMutationBody =
  CreateCustomerCriteriaValidationDto;
export type PostApiDecisionTestCustomerRegisterCriteriaValidationMutationError =
  unknown;

export const usePostApiDecisionTestCustomerRegisterCriteriaValidation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
      >,
      TError,
      { data: CreateCustomerCriteriaValidationDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiDecisionTestCustomerRegisterCriteriaValidation>
  >,
  TError,
  { data: CreateCustomerCriteriaValidationDto },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestCustomerRegisterCriteriaValidationMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiDecisionTestLimitUpdateAfterPaymentV2 = (
  params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLimitUpdateAfterPaymentReturnDto>(
    {
      url: `/api/decision/testLimitUpdateAfterPaymentV2`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionTestLimitUpdateAfterPaymentV2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>,
    TError,
    { params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>,
  TError,
  { params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params },
  TContext
> => {
  const mutationKey = ["postApiDecisionTestLimitUpdateAfterPaymentV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>,
    { params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return postApiDecisionTestLimitUpdateAfterPaymentV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionTestLimitUpdateAfterPaymentV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>
  >;

export type PostApiDecisionTestLimitUpdateAfterPaymentV2MutationError = unknown;

export const usePostApiDecisionTestLimitUpdateAfterPaymentV2 = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>,
      TError,
      { params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionTestLimitUpdateAfterPaymentV2>>,
  TError,
  { params: PostApiDecisionTestLimitUpdateAfterPaymentV2Params },
  TContext
> => {
  return useMutation(
    getPostApiDecisionTestLimitUpdateAfterPaymentV2MutationOptions(options),
    queryClient
  );
};

export const postApiDecisionCustomerDecisionDto = (
  params: PostApiDecisionCustomerDecisionDtoParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDetailedDecisionDTO>(
    {
      url: `/api/decision/customerDecisionDto`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionCustomerDecisionDtoMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>,
    TError,
    { params: PostApiDecisionCustomerDecisionDtoParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>,
  TError,
  { params: PostApiDecisionCustomerDecisionDtoParams },
  TContext
> => {
  const mutationKey = ["postApiDecisionCustomerDecisionDto"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>,
    { params: PostApiDecisionCustomerDecisionDtoParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiDecisionCustomerDecisionDto(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionCustomerDecisionDtoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>
>;

export type PostApiDecisionCustomerDecisionDtoMutationError = unknown;

export const usePostApiDecisionCustomerDecisionDto = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>,
      TError,
      { params: PostApiDecisionCustomerDecisionDtoParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionCustomerDecisionDto>>,
  TError,
  { params: PostApiDecisionCustomerDecisionDtoParams },
  TContext
> => {
  return useMutation(
    getPostApiDecisionCustomerDecisionDtoMutationOptions(options),
    queryClient
  );
};

export const postApiDecisionMockRunDecisionModelRemotelyResponse = (
  runDecisionModelRemotelyResponse: RunDecisionModelRemotelyResponse,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/decision/mockRunDecisionModelRemotelyResponse`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: runDecisionModelRemotelyResponse,
      signal,
    },
    options
  );
};

export const getPostApiDecisionMockRunDecisionModelRemotelyResponseMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      TError,
      { data: RunDecisionModelRemotelyResponse },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
    >,
    TError,
    { data: RunDecisionModelRemotelyResponse },
    TContext
  > => {
    const mutationKey = ["postApiDecisionMockRunDecisionModelRemotelyResponse"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      { data: RunDecisionModelRemotelyResponse }
    > = (props) => {
      const { data } = props ?? {};

      return postApiDecisionMockRunDecisionModelRemotelyResponse(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiDecisionMockRunDecisionModelRemotelyResponseMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
    >
  >;
export type PostApiDecisionMockRunDecisionModelRemotelyResponseMutationBody =
  RunDecisionModelRemotelyResponse;
export type PostApiDecisionMockRunDecisionModelRemotelyResponseMutationError =
  unknown;

export const usePostApiDecisionMockRunDecisionModelRemotelyResponse = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      TError,
      { data: RunDecisionModelRemotelyResponse },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiDecisionMockRunDecisionModelRemotelyResponse>
  >,
  TError,
  { data: RunDecisionModelRemotelyResponse },
  TContext
> => {
  return useMutation(
    getPostApiDecisionMockRunDecisionModelRemotelyResponseMutationOptions(
      options
    ),
    queryClient
  );
};

export const deleteApiDecisionMockRunDecisionModelRemotelyResponse = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/decision/mockRunDecisionModelRemotelyResponse`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteApiDecisionMockRunDecisionModelRemotelyResponseMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "deleteApiDecisionMockRunDecisionModelRemotelyResponse",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      void
    > = () => {
      return deleteApiDecisionMockRunDecisionModelRemotelyResponse(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteApiDecisionMockRunDecisionModelRemotelyResponseMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
    >
  >;

export type DeleteApiDecisionMockRunDecisionModelRemotelyResponseMutationError =
  unknown;

export const useDeleteApiDecisionMockRunDecisionModelRemotelyResponse = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteApiDecisionMockRunDecisionModelRemotelyResponse>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getDeleteApiDecisionMockRunDecisionModelRemotelyResponseMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiDecisionCardDecisionResponses = (
  params: PostApiDecisionCardDecisionResponsesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCardDecisionResponseDto>(
    {
      url: `/api/decision/cardDecisionResponses`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiDecisionCardDecisionResponsesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>,
    TError,
    { params: PostApiDecisionCardDecisionResponsesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>,
  TError,
  { params: PostApiDecisionCardDecisionResponsesParams },
  TContext
> => {
  const mutationKey = ["postApiDecisionCardDecisionResponses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>,
    { params: PostApiDecisionCardDecisionResponsesParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiDecisionCardDecisionResponses(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionCardDecisionResponsesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>
>;

export type PostApiDecisionCardDecisionResponsesMutationError = unknown;

export const usePostApiDecisionCardDecisionResponses = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>,
      TError,
      { params: PostApiDecisionCardDecisionResponsesParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionCardDecisionResponses>>,
  TError,
  { params: PostApiDecisionCardDecisionResponsesParams },
  TContext
> => {
  return useMutation(
    getPostApiDecisionCardDecisionResponsesMutationOptions(options),
    queryClient
  );
};

export const getApiDecisionGetCheckList = (
  params: GetApiDecisionGetCheckListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultChecklistDto>(
    { url: `/api/decision/getCheckList`, method: "GET", params, signal },
    options
  );
};

export const getGetApiDecisionGetCheckListQueryKey = (
  params?: GetApiDecisionGetCheckListParams
) => {
  return [`/api/decision/getCheckList`, ...(params ? [params] : [])] as const;
};

export const getGetApiDecisionGetCheckListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
  TError = unknown
>(
  params: GetApiDecisionGetCheckListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDecisionGetCheckListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDecisionGetCheckList>>
  > = ({ signal }) =>
    getApiDecisionGetCheckList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDecisionGetCheckListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDecisionGetCheckList>>
>;
export type GetApiDecisionGetCheckListQueryError = unknown;

export function useGetApiDecisionGetCheckList<
  TData = Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
  TError = unknown
>(
  params: GetApiDecisionGetCheckListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionGetCheckList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionGetCheckList<
  TData = Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
  TError = unknown
>(
  params: GetApiDecisionGetCheckListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionGetCheckList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionGetCheckList<
  TData = Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
  TError = unknown
>(
  params: GetApiDecisionGetCheckListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDecisionGetCheckList<
  TData = Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
  TError = unknown
>(
  params: GetApiDecisionGetCheckListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionGetCheckList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiDecisionGetCheckListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiDecisionFullFlowTest = (
  params: GetApiDecisionFullFlowTestParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultChecklistDto>(
    { url: `/api/decision/fullFlowTest`, method: "GET", params, signal },
    options
  );
};

export const getGetApiDecisionFullFlowTestQueryKey = (
  params?: GetApiDecisionFullFlowTestParams
) => {
  return [`/api/decision/fullFlowTest`, ...(params ? [params] : [])] as const;
};

export const getGetApiDecisionFullFlowTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
  TError = unknown
>(
  params: GetApiDecisionFullFlowTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiDecisionFullFlowTestQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>
  > = ({ signal }) =>
    getApiDecisionFullFlowTest(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDecisionFullFlowTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>
>;
export type GetApiDecisionFullFlowTestQueryError = unknown;

export function useGetApiDecisionFullFlowTest<
  TData = Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
  TError = unknown
>(
  params: GetApiDecisionFullFlowTestParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionFullFlowTest<
  TData = Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
  TError = unknown
>(
  params: GetApiDecisionFullFlowTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionFullFlowTest<
  TData = Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
  TError = unknown
>(
  params: GetApiDecisionFullFlowTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDecisionFullFlowTest<
  TData = Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
  TError = unknown
>(
  params: GetApiDecisionFullFlowTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionFullFlowTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiDecisionFullFlowTestQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiDecisionAutoCheckStatusExpiryCheck = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/decision/autoCheckStatusExpiryCheck`, method: "GET", signal },
    options
  );
};

export const getGetApiDecisionAutoCheckStatusExpiryCheckQueryKey = () => {
  return [`/api/decision/autoCheckStatusExpiryCheck`] as const;
};

export const getGetApiDecisionAutoCheckStatusExpiryCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDecisionAutoCheckStatusExpiryCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>
  > = ({ signal }) =>
    getApiDecisionAutoCheckStatusExpiryCheck(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDecisionAutoCheckStatusExpiryCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>
>;
export type GetApiDecisionAutoCheckStatusExpiryCheckQueryError = unknown;

export function useGetApiDecisionAutoCheckStatusExpiryCheck<
  TData = Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionAutoCheckStatusExpiryCheck<
  TData = Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDecisionAutoCheckStatusExpiryCheck<
  TData = Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDecisionAutoCheckStatusExpiryCheck<
  TData = Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDecisionAutoCheckStatusExpiryCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiDecisionAutoCheckStatusExpiryCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiDecisionAutoflowChecklistUpdate = (
  checklistDto: ChecklistDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/decision/autoflow/checklist/update`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checklistDto,
      signal,
    },
    options
  );
};

export const getPostApiDecisionAutoflowChecklistUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>,
    TError,
    { data: ChecklistDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>,
  TError,
  { data: ChecklistDto },
  TContext
> => {
  const mutationKey = ["postApiDecisionAutoflowChecklistUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>,
    { data: ChecklistDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiDecisionAutoflowChecklistUpdate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiDecisionAutoflowChecklistUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>
>;
export type PostApiDecisionAutoflowChecklistUpdateMutationBody = ChecklistDto;
export type PostApiDecisionAutoflowChecklistUpdateMutationError = unknown;

export const usePostApiDecisionAutoflowChecklistUpdate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>,
      TError,
      { data: ChecklistDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiDecisionAutoflowChecklistUpdate>>,
  TError,
  { data: ChecklistDto },
  TContext
> => {
  return useMutation(
    getPostApiDecisionAutoflowChecklistUpdateMutationOptions(options),
    queryClient
  );
};

export const getApiHealthcheck = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiHealthcheck200One | GetApiHealthcheck200Two | Blob
  >({ url: `/api/healthcheck`, method: "GET", signal }, options);
};

export const getGetApiHealthcheckQueryKey = () => {
  return [`/api/healthcheck`] as const;
};

export const getGetApiHealthcheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheck>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheck>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiHealthcheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheck>>
  > = ({ signal }) => getApiHealthcheck(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheck>>
>;
export type GetApiHealthcheckQueryError = unknown;

export function useGetApiHealthcheck<
  TData = Awaited<ReturnType<typeof getApiHealthcheck>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheck<
  TData = Awaited<ReturnType<typeof getApiHealthcheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheck>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheck<
  TData = Awaited<ReturnType<typeof getApiHealthcheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheck<
  TData = Awaited<ReturnType<typeof getApiHealthcheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiHealthcheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckFail = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiHealthcheckFail200One | GetApiHealthcheckFail200Two | Blob
  >({ url: `/api/healthcheck/fail`, method: "GET", signal }, options);
};

export const getGetApiHealthcheckFailQueryKey = () => {
  return [`/api/healthcheck/fail`] as const;
};

export const getGetApiHealthcheckFailQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheckFail>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheckFail>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiHealthcheckFailQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckFail>>
  > = ({ signal }) => getApiHealthcheckFail(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckFail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckFailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheckFail>>
>;
export type GetApiHealthcheckFailQueryError = unknown;

export function useGetApiHealthcheckFail<
  TData = Awaited<ReturnType<typeof getApiHealthcheckFail>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckFail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckFail>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckFail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckFail<
  TData = Awaited<ReturnType<typeof getApiHealthcheckFail>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckFail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckFail>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckFail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckFail<
  TData = Awaited<ReturnType<typeof getApiHealthcheckFail>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckFail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckFail<
  TData = Awaited<ReturnType<typeof getApiHealthcheckFail>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckFail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiHealthcheckFailQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckVersion = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiHealthcheckVersion200One | GetApiHealthcheckVersion200Two | Blob
  >({ url: `/api/healthcheck/version`, method: "GET", signal }, options);
};

export const getGetApiHealthcheckVersionQueryKey = () => {
  return [`/api/healthcheck/version`] as const;
};

export const getGetApiHealthcheckVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiHealthcheckVersionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckVersion>>
  > = ({ signal }) => getApiHealthcheckVersion(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheckVersion>>
>;
export type GetApiHealthcheckVersionQueryError = unknown;

export function useGetApiHealthcheckVersion<
  TData = Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckVersion<
  TData = Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckVersion>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckVersion<
  TData = Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckVersion<
  TData = Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckVersion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiHealthcheckVersionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckConfig = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiHealthcheckConfig200One | GetApiHealthcheckConfig200Two | Blob
  >({ url: `/api/healthcheck/config`, method: "GET", signal }, options);
};

export const getGetApiHealthcheckConfigQueryKey = () => {
  return [`/api/healthcheck/config`] as const;
};

export const getGetApiHealthcheckConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiHealthcheckConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckConfig>>
  > = ({ signal }) => getApiHealthcheckConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheckConfig>>
>;
export type GetApiHealthcheckConfigQueryError = unknown;

export function useGetApiHealthcheckConfig<
  TData = Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckConfig<
  TData = Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckConfig<
  TData = Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckConfig<
  TData = Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiHealthcheckConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckElasticSearchAlertIndexCleaner = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/healthcheck/elasticSearchAlertIndexCleaner`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiHealthcheckElasticSearchAlertIndexCleanerQueryKey =
  () => {
    return [`/api/healthcheck/elasticSearchAlertIndexCleaner`] as const;
  };

export const getGetApiHealthcheckElasticSearchAlertIndexCleanerQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiHealthcheckElasticSearchAlertIndexCleanerQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>>
  > = ({ signal }) =>
    getApiHealthcheckElasticSearchAlertIndexCleaner(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckElasticSearchAlertIndexCleanerQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>>
  >;
export type GetApiHealthcheckElasticSearchAlertIndexCleanerQueryError = unknown;

export function useGetApiHealthcheckElasticSearchAlertIndexCleaner<
  TData = Awaited<
    ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckElasticSearchAlertIndexCleaner<
  TData = Awaited<
    ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckElasticSearchAlertIndexCleaner<
  TData = Awaited<
    ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckElasticSearchAlertIndexCleaner<
  TData = Awaited<
    ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiHealthcheckElasticSearchAlertIndexCleaner>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiHealthcheckElasticSearchAlertIndexCleanerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckTestRedis = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/healthcheck/TestRedis`, method: "GET", signal },
    options
  );
};

export const getGetApiHealthcheckTestRedisQueryKey = () => {
  return [`/api/healthcheck/TestRedis`] as const;
};

export const getGetApiHealthcheckTestRedisQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiHealthcheckTestRedisQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>
  > = ({ signal }) => getApiHealthcheckTestRedis(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckTestRedisQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>
>;
export type GetApiHealthcheckTestRedisQueryError = unknown;

export function useGetApiHealthcheckTestRedis<
  TData = Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckTestRedis<
  TData = Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckTestRedis<
  TData = Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckTestRedis<
  TData = Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckTestRedis>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiHealthcheckTestRedisQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiHealthcheckHangfireRedisTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/healthcheck/hangfireRedisTest`, method: "GET", signal },
    options
  );
};

export const getGetApiHealthcheckHangfireRedisTestQueryKey = () => {
  return [`/api/healthcheck/hangfireRedisTest`] as const;
};

export const getGetApiHealthcheckHangfireRedisTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiHealthcheckHangfireRedisTestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>
  > = ({ signal }) =>
    getApiHealthcheckHangfireRedisTest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiHealthcheckHangfireRedisTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>
>;
export type GetApiHealthcheckHangfireRedisTestQueryError = unknown;

export function useGetApiHealthcheckHangfireRedisTest<
  TData = Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckHangfireRedisTest<
  TData = Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
          TError,
          Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiHealthcheckHangfireRedisTest<
  TData = Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiHealthcheckHangfireRedisTest<
  TData = Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiHealthcheckHangfireRedisTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiHealthcheckHangfireRedisTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiInboundpaymentCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/callback`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentCallbackQueryKey = () => {
  return [`/api/inboundpayment/callback`] as const;
};

export const getGetApiInboundpaymentCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInboundpaymentCallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentCallback>>
  > = ({ signal }) => getApiInboundpaymentCallback(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentCallback>>
>;
export type GetApiInboundpaymentCallbackQueryError = unknown;

export function useGetApiInboundpaymentCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiInboundpaymentCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiInboundpaymentCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/callback`, method: "POST", signal },
    options
  );
};

export const getPostApiInboundpaymentCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentCallback>>,
    void
  > = () => {
    return postApiInboundpaymentCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentCallback>>
>;

export type PostApiInboundpaymentCallbackMutationError = unknown;

export const usePostApiInboundpaymentCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiInboundpaymentItnCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/itnCallback`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentItnCallbackQueryKey = () => {
  return [`/api/inboundpayment/itnCallback`] as const;
};

export const getGetApiInboundpaymentItnCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInboundpaymentItnCallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>
  > = ({ signal }) => getApiInboundpaymentItnCallback(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentItnCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>
>;
export type GetApiInboundpaymentItnCallbackQueryError = unknown;

export function useGetApiInboundpaymentItnCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentItnCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentItnCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentItnCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentItnCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiInboundpaymentItnCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiInboundpaymentItnCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiInboundpaymentItnCallback200One
    | PostApiInboundpaymentItnCallback200Two
    | Blob
  >(
    { url: `/api/inboundpayment/itnCallback`, method: "POST", signal },
    options
  );
};

export const getPostApiInboundpaymentItnCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentItnCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>,
    void
  > = () => {
    return postApiInboundpaymentItnCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentItnCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>
>;

export type PostApiInboundpaymentItnCallbackMutationError = unknown;

export const usePostApiInboundpaymentItnCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentItnCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentItnCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiInboundpaymentAisSuccessCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisSuccessCallback`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentAisSuccessCallbackQueryKey = () => {
  return [`/api/inboundpayment/aisSuccessCallback`] as const;
};

export const getGetApiInboundpaymentAisSuccessCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiInboundpaymentAisSuccessCallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>
  > = ({ signal }) =>
    getApiInboundpaymentAisSuccessCallback(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentAisSuccessCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>
>;
export type GetApiInboundpaymentAisSuccessCallbackQueryError = unknown;

export function useGetApiInboundpaymentAisSuccessCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisSuccessCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisSuccessCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentAisSuccessCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisSuccessCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiInboundpaymentAisSuccessCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiInboundpaymentAisSuccessCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisSuccessCallback`, method: "POST", signal },
    options
  );
};

export const getPostApiInboundpaymentAisSuccessCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentAisSuccessCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>,
    void
  > = () => {
    return postApiInboundpaymentAisSuccessCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentAisSuccessCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>
>;

export type PostApiInboundpaymentAisSuccessCallbackMutationError = unknown;

export const usePostApiInboundpaymentAisSuccessCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentAisSuccessCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentAisSuccessCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiInboundpaymentAisErrorCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisErrorCallback`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentAisErrorCallbackQueryKey = () => {
  return [`/api/inboundpayment/aisErrorCallback`] as const;
};

export const getGetApiInboundpaymentAisErrorCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInboundpaymentAisErrorCallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>
  > = ({ signal }) =>
    getApiInboundpaymentAisErrorCallback(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentAisErrorCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>
>;
export type GetApiInboundpaymentAisErrorCallbackQueryError = unknown;

export function useGetApiInboundpaymentAisErrorCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisErrorCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisErrorCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentAisErrorCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisErrorCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiInboundpaymentAisErrorCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiInboundpaymentAisErrorCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisErrorCallback`, method: "POST", signal },
    options
  );
};

export const getPostApiInboundpaymentAisErrorCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentAisErrorCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>,
    void
  > = () => {
    return postApiInboundpaymentAisErrorCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentAisErrorCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>
>;

export type PostApiInboundpaymentAisErrorCallbackMutationError = unknown;

export const usePostApiInboundpaymentAisErrorCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentAisErrorCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentAisErrorCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiInboundpaymentPaymentLink = (
  createPaymentLinkDto: CreatePaymentLinkDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/inboundpayment/paymentLink`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentLinkDto,
      signal,
    },
    options
  );
};

export const getPostApiInboundpaymentPaymentLinkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>,
    TError,
    { data: CreatePaymentLinkDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>,
  TError,
  { data: CreatePaymentLinkDto },
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentPaymentLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>,
    { data: CreatePaymentLinkDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiInboundpaymentPaymentLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentPaymentLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>
>;
export type PostApiInboundpaymentPaymentLinkMutationBody = CreatePaymentLinkDto;
export type PostApiInboundpaymentPaymentLinkMutationError = unknown;

export const usePostApiInboundpaymentPaymentLink = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>,
      TError,
      { data: CreatePaymentLinkDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentPaymentLink>>,
  TError,
  { data: CreatePaymentLinkDto },
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentPaymentLinkMutationOptions(options),
    queryClient
  );
};

export const postApiInboundpaymentInitUnnax = (
  unnaxInboundInitRequestDto: UnnaxInboundInitRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxInboundInitResponseDto>(
    {
      url: `/api/inboundpayment/init/unnax`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxInboundInitRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiInboundpaymentInitUnnaxMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>,
    TError,
    { data: UnnaxInboundInitRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>,
  TError,
  { data: UnnaxInboundInitRequestDto },
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentInitUnnax"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>,
    { data: UnnaxInboundInitRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiInboundpaymentInitUnnax(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentInitUnnaxMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>
>;
export type PostApiInboundpaymentInitUnnaxMutationBody =
  UnnaxInboundInitRequestDto;
export type PostApiInboundpaymentInitUnnaxMutationError = unknown;

export const usePostApiInboundpaymentInitUnnax = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>,
      TError,
      { data: UnnaxInboundInitRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentInitUnnax>>,
  TError,
  { data: UnnaxInboundInitRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentInitUnnaxMutationOptions(options),
    queryClient
  );
};

export const postApiInboundpaymentCallbackUnnaxCallbackEvent = (
  callbackEvent:
    | "event_default"
    | "event_payin_login"
    | "event_payin_account_selected"
    | "event_payment_transfer_lockstep_authorized"
    | "event_payment_transfer_lockstep_completed"
    | "event_pending_authorized_orders"
    | "event_payment_transfer_ownership_validation",
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/inboundpayment/callback/unnax/${callbackEvent}`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiInboundpaymentCallbackUnnaxCallbackEventMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>
      >,
      TError,
      {
        callbackEvent:
          | "event_default"
          | "event_payin_login"
          | "event_payin_account_selected"
          | "event_payment_transfer_lockstep_authorized"
          | "event_payment_transfer_lockstep_completed"
          | "event_pending_authorized_orders"
          | "event_payment_transfer_ownership_validation";
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>>,
    TError,
    {
      callbackEvent:
        | "event_default"
        | "event_payin_login"
        | "event_payin_account_selected"
        | "event_payment_transfer_lockstep_authorized"
        | "event_payment_transfer_lockstep_completed"
        | "event_pending_authorized_orders"
        | "event_payment_transfer_ownership_validation";
    },
    TContext
  > => {
    const mutationKey = ["postApiInboundpaymentCallbackUnnaxCallbackEvent"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>
      >,
      {
        callbackEvent:
          | "event_default"
          | "event_payin_login"
          | "event_payin_account_selected"
          | "event_payment_transfer_lockstep_authorized"
          | "event_payment_transfer_lockstep_completed"
          | "event_pending_authorized_orders"
          | "event_payment_transfer_ownership_validation";
      }
    > = (props) => {
      const { callbackEvent } = props ?? {};

      return postApiInboundpaymentCallbackUnnaxCallbackEvent(
        callbackEvent,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiInboundpaymentCallbackUnnaxCallbackEventMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>>
  >;

export type PostApiInboundpaymentCallbackUnnaxCallbackEventMutationError =
  unknown;

export const usePostApiInboundpaymentCallbackUnnaxCallbackEvent = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>
      >,
      TError,
      {
        callbackEvent:
          | "event_default"
          | "event_payin_login"
          | "event_payin_account_selected"
          | "event_payment_transfer_lockstep_authorized"
          | "event_payment_transfer_lockstep_completed"
          | "event_pending_authorized_orders"
          | "event_payment_transfer_ownership_validation";
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentCallbackUnnaxCallbackEvent>>,
  TError,
  {
    callbackEvent:
      | "event_default"
      | "event_payin_login"
      | "event_payin_account_selected"
      | "event_payment_transfer_lockstep_authorized"
      | "event_payment_transfer_lockstep_completed"
      | "event_pending_authorized_orders"
      | "event_payment_transfer_ownership_validation";
  },
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentCallbackUnnaxCallbackEventMutationOptions(options),
    queryClient
  );
};

export const getApiInboundpaymentOrdersUnnax = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListUnnaxInboundOrderResponseDto>(
    { url: `/api/inboundpayment/orders/unnax`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentOrdersUnnaxQueryKey = () => {
  return [`/api/inboundpayment/orders/unnax`] as const;
};

export const getGetApiInboundpaymentOrdersUnnaxQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInboundpaymentOrdersUnnaxQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>
  > = ({ signal }) => getApiInboundpaymentOrdersUnnax(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentOrdersUnnaxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>
>;
export type GetApiInboundpaymentOrdersUnnaxQueryError = unknown;

export function useGetApiInboundpaymentOrdersUnnax<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentOrdersUnnax<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentOrdersUnnax<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentOrdersUnnax<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentOrdersUnnax>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiInboundpaymentOrdersUnnaxQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiInboundpaymentAisCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisCallback`, method: "GET", signal },
    options
  );
};

export const getGetApiInboundpaymentAisCallbackQueryKey = () => {
  return [`/api/inboundpayment/aisCallback`] as const;
};

export const getGetApiInboundpaymentAisCallbackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiInboundpaymentAisCallbackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>
  > = ({ signal }) => getApiInboundpaymentAisCallback(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInboundpaymentAisCallbackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>
>;
export type GetApiInboundpaymentAisCallbackQueryError = unknown;

export function useGetApiInboundpaymentAisCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInboundpaymentAisCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiInboundpaymentAisCallback<
  TData = Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiInboundpaymentAisCallback>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiInboundpaymentAisCallbackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiInboundpaymentAisCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/inboundpayment/aisCallback`, method: "POST", signal },
    options
  );
};

export const getPostApiInboundpaymentAisCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiInboundpaymentAisCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>,
    void
  > = () => {
    return postApiInboundpaymentAisCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiInboundpaymentAisCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>
>;

export type PostApiInboundpaymentAisCallbackMutationError = unknown;

export const usePostApiInboundpaymentAisCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiInboundpaymentAisCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiInboundpaymentAisCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiKontomatikKontomatikCallback = (
  kontomatikCallbackDto: KontomatikCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/kontomatik/kontomatikCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: kontomatikCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiKontomatikKontomatikCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>,
    TError,
    { data: KontomatikCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>,
  TError,
  { data: KontomatikCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiKontomatikKontomatikCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>,
    { data: KontomatikCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKontomatikKontomatikCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKontomatikKontomatikCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>
>;
export type PostApiKontomatikKontomatikCallbackMutationBody =
  KontomatikCallbackDto;
export type PostApiKontomatikKontomatikCallbackMutationError = unknown;

export const usePostApiKontomatikKontomatikCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>,
      TError,
      { data: KontomatikCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKontomatikKontomatikCallback>>,
  TError,
  { data: KontomatikCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiKontomatikKontomatikCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiKontomatikLoginStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultKontomatikLoginStatusDto>(
    { url: `/api/kontomatik/loginStatus`, method: "GET", signal },
    options
  );
};

export const getGetApiKontomatikLoginStatusQueryKey = () => {
  return [`/api/kontomatik/loginStatus`] as const;
};

export const getGetApiKontomatikLoginStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiKontomatikLoginStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>
  > = ({ signal }) => getApiKontomatikLoginStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKontomatikLoginStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>
>;
export type GetApiKontomatikLoginStatusQueryError = unknown;

export function useGetApiKontomatikLoginStatus<
  TData = Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKontomatikLoginStatus<
  TData = Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKontomatikLoginStatus<
  TData = Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKontomatikLoginStatus<
  TData = Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKontomatikLoginStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKontomatikLoginStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiKycGetWasptoken = (
  idHubConnectDTO: IdHubConnectDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIdHubConnectResponseDTO>(
    {
      url: `/api/kyc/getWasptoken`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: idHubConnectDTO,
      signal,
    },
    options
  );
};

export const getPostApiKycGetWasptokenMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycGetWasptoken>>,
    TError,
    { data: IdHubConnectDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycGetWasptoken>>,
  TError,
  { data: IdHubConnectDTO },
  TContext
> => {
  const mutationKey = ["postApiKycGetWasptoken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycGetWasptoken>>,
    { data: IdHubConnectDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycGetWasptoken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycGetWasptokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycGetWasptoken>>
>;
export type PostApiKycGetWasptokenMutationBody = IdHubConnectDTO;
export type PostApiKycGetWasptokenMutationError = unknown;

export const usePostApiKycGetWasptoken = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycGetWasptoken>>,
      TError,
      { data: IdHubConnectDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycGetWasptoken>>,
  TError,
  { data: IdHubConnectDTO },
  TContext
> => {
  return useMutation(
    getPostApiKycGetWasptokenMutationOptions(options),
    queryClient
  );
};

export const postApiKycIdhubFindProcessConfiguration = (
  idHubFindConfigProcessDTO: NonReadonly<IdHubFindConfigProcessDTO>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIdHubFindConfigProcessResponseDTO>(
    {
      url: `/api/kyc/idhubFindProcessConfiguration`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: idHubFindConfigProcessDTO,
      signal,
    },
    options
  );
};

export const getPostApiKycIdhubFindProcessConfigurationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>,
    TError,
    { data: NonReadonly<IdHubFindConfigProcessDTO> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>,
  TError,
  { data: NonReadonly<IdHubFindConfigProcessDTO> },
  TContext
> => {
  const mutationKey = ["postApiKycIdhubFindProcessConfiguration"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>,
    { data: NonReadonly<IdHubFindConfigProcessDTO> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycIdhubFindProcessConfiguration(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycIdhubFindProcessConfigurationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>
>;
export type PostApiKycIdhubFindProcessConfigurationMutationBody =
  NonReadonly<IdHubFindConfigProcessDTO>;
export type PostApiKycIdhubFindProcessConfigurationMutationError = unknown;

export const usePostApiKycIdhubFindProcessConfiguration = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>,
      TError,
      { data: NonReadonly<IdHubFindConfigProcessDTO> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycIdhubFindProcessConfiguration>>,
  TError,
  { data: NonReadonly<IdHubFindConfigProcessDTO> },
  TContext
> => {
  return useMutation(
    getPostApiKycIdhubFindProcessConfigurationMutationOptions(options),
    queryClient
  );
};

export const getApiKycIdhubGetCustomeResult = (
  params: GetApiKycIdhubGetCustomeResultParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIdHubExecuteRequestResponseDTO>(
    { url: `/api/kyc/idhubGetCustomeResult`, method: "GET", params, signal },
    options
  );
};

export const getGetApiKycIdhubGetCustomeResultQueryKey = (
  params?: GetApiKycIdhubGetCustomeResultParams
) => {
  return [
    `/api/kyc/idhubGetCustomeResult`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiKycIdhubGetCustomeResultQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomeResultParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiKycIdhubGetCustomeResultQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>
  > = ({ signal }) =>
    getApiKycIdhubGetCustomeResult(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycIdhubGetCustomeResultQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>
>;
export type GetApiKycIdhubGetCustomeResultQueryError = unknown;

export function useGetApiKycIdhubGetCustomeResult<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomeResultParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIdhubGetCustomeResult<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomeResultParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIdhubGetCustomeResult<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomeResultParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycIdhubGetCustomeResult<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomeResultParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomeResult>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycIdhubGetCustomeResultQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiKycIdhubGetCustomerAllResults = (
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListIdHubExecuteRequestResponseDTO>(
    {
      url: `/api/kyc/idhubGetCustomerAllResults`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiKycIdhubGetCustomerAllResultsQueryKey = (
  params?: GetApiKycIdhubGetCustomerAllResultsParams
) => {
  return [
    `/api/kyc/idhubGetCustomerAllResults`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiKycIdhubGetCustomerAllResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiKycIdhubGetCustomerAllResultsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>
  > = ({ signal }) =>
    getApiKycIdhubGetCustomerAllResults(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycIdhubGetCustomerAllResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>
>;
export type GetApiKycIdhubGetCustomerAllResultsQueryError = unknown;

export function useGetApiKycIdhubGetCustomerAllResults<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIdhubGetCustomerAllResults<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIdhubGetCustomerAllResults<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycIdhubGetCustomerAllResults<
  TData = Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
  TError = unknown
>(
  params: GetApiKycIdhubGetCustomerAllResultsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIdhubGetCustomerAllResults>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycIdhubGetCustomerAllResultsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiKycIdhubExecuteRequest = (
  idHubPersonalDetailDTO: IdHubPersonalDetailDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/kyc/idhubExecuteRequest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: idHubPersonalDetailDTO,
      signal,
    },
    options
  );
};

export const getPostApiKycIdhubExecuteRequestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>,
    TError,
    { data: IdHubPersonalDetailDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>,
  TError,
  { data: IdHubPersonalDetailDTO },
  TContext
> => {
  const mutationKey = ["postApiKycIdhubExecuteRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>,
    { data: IdHubPersonalDetailDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycIdhubExecuteRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycIdhubExecuteRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>
>;
export type PostApiKycIdhubExecuteRequestMutationBody = IdHubPersonalDetailDTO;
export type PostApiKycIdhubExecuteRequestMutationError = unknown;

export const usePostApiKycIdhubExecuteRequest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>,
      TError,
      { data: IdHubPersonalDetailDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequest>>,
  TError,
  { data: IdHubPersonalDetailDTO },
  TContext
> => {
  return useMutation(
    getPostApiKycIdhubExecuteRequestMutationOptions(options),
    queryClient
  );
};

export const postApiKycIdhubExecuteRequestByCustomer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/kyc/idhubExecuteRequestByCustomer`, method: "POST", signal },
    options
  );
};

export const getPostApiKycIdhubExecuteRequestByCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiKycIdhubExecuteRequestByCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>,
    void
  > = () => {
    return postApiKycIdhubExecuteRequestByCustomer(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycIdhubExecuteRequestByCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>
>;

export type PostApiKycIdhubExecuteRequestByCustomerMutationError = unknown;

export const usePostApiKycIdhubExecuteRequestByCustomer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycIdhubExecuteRequestByCustomer>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiKycIdhubExecuteRequestByCustomerMutationOptions(options),
    queryClient
  );
};

export const postApiKycCreateConsumerSummaryWithpersonalData = (
  newDelphiExecuteInteractiveRequestDTO: NewDelphiExecuteInteractiveRequestDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/kyc/createConsumerSummaryWithpersonalData`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: newDelphiExecuteInteractiveRequestDTO,
      signal,
    },
    options
  );
};

export const getPostApiKycCreateConsumerSummaryWithpersonalDataMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>
      >,
      TError,
      { data: NewDelphiExecuteInteractiveRequestDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>>,
    TError,
    { data: NewDelphiExecuteInteractiveRequestDTO },
    TContext
  > => {
    const mutationKey = ["postApiKycCreateConsumerSummaryWithpersonalData"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>
      >,
      { data: NewDelphiExecuteInteractiveRequestDTO }
    > = (props) => {
      const { data } = props ?? {};

      return postApiKycCreateConsumerSummaryWithpersonalData(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiKycCreateConsumerSummaryWithpersonalDataMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>>
  >;
export type PostApiKycCreateConsumerSummaryWithpersonalDataMutationBody =
  NewDelphiExecuteInteractiveRequestDTO;
export type PostApiKycCreateConsumerSummaryWithpersonalDataMutationError =
  unknown;

export const usePostApiKycCreateConsumerSummaryWithpersonalData = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>
      >,
      TError,
      { data: NewDelphiExecuteInteractiveRequestDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycCreateConsumerSummaryWithpersonalData>>,
  TError,
  { data: NewDelphiExecuteInteractiveRequestDTO },
  TContext
> => {
  return useMutation(
    getPostApiKycCreateConsumerSummaryWithpersonalDataMutationOptions(options),
    queryClient
  );
};

export const postApiKycNewdelphiCreateConsumerSummary = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/kyc/newdelphiCreateConsumerSummary`, method: "POST", signal },
    options
  );
};

export const getPostApiKycNewdelphiCreateConsumerSummaryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiKycNewdelphiCreateConsumerSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>,
    void
  > = () => {
    return postApiKycNewdelphiCreateConsumerSummary(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycNewdelphiCreateConsumerSummaryMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>
  >;

export type PostApiKycNewdelphiCreateConsumerSummaryMutationError = unknown;

export const usePostApiKycNewdelphiCreateConsumerSummary = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycNewdelphiCreateConsumerSummary>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiKycNewdelphiCreateConsumerSummaryMutationOptions(options),
    queryClient
  );
};

export const getApiKycNewdelphiGetCustomerLastConsumerSummary = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultNewDelphiExecuteInteractiveResponseDTO>(
    {
      url: `/api/kyc/newdelphiGetCustomerLastConsumerSummary`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryKey =
  () => {
    return [`/api/kyc/newdelphiGetCustomerLastConsumerSummary`] as const;
  };

export const getGetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
      >,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>>
  > = ({ signal }) =>
    getApiKycNewdelphiGetCustomerLastConsumerSummary(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>>
  >;
export type GetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryError =
  unknown;

export function useGetApiKycNewdelphiGetCustomerLastConsumerSummary<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycNewdelphiGetCustomerLastConsumerSummary<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycNewdelphiGetCustomerLastConsumerSummary<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycNewdelphiGetCustomerLastConsumerSummary<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerLastConsumerSummary>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiKycNewdelphiGetCustomerLastConsumerSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiKycNewdelphiGetCustomerConsumerSummaryList = (
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListNewDelphiExecuteInteractiveResponseDTO>(
    {
      url: `/api/kyc/newdelphiGetCustomerConsumerSummaryList`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiKycNewdelphiGetCustomerConsumerSummaryListQueryKey = (
  params?: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams
) => {
  return [
    `/api/kyc/newdelphiGetCustomerConsumerSummaryList`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiKycNewdelphiGetCustomerConsumerSummaryListQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
  >,
  TError = unknown
>(
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiKycNewdelphiGetCustomerConsumerSummaryListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>>
  > = ({ signal }) =>
    getApiKycNewdelphiGetCustomerConsumerSummaryList(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycNewdelphiGetCustomerConsumerSummaryListQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>>
  >;
export type GetApiKycNewdelphiGetCustomerConsumerSummaryListQueryError =
  unknown;

export function useGetApiKycNewdelphiGetCustomerConsumerSummaryList<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
  >,
  TError = unknown
>(
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycNewdelphiGetCustomerConsumerSummaryList<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
  >,
  TError = unknown
>(
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycNewdelphiGetCustomerConsumerSummaryList<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
  >,
  TError = unknown
>(
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycNewdelphiGetCustomerConsumerSummaryList<
  TData = Awaited<
    ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
  >,
  TError = unknown
>(
  params: GetApiKycNewdelphiGetCustomerConsumerSummaryListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiKycNewdelphiGetCustomerConsumerSummaryList>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiKycNewdelphiGetCustomerConsumerSummaryListQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiKycCallCreditChangeAdminPassword = (
  changeAdminPasswordRequestDto: ChangeAdminPasswordRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultChangeAdminPasswordResponseDto>(
    {
      url: `/api/kyc/callCreditChangeAdminPassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeAdminPasswordRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiKycCallCreditChangeAdminPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>,
    TError,
    { data: ChangeAdminPasswordRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>,
  TError,
  { data: ChangeAdminPasswordRequestDto },
  TContext
> => {
  const mutationKey = ["postApiKycCallCreditChangeAdminPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>,
    { data: ChangeAdminPasswordRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycCallCreditChangeAdminPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycCallCreditChangeAdminPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>
>;
export type PostApiKycCallCreditChangeAdminPasswordMutationBody =
  ChangeAdminPasswordRequestDto;
export type PostApiKycCallCreditChangeAdminPasswordMutationError = unknown;

export const usePostApiKycCallCreditChangeAdminPassword = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>,
      TError,
      { data: ChangeAdminPasswordRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycCallCreditChangeAdminPassword>>,
  TError,
  { data: ChangeAdminPasswordRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiKycCallCreditChangeAdminPasswordMutationOptions(options),
    queryClient
  );
};

export const postApiKycCallCreditMLSearch = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSearchMLResponseDto>(
    { url: `/api/kyc/callCreditMLSearch`, method: "POST", signal },
    options
  );
};

export const getPostApiKycCallCreditMLSearchMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiKycCallCreditMLSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>,
    void
  > = () => {
    return postApiKycCallCreditMLSearch(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycCallCreditMLSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>
>;

export type PostApiKycCallCreditMLSearchMutationError = unknown;

export const usePostApiKycCallCreditMLSearch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycCallCreditMLSearch>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiKycCallCreditMLSearchMutationOptions(options),
    queryClient
  );
};

export const postApiKycCallCreditReportSearch = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSearchMLResponseDto>(
    { url: `/api/kyc/callCreditReportSearch`, method: "POST", signal },
    options
  );
};

export const getPostApiKycCallCreditReportSearchMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiKycCallCreditReportSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>,
    void
  > = () => {
    return postApiKycCallCreditReportSearch(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycCallCreditReportSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>
>;

export type PostApiKycCallCreditReportSearchMutationError = unknown;

export const usePostApiKycCallCreditReportSearch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycCallCreditReportSearch>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiKycCallCreditReportSearchMutationOptions(options),
    queryClient
  );
};

export const postApiKycGetCallCreditSearchResult = (
  getCallCreditSearchResultDto: GetCallCreditSearchResultDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSearchMLResponseDto>(
    {
      url: `/api/kyc/getCallCreditSearchResult`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getCallCreditSearchResultDto,
      signal,
    },
    options
  );
};

export const getPostApiKycGetCallCreditSearchResultMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>,
    TError,
    { data: GetCallCreditSearchResultDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>,
  TError,
  { data: GetCallCreditSearchResultDto },
  TContext
> => {
  const mutationKey = ["postApiKycGetCallCreditSearchResult"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>,
    { data: GetCallCreditSearchResultDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycGetCallCreditSearchResult(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycGetCallCreditSearchResultMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>
>;
export type PostApiKycGetCallCreditSearchResultMutationBody =
  GetCallCreditSearchResultDto;
export type PostApiKycGetCallCreditSearchResultMutationError = unknown;

export const usePostApiKycGetCallCreditSearchResult = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>,
      TError,
      { data: GetCallCreditSearchResultDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycGetCallCreditSearchResult>>,
  TError,
  { data: GetCallCreditSearchResultDto },
  TContext
> => {
  return useMutation(
    getPostApiKycGetCallCreditSearchResultMutationOptions(options),
    queryClient
  );
};

export const postApiKycEquifaxCustomerSearch = (
  creditInformation: CreditInformation,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultEquifaxInterConnectResponseDTO>(
    {
      url: `/api/kyc/equifaxCustomerSearch`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: creditInformation,
      signal,
    },
    options
  );
};

export const getPostApiKycEquifaxCustomerSearchMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>,
    TError,
    { data: CreditInformation },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>,
  TError,
  { data: CreditInformation },
  TContext
> => {
  const mutationKey = ["postApiKycEquifaxCustomerSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>,
    { data: CreditInformation }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycEquifaxCustomerSearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycEquifaxCustomerSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>
>;
export type PostApiKycEquifaxCustomerSearchMutationBody = CreditInformation;
export type PostApiKycEquifaxCustomerSearchMutationError = unknown;

export const usePostApiKycEquifaxCustomerSearch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>,
      TError,
      { data: CreditInformation },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycEquifaxCustomerSearch>>,
  TError,
  { data: CreditInformation },
  TContext
> => {
  return useMutation(
    getPostApiKycEquifaxCustomerSearchMutationOptions(options),
    queryClient
  );
};

export const getApiKycEquifaxInterConnectResponse = (
  params: GetApiKycEquifaxInterConnectResponseParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultEquifaxInterConnectResponseDTO>(
    {
      url: `/api/kyc/equifaxInterConnectResponse`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiKycEquifaxInterConnectResponseQueryKey = (
  params?: GetApiKycEquifaxInterConnectResponseParams
) => {
  return [
    `/api/kyc/equifaxInterConnectResponse`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiKycEquifaxInterConnectResponseQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
  TError = unknown
>(
  params: GetApiKycEquifaxInterConnectResponseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiKycEquifaxInterConnectResponseQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>
  > = ({ signal }) =>
    getApiKycEquifaxInterConnectResponse(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycEquifaxInterConnectResponseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>
>;
export type GetApiKycEquifaxInterConnectResponseQueryError = unknown;

export function useGetApiKycEquifaxInterConnectResponse<
  TData = Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
  TError = unknown
>(
  params: GetApiKycEquifaxInterConnectResponseParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
          TError,
          Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycEquifaxInterConnectResponse<
  TData = Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
  TError = unknown
>(
  params: GetApiKycEquifaxInterConnectResponseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
          TError,
          Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycEquifaxInterConnectResponse<
  TData = Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
  TError = unknown
>(
  params: GetApiKycEquifaxInterConnectResponseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycEquifaxInterConnectResponse<
  TData = Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
  TError = unknown
>(
  params: GetApiKycEquifaxInterConnectResponseParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycEquifaxInterConnectResponse>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycEquifaxInterConnectResponseQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiKycDeydeGetNameSurnameNormalization = (
  nameSurnameValidationDto: NameSurnameValidationDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultNameSurnameValidationResponseDto>(
    {
      url: `/api/kyc/deydeGetNameSurnameNormalization`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: nameSurnameValidationDto,
      signal,
    },
    options
  );
};

export const getPostApiKycDeydeGetNameSurnameNormalizationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>,
    TError,
    { data: NameSurnameValidationDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>,
  TError,
  { data: NameSurnameValidationDto },
  TContext
> => {
  const mutationKey = ["postApiKycDeydeGetNameSurnameNormalization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>,
    { data: NameSurnameValidationDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycDeydeGetNameSurnameNormalization(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycDeydeGetNameSurnameNormalizationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>
  >;
export type PostApiKycDeydeGetNameSurnameNormalizationMutationBody =
  NameSurnameValidationDto;
export type PostApiKycDeydeGetNameSurnameNormalizationMutationError = unknown;

export const usePostApiKycDeydeGetNameSurnameNormalization = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>,
      TError,
      { data: NameSurnameValidationDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycDeydeGetNameSurnameNormalization>>,
  TError,
  { data: NameSurnameValidationDto },
  TContext
> => {
  return useMutation(
    getPostApiKycDeydeGetNameSurnameNormalizationMutationOptions(options),
    queryClient
  );
};

export const postApiKycDeydeThoroughfareEncoding = (
  deydeThoroughfareEncodingDto: DeydeThoroughfareEncodingDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDeydeThoroughfareEncodingResponseDto>(
    {
      url: `/api/kyc/deydeThoroughfareEncoding`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deydeThoroughfareEncodingDto,
      signal,
    },
    options
  );
};

export const getPostApiKycDeydeThoroughfareEncodingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>,
    TError,
    { data: DeydeThoroughfareEncodingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>,
  TError,
  { data: DeydeThoroughfareEncodingDto },
  TContext
> => {
  const mutationKey = ["postApiKycDeydeThoroughfareEncoding"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>,
    { data: DeydeThoroughfareEncodingDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycDeydeThoroughfareEncoding(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycDeydeThoroughfareEncodingMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>
>;
export type PostApiKycDeydeThoroughfareEncodingMutationBody =
  DeydeThoroughfareEncodingDto;
export type PostApiKycDeydeThoroughfareEncodingMutationError = unknown;

export const usePostApiKycDeydeThoroughfareEncoding = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>,
      TError,
      { data: DeydeThoroughfareEncodingDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycDeydeThoroughfareEncoding>>,
  TError,
  { data: DeydeThoroughfareEncodingDto },
  TContext
> => {
  return useMutation(
    getPostApiKycDeydeThoroughfareEncodingMutationOptions(options),
    queryClient
  );
};

export const postApiKycSetAMLCheckActive = (
  params: PostApiKycSetAMLCheckActiveParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/kyc/setAMLCheckActive`, method: "POST", params, signal },
    options
  );
};

export const getPostApiKycSetAMLCheckActiveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>,
    TError,
    { params: PostApiKycSetAMLCheckActiveParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>,
  TError,
  { params: PostApiKycSetAMLCheckActiveParams },
  TContext
> => {
  const mutationKey = ["postApiKycSetAMLCheckActive"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>,
    { params: PostApiKycSetAMLCheckActiveParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiKycSetAMLCheckActive(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycSetAMLCheckActiveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>
>;

export type PostApiKycSetAMLCheckActiveMutationError = unknown;

export const usePostApiKycSetAMLCheckActive = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>,
      TError,
      { params: PostApiKycSetAMLCheckActiveParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycSetAMLCheckActive>>,
  TError,
  { params: PostApiKycSetAMLCheckActiveParams },
  TContext
> => {
  return useMutation(
    getPostApiKycSetAMLCheckActiveMutationOptions(options),
    queryClient
  );
};

export const getApiKycGetAMLCheckActive = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/kyc/getAMLCheckActive`, method: "GET", signal },
    options
  );
};

export const getGetApiKycGetAMLCheckActiveQueryKey = () => {
  return [`/api/kyc/getAMLCheckActive`] as const;
};

export const getGetApiKycGetAMLCheckActiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiKycGetAMLCheckActiveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>
  > = ({ signal }) => getApiKycGetAMLCheckActive(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycGetAMLCheckActiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>
>;
export type GetApiKycGetAMLCheckActiveQueryError = unknown;

export function useGetApiKycGetAMLCheckActive<
  TData = Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
          TError,
          Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycGetAMLCheckActive<
  TData = Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
          TError,
          Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycGetAMLCheckActive<
  TData = Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycGetAMLCheckActive<
  TData = Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGetAMLCheckActive>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycGetAMLCheckActiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiKycIsCustomerAMLChecked = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/kyc/isCustomerAMLChecked`, method: "GET", signal },
    options
  );
};

export const getGetApiKycIsCustomerAMLCheckedQueryKey = () => {
  return [`/api/kyc/isCustomerAMLChecked`] as const;
};

export const getGetApiKycIsCustomerAMLCheckedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiKycIsCustomerAMLCheckedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>
  > = ({ signal }) => getApiKycIsCustomerAMLChecked(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycIsCustomerAMLCheckedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>
>;
export type GetApiKycIsCustomerAMLCheckedQueryError = unknown;

export function useGetApiKycIsCustomerAMLChecked<
  TData = Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIsCustomerAMLChecked<
  TData = Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
          TError,
          Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycIsCustomerAMLChecked<
  TData = Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycIsCustomerAMLChecked<
  TData = Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycIsCustomerAMLChecked>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycIsCustomerAMLCheckedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiKycGeolocation = (
  params: GetApiKycGeolocationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultGeoLocationDto>(
    { url: `/api/kyc/geolocation`, method: "GET", params, signal },
    options
  );
};

export const getGetApiKycGeolocationQueryKey = (
  params?: GetApiKycGeolocationParams
) => {
  return [`/api/kyc/geolocation`, ...(params ? [params] : [])] as const;
};

export const getGetApiKycGeolocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiKycGeolocation>>,
  TError = unknown
>(
  params: GetApiKycGeolocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGeolocation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiKycGeolocationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiKycGeolocation>>
  > = ({ signal }) => getApiKycGeolocation(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiKycGeolocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiKycGeolocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiKycGeolocation>>
>;
export type GetApiKycGeolocationQueryError = unknown;

export function useGetApiKycGeolocation<
  TData = Awaited<ReturnType<typeof getApiKycGeolocation>>,
  TError = unknown
>(
  params: GetApiKycGeolocationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGeolocation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycGeolocation>>,
          TError,
          Awaited<ReturnType<typeof getApiKycGeolocation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycGeolocation<
  TData = Awaited<ReturnType<typeof getApiKycGeolocation>>,
  TError = unknown
>(
  params: GetApiKycGeolocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGeolocation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiKycGeolocation>>,
          TError,
          Awaited<ReturnType<typeof getApiKycGeolocation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiKycGeolocation<
  TData = Awaited<ReturnType<typeof getApiKycGeolocation>>,
  TError = unknown
>(
  params: GetApiKycGeolocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGeolocation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiKycGeolocation<
  TData = Awaited<ReturnType<typeof getApiKycGeolocation>>,
  TError = unknown
>(
  params: GetApiKycGeolocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiKycGeolocation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiKycGeolocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiKycIncofisaPetition = (
  doInstantPetitionRequestDto: DoInstantPetitionRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultGrupoIncofisaPetitionResultDto>(
    {
      url: `/api/kyc/incofisa/petition`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: doInstantPetitionRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiKycIncofisaPetitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycIncofisaPetition>>,
    TError,
    { data: DoInstantPetitionRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycIncofisaPetition>>,
  TError,
  { data: DoInstantPetitionRequestDto },
  TContext
> => {
  const mutationKey = ["postApiKycIncofisaPetition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycIncofisaPetition>>,
    { data: DoInstantPetitionRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycIncofisaPetition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycIncofisaPetitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycIncofisaPetition>>
>;
export type PostApiKycIncofisaPetitionMutationBody =
  DoInstantPetitionRequestDto;
export type PostApiKycIncofisaPetitionMutationError = unknown;

export const usePostApiKycIncofisaPetition = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycIncofisaPetition>>,
      TError,
      { data: DoInstantPetitionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycIncofisaPetition>>,
  TError,
  { data: DoInstantPetitionRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiKycIncofisaPetitionMutationOptions(options),
    queryClient
  );
};

export const postApiKycIncofisaPetitionEnqueue = (
  params: PostApiKycIncofisaPetitionEnqueueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/kyc/incofisa/petition/enqueue`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiKycIncofisaPetitionEnqueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>,
    TError,
    { params: PostApiKycIncofisaPetitionEnqueueParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>,
  TError,
  { params: PostApiKycIncofisaPetitionEnqueueParams },
  TContext
> => {
  const mutationKey = ["postApiKycIncofisaPetitionEnqueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>,
    { params: PostApiKycIncofisaPetitionEnqueueParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiKycIncofisaPetitionEnqueue(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycIncofisaPetitionEnqueueMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>
>;

export type PostApiKycIncofisaPetitionEnqueueMutationError = unknown;

export const usePostApiKycIncofisaPetitionEnqueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>,
      TError,
      { params: PostApiKycIncofisaPetitionEnqueueParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycIncofisaPetitionEnqueue>>,
  TError,
  { params: PostApiKycIncofisaPetitionEnqueueParams },
  TContext
> => {
  return useMutation(
    getPostApiKycIncofisaPetitionEnqueueMutationOptions(options),
    queryClient
  );
};

export const putApiKycAmlProvider = (
  aMLProviderDtoBody: AMLProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAMLProviderDto>(
    {
      url: `/api/kyc/AmlProvider`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: aMLProviderDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiKycAmlProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiKycAmlProvider>>,
    TError,
    { data: AMLProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  const mutationKey = ["putApiKycAmlProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiKycAmlProvider>>,
    { data: AMLProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiKycAmlProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiKycAmlProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiKycAmlProvider>>
>;
export type PutApiKycAmlProviderMutationBody = AMLProviderDtoBody;
export type PutApiKycAmlProviderMutationError = unknown;

export const usePutApiKycAmlProvider = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiKycAmlProvider>>,
      TError,
      { data: AMLProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiKycAmlProviderMutationOptions(options),
    queryClient
  );
};

export const postApiKycAmlProvider = (
  aMLProviderDtoBody: AMLProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAMLProviderDto>(
    {
      url: `/api/kyc/AmlProvider`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: aMLProviderDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiKycAmlProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycAmlProvider>>,
    TError,
    { data: AMLProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  const mutationKey = ["postApiKycAmlProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycAmlProvider>>,
    { data: AMLProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiKycAmlProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycAmlProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycAmlProvider>>
>;
export type PostApiKycAmlProviderMutationBody = AMLProviderDtoBody;
export type PostApiKycAmlProviderMutationError = unknown;

export const usePostApiKycAmlProvider = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycAmlProvider>>,
      TError,
      { data: AMLProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiKycAmlProviderMutationOptions(options),
    queryClient
  );
};

export const deleteApiKycAmlProvider = (
  aMLProviderDtoBody: AMLProviderDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAMLProviderDto>(
    {
      url: `/api/kyc/AmlProvider`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: aMLProviderDtoBody,
      signal,
    },
    options
  );
};

export const getDeleteApiKycAmlProviderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiKycAmlProvider>>,
    TError,
    { data: AMLProviderDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  const mutationKey = ["deleteApiKycAmlProvider"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiKycAmlProvider>>,
    { data: AMLProviderDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteApiKycAmlProvider(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiKycAmlProviderMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiKycAmlProvider>>
>;
export type DeleteApiKycAmlProviderMutationBody = AMLProviderDtoBody;
export type DeleteApiKycAmlProviderMutationError = unknown;

export const useDeleteApiKycAmlProvider = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiKycAmlProvider>>,
      TError,
      { data: AMLProviderDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiKycAmlProvider>>,
  TError,
  { data: AMLProviderDtoBody },
  TContext
> => {
  return useMutation(
    getDeleteApiKycAmlProviderMutationOptions(options),
    queryClient
  );
};

export const postApiKycAmlProviderList = (
  params: PostApiKycAmlProviderListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListAMLProviderDto>(
    { url: `/api/kyc/AmlProviderList`, method: "POST", params, signal },
    options
  );
};

export const getPostApiKycAmlProviderListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiKycAmlProviderList>>,
    TError,
    { params: PostApiKycAmlProviderListParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiKycAmlProviderList>>,
  TError,
  { params: PostApiKycAmlProviderListParams },
  TContext
> => {
  const mutationKey = ["postApiKycAmlProviderList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiKycAmlProviderList>>,
    { params: PostApiKycAmlProviderListParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiKycAmlProviderList(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiKycAmlProviderListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiKycAmlProviderList>>
>;

export type PostApiKycAmlProviderListMutationError = unknown;

export const usePostApiKycAmlProviderList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiKycAmlProviderList>>,
      TError,
      { params: PostApiKycAmlProviderListParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiKycAmlProviderList>>,
  TError,
  { params: PostApiKycAmlProviderListParams },
  TContext
> => {
  return useMutation(
    getPostApiKycAmlProviderListMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaBulkCustomerComment = (
  bulkCustomerCommentRequestDto: BulkCustomerCommentRequestDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/bulkCustomerComment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkCustomerCommentRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaBulkCustomerCommentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>,
    TError,
    { data: BulkCustomerCommentRequestDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>,
  TError,
  { data: BulkCustomerCommentRequestDto[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaBulkCustomerComment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>,
    { data: BulkCustomerCommentRequestDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaBulkCustomerComment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaBulkCustomerCommentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>
>;
export type PostApiLambdaBulkCustomerCommentMutationBody =
  BulkCustomerCommentRequestDto[];
export type PostApiLambdaBulkCustomerCommentMutationError = unknown;

export const usePostApiLambdaBulkCustomerComment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>,
      TError,
      { data: BulkCustomerCommentRequestDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaBulkCustomerComment>>,
  TError,
  { data: BulkCustomerCommentRequestDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaBulkCustomerCommentMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCredoraxChargebackQueue = (
  credoraxChargebackDto: CredoraxChargebackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/credorax/chargebackQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: credoraxChargebackDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCredoraxChargebackQueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>,
    TError,
    { data: CredoraxChargebackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>,
  TError,
  { data: CredoraxChargebackDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaCredoraxChargebackQueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>,
    { data: CredoraxChargebackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCredoraxChargebackQueue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCredoraxChargebackQueueMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>
>;
export type PostApiLambdaCredoraxChargebackQueueMutationBody =
  CredoraxChargebackDto;
export type PostApiLambdaCredoraxChargebackQueueMutationError = unknown;

export const usePostApiLambdaCredoraxChargebackQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>,
      TError,
      { data: CredoraxChargebackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCredoraxChargebackQueue>>,
  TError,
  { data: CredoraxChargebackDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCredoraxChargebackQueueMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationBankscraperAutoLink = (
  autoLinkSqsDto: AutoLinkSqsDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/bankscraper/autoLink`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: autoLinkSqsDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationBankscraperAutoLinkMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>,
    TError,
    { data: AutoLinkSqsDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>,
  TError,
  { data: AutoLinkSqsDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationBankscraperAutoLink"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>,
    { data: AutoLinkSqsDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAutomationBankscraperAutoLink(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationBankscraperAutoLinkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>
  >;
export type PostApiLambdaAutomationBankscraperAutoLinkMutationBody =
  AutoLinkSqsDto;
export type PostApiLambdaAutomationBankscraperAutoLinkMutationError = unknown;

export const usePostApiLambdaAutomationBankscraperAutoLink = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>,
      TError,
      { data: AutoLinkSqsDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationBankscraperAutoLink>>,
  TError,
  { data: AutoLinkSqsDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationBankscraperAutoLinkMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanCheckAutoIssueFtbBeforeCancel = (
  params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/checkAutoIssueFtbBeforeCancel`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanCheckAutoIssueFtbBeforeCancelMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>
      >,
      TError,
      { params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>>,
    TError,
    { params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaLoanCheckAutoIssueFtbBeforeCancel"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>
      >,
      { params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanCheckAutoIssueFtbBeforeCancel(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>>
  >;

export type PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelMutationError =
  unknown;

export const usePostApiLambdaLoanCheckAutoIssueFtbBeforeCancel = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>
      >,
      TError,
      { params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanCheckAutoIssueFtbBeforeCancel>>,
  TError,
  { params?: PostApiLambdaLoanCheckAutoIssueFtbBeforeCancelParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanCheckAutoIssueFtbBeforeCancelMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationCourtPaymentBulkEmail = (
  communicationPaymentModel: CommunicationPaymentModel[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCommunicationPaymentResponseModel>(
    {
      url: `/api/lambda/communication/courtPaymentBulkEmail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationPaymentModel,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationCourtPaymentBulkEmailMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>
      >,
      TError,
      { data: CommunicationPaymentModel[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>>,
    TError,
    { data: CommunicationPaymentModel[] },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationCourtPaymentBulkEmail"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>
      >,
      { data: CommunicationPaymentModel[] }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaCommunicationCourtPaymentBulkEmail(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationCourtPaymentBulkEmailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>>
  >;
export type PostApiLambdaCommunicationCourtPaymentBulkEmailMutationBody =
  CommunicationPaymentModel[];
export type PostApiLambdaCommunicationCourtPaymentBulkEmailMutationError =
  unknown;

export const usePostApiLambdaCommunicationCourtPaymentBulkEmail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>
      >,
      TError,
      { data: CommunicationPaymentModel[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationCourtPaymentBulkEmail>>,
  TError,
  { data: CommunicationPaymentModel[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationCourtPaymentBulkEmailMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationCommunicationSetIVRCallQueue = (
  setIVRCallDto: SetIVRCallDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/communication/setIVRCallQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setIVRCallDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationCommunicationSetIVRCallQueueMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
      >,
      TError,
      { data: SetIVRCallDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
    >,
    TError,
    { data: SetIVRCallDto },
    TContext
  > => {
    const mutationKey = ["postApiLambdaAutomationCommunicationSetIVRCallQueue"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
      >,
      { data: SetIVRCallDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaAutomationCommunicationSetIVRCallQueue(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaAutomationCommunicationSetIVRCallQueueMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
    >
  >;
export type PostApiLambdaAutomationCommunicationSetIVRCallQueueMutationBody =
  SetIVRCallDto;
export type PostApiLambdaAutomationCommunicationSetIVRCallQueueMutationError =
  unknown;

export const usePostApiLambdaAutomationCommunicationSetIVRCallQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
      >,
      TError,
      { data: SetIVRCallDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaAutomationCommunicationSetIVRCallQueue>
  >,
  TError,
  { data: SetIVRCallDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationCommunicationSetIVRCallQueueMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaChargebackRunJobs = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/chargeback/runJobs`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaChargebackRunJobsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaChargebackRunJobs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>,
    void
  > = () => {
    return postApiLambdaChargebackRunJobs(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaChargebackRunJobsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>
>;

export type PostApiLambdaChargebackRunJobsMutationError = unknown;

export const usePostApiLambdaChargebackRunJobs = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaChargebackRunJobs>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaChargebackRunJobsMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCompanySftpMailConfig = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CompanySftpForMailConfigDto[]>(
    { url: `/api/lambda/company/sftp/mailConfig`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaCompanySftpMailConfigQueryKey = () => {
  return [`/api/lambda/company/sftp/mailConfig`] as const;
};

export const getGetApiLambdaCompanySftpMailConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLambdaCompanySftpMailConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>
  > = ({ signal }) => getApiLambdaCompanySftpMailConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCompanySftpMailConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>
>;
export type GetApiLambdaCompanySftpMailConfigQueryError = unknown;

export function useGetApiLambdaCompanySftpMailConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCompanySftpMailConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCompanySftpMailConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCompanySftpMailConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCompanySftpMailConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaCompanySftpMailConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCompanySftpSendMail = (
  companySftpMailRequest: CompanySftpMailRequest[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/company/sftp/sendMail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: companySftpMailRequest,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCompanySftpSendMailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>,
    TError,
    { data: CompanySftpMailRequest[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>,
  TError,
  { data: CompanySftpMailRequest[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaCompanySftpSendMail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>,
    { data: CompanySftpMailRequest[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCompanySftpSendMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCompanySftpSendMailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>
>;
export type PostApiLambdaCompanySftpSendMailMutationBody =
  CompanySftpMailRequest[];
export type PostApiLambdaCompanySftpSendMailMutationError = unknown;

export const usePostApiLambdaCompanySftpSendMail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>,
      TError,
      { data: CompanySftpMailRequest[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpSendMail>>,
  TError,
  { data: CompanySftpMailRequest[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCompanySftpSendMailMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaDengageStartSixMonthsJob = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLambdaDengageStartSixMonthsJob200One
    | PostApiLambdaDengageStartSixMonthsJob200Two
    | Blob
  >(
    { url: `/api/lambda/dengage/startSixMonthsJob`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaDengageStartSixMonthsJobMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaDengageStartSixMonthsJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>,
    void
  > = () => {
    return postApiLambdaDengageStartSixMonthsJob(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaDengageStartSixMonthsJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>
>;

export type PostApiLambdaDengageStartSixMonthsJobMutationError = unknown;

export const usePostApiLambdaDengageStartSixMonthsJob = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaDengageStartSixMonthsJob>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaDengageStartSixMonthsJobMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaDengageStartPassiveStatusCustomersJob = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLambdaDengageStartPassiveStatusCustomersJob200One
    | PostApiLambdaDengageStartPassiveStatusCustomersJob200Two
    | Blob
  >(
    {
      url: `/api/lambda/dengage/startPassiveStatusCustomersJob`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaDengageStartPassiveStatusCustomersJobMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaDengageStartPassiveStatusCustomersJob"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
      >,
      void
    > = () => {
      return postApiLambdaDengageStartPassiveStatusCustomersJob(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaDengageStartPassiveStatusCustomersJobMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
    >
  >;

export type PostApiLambdaDengageStartPassiveStatusCustomersJobMutationError =
  unknown;

export const usePostApiLambdaDengageStartPassiveStatusCustomersJob = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaDengageStartPassiveStatusCustomersJob>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaDengageStartPassiveStatusCustomersJobMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiLambdaPaynopainGetSubMerchantPayments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<boolean>(
    {
      url: `/api/lambda/paynopain/getSubMerchantPayments`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaPaynopainGetSubMerchantPaymentsQueryKey = () => {
  return [`/api/lambda/paynopain/getSubMerchantPayments`] as const;
};

export const getGetApiLambdaPaynopainGetSubMerchantPaymentsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaPaynopainGetSubMerchantPaymentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>
  > = ({ signal }) =>
    getApiLambdaPaynopainGetSubMerchantPayments(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaPaynopainGetSubMerchantPaymentsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>
  >;
export type GetApiLambdaPaynopainGetSubMerchantPaymentsQueryError = unknown;

export function useGetApiLambdaPaynopainGetSubMerchantPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaPaynopainGetSubMerchantPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaPaynopainGetSubMerchantPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaPaynopainGetSubMerchantPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaPaynopainGetSubMerchantPayments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaPaynopainGetSubMerchantPaymentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCollectionSendCollectionOperationsMail = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/collection/sendCollectionOperationsMail`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionSendCollectionOperationsMailMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCollectionSendCollectionOperationsMail"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
      >,
      void
    > = () => {
      return postApiLambdaCollectionSendCollectionOperationsMail(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCollectionSendCollectionOperationsMailMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
    >
  >;

export type PostApiLambdaCollectionSendCollectionOperationsMailMutationError =
  unknown;

export const usePostApiLambdaCollectionSendCollectionOperationsMail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCollectionSendCollectionOperationsMail>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionSendCollectionOperationsMailMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaRescrapeRtbCustomer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/rescrape/rtbCustomer`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaRescrapeRtbCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeRtbCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>,
    void
  > = () => {
    return postApiLambdaRescrapeRtbCustomer(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeRtbCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>
>;

export type PostApiLambdaRescrapeRtbCustomerMutationError = unknown;

export const usePostApiLambdaRescrapeRtbCustomer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeRtbCustomer>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeRtbCustomerMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanSendLoanReasonMailBeforeNDays = (
  params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/sendLoanReasonMailBeforeNDays`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanSendLoanReasonMailBeforeNDaysMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>
      >,
      TError,
      { params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>>,
    TError,
    { params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaLoanSendLoanReasonMailBeforeNDays"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>
      >,
      { params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanSendLoanReasonMailBeforeNDays(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanSendLoanReasonMailBeforeNDaysMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>>
  >;

export type PostApiLambdaLoanSendLoanReasonMailBeforeNDaysMutationError =
  unknown;

export const usePostApiLambdaLoanSendLoanReasonMailBeforeNDays = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>
      >,
      TError,
      { params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanSendLoanReasonMailBeforeNDays>>,
  TError,
  { params?: PostApiLambdaLoanSendLoanReasonMailBeforeNDaysParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanSendLoanReasonMailBeforeNDaysMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaLoanCloseOpenBalances = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/loan/closeOpenBalances`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaLoanCloseOpenBalancesQueryKey = () => {
  return [`/api/lambda/loan/closeOpenBalances`] as const;
};

export const getGetApiLambdaLoanCloseOpenBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLambdaLoanCloseOpenBalancesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>
  > = ({ signal }) => getApiLambdaLoanCloseOpenBalances(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaLoanCloseOpenBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>
>;
export type GetApiLambdaLoanCloseOpenBalancesQueryError = unknown;

export function useGetApiLambdaLoanCloseOpenBalances<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanCloseOpenBalances<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanCloseOpenBalances<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaLoanCloseOpenBalances<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanCloseOpenBalances>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaLoanCloseOpenBalancesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaLoanSendSmsToCustomersWithNoValidCards = (
  params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/sendSmsToCustomersWithNoValidCards`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanSendSmsToCustomersWithNoValidCardsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
      >,
      TError,
      { params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
    >,
    TError,
    { params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaLoanSendSmsToCustomersWithNoValidCards"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
      >,
      { params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanSendSmsToCustomersWithNoValidCards(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
    >
  >;

export type PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsMutationError =
  unknown;

export const usePostApiLambdaLoanSendSmsToCustomersWithNoValidCards = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
      >,
      TError,
      { params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaLoanSendSmsToCustomersWithNoValidCards>
  >,
  TError,
  { params?: PostApiLambdaLoanSendSmsToCustomersWithNoValidCardsParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanSendSmsToCustomersWithNoValidCardsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneyTransferSendMoneyReal = (
  sendMoneyRealDto: SendMoneyRealDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneyTransfer/sendMoneyReal`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendMoneyRealDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneyTransferSendMoneyRealMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>,
    TError,
    { data: SendMoneyRealDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>,
  TError,
  { data: SendMoneyRealDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaMoneyTransferSendMoneyReal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>,
    { data: SendMoneyRealDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaMoneyTransferSendMoneyReal(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaMoneyTransferSendMoneyRealMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>
>;
export type PostApiLambdaMoneyTransferSendMoneyRealMutationBody =
  SendMoneyRealDto;
export type PostApiLambdaMoneyTransferSendMoneyRealMutationError = unknown;

export const usePostApiLambdaMoneyTransferSendMoneyReal = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>,
      TError,
      { data: SendMoneyRealDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneyTransferSendMoneyReal>>,
  TError,
  { data: SendMoneyRealDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneyTransferSendMoneyRealMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaPromotionDataQueue = (
  promotionDataQueueItem: PromotionDataQueueItem,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/promotionDataQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: promotionDataQueueItem,
      signal,
    },
    options
  );
};

export const getPostApiLambdaPromotionDataQueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>,
    TError,
    { data: PromotionDataQueueItem },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>,
  TError,
  { data: PromotionDataQueueItem },
  TContext
> => {
  const mutationKey = ["postApiLambdaPromotionDataQueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>,
    { data: PromotionDataQueueItem }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaPromotionDataQueue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaPromotionDataQueueMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>
>;
export type PostApiLambdaPromotionDataQueueMutationBody =
  PromotionDataQueueItem;
export type PostApiLambdaPromotionDataQueueMutationError = unknown;

export const usePostApiLambdaPromotionDataQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>,
      TError,
      { data: PromotionDataQueueItem },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaPromotionDataQueue>>,
  TError,
  { data: PromotionDataQueueItem },
  TContext
> => {
  return useMutation(
    getPostApiLambdaPromotionDataQueueMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerManageDuplicateDniCustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListManageDuplicateDto>(
    {
      url: `/api/lambda/customer/manageDuplicateDniCustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerManageDuplicateDniCustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCustomerManageDuplicateDniCustomers"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>
      >,
      void
    > = () => {
      return postApiLambdaCustomerManageDuplicateDniCustomers(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerManageDuplicateDniCustomersMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>>
  >;

export type PostApiLambdaCustomerManageDuplicateDniCustomersMutationError =
  unknown;

export const usePostApiLambdaCustomerManageDuplicateDniCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCustomerManageDuplicateDniCustomers>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerManageDuplicateDniCustomersMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerManageDuplicatePhoneCustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListManageDuplicateDto>(
    {
      url: `/api/lambda/customer/manageDuplicatePhoneCustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerManageDuplicatePhoneCustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCustomerManageDuplicatePhoneCustomers"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
      >,
      void
    > = () => {
      return postApiLambdaCustomerManageDuplicatePhoneCustomers(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerManageDuplicatePhoneCustomersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
    >
  >;

export type PostApiLambdaCustomerManageDuplicatePhoneCustomersMutationError =
  unknown;

export const usePostApiLambdaCustomerManageDuplicatePhoneCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCustomerManageDuplicatePhoneCustomers>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerManageDuplicatePhoneCustomersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays = (
  params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/sendLoanBulkPaymentCompanyMailNDays`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
      >,
      TError,
      { params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
    >,
    TError,
    { params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
      >,
      { params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
    >
  >;

export type PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysMutationError =
  unknown;

export const usePostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
      >,
      TError,
      { params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaLoanSendLoanBulkPaymentCompanyMailNDays>
  >,
  TError,
  { params?: PostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanSendLoanBulkPaymentCompanyMailNDaysMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaAutomationCommunicationRetrySmsSend = (
  retrySmsSendRequestDtoBody: RetrySmsSendRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/communication/retrySmsSend`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: retrySmsSendRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationCommunicationRetrySmsSendMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>
      >,
      TError,
      { data: RetrySmsSendRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>
    >,
    TError,
    { data: RetrySmsSendRequestDtoBody },
    TContext
  > => {
    const mutationKey = ["postApiLambdaAutomationCommunicationRetrySmsSend"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>
      >,
      { data: RetrySmsSendRequestDtoBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaAutomationCommunicationRetrySmsSend(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaAutomationCommunicationRetrySmsSendMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>>
  >;
export type PostApiLambdaAutomationCommunicationRetrySmsSendMutationBody =
  RetrySmsSendRequestDtoBody;
export type PostApiLambdaAutomationCommunicationRetrySmsSendMutationError =
  unknown;

export const usePostApiLambdaAutomationCommunicationRetrySmsSend = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>
      >,
      TError,
      { data: RetrySmsSendRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationCommunicationRetrySmsSend>>,
  TError,
  { data: RetrySmsSendRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationCommunicationRetrySmsSendMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaAlert = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListAlertDto>(
    { url: `/api/lambda/alert`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaAlertQueryKey = () => {
  return [`/api/lambda/alert`] as const;
};

export const getGetApiLambdaAlertQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaAlert>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaAlert>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLambdaAlertQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaAlert>>
  > = ({ signal }) => getApiLambdaAlert(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaAlert>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaAlertQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaAlert>>
>;
export type GetApiLambdaAlertQueryError = unknown;

export function useGetApiLambdaAlert<
  TData = Awaited<ReturnType<typeof getApiLambdaAlert>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaAlert>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaAlert>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaAlert>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaAlert<
  TData = Awaited<ReturnType<typeof getApiLambdaAlert>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaAlert>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaAlert>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaAlert>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaAlert<
  TData = Awaited<ReturnType<typeof getApiLambdaAlert>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaAlert>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaAlert<
  TData = Awaited<ReturnType<typeof getApiLambdaAlert>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaAlert>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaAlertQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaAlertEvaluate = (
  alertDto: AlertDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/alert/evaluate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: alertDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAlertEvaluateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>,
    TError,
    { data: AlertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>,
  TError,
  { data: AlertDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaAlertEvaluate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>,
    { data: AlertDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAlertEvaluate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAlertEvaluateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>
>;
export type PostApiLambdaAlertEvaluateMutationBody = AlertDto;
export type PostApiLambdaAlertEvaluateMutationError = unknown;

export const usePostApiLambdaAlertEvaluate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>,
      TError,
      { data: AlertDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAlertEvaluate>>,
  TError,
  { data: AlertDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAlertEvaluateMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaRescrapeTinkCreateSession = (
  tinkCreateSession: TinkCreateSession[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTinkCreateSession>(
    {
      url: `/api/lambda/rescrape/tinkCreateSession`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tinkCreateSession,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeTinkCreateSessionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>,
    TError,
    { data: TinkCreateSession[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>,
  TError,
  { data: TinkCreateSession[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeTinkCreateSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>,
    { data: TinkCreateSession[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeTinkCreateSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeTinkCreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>
>;
export type PostApiLambdaRescrapeTinkCreateSessionMutationBody =
  TinkCreateSession[];
export type PostApiLambdaRescrapeTinkCreateSessionMutationError = unknown;

export const usePostApiLambdaRescrapeTinkCreateSession = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>,
      TError,
      { data: TinkCreateSession[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeTinkCreateSession>>,
  TError,
  { data: TinkCreateSession[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeTinkCreateSessionMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaStartCollectionCompanyAssign = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/lambda/startCollectionCompanyAssign`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaStartCollectionCompanyAssignMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaStartCollectionCompanyAssign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>,
    void
  > = () => {
    return postApiLambdaStartCollectionCompanyAssign(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaStartCollectionCompanyAssignMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>
  >;

export type PostApiLambdaStartCollectionCompanyAssignMutationError = unknown;

export const usePostApiLambdaStartCollectionCompanyAssign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaStartCollectionCompanyAssign>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaStartCollectionCompanyAssignMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationCustomerLegalCompanyInfoProcess = (
  customerLegalCompanyInfoQueueDto: CustomerLegalCompanyInfoQueueDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/customer/legalCompanyInfoProcess`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerLegalCompanyInfoQueueDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationCustomerLegalCompanyInfoProcessMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess
        >
      >,
      TError,
      { data: CustomerLegalCompanyInfoQueueDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess>
    >,
    TError,
    { data: CustomerLegalCompanyInfoQueueDto },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaAutomationCustomerLegalCompanyInfoProcess",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess
        >
      >,
      { data: CustomerLegalCompanyInfoQueueDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaAutomationCustomerLegalCompanyInfoProcess(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaAutomationCustomerLegalCompanyInfoProcessMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess>
    >
  >;
export type PostApiLambdaAutomationCustomerLegalCompanyInfoProcessMutationBody =
  CustomerLegalCompanyInfoQueueDto;
export type PostApiLambdaAutomationCustomerLegalCompanyInfoProcessMutationError =
  unknown;

export const usePostApiLambdaAutomationCustomerLegalCompanyInfoProcess = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess
        >
      >,
      TError,
      { data: CustomerLegalCompanyInfoQueueDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaAutomationCustomerLegalCompanyInfoProcess>
  >,
  TError,
  { data: CustomerLegalCompanyInfoQueueDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationCustomerLegalCompanyInfoProcessMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationEmailBouncedQueue = (
  emailBouncedRequestDto: EmailBouncedRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/emailBouncedQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: emailBouncedRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationEmailBouncedQueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>,
    TError,
    { data: EmailBouncedRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>,
  TError,
  { data: EmailBouncedRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationEmailBouncedQueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>,
    { data: EmailBouncedRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCommunicationEmailBouncedQueue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationEmailBouncedQueueMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>
  >;
export type PostApiLambdaCommunicationEmailBouncedQueueMutationBody =
  EmailBouncedRequestDto;
export type PostApiLambdaCommunicationEmailBouncedQueueMutationError = unknown;

export const usePostApiLambdaCommunicationEmailBouncedQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>,
      TError,
      { data: EmailBouncedRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationEmailBouncedQueue>>,
  TError,
  { data: EmailBouncedRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationEmailBouncedQueueMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationSmsUnreachedQueue = (
  smsUnreachedRequestDto: SmsUnreachedRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/smsUnreachedQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: smsUnreachedRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationSmsUnreachedQueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>,
    TError,
    { data: SmsUnreachedRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>,
  TError,
  { data: SmsUnreachedRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationSmsUnreachedQueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>,
    { data: SmsUnreachedRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCommunicationSmsUnreachedQueue(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationSmsUnreachedQueueMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>
  >;
export type PostApiLambdaCommunicationSmsUnreachedQueueMutationBody =
  SmsUnreachedRequestDto;
export type PostApiLambdaCommunicationSmsUnreachedQueueMutationError = unknown;

export const usePostApiLambdaCommunicationSmsUnreachedQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>,
      TError,
      { data: SmsUnreachedRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationSmsUnreachedQueue>>,
  TError,
  { data: SmsUnreachedRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationSmsUnreachedQueueMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaReScrapeForDecline = (
  params?: PostApiLambdaReScrapeForDeclineParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/lambda/reScrapeForDecline`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLambdaReScrapeForDeclineMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>,
    TError,
    { params?: PostApiLambdaReScrapeForDeclineParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>,
  TError,
  { params?: PostApiLambdaReScrapeForDeclineParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaReScrapeForDecline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>,
    { params?: PostApiLambdaReScrapeForDeclineParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaReScrapeForDecline(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaReScrapeForDeclineMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>
>;

export type PostApiLambdaReScrapeForDeclineMutationError = unknown;

export const usePostApiLambdaReScrapeForDecline = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>,
      TError,
      { params?: PostApiLambdaReScrapeForDeclineParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaReScrapeForDecline>>,
  TError,
  { params?: PostApiLambdaReScrapeForDeclineParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaReScrapeForDeclineMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaDeceasedCustomersImport = (
  deceasedCustomersImportDto: DeceasedCustomersImportDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/deceasedCustomersImport`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deceasedCustomersImportDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaDeceasedCustomersImportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>,
    TError,
    { data: DeceasedCustomersImportDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>,
  TError,
  { data: DeceasedCustomersImportDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaDeceasedCustomersImport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>,
    { data: DeceasedCustomersImportDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaDeceasedCustomersImport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaDeceasedCustomersImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>
>;
export type PostApiLambdaDeceasedCustomersImportMutationBody =
  DeceasedCustomersImportDto;
export type PostApiLambdaDeceasedCustomersImportMutationError = unknown;

export const usePostApiLambdaDeceasedCustomersImport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>,
      TError,
      { data: DeceasedCustomersImportDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaDeceasedCustomersImport>>,
  TError,
  { data: DeceasedCustomersImportDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaDeceasedCustomersImportMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCompanySftpConfig = (
  companySftpConfigRequestDto: CompanySftpConfigRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CompanySftpDto[]>(
    {
      url: `/api/lambda/company/sftp/config`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: companySftpConfigRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCompanySftpConfigMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>,
    TError,
    { data: CompanySftpConfigRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>,
  TError,
  { data: CompanySftpConfigRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaCompanySftpConfig"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>,
    { data: CompanySftpConfigRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCompanySftpConfig(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCompanySftpConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>
>;
export type PostApiLambdaCompanySftpConfigMutationBody =
  CompanySftpConfigRequestDto;
export type PostApiLambdaCompanySftpConfigMutationError = unknown;

export const usePostApiLambdaCompanySftpConfig = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>,
      TError,
      { data: CompanySftpConfigRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCompanySftpConfig>>,
  TError,
  { data: CompanySftpConfigRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCompanySftpConfigMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaReclamationRefundReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/lambda/reclamationRefundReport`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaReclamationRefundReportQueryKey = () => {
  return [`/api/lambda/reclamationRefundReport`] as const;
};

export const getGetApiLambdaReclamationRefundReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLambdaReclamationRefundReportQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>
  > = ({ signal }) =>
    getApiLambdaReclamationRefundReport(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaReclamationRefundReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>
>;
export type GetApiLambdaReclamationRefundReportQueryError = unknown;

export function useGetApiLambdaReclamationRefundReport<
  TData = Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaReclamationRefundReport<
  TData = Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaReclamationRefundReport<
  TData = Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaReclamationRefundReport<
  TData = Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaReclamationRefundReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaReclamationRefundReportQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaTruliooCallback = (
  truliooCallbackDto: TruliooCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/truliooCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: truliooCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaTruliooCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>,
    TError,
    { data: TruliooCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>,
  TError,
  { data: TruliooCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaTruliooCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>,
    { data: TruliooCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaTruliooCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaTruliooCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>
>;
export type PostApiLambdaTruliooCallbackMutationBody = TruliooCallbackDto;
export type PostApiLambdaTruliooCallbackMutationError = unknown;

export const usePostApiLambdaTruliooCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>,
      TError,
      { data: TruliooCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaTruliooCallback>>,
  TError,
  { data: TruliooCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaTruliooCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaChargebackPaynopain = (
  paynopainChargebackRequestDto: PaynopainChargebackRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/chargeback/paynopain`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paynopainChargebackRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaChargebackPaynopainMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>,
    TError,
    { data: PaynopainChargebackRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>,
  TError,
  { data: PaynopainChargebackRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaChargebackPaynopain"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>,
    { data: PaynopainChargebackRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaChargebackPaynopain(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaChargebackPaynopainMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>
>;
export type PostApiLambdaChargebackPaynopainMutationBody =
  PaynopainChargebackRequestDto;
export type PostApiLambdaChargebackPaynopainMutationError = unknown;

export const usePostApiLambdaChargebackPaynopain = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>,
      TError,
      { data: PaynopainChargebackRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopain>>,
  TError,
  { data: PaynopainChargebackRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaChargebackPaynopainMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaChargebackPaynopainMock = (
  paynopainChargebackMockRequestDto: PaynopainChargebackMockRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/chargeback/paynopain/mock`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paynopainChargebackMockRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaChargebackPaynopainMockMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>,
    TError,
    { data: PaynopainChargebackMockRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>,
  TError,
  { data: PaynopainChargebackMockRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaChargebackPaynopainMock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>,
    { data: PaynopainChargebackMockRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaChargebackPaynopainMock(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaChargebackPaynopainMockMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>
>;
export type PostApiLambdaChargebackPaynopainMockMutationBody =
  PaynopainChargebackMockRequestDto;
export type PostApiLambdaChargebackPaynopainMockMutationError = unknown;

export const usePostApiLambdaChargebackPaynopainMock = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>,
      TError,
      { data: PaynopainChargebackMockRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaChargebackPaynopainMock>>,
  TError,
  { data: PaynopainChargebackMockRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaChargebackPaynopainMockMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAskEvalReportStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/askEvalReportStatus`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaAskEvalReportStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaAskEvalReportStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>,
    void
  > = () => {
    return postApiLambdaAskEvalReportStatus(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAskEvalReportStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>
>;

export type PostApiLambdaAskEvalReportStatusMutationError = unknown;

export const usePostApiLambdaAskEvalReportStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAskEvalReportStatus>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaAskEvalReportStatusMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCheckDengageEmailStatus = (
  params: PostApiLambdaCheckDengageEmailStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/checkDengageEmailStatus`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCheckDengageEmailStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>,
    TError,
    { params: PostApiLambdaCheckDengageEmailStatusParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>,
  TError,
  { params: PostApiLambdaCheckDengageEmailStatusParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaCheckDengageEmailStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>,
    { params: PostApiLambdaCheckDengageEmailStatusParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaCheckDengageEmailStatus(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCheckDengageEmailStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>
>;

export type PostApiLambdaCheckDengageEmailStatusMutationError = unknown;

export const usePostApiLambdaCheckDengageEmailStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>,
      TError,
      { params: PostApiLambdaCheckDengageEmailStatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCheckDengageEmailStatus>>,
  TError,
  { params: PostApiLambdaCheckDengageEmailStatusParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCheckDengageEmailStatusMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationFixReceiptDocuments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/communication/fixReceiptDocuments`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationFixReceiptDocumentsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationFixReceiptDocuments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>,
    void
  > = () => {
    return postApiLambdaCommunicationFixReceiptDocuments(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationFixReceiptDocumentsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>
  >;

export type PostApiLambdaCommunicationFixReceiptDocumentsMutationError =
  unknown;

export const usePostApiLambdaCommunicationFixReceiptDocuments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationFixReceiptDocuments>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationFixReceiptDocumentsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationProcessReclamationEmailAttachments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/communication/processReclamationEmailAttachments`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationProcessReclamationEmailAttachmentsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationProcessReclamationEmailAttachments",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
        >
      >,
      void
    > = () => {
      return postApiLambdaCommunicationProcessReclamationEmailAttachments(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationProcessReclamationEmailAttachmentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
      >
    >
  >;

export type PostApiLambdaCommunicationProcessReclamationEmailAttachmentsMutationError =
  unknown;

export const usePostApiLambdaCommunicationProcessReclamationEmailAttachments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLambdaCommunicationProcessReclamationEmailAttachments
    >
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationProcessReclamationEmailAttachmentsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationProcessBepiSftpDocuments = (
  params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/communication/processBepiSftpDocuments`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationProcessBepiSftpDocumentsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
      >,
      TError,
      { params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
    >,
    TError,
    { params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationProcessBepiSftpDocuments"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
      >,
      { params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCommunicationProcessBepiSftpDocuments(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationProcessBepiSftpDocumentsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
    >
  >;

export type PostApiLambdaCommunicationProcessBepiSftpDocumentsMutationError =
  unknown;

export const usePostApiLambdaCommunicationProcessBepiSftpDocuments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
      >,
      TError,
      { params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationProcessBepiSftpDocuments>
  >,
  TError,
  { params: PostApiLambdaCommunicationProcessBepiSftpDocumentsParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationProcessBepiSftpDocumentsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCustomerSendLegalTemplate = (
  params: PostApiLambdaCustomerSendLegalTemplateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/customer/sendLegalTemplate`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerSendLegalTemplateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>,
    TError,
    { params: PostApiLambdaCustomerSendLegalTemplateParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>,
  TError,
  { params: PostApiLambdaCustomerSendLegalTemplateParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaCustomerSendLegalTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>,
    { params: PostApiLambdaCustomerSendLegalTemplateParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaCustomerSendLegalTemplate(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCustomerSendLegalTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>
>;

export type PostApiLambdaCustomerSendLegalTemplateMutationError = unknown;

export const usePostApiLambdaCustomerSendLegalTemplate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>,
      TError,
      { params: PostApiLambdaCustomerSendLegalTemplateParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCustomerSendLegalTemplate>>,
  TError,
  { params: PostApiLambdaCustomerSendLegalTemplateParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerSendLegalTemplateMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaTinkUpdateCredentialStatuses = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/tink/updateCredentialStatuses`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaTinkUpdateCredentialStatusesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaTinkUpdateCredentialStatuses"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>,
    void
  > = () => {
    return postApiLambdaTinkUpdateCredentialStatuses(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaTinkUpdateCredentialStatusesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>
  >;

export type PostApiLambdaTinkUpdateCredentialStatusesMutationError = unknown;

export const usePostApiLambdaTinkUpdateCredentialStatuses = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaTinkUpdateCredentialStatuses>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaTinkUpdateCredentialStatusesMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCardCheckPayment = (
  paymentStateDtoBody: PaymentStateDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/card/checkPayment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentStateDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCardCheckPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>,
    TError,
    { data: PaymentStateDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>,
  TError,
  { data: PaymentStateDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCardCheckPayment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>,
    { data: PaymentStateDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCardCheckPayment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCardCheckPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>
>;
export type PostApiLambdaCardCheckPaymentMutationBody = PaymentStateDtoBody;
export type PostApiLambdaCardCheckPaymentMutationError = unknown;

export const usePostApiLambdaCardCheckPayment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>,
      TError,
      { data: PaymentStateDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCardCheckPayment>>,
  TError,
  { data: PaymentStateDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCardCheckPaymentMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCardDelayedRollover = (
  paymentStateDtoBody: PaymentStateDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/card/delayedRollover`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentStateDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCardDelayedRolloverMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>,
    TError,
    { data: PaymentStateDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>,
  TError,
  { data: PaymentStateDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCardDelayedRollover"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>,
    { data: PaymentStateDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCardDelayedRollover(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCardDelayedRolloverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>
>;
export type PostApiLambdaCardDelayedRolloverMutationBody = PaymentStateDtoBody;
export type PostApiLambdaCardDelayedRolloverMutationError = unknown;

export const usePostApiLambdaCardDelayedRollover = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>,
      TError,
      { data: PaymentStateDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCardDelayedRollover>>,
  TError,
  { data: PaymentStateDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCardDelayedRolloverMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCardRetrieveCredoraxGatewayTransactions = (
  params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/card/retrieveCredoraxGatewayTransactions`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCardRetrieveCredoraxGatewayTransactionsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
      >,
      TError,
      { params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
    >,
    TError,
    { params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCardRetrieveCredoraxGatewayTransactions",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
      >,
      { params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCardRetrieveCredoraxGatewayTransactions(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCardRetrieveCredoraxGatewayTransactionsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
    >
  >;

export type PostApiLambdaCardRetrieveCredoraxGatewayTransactionsMutationError =
  unknown;

export const usePostApiLambdaCardRetrieveCredoraxGatewayTransactions = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
      >,
      TError,
      { params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCardRetrieveCredoraxGatewayTransactions>
  >,
  TError,
  { params: PostApiLambdaCardRetrieveCredoraxGatewayTransactionsParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCardRetrieveCredoraxGatewayTransactionsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationCheckCustomerCallHistory = (
  params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerCallHistoryDto>(
    {
      url: `/api/lambda/communication/checkCustomerCallHistory`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationCheckCustomerCallHistoryMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
      >,
      TError,
      { params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
    >,
    TError,
    { params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationCheckCustomerCallHistory"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
      >,
      { params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCommunicationCheckCustomerCallHistory(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationCheckCustomerCallHistoryMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
    >
  >;

export type PostApiLambdaCommunicationCheckCustomerCallHistoryMutationError =
  unknown;

export const usePostApiLambdaCommunicationCheckCustomerCallHistory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
      >,
      TError,
      { params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationCheckCustomerCallHistory>
  >,
  TError,
  { params?: PostApiLambdaCommunicationCheckCustomerCallHistoryParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationCheckCustomerCallHistoryMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationCheckCustomerUnansweredCallHistory = (
  params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/checkCustomerUnansweredCallHistory`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
        >
      >,
      TError,
      {
        params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
      >
    >,
    TError,
    {
      params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams;
    },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationCheckCustomerUnansweredCallHistory",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
        >
      >,
      {
        params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCommunicationCheckCustomerUnansweredCallHistory(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
      >
    >
  >;

export type PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryMutationError =
  unknown;

export const usePostApiLambdaCommunicationCheckCustomerUnansweredCallHistory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
        >
      >,
      TError,
      {
        params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLambdaCommunicationCheckCustomerUnansweredCallHistory
    >
  >,
  TError,
  {
    params: PostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationCheckCustomerUnansweredCallHistoryMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationCheckVoiscopeCallHistory = (
  getIVRCallReportRequestDto: NonReadonly<GetIVRCallReportRequestDto>,
  params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/communication/checkVoiscopeCallHistory`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getIVRCallReportRequestDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationCheckVoiscopeCallHistoryMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
      >,
      TError,
      {
        data: NonReadonly<GetIVRCallReportRequestDto>;
        params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
    >,
    TError,
    {
      data: NonReadonly<GetIVRCallReportRequestDto>;
      params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams;
    },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationCheckVoiscopeCallHistory"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
      >,
      {
        data: NonReadonly<GetIVRCallReportRequestDto>;
        params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return postApiLambdaCommunicationCheckVoiscopeCallHistory(
        data,
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationCheckVoiscopeCallHistoryMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
    >
  >;
export type PostApiLambdaCommunicationCheckVoiscopeCallHistoryMutationBody =
  NonReadonly<GetIVRCallReportRequestDto>;
export type PostApiLambdaCommunicationCheckVoiscopeCallHistoryMutationError =
  unknown;

export const usePostApiLambdaCommunicationCheckVoiscopeCallHistory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
      >,
      TError,
      {
        data: NonReadonly<GetIVRCallReportRequestDto>;
        params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationCheckVoiscopeCallHistory>
  >,
  TError,
  {
    data: NonReadonly<GetIVRCallReportRequestDto>;
    params: PostApiLambdaCommunicationCheckVoiscopeCallHistoryParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationCheckVoiscopeCallHistoryMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationDengageHardbounce = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/dengageHardbounce`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationDengageHardbounceMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationDengageHardbounce"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>,
    void
  > = () => {
    return postApiLambdaCommunicationDengageHardbounce(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationDengageHardbounceMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>
  >;

export type PostApiLambdaCommunicationDengageHardbounceMutationError = unknown;

export const usePostApiLambdaCommunicationDengageHardbounce = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationDengageHardbounce>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationDengageHardbounceMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationRefillVoiscopeCampaignData = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/communication/refillVoiscopeCampaignData`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationRefillVoiscopeCampaignDataMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationRefillVoiscopeCampaignData",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
      >,
      void
    > = () => {
      return postApiLambdaCommunicationRefillVoiscopeCampaignData(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationRefillVoiscopeCampaignDataMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
    >
  >;

export type PostApiLambdaCommunicationRefillVoiscopeCampaignDataMutationError =
  unknown;

export const usePostApiLambdaCommunicationRefillVoiscopeCampaignData = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationRefillVoiscopeCampaignData>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationRefillVoiscopeCampaignDataMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache = (
  params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/readAndUpdateSmsStatusesInRedisCache`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
        >
      >,
      TError,
      {
        params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
      >
    >,
    TError,
    {
      params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams;
    },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
        >
      >,
      {
        params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
      >
    >
  >;

export type PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheMutationError =
  unknown;

export const usePostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
          >
        >,
        TError,
        {
          params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams;
        },
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCache
      >
    >,
    TError,
    {
      params?: PostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheParams;
    },
    TContext
  > => {
    return useMutation(
      getPostApiLambdaCommunicationReadAndUpdateSmsStatusesInRedisCacheMutationOptions(
        options
      ),
      queryClient
    );
  };

export const postApiLambdaCommunicationReadAndWriteMailSpamReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/readAndWriteMailSpamReport`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationReadAndWriteMailSpamReportMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationReadAndWriteMailSpamReport",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
      >,
      void
    > = () => {
      return postApiLambdaCommunicationReadAndWriteMailSpamReport(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationReadAndWriteMailSpamReportMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
    >
  >;

export type PostApiLambdaCommunicationReadAndWriteMailSpamReportMutationError =
  unknown;

export const usePostApiLambdaCommunicationReadAndWriteMailSpamReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationReadAndWriteMailSpamReport>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationReadAndWriteMailSpamReportMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/sendSmsToCustomersWithRequestedLoan`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationSendSmsToCustomersWithRequestedLoanMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
        >
      >,
      void
    > = () => {
      return postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationSendSmsToCustomersWithRequestedLoanMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
      >
    >
  >;

export type PostApiLambdaCommunicationSendSmsToCustomersWithRequestedLoanMutationError =
  unknown;

export const usePostApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
          >
        >,
        TError,
        void,
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationSendSmsToCustomersWithRequestedLoan
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getPostApiLambdaCommunicationSendSmsToCustomersWithRequestedLoanMutationOptions(
        options
      ),
      queryClient
    );
  };

export const postApiLambdaCommunicationSupportEmailInsert = (
  rawTicketEmailDtoBody: RawTicketEmailDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/supportEmail/insert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rawTicketEmailDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationSupportEmailInsertMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>,
    TError,
    { data: RawTicketEmailDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>,
  TError,
  { data: RawTicketEmailDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationSupportEmailInsert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>,
    { data: RawTicketEmailDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCommunicationSupportEmailInsert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationSupportEmailInsertMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>
  >;
export type PostApiLambdaCommunicationSupportEmailInsertMutationBody =
  RawTicketEmailDtoBody;
export type PostApiLambdaCommunicationSupportEmailInsertMutationError = unknown;

export const usePostApiLambdaCommunicationSupportEmailInsert = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>,
      TError,
      { data: RawTicketEmailDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationSupportEmailInsert>>,
  TError,
  { data: RawTicketEmailDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationSupportEmailInsertMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationSupportEmailAttachmentInsert = (
  inboundAttachmentMessage: InboundAttachmentMessage,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/supportEmail/attachment/insert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: inboundAttachmentMessage,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationSupportEmailAttachmentInsertMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailAttachmentInsert
        >
      >,
      TError,
      { data: InboundAttachmentMessage },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationSupportEmailAttachmentInsert>
    >,
    TError,
    { data: InboundAttachmentMessage },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationSupportEmailAttachmentInsert",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailAttachmentInsert
        >
      >,
      { data: InboundAttachmentMessage }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaCommunicationSupportEmailAttachmentInsert(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationSupportEmailAttachmentInsertMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationSupportEmailAttachmentInsert>
    >
  >;
export type PostApiLambdaCommunicationSupportEmailAttachmentInsertMutationBody =
  InboundAttachmentMessage;
export type PostApiLambdaCommunicationSupportEmailAttachmentInsertMutationError =
  unknown;

export const usePostApiLambdaCommunicationSupportEmailAttachmentInsert = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailAttachmentInsert
        >
      >,
      TError,
      { data: InboundAttachmentMessage },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationSupportEmailAttachmentInsert>
  >,
  TError,
  { data: InboundAttachmentMessage },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationSupportEmailAttachmentInsertMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationSupportEmailUnassignDeletedCams = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/supportEmail/unassignDeletedCams`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationSupportEmailUnassignDeletedCamsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCommunicationSupportEmailUnassignDeletedCams",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams
        >
      >,
      void
    > = () => {
      return postApiLambdaCommunicationSupportEmailUnassignDeletedCams(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationSupportEmailUnassignDeletedCamsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams
      >
    >
  >;

export type PostApiLambdaCommunicationSupportEmailUnassignDeletedCamsMutationError =
  unknown;

export const usePostApiLambdaCommunicationSupportEmailUnassignDeletedCams = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCommunicationSupportEmailUnassignDeletedCams>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationSupportEmailUnassignDeletedCamsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCommunicationAutoSetUnansweredCalls = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/autoSetUnansweredCalls`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationAutoSetUnansweredCallsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationAutoSetUnansweredCalls"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>
      >,
      void
    > = () => {
      return postApiLambdaCommunicationAutoSetUnansweredCalls(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationAutoSetUnansweredCallsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>>
  >;

export type PostApiLambdaCommunicationAutoSetUnansweredCallsMutationError =
  unknown;

export const usePostApiLambdaCommunicationAutoSetUnansweredCalls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetUnansweredCalls>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationAutoSetUnansweredCallsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationAutoSetWelcomeCalls = (
  params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/autoSetWelcomeCalls`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationAutoSetWelcomeCallsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>,
    TError,
    { params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>,
  TError,
  { params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationAutoSetWelcomeCalls"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>,
    { params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaCommunicationAutoSetWelcomeCalls(
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationAutoSetWelcomeCallsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>
  >;

export type PostApiLambdaCommunicationAutoSetWelcomeCallsMutationError =
  unknown;

export const usePostApiLambdaCommunicationAutoSetWelcomeCalls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>,
      TError,
      { params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetWelcomeCalls>>,
  TError,
  { params?: PostApiLambdaCommunicationAutoSetWelcomeCallsParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationAutoSetWelcomeCallsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCommunicationAutoSetCollectionCalls = (
  params: PostApiLambdaCommunicationAutoSetCollectionCallsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/communication/autoSetCollectionCalls`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationAutoSetCollectionCallsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>
      >,
      TError,
      { params: PostApiLambdaCommunicationAutoSetCollectionCallsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>
    >,
    TError,
    { params: PostApiLambdaCommunicationAutoSetCollectionCallsParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCommunicationAutoSetCollectionCalls"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>
      >,
      { params: PostApiLambdaCommunicationAutoSetCollectionCallsParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaCommunicationAutoSetCollectionCalls(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCommunicationAutoSetCollectionCallsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>>
  >;

export type PostApiLambdaCommunicationAutoSetCollectionCallsMutationError =
  unknown;

export const usePostApiLambdaCommunicationAutoSetCollectionCalls = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>
      >,
      TError,
      { params: PostApiLambdaCommunicationAutoSetCollectionCallsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationAutoSetCollectionCalls>>,
  TError,
  { params: PostApiLambdaCommunicationAutoSetCollectionCallsParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationAutoSetCollectionCallsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerAutoCreateLetterApprovals = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/customer/autoCreateLetterApprovals`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerAutoCreateLetterApprovalsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCustomerAutoCreateLetterApprovals"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>
      >,
      void
    > = () => {
      return postApiLambdaCustomerAutoCreateLetterApprovals(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerAutoCreateLetterApprovalsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>>
  >;

export type PostApiLambdaCustomerAutoCreateLetterApprovalsMutationError =
  unknown;

export const usePostApiLambdaCustomerAutoCreateLetterApprovals = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCustomerAutoCreateLetterApprovals>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerAutoCreateLetterApprovalsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/customer/notifyCustomersLettersWillBeSentTomorrow`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrowMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
        >
      >,
      void
    > = () => {
      return postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrowMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
      >
    >
  >;

export type PostApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrowMutationError =
  unknown;

export const usePostApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
          >
        >,
        TError,
        void,
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrow
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getPostApiLambdaCustomerNotifyCustomersLettersWillBeSentTomorrowMutationOptions(
        options
      ),
      queryClient
    );
  };

export const postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday =
  (options?: SecondParameter<typeof customInstance>, signal?: AbortSignal) => {
    return customInstance<ResultBoolean>(
      {
        url: `/api/lambda/customer/notifyExternalCollectionCustomersAssignedToday`,
        method: "POST",
        signal,
      },
      options
    );
  };

export const getPostApiLambdaCustomerNotifyExternalCollectionCustomersAssignedTodayMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
        >
      >,
      void
    > = () => {
      return postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerNotifyExternalCollectionCustomersAssignedTodayMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
      >
    >
  >;

export type PostApiLambdaCustomerNotifyExternalCollectionCustomersAssignedTodayMutationError =
  unknown;

export const usePostApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
          >
        >,
        TError,
        void,
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerNotifyExternalCollectionCustomersAssignedToday
      >
    >,
    TError,
    void,
    TContext
  > => {
    return useMutation(
      getPostApiLambdaCustomerNotifyExternalCollectionCustomersAssignedTodayMutationOptions(
        options
      ),
      queryClient
    );
  };

export const postApiLambdaCustomerReclamationTimeout = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/customer/reclamationTimeout`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaCustomerReclamationTimeoutMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaCustomerReclamationTimeout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>,
    void
  > = () => {
    return postApiLambdaCustomerReclamationTimeout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCustomerReclamationTimeoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>
>;

export type PostApiLambdaCustomerReclamationTimeoutMutationError = unknown;

export const usePostApiLambdaCustomerReclamationTimeout = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCustomerReclamationTimeout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerReclamationTimeoutMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerECUnassignReminderOneWeekLater = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/customer/ECUnassignReminderOneWeekLater`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerECUnassignReminderOneWeekLaterMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaCustomerECUnassignReminderOneWeekLater"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
      >,
      void
    > = () => {
      return postApiLambdaCustomerECUnassignReminderOneWeekLater(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerECUnassignReminderOneWeekLaterMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
    >
  >;

export type PostApiLambdaCustomerECUnassignReminderOneWeekLaterMutationError =
  unknown;

export const usePostApiLambdaCustomerECUnassignReminderOneWeekLater = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCustomerECUnassignReminderOneWeekLater>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerECUnassignReminderOneWeekLaterMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCustomerLightRegisterProtectionActivate = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/customer/lightRegisterProtection/activate`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerLightRegisterProtectionActivateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCustomerLightRegisterProtectionActivate",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
      >,
      void
    > = () => {
      return postApiLambdaCustomerLightRegisterProtectionActivate(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerLightRegisterProtectionActivateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
    >
  >;

export type PostApiLambdaCustomerLightRegisterProtectionActivateMutationError =
  unknown;

export const usePostApiLambdaCustomerLightRegisterProtectionActivate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionActivate>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerLightRegisterProtectionActivateMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaCustomerLightRegisterProtectionCheckCooldown = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/customer/lightRegisterProtection/checkCooldown`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerLightRegisterProtectionCheckCooldownMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCustomerLightRegisterProtectionCheckCooldown",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown
        >
      >,
      void
    > = () => {
      return postApiLambdaCustomerLightRegisterProtectionCheckCooldown(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerLightRegisterProtectionCheckCooldownMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown
      >
    >
  >;

export type PostApiLambdaCustomerLightRegisterProtectionCheckCooldownMutationError =
  unknown;

export const usePostApiLambdaCustomerLightRegisterProtectionCheckCooldown = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCustomerLightRegisterProtectionCheckCooldown>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerLightRegisterProtectionCheckCooldownMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaHealthcheckElasticSearchOldIndexCleaner = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/healthcheck/elasticSearchOldIndexCleaner`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaHealthcheckElasticSearchOldIndexCleanerMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaHealthcheckElasticSearchOldIndexCleaner",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
      >,
      void
    > = () => {
      return postApiLambdaHealthcheckElasticSearchOldIndexCleaner(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaHealthcheckElasticSearchOldIndexCleanerMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
    >
  >;

export type PostApiLambdaHealthcheckElasticSearchOldIndexCleanerMutationError =
  unknown;

export const usePostApiLambdaHealthcheckElasticSearchOldIndexCleaner = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaHealthcheckElasticSearchOldIndexCleaner>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaHealthcheckElasticSearchOldIndexCleanerMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaHealthcheckHangfireConsumers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultIListServerDto>(
    {
      url: `/api/lambda/healthcheck/hangfireConsumers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaHealthcheckHangfireConsumersMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaHealthcheckHangfireConsumers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>,
    void
  > = () => {
    return postApiLambdaHealthcheckHangfireConsumers(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaHealthcheckHangfireConsumersMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>
  >;

export type PostApiLambdaHealthcheckHangfireConsumersMutationError = unknown;

export const usePostApiLambdaHealthcheckHangfireConsumers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaHealthcheckHangfireConsumers>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaHealthcheckHangfireConsumersMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaLoanReminderAsLastPaymentDate = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/loan/reminderAsLastPaymentDate`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaLoanReminderAsLastPaymentDateQueryKey = () => {
  return [`/api/lambda/loan/reminderAsLastPaymentDate`] as const;
};

export const getGetApiLambdaLoanReminderAsLastPaymentDateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaLoanReminderAsLastPaymentDateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>
  > = ({ signal }) =>
    getApiLambdaLoanReminderAsLastPaymentDate(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaLoanReminderAsLastPaymentDateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>
>;
export type GetApiLambdaLoanReminderAsLastPaymentDateQueryError = unknown;

export function useGetApiLambdaLoanReminderAsLastPaymentDate<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanReminderAsLastPaymentDate<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanReminderAsLastPaymentDate<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaLoanReminderAsLastPaymentDate<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanReminderAsLastPaymentDate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaLoanReminderAsLastPaymentDateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLambdaLoanScheduledCommunicationForMissingDocuments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/loan/scheduledCommunicationForMissingDocuments`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryKey =
  () => {
    return [
      `/api/lambda/loan/scheduledCommunicationForMissingDocuments`,
    ] as const;
  };

export const getGetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
        >
      >
    > = ({ signal }) =>
      getApiLambdaLoanScheduledCommunicationForMissingDocuments(
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
      >
    >
  >;
export type GetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryError =
  unknown;

export function useGetApiLambdaLoanScheduledCommunicationForMissingDocuments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanScheduledCommunicationForMissingDocuments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanScheduledCommunicationForMissingDocuments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaLoanScheduledCommunicationForMissingDocuments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanScheduledCommunicationForMissingDocuments
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaLoanScheduledCommunicationForMissingDocumentsQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaLoanArrangedLoanReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/loan/arrangedLoanReminder`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanArrangedLoanReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanArrangedLoanReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>,
    void
  > = () => {
    return postApiLambdaLoanArrangedLoanReminder(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanArrangedLoanReminderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>
>;

export type PostApiLambdaLoanArrangedLoanReminderMutationError = unknown;

export const usePostApiLambdaLoanArrangedLoanReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoanReminder>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanArrangedLoanReminderMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanArrangedLoansDailyCheck = (
  params: PostApiLambdaLoanArrangedLoansDailyCheckParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/loan/arrangedLoansDailyCheck`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanArrangedLoansDailyCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>,
    TError,
    { params: PostApiLambdaLoanArrangedLoansDailyCheckParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>,
  TError,
  { params: PostApiLambdaLoanArrangedLoansDailyCheckParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanArrangedLoansDailyCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>,
    { params: PostApiLambdaLoanArrangedLoansDailyCheckParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaLoanArrangedLoansDailyCheck(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanArrangedLoansDailyCheckMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>
  >;

export type PostApiLambdaLoanArrangedLoansDailyCheckMutationError = unknown;

export const usePostApiLambdaLoanArrangedLoansDailyCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>,
      TError,
      { params: PostApiLambdaLoanArrangedLoansDailyCheckParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanArrangedLoansDailyCheck>>,
  TError,
  { params: PostApiLambdaLoanArrangedLoansDailyCheckParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanArrangedLoansDailyCheckMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days = (
  params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64ListAutoDeclineLoanDto>(
    {
      url: `/api/lambda/loan/autoDeclinePendingLoansMoreThan7Days`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
      >,
      TError,
      { params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
    >,
    TError,
    { params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
      >,
      { params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
    >
  >;

export type PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysMutationError =
  unknown;

export const usePostApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
      >,
      TError,
      { params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaLoanAutoDeclinePendingLoansMoreThan7Days>
  >,
  TError,
  { params?: PostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAutoDeclinePendingLoansMoreThan7DaysMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaLoanAutomaticallySetCustomerExternalCollection = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/loan/automaticallySetCustomerExternalCollection`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanAutomaticallySetCustomerExternalCollectionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaLoanAutomaticallySetCustomerExternalCollection",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
        >
      >,
      void
    > = () => {
      return postApiLambdaLoanAutomaticallySetCustomerExternalCollection(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanAutomaticallySetCustomerExternalCollectionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
      >
    >
  >;

export type PostApiLambdaLoanAutomaticallySetCustomerExternalCollectionMutationError =
  unknown;

export const usePostApiLambdaLoanAutomaticallySetCustomerExternalCollection = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLambdaLoanAutomaticallySetCustomerExternalCollection
    >
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAutomaticallySetCustomerExternalCollectionMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaLoanMissingDocumentNotifier = (
  params: PostApiLambdaLoanMissingDocumentNotifierParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInt64>(
    {
      url: `/api/lambda/loan/missingDocumentNotifier`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanMissingDocumentNotifierMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>,
    TError,
    { params: PostApiLambdaLoanMissingDocumentNotifierParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>,
  TError,
  { params: PostApiLambdaLoanMissingDocumentNotifierParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanMissingDocumentNotifier"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>,
    { params: PostApiLambdaLoanMissingDocumentNotifierParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaLoanMissingDocumentNotifier(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanMissingDocumentNotifierMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>
  >;

export type PostApiLambdaLoanMissingDocumentNotifierMutationError = unknown;

export const usePostApiLambdaLoanMissingDocumentNotifier = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>,
      TError,
      { params: PostApiLambdaLoanMissingDocumentNotifierParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanMissingDocumentNotifier>>,
  TError,
  { params: PostApiLambdaLoanMissingDocumentNotifierParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanMissingDocumentNotifierMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanNcpReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/lambda/loan/ncpReminder`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanNcpReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanNcpReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>,
    void
  > = () => {
    return postApiLambdaLoanNcpReminder(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanNcpReminderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>
>;

export type PostApiLambdaLoanNcpReminderMutationError = unknown;

export const usePostApiLambdaLoanNcpReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpReminder>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanNcpReminderMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanNcpPaymentReminder = (
  params: PostApiLambdaLoanNcpPaymentReminderParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/loan/ncpPaymentReminder`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanNcpPaymentReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>,
    TError,
    { params: PostApiLambdaLoanNcpPaymentReminderParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>,
  TError,
  { params: PostApiLambdaLoanNcpPaymentReminderParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanNcpPaymentReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>,
    { params: PostApiLambdaLoanNcpPaymentReminderParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaLoanNcpPaymentReminder(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanNcpPaymentReminderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>
>;

export type PostApiLambdaLoanNcpPaymentReminderMutationError = unknown;

export const usePostApiLambdaLoanNcpPaymentReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>,
      TError,
      { params: PostApiLambdaLoanNcpPaymentReminderParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanNcpPaymentReminder>>,
  TError,
  { params: PostApiLambdaLoanNcpPaymentReminderParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanNcpPaymentReminderMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanRestructureLoanReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/lambda/loan/RestructureLoanReminder`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanRestructureLoanReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanRestructureLoanReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>,
    void
  > = () => {
    return postApiLambdaLoanRestructureLoanReminder(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanRestructureLoanReminderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>
  >;

export type PostApiLambdaLoanRestructureLoanReminderMutationError = unknown;

export const usePostApiLambdaLoanRestructureLoanReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanRestructureLoanReminder>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanRestructureLoanReminderMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanOneTimeSmsForRequestedLoans = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/oneTimeSmsForRequestedLoans`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanOneTimeSmsForRequestedLoansMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanOneTimeSmsForRequestedLoans"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>,
    void
  > = () => {
    return postApiLambdaLoanOneTimeSmsForRequestedLoans(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanOneTimeSmsForRequestedLoansMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>
  >;

export type PostApiLambdaLoanOneTimeSmsForRequestedLoansMutationError = unknown;

export const usePostApiLambdaLoanOneTimeSmsForRequestedLoans = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanOneTimeSmsForRequestedLoans>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanOneTimeSmsForRequestedLoansMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanDocumentNotify = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt64Array>(
    { url: `/api/lambda/loan/documentNotify`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanDocumentNotifyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanDocumentNotify"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>,
    void
  > = () => {
    return postApiLambdaLoanDocumentNotify(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanDocumentNotifyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>
>;

export type PostApiLambdaLoanDocumentNotifyMutationError = unknown;

export const usePostApiLambdaLoanDocumentNotify = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanDocumentNotify>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanDocumentNotifyMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInt64>(
    { url: `/api/lambda/loan/reminder`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanReminder>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanReminder>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanReminder>>,
    void
  > = () => {
    return postApiLambdaLoanReminder(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanReminderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanReminder>>
>;

export type PostApiLambdaLoanReminderMutationError = unknown;

export const usePostApiLambdaLoanReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanReminder>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanReminder>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanReminderMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanInstallmentReport = (
  params: PostApiLambdaLoanInstallmentReportParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUpdateInstallmentReportResult>(
    {
      url: `/api/lambda/loan/installmentReport`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanInstallmentReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>,
    TError,
    { params: PostApiLambdaLoanInstallmentReportParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>,
  TError,
  { params: PostApiLambdaLoanInstallmentReportParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanInstallmentReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>,
    { params: PostApiLambdaLoanInstallmentReportParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaLoanInstallmentReport(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanInstallmentReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>
>;

export type PostApiLambdaLoanInstallmentReportMutationError = unknown;

export const usePostApiLambdaLoanInstallmentReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>,
      TError,
      { params: PostApiLambdaLoanInstallmentReportParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanInstallmentReport>>,
  TError,
  { params: PostApiLambdaLoanInstallmentReportParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanInstallmentReportMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanAutoPayoutOfAMLInReview = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/loan/autoPayoutOfAMLInReview`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanAutoPayoutOfAMLInReviewMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanAutoPayoutOfAMLInReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>,
    void
  > = () => {
    return postApiLambdaLoanAutoPayoutOfAMLInReview(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanAutoPayoutOfAMLInReviewMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>
  >;

export type PostApiLambdaLoanAutoPayoutOfAMLInReviewMutationError = unknown;

export const usePostApiLambdaLoanAutoPayoutOfAMLInReview = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanAutoPayoutOfAMLInReview>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAutoPayoutOfAMLInReviewMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanCheckDueForFreeInterest = (
  params: PostApiLambdaLoanCheckDueForFreeInterestParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/checkDueForFreeInterest`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanCheckDueForFreeInterestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>,
    TError,
    { params: PostApiLambdaLoanCheckDueForFreeInterestParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>,
  TError,
  { params: PostApiLambdaLoanCheckDueForFreeInterestParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanCheckDueForFreeInterest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>,
    { params: PostApiLambdaLoanCheckDueForFreeInterestParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaLoanCheckDueForFreeInterest(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanCheckDueForFreeInterestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>
  >;

export type PostApiLambdaLoanCheckDueForFreeInterestMutationError = unknown;

export const usePostApiLambdaLoanCheckDueForFreeInterest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>,
      TError,
      { params: PostApiLambdaLoanCheckDueForFreeInterestParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanCheckDueForFreeInterest>>,
  TError,
  { params: PostApiLambdaLoanCheckDueForFreeInterestParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanCheckDueForFreeInterestMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanAgreementAssignmentReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/agreementAssignmentReminder`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanAgreementAssignmentReminderMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanAgreementAssignmentReminder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>,
    void
  > = () => {
    return postApiLambdaLoanAgreementAssignmentReminder(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanAgreementAssignmentReminderMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>
  >;

export type PostApiLambdaLoanAgreementAssignmentReminderMutationError = unknown;

export const usePostApiLambdaLoanAgreementAssignmentReminder = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminder>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAgreementAssignmentReminderMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaLoanInformloanpaymentfornotexistedtransaction = (
  params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/informloanpaymentfornotexistedtransaction`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryKey =
  (
    params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams
  ) => {
    return [
      `/api/lambda/loan/informloanpaymentfornotexistedtransaction`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
      >
    >,
    TError = unknown
  >(
    params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
        >
      >
    > = ({ signal }) =>
      getApiLambdaLoanInformloanpaymentfornotexistedtransaction(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
      >
    >
  >;
export type GetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryError =
  unknown;

export function useGetApiLambdaLoanInformloanpaymentfornotexistedtransaction<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction>
  >,
  TError = unknown
>(
  params:
    | undefined
    | GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanInformloanpaymentfornotexistedtransaction<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction>
  >,
  TError = unknown
>(
  params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanInformloanpaymentfornotexistedtransaction<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction>
  >,
  TError = unknown
>(
  params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaLoanInformloanpaymentfornotexistedtransaction<
  TData = Awaited<
    ReturnType<typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction>
  >,
  TError = unknown
>(
  params?: GetApiLambdaLoanInformloanpaymentfornotexistedtransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaLoanInformloanpaymentfornotexistedtransaction
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaLoanInformloanpaymentfornotexistedtransactionQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaLoanCardValidateMultiple = (
  multipleValidateRequestDto: MultipleValidateRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/cardValidateMultiple`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: multipleValidateRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanCardValidateMultipleMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>,
    TError,
    { data: MultipleValidateRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>,
  TError,
  { data: MultipleValidateRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanCardValidateMultiple"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>,
    { data: MultipleValidateRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaLoanCardValidateMultiple(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanCardValidateMultipleMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>
>;
export type PostApiLambdaLoanCardValidateMultipleMutationBody =
  MultipleValidateRequestDto;
export type PostApiLambdaLoanCardValidateMultipleMutationError = unknown;

export const usePostApiLambdaLoanCardValidateMultiple = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>,
      TError,
      { data: MultipleValidateRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanCardValidateMultiple>>,
  TError,
  { data: MultipleValidateRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanCardValidateMultipleMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanOverDueLoansDaily = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/loan/OverDueLoansDaily`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanOverDueLoansDailyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanOverDueLoansDaily"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>,
    void
  > = () => {
    return postApiLambdaLoanOverDueLoansDaily(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanOverDueLoansDailyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>
>;

export type PostApiLambdaLoanOverDueLoansDailyMutationError = unknown;

export const usePostApiLambdaLoanOverDueLoansDaily = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanOverDueLoansDaily>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanOverDueLoansDailyMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans = (
  params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/loanhooks/updateExpiredCustomersAndLoans`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
      >,
      TError,
      { params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
    >,
    TError,
    { params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
      >,
      { params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
    >
  >;

export type PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansMutationError =
  unknown;

export const usePostApiLambdaLoanhooksUpdateExpiredCustomersAndLoans = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
      >,
      TError,
      { params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaLoanhooksUpdateExpiredCustomersAndLoans>
  >,
  TError,
  { params?: PostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanhooksUpdateExpiredCustomersAndLoansMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferUnnaxCheckUncreatedOrders = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/unnax/checkUncreatedOrders`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferUnnaxCheckUncreatedOrdersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaMoneytransferUnnaxCheckUncreatedOrders"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
      >,
      void
    > = () => {
      return postApiLambdaMoneytransferUnnaxCheckUncreatedOrders(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferUnnaxCheckUncreatedOrdersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
    >
  >;

export type PostApiLambdaMoneytransferUnnaxCheckUncreatedOrdersMutationError =
  unknown;

export const usePostApiLambdaMoneytransferUnnaxCheckUncreatedOrders = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaMoneytransferUnnaxCheckUncreatedOrders>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferUnnaxCheckUncreatedOrdersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferSefideBalanceCheck = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/sefide/balanceCheck`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferSefideBalanceCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaMoneytransferSefideBalanceCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>,
    void
  > = () => {
    return postApiLambdaMoneytransferSefideBalanceCheck(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaMoneytransferSefideBalanceCheckMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>
  >;

export type PostApiLambdaMoneytransferSefideBalanceCheckMutationError = unknown;

export const usePostApiLambdaMoneytransferSefideBalanceCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideBalanceCheck>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferSefideBalanceCheckMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaMoneytransferSefideReconciliation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/sefide/reconciliation`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferSefideReconciliationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaMoneytransferSefideReconciliation"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>
      >,
      void
    > = () => {
      return postApiLambdaMoneytransferSefideReconciliation(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferSefideReconciliationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>>
  >;

export type PostApiLambdaMoneytransferSefideReconciliationMutationError =
  unknown;

export const usePostApiLambdaMoneytransferSefideReconciliation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSefideReconciliation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferSefideReconciliationMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaMoneytransferConektaBalanceCheck = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/conekta/balanceCheck`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferConektaBalanceCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaMoneytransferConektaBalanceCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>,
    void
  > = () => {
    return postApiLambdaMoneytransferConektaBalanceCheck(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaMoneytransferConektaBalanceCheckMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>
  >;

export type PostApiLambdaMoneytransferConektaBalanceCheckMutationError =
  unknown;

export const usePostApiLambdaMoneytransferConektaBalanceCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaBalanceCheck>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferConektaBalanceCheckMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaMoneytransferConektaReconciliation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/conekta/reconciliation`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferConektaReconciliationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaMoneytransferConektaReconciliation"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>
      >,
      void
    > = () => {
      return postApiLambdaMoneytransferConektaReconciliation(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferConektaReconciliationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>>
  >;

export type PostApiLambdaMoneytransferConektaReconciliationMutationError =
  unknown;

export const usePostApiLambdaMoneytransferConektaReconciliation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferConektaReconciliation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferConektaReconciliationMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaMoneytransferUnnaxProcessedCallbackFix = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64String>(
    {
      url: `/api/lambda/moneytransfer/unnax/processedCallbackFix`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferUnnaxProcessedCallbackFixMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
    >,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiLambdaMoneytransferUnnaxProcessedCallbackFix"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaMoneytransferUnnaxProcessedCallbackFix(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferUnnaxProcessedCallbackFixMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
    >
  >;
export type PostApiLambdaMoneytransferUnnaxProcessedCallbackFixMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLambdaMoneytransferUnnaxProcessedCallbackFixMutationError =
  unknown;

export const usePostApiLambdaMoneytransferUnnaxProcessedCallbackFix = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaMoneytransferUnnaxProcessedCallbackFix>
  >,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferUnnaxProcessedCallbackFixMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferDevengoTransferRequestedReconcile = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/devengo/transferRequestedReconcile`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferDevengoTransferRequestedReconcileMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaMoneytransferDevengoTransferRequestedReconcile",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
        >
      >,
      void
    > = () => {
      return postApiLambdaMoneytransferDevengoTransferRequestedReconcile(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferDevengoTransferRequestedReconcileMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
      >
    >
  >;

export type PostApiLambdaMoneytransferDevengoTransferRequestedReconcileMutationError =
  unknown;

export const usePostApiLambdaMoneytransferDevengoTransferRequestedReconcile = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLambdaMoneytransferDevengoTransferRequestedReconcile
    >
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferDevengoTransferRequestedReconcileMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferDevengoPendingCallbackReconcile = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/devengo/pendingCallbackReconcile`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferDevengoPendingCallbackReconcileMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile
      >
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaMoneytransferDevengoPendingCallbackReconcile",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile
        >
      >,
      void
    > = () => {
      return postApiLambdaMoneytransferDevengoPendingCallbackReconcile(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferDevengoPendingCallbackReconcileMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile
      >
    >
  >;

export type PostApiLambdaMoneytransferDevengoPendingCallbackReconcileMutationError =
  unknown;

export const usePostApiLambdaMoneytransferDevengoPendingCallbackReconcile = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaMoneytransferDevengoPendingCallbackReconcile>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferDevengoPendingCallbackReconcileMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferManuelProcessedCallbackFix = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64String>(
    {
      url: `/api/lambda/moneytransfer/manuel/processedCallbackFix`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferManuelProcessedCallbackFixMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
    >,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaMoneytransferManuelProcessedCallbackFix",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaMoneytransferManuelProcessedCallbackFix(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferManuelProcessedCallbackFixMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
    >
  >;
export type PostApiLambdaMoneytransferManuelProcessedCallbackFixMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLambdaMoneytransferManuelProcessedCallbackFixMutationError =
  unknown;

export const usePostApiLambdaMoneytransferManuelProcessedCallbackFix = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaMoneytransferManuelProcessedCallbackFix>
  >,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferManuelProcessedCallbackFixMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer = (
  uploadCCFilesToFtpServerRequestDto: UploadCCFilesToFtpServerRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/reporting/uploadCollectionCompanyFilesToFtpServer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: uploadCCFilesToFtpServerRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaReportingUploadCollectionCompanyFilesToFtpServerMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
        >
      >,
      TError,
      { data: UploadCCFilesToFtpServerRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
      >
    >,
    TError,
    { data: UploadCCFilesToFtpServerRequestDto },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
        >
      >,
      { data: UploadCCFilesToFtpServerRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaReportingUploadCollectionCompanyFilesToFtpServerMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
      >
    >
  >;
export type PostApiLambdaReportingUploadCollectionCompanyFilesToFtpServerMutationBody =
  UploadCCFilesToFtpServerRequestDto;
export type PostApiLambdaReportingUploadCollectionCompanyFilesToFtpServerMutationError =
  unknown;

export const usePostApiLambdaReportingUploadCollectionCompanyFilesToFtpServer =
  <TError = unknown, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
          >
        >,
        TError,
        { data: UploadCCFilesToFtpServerRequestDto },
        TContext
      >;
      request?: SecondParameter<typeof customInstance>;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof postApiLambdaReportingUploadCollectionCompanyFilesToFtpServer
      >
    >,
    TError,
    { data: UploadCCFilesToFtpServerRequestDto },
    TContext
  > => {
    return useMutation(
      getPostApiLambdaReportingUploadCollectionCompanyFilesToFtpServerMutationOptions(
        options
      ),
      queryClient
    );
  };

export const postApiLambdaReportingCreateASNEFReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/reporting/createASNEFReport`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaReportingCreateASNEFReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaReportingCreateASNEFReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>,
    void
  > = () => {
    return postApiLambdaReportingCreateASNEFReport(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaReportingCreateASNEFReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>
>;

export type PostApiLambdaReportingCreateASNEFReportMutationError = unknown;

export const usePostApiLambdaReportingCreateASNEFReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaReportingCreateASNEFReport>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaReportingCreateASNEFReportMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCustomersForUnsuccessfulPayments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/customersForUnsuccessfulPayments`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaCustomersForUnsuccessfulPaymentsQueryKey = () => {
  return [`/api/lambda/customersForUnsuccessfulPayments`] as const;
};

export const getGetApiLambdaCustomersForUnsuccessfulPaymentsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCustomersForUnsuccessfulPaymentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>>
  > = ({ signal }) =>
    getApiLambdaCustomersForUnsuccessfulPayments(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCustomersForUnsuccessfulPaymentsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>>
  >;
export type GetApiLambdaCustomersForUnsuccessfulPaymentsQueryError = unknown;

export function useGetApiLambdaCustomersForUnsuccessfulPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCustomersForUnsuccessfulPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCustomersForUnsuccessfulPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCustomersForUnsuccessfulPayments<
  TData = Awaited<
    ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLambdaCustomersForUnsuccessfulPayments>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaCustomersForUnsuccessfulPaymentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @deprecated
 */
export const postApiLambdaUpdateCustomerNonExistRiskScore = (
  params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/updateCustomerNonExistRiskScore`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaUpdateCustomerNonExistRiskScoreMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>,
    TError,
    { params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>,
  TError,
  { params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaUpdateCustomerNonExistRiskScore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>,
    { params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaUpdateCustomerNonExistRiskScore(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaUpdateCustomerNonExistRiskScoreMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>
  >;

export type PostApiLambdaUpdateCustomerNonExistRiskScoreMutationError = unknown;

/**
 * @deprecated
 */
export const usePostApiLambdaUpdateCustomerNonExistRiskScore = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>,
      TError,
      { params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaUpdateCustomerNonExistRiskScore>>,
  TError,
  { params: PostApiLambdaUpdateCustomerNonExistRiskScoreParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaUpdateCustomerNonExistRiskScoreMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaUnnaxReScrapeV2 = (
  params?: PostApiLambdaUnnaxReScrapeV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/lambda/unnax/reScrapeV2`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLambdaUnnaxReScrapeV2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>,
    TError,
    { params?: PostApiLambdaUnnaxReScrapeV2Params },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>,
  TError,
  { params?: PostApiLambdaUnnaxReScrapeV2Params },
  TContext
> => {
  const mutationKey = ["postApiLambdaUnnaxReScrapeV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>,
    { params?: PostApiLambdaUnnaxReScrapeV2Params }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaUnnaxReScrapeV2(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaUnnaxReScrapeV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>
>;

export type PostApiLambdaUnnaxReScrapeV2MutationError = unknown;

export const usePostApiLambdaUnnaxReScrapeV2 = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>,
      TError,
      { params?: PostApiLambdaUnnaxReScrapeV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaUnnaxReScrapeV2>>,
  TError,
  { params?: PostApiLambdaUnnaxReScrapeV2Params },
  TContext
> => {
  return useMutation(
    getPostApiLambdaUnnaxReScrapeV2MutationOptions(options),
    queryClient
  );
};

export const postApiLambdaUnnaxNotifyUnavailableBanksCustomers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/unnax/notifyUnavailableBanksCustomers`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaUnnaxNotifyUnavailableBanksCustomersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiLambdaUnnaxNotifyUnavailableBanksCustomers"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>
      >,
      void
    > = () => {
      return postApiLambdaUnnaxNotifyUnavailableBanksCustomers(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaUnnaxNotifyUnavailableBanksCustomersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>
    >
  >;

export type PostApiLambdaUnnaxNotifyUnavailableBanksCustomersMutationError =
  unknown;

export const usePostApiLambdaUnnaxNotifyUnavailableBanksCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaUnnaxNotifyUnavailableBanksCustomers>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaUnnaxNotifyUnavailableBanksCustomersMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaTinkRefreshKnownBanks = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/tink/refreshKnownBanks`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaTinkRefreshKnownBanksMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaTinkRefreshKnownBanks"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>,
    void
  > = () => {
    return postApiLambdaTinkRefreshKnownBanks(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaTinkRefreshKnownBanksMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>
>;

export type PostApiLambdaTinkRefreshKnownBanksMutationError = unknown;

export const usePostApiLambdaTinkRefreshKnownBanks = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaTinkRefreshKnownBanks>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaTinkRefreshKnownBanksMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaManuelPaymentReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/ManuelPaymentReport`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaManuelPaymentReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaManuelPaymentReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>,
    void
  > = () => {
    return postApiLambdaManuelPaymentReport(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaManuelPaymentReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>
>;

export type PostApiLambdaManuelPaymentReportMutationError = unknown;

export const usePostApiLambdaManuelPaymentReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaManuelPaymentReport>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaManuelPaymentReportMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/test`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaTest>>,
    void
  > = () => {
    return postApiLambdaTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaTest>>
>;

export type PostApiLambdaTestMutationError = unknown;

export const usePostApiLambdaTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaTest>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostApiLambdaTestMutationOptions(options), queryClient);
};

export const postApiLambdaUnidentifiedCourtPaymentsReport = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/UnidentifiedCourtPaymentsReport`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaUnidentifiedCourtPaymentsReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaUnidentifiedCourtPaymentsReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>,
    void
  > = () => {
    return postApiLambdaUnidentifiedCourtPaymentsReport(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaUnidentifiedCourtPaymentsReportMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>
  >;

export type PostApiLambdaUnidentifiedCourtPaymentsReportMutationError = unknown;

export const usePostApiLambdaUnidentifiedCourtPaymentsReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaUnidentifiedCourtPaymentsReport>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaUnidentifiedCourtPaymentsReportMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaIggLegalReportReconciliation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/IggLegalReportReconciliation`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaIggLegalReportReconciliationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaIggLegalReportReconciliation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>,
    void
  > = () => {
    return postApiLambdaIggLegalReportReconciliation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaIggLegalReportReconciliationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>
  >;

export type PostApiLambdaIggLegalReportReconciliationMutationError = unknown;

export const usePostApiLambdaIggLegalReportReconciliation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaIggLegalReportReconciliation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaIggLegalReportReconciliationMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaIggLegalReportSendMail = (
  iggLegalReportSendMailRequestDto: IggLegalReportSendMailRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/IggLegalReportSendMail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: iggLegalReportSendMailRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaIggLegalReportSendMailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>,
    TError,
    { data: IggLegalReportSendMailRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>,
  TError,
  { data: IggLegalReportSendMailRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaIggLegalReportSendMail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>,
    { data: IggLegalReportSendMailRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaIggLegalReportSendMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaIggLegalReportSendMailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>
>;
export type PostApiLambdaIggLegalReportSendMailMutationBody =
  IggLegalReportSendMailRequestDto;
export type PostApiLambdaIggLegalReportSendMailMutationError = unknown;

export const usePostApiLambdaIggLegalReportSendMail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>,
      TError,
      { data: IggLegalReportSendMailRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaIggLegalReportSendMail>>,
  TError,
  { data: IggLegalReportSendMailRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaIggLegalReportSendMailMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaChargebackCredorax = (
  credoraxChargebackRequestDto: CredoraxChargebackRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/chargeback/credorax`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: credoraxChargebackRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaChargebackCredoraxMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>,
    TError,
    { data: CredoraxChargebackRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>,
  TError,
  { data: CredoraxChargebackRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaChargebackCredorax"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>,
    { data: CredoraxChargebackRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaChargebackCredorax(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaChargebackCredoraxMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>
>;
export type PostApiLambdaChargebackCredoraxMutationBody =
  CredoraxChargebackRequestDto;
export type PostApiLambdaChargebackCredoraxMutationError = unknown;

export const usePostApiLambdaChargebackCredorax = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>,
      TError,
      { data: CredoraxChargebackRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaChargebackCredorax>>,
  TError,
  { data: CredoraxChargebackRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaChargebackCredoraxMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaUploadCustomerLoanAgreement = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/uploadCustomerLoanAgreement`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaUploadCustomerLoanAgreementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaUploadCustomerLoanAgreement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>,
    void
  > = () => {
    return postApiLambdaUploadCustomerLoanAgreement(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaUploadCustomerLoanAgreementMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>
  >;

export type PostApiLambdaUploadCustomerLoanAgreementMutationError = unknown;

export const usePostApiLambdaUploadCustomerLoanAgreement = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaUploadCustomerLoanAgreement>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaUploadCustomerLoanAgreementMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationDecisionTrigger = (
  params: PostApiLambdaAutomationDecisionTriggerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/automation/decision/trigger`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationDecisionTriggerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>,
    TError,
    { params: PostApiLambdaAutomationDecisionTriggerParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>,
  TError,
  { params: PostApiLambdaAutomationDecisionTriggerParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationDecisionTrigger"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>,
    { params: PostApiLambdaAutomationDecisionTriggerParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaAutomationDecisionTrigger(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationDecisionTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>
>;

export type PostApiLambdaAutomationDecisionTriggerMutationError = unknown;

export const usePostApiLambdaAutomationDecisionTrigger = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>,
      TError,
      { params: PostApiLambdaAutomationDecisionTriggerParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionTrigger>>,
  TError,
  { params: PostApiLambdaAutomationDecisionTriggerParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationDecisionTriggerMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationDecisionSendSms = (
  automationDecisionSqsDtoBody: AutomationDecisionSqsDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/automation/decision/send/sms`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: automationDecisionSqsDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationDecisionSendSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>,
    TError,
    { data: AutomationDecisionSqsDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>,
  TError,
  { data: AutomationDecisionSqsDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationDecisionSendSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>,
    { data: AutomationDecisionSqsDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAutomationDecisionSendSms(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationDecisionSendSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>
>;
export type PostApiLambdaAutomationDecisionSendSmsMutationBody =
  AutomationDecisionSqsDtoBody;
export type PostApiLambdaAutomationDecisionSendSmsMutationError = unknown;

export const usePostApiLambdaAutomationDecisionSendSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>,
      TError,
      { data: AutomationDecisionSqsDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendSms>>,
  TError,
  { data: AutomationDecisionSqsDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationDecisionSendSmsMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationDecisionSendEmail = (
  automationDecisionSqsDtoBody: AutomationDecisionSqsDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/automation/decision/send/email`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: automationDecisionSqsDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationDecisionSendEmailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>,
    TError,
    { data: AutomationDecisionSqsDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>,
  TError,
  { data: AutomationDecisionSqsDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationDecisionSendEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>,
    { data: AutomationDecisionSqsDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAutomationDecisionSendEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationDecisionSendEmailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>
  >;
export type PostApiLambdaAutomationDecisionSendEmailMutationBody =
  AutomationDecisionSqsDtoBody;
export type PostApiLambdaAutomationDecisionSendEmailMutationError = unknown;

export const usePostApiLambdaAutomationDecisionSendEmail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>,
      TError,
      { data: AutomationDecisionSqsDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationDecisionSendEmail>>,
  TError,
  { data: AutomationDecisionSqsDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationDecisionSendEmailMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationIvrSet = (
  postApiLambdaAutomationIvrSetBody:
    | PostApiLambdaAutomationIvrSetBodyOneItem[]
    | PostApiLambdaAutomationIvrSetBodyTwoItem[]
    | PostApiLambdaAutomationIvrSetBodyThreeItem[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/automation/ivr/set`,
      method: "POST",
      data: postApiLambdaAutomationIvrSetBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationIvrSetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>,
    TError,
    {
      data:
        | PostApiLambdaAutomationIvrSetBodyOneItem[]
        | PostApiLambdaAutomationIvrSetBodyTwoItem[]
        | PostApiLambdaAutomationIvrSetBodyThreeItem[];
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>,
  TError,
  {
    data:
      | PostApiLambdaAutomationIvrSetBodyOneItem[]
      | PostApiLambdaAutomationIvrSetBodyTwoItem[]
      | PostApiLambdaAutomationIvrSetBodyThreeItem[];
  },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationIvrSet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>,
    {
      data:
        | PostApiLambdaAutomationIvrSetBodyOneItem[]
        | PostApiLambdaAutomationIvrSetBodyTwoItem[]
        | PostApiLambdaAutomationIvrSetBodyThreeItem[];
    }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAutomationIvrSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationIvrSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>
>;
export type PostApiLambdaAutomationIvrSetMutationBody =
  | PostApiLambdaAutomationIvrSetBodyOneItem[]
  | PostApiLambdaAutomationIvrSetBodyTwoItem[]
  | PostApiLambdaAutomationIvrSetBodyThreeItem[];
export type PostApiLambdaAutomationIvrSetMutationError = unknown;

export const usePostApiLambdaAutomationIvrSet = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>,
      TError,
      {
        data:
          | PostApiLambdaAutomationIvrSetBodyOneItem[]
          | PostApiLambdaAutomationIvrSetBodyTwoItem[]
          | PostApiLambdaAutomationIvrSetBodyThreeItem[];
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrSet>>,
  TError,
  {
    data:
      | PostApiLambdaAutomationIvrSetBodyOneItem[]
      | PostApiLambdaAutomationIvrSetBodyTwoItem[]
      | PostApiLambdaAutomationIvrSetBodyThreeItem[];
  },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationIvrSetMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationIvrDelete = (
  deleteAutomationIVRDto: DeleteAutomationIVRDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/ivr/delete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: deleteAutomationIVRDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationIvrDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>,
    TError,
    { data: DeleteAutomationIVRDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>,
  TError,
  { data: DeleteAutomationIVRDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaAutomationIvrDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>,
    { data: DeleteAutomationIVRDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaAutomationIvrDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaAutomationIvrDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>
>;
export type PostApiLambdaAutomationIvrDeleteMutationBody =
  DeleteAutomationIVRDto;
export type PostApiLambdaAutomationIvrDeleteMutationError = unknown;

export const usePostApiLambdaAutomationIvrDelete = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>,
      TError,
      { data: DeleteAutomationIVRDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationIvrDelete>>,
  TError,
  { data: DeleteAutomationIVRDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationIvrDeleteMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaContentGenerator = (
  postApiLambdaContentGeneratorBody:
    | PostApiLambdaContentGeneratorBodyOne
    | PostApiLambdaContentGeneratorBodyTwo
    | PostApiLambdaContentGeneratorBodyThree,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryStringDictionaryInt64Object>(
    {
      url: `/api/lambda/contentGenerator`,
      method: "POST",
      data: postApiLambdaContentGeneratorBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaContentGeneratorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaContentGenerator>>,
    TError,
    {
      data:
        | PostApiLambdaContentGeneratorBodyOne
        | PostApiLambdaContentGeneratorBodyTwo
        | PostApiLambdaContentGeneratorBodyThree;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaContentGenerator>>,
  TError,
  {
    data:
      | PostApiLambdaContentGeneratorBodyOne
      | PostApiLambdaContentGeneratorBodyTwo
      | PostApiLambdaContentGeneratorBodyThree;
  },
  TContext
> => {
  const mutationKey = ["postApiLambdaContentGenerator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaContentGenerator>>,
    {
      data:
        | PostApiLambdaContentGeneratorBodyOne
        | PostApiLambdaContentGeneratorBodyTwo
        | PostApiLambdaContentGeneratorBodyThree;
    }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaContentGenerator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaContentGeneratorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaContentGenerator>>
>;
export type PostApiLambdaContentGeneratorMutationBody =
  | PostApiLambdaContentGeneratorBodyOne
  | PostApiLambdaContentGeneratorBodyTwo
  | PostApiLambdaContentGeneratorBodyThree;
export type PostApiLambdaContentGeneratorMutationError = unknown;

export const usePostApiLambdaContentGenerator = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaContentGenerator>>,
      TError,
      {
        data:
          | PostApiLambdaContentGeneratorBodyOne
          | PostApiLambdaContentGeneratorBodyTwo
          | PostApiLambdaContentGeneratorBodyThree;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaContentGenerator>>,
  TError,
  {
    data:
      | PostApiLambdaContentGeneratorBodyOne
      | PostApiLambdaContentGeneratorBodyTwo
      | PostApiLambdaContentGeneratorBodyThree;
  },
  TContext
> => {
  return useMutation(
    getPostApiLambdaContentGeneratorMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCollectionRunLegalExecutionAudit = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/collection/runLegalExecutionAudit`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionRunLegalExecutionAuditMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionRunLegalExecutionAudit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>,
    void
  > = () => {
    return postApiLambdaCollectionRunLegalExecutionAudit(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionRunLegalExecutionAuditMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>
  >;

export type PostApiLambdaCollectionRunLegalExecutionAuditMutationError =
  unknown;

export const usePostApiLambdaCollectionRunLegalExecutionAudit = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionRunLegalExecutionAudit>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionRunLegalExecutionAuditMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCollectionCollect = (
  collectionSqsDtoArrayBody: CollectionSqsDtoArrayBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<KeyValuePairInt64Boolean[]>(
    {
      url: `/api/lambda/collection/collect`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionSqsDtoArrayBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionCollectMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>,
    TError,
    { data: CollectionSqsDtoArrayBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>,
  TError,
  { data: CollectionSqsDtoArrayBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionCollect"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>,
    { data: CollectionSqsDtoArrayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionCollect(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionCollectMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>
>;
export type PostApiLambdaCollectionCollectMutationBody =
  CollectionSqsDtoArrayBody;
export type PostApiLambdaCollectionCollectMutationError = unknown;

export const usePostApiLambdaCollectionCollect = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>,
      TError,
      { data: CollectionSqsDtoArrayBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionCollect>>,
  TError,
  { data: CollectionSqsDtoArrayBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionCollectMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCollectionTrigger = (
  collectionSqsDtoArrayBody: CollectionSqsDtoArrayBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<KeyValuePairInt64NullableBoolean[]>(
    {
      url: `/api/lambda/collection/trigger`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionSqsDtoArrayBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionTriggerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>,
    TError,
    { data: CollectionSqsDtoArrayBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>,
  TError,
  { data: CollectionSqsDtoArrayBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionTrigger"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>,
    { data: CollectionSqsDtoArrayBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionTrigger(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionTriggerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>
>;
export type PostApiLambdaCollectionTriggerMutationBody =
  CollectionSqsDtoArrayBody;
export type PostApiLambdaCollectionTriggerMutationError = unknown;

export const usePostApiLambdaCollectionTrigger = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>,
      TError,
      { data: CollectionSqsDtoArrayBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionTrigger>>,
  TError,
  { data: CollectionSqsDtoArrayBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionTriggerMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCollectionSearch = (
  collectionConfigDto: CollectionConfigDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CollectionSearchResponseDto[]>(
    {
      url: `/api/lambda/collection/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionConfigDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionSearchMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>,
    TError,
    { data: CollectionConfigDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>,
  TError,
  { data: CollectionConfigDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>,
    { data: CollectionConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionSearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>
>;
export type PostApiLambdaCollectionSearchMutationBody = CollectionConfigDto;
export type PostApiLambdaCollectionSearchMutationError = unknown;

export const usePostApiLambdaCollectionSearch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>,
      TError,
      { data: CollectionConfigDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionSearch>>,
  TError,
  { data: CollectionConfigDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionSearchMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCollectionConfig = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CollectionDto>(
    { url: `/api/lambda/collection/config`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaCollectionConfigQueryKey = () => {
  return [`/api/lambda/collection/config`] as const;
};

export const getGetApiLambdaCollectionConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLambdaCollectionConfigQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>
  > = ({ signal }) => getApiLambdaCollectionConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>
>;
export type GetApiLambdaCollectionConfigQueryError = unknown;

export function useGetApiLambdaCollectionConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionConfig<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionConfig>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaCollectionConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCollectionStart = (
  collectionSqsDtoBody: CollectionSqsDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<number>(
    {
      url: `/api/lambda/collection/start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionSqsDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionStartMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionStart>>,
    TError,
    { data: CollectionSqsDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionStart>>,
  TError,
  { data: CollectionSqsDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionStart>>,
    { data: CollectionSqsDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionStart(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionStart>>
>;
export type PostApiLambdaCollectionStartMutationBody = CollectionSqsDtoBody;
export type PostApiLambdaCollectionStartMutationError = unknown;

export const usePostApiLambdaCollectionStart = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionStart>>,
      TError,
      { data: CollectionSqsDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionStart>>,
  TError,
  { data: CollectionSqsDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionStartMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCollectionForceReleaseLock = (
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<boolean>(
    {
      url: `/api/lambda/collection/forceReleaseLock`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLambdaCollectionForceReleaseLockQueryKey = (
  params?: GetApiLambdaCollectionForceReleaseLockParams
) => {
  return [
    `/api/lambda/collection/forceReleaseLock`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLambdaCollectionForceReleaseLockQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
  TError = unknown
>(
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCollectionForceReleaseLockQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>
  > = ({ signal }) =>
    getApiLambdaCollectionForceReleaseLock(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionForceReleaseLockQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>
>;
export type GetApiLambdaCollectionForceReleaseLockQueryError = unknown;

export function useGetApiLambdaCollectionForceReleaseLock<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
  TError = unknown
>(
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionForceReleaseLock<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
  TError = unknown
>(
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionForceReleaseLock<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
  TError = unknown
>(
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionForceReleaseLock<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
  TError = unknown
>(
  params: GetApiLambdaCollectionForceReleaseLockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionForceReleaseLock>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaCollectionForceReleaseLockQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCollectionCheck = (
  collectionSqsDtoBody: CollectionSqsDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<boolean>(
    {
      url: `/api/lambda/collection/check`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionSqsDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>,
    TError,
    { data: CollectionSqsDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>,
  TError,
  { data: CollectionSqsDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>,
    { data: CollectionSqsDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>
>;
export type PostApiLambdaCollectionCheckMutationBody = CollectionSqsDtoBody;
export type PostApiLambdaCollectionCheckMutationError = unknown;

export const usePostApiLambdaCollectionCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>,
      TError,
      { data: CollectionSqsDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionCheck>>,
  TError,
  { data: CollectionSqsDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionCheckMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCollectionRollover = (
  rolloverRequestDtoBody: RolloverRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<RolloverLoanResponseDto>(
    {
      url: `/api/lambda/collection/rollover`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rolloverRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionRolloverMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>,
    TError,
    { data: RolloverRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionRollover"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>,
    { data: RolloverRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionRollover(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionRolloverMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>
>;
export type PostApiLambdaCollectionRolloverMutationBody =
  RolloverRequestDtoBody;
export type PostApiLambdaCollectionRolloverMutationError = unknown;

export const usePostApiLambdaCollectionRollover = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>,
      TError,
      { data: RolloverRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionRollover>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionRolloverMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCollectionRolloverDates = (
  params?: GetApiLambdaCollectionRolloverDatesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string[]>(
    {
      url: `/api/lambda/collection/rollover/dates`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLambdaCollectionRolloverDatesQueryKey = (
  params?: GetApiLambdaCollectionRolloverDatesParams
) => {
  return [
    `/api/lambda/collection/rollover/dates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLambdaCollectionRolloverDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
  TError = unknown
>(
  params?: GetApiLambdaCollectionRolloverDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCollectionRolloverDatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>
  > = ({ signal }) =>
    getApiLambdaCollectionRolloverDates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionRolloverDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>
>;
export type GetApiLambdaCollectionRolloverDatesQueryError = unknown;

export function useGetApiLambdaCollectionRolloverDates<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
  TError = unknown
>(
  params: undefined | GetApiLambdaCollectionRolloverDatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverDates<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
  TError = unknown
>(
  params?: GetApiLambdaCollectionRolloverDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverDates<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
  TError = unknown
>(
  params?: GetApiLambdaCollectionRolloverDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionRolloverDates<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
  TError = unknown
>(
  params?: GetApiLambdaCollectionRolloverDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaCollectionRolloverDatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLambdaCollectionRolloverLoanId = (
  id: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<LoanDto>(
    {
      url: `/api/lambda/collection/rollover/loan/${id}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaCollectionRolloverLoanIdQueryKey = (id: number) => {
  return [`/api/lambda/collection/rollover/loan/${id}`] as const;
};

export const getGetApiLambdaCollectionRolloverLoanIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCollectionRolloverLoanIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>
  > = ({ signal }) =>
    getApiLambdaCollectionRolloverLoanId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionRolloverLoanIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>
>;
export type GetApiLambdaCollectionRolloverLoanIdQueryError = unknown;

export function useGetApiLambdaCollectionRolloverLoanId<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverLoanId<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverLoanId<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionRolloverLoanId<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaCollectionRolloverLoanIdQueryOptions(
    id,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCollectionRolloverLoanCalculate = (
  rolloverRequestDtoBody: RolloverRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<number>(
    {
      url: `/api/lambda/collection/rollover/loan/calculate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rolloverRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionRolloverLoanCalculateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>,
    TError,
    { data: RolloverRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLambdaCollectionRolloverLoanCalculate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>,
    { data: RolloverRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaCollectionRolloverLoanCalculate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCollectionRolloverLoanCalculateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>
  >;
export type PostApiLambdaCollectionRolloverLoanCalculateMutationBody =
  RolloverRequestDtoBody;
export type PostApiLambdaCollectionRolloverLoanCalculateMutationError = unknown;

export const usePostApiLambdaCollectionRolloverLoanCalculate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>,
      TError,
      { data: RolloverRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionRolloverLoanCalculate>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionRolloverLoanCalculateMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCollectionRolloverCardList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<SearchCardReturnDto>(
    { url: `/api/lambda/collection/rollover/card/list`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaCollectionRolloverCardListQueryKey = () => {
  return [`/api/lambda/collection/rollover/card/list`] as const;
};

export const getGetApiLambdaCollectionRolloverCardListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCollectionRolloverCardListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>
  > = ({ signal }) =>
    getApiLambdaCollectionRolloverCardList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionRolloverCardListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>
>;
export type GetApiLambdaCollectionRolloverCardListQueryError = unknown;

export function useGetApiLambdaCollectionRolloverCardList<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverCardList<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverCardList<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionRolloverCardList<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaCollectionRolloverCardListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCollectionRolloverCardValidateBulk = (
  validateCardDto: ValidateCardDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ValidateCardReturnDto[]>(
    {
      url: `/api/lambda/collection/rollover/card/validate/bulk`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validateCardDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCollectionRolloverCardValidateBulkMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>
      >,
      TError,
      { data: ValidateCardDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>>,
    TError,
    { data: ValidateCardDto[] },
    TContext
  > => {
    const mutationKey = ["postApiLambdaCollectionRolloverCardValidateBulk"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>
      >,
      { data: ValidateCardDto[] }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaCollectionRolloverCardValidateBulk(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCollectionRolloverCardValidateBulkMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>>
  >;
export type PostApiLambdaCollectionRolloverCardValidateBulkMutationBody =
  ValidateCardDto[];
export type PostApiLambdaCollectionRolloverCardValidateBulkMutationError =
  unknown;

export const usePostApiLambdaCollectionRolloverCardValidateBulk = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>
      >,
      TError,
      { data: ValidateCardDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCollectionRolloverCardValidateBulk>>,
  TError,
  { data: ValidateCardDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCollectionRolloverCardValidateBulkMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaCollectionRolloverCardOrdered = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CardResponseDto[]>(
    {
      url: `/api/lambda/collection/rollover/card/ordered`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaCollectionRolloverCardOrderedQueryKey = () => {
  return [`/api/lambda/collection/rollover/card/ordered`] as const;
};

export const getGetApiLambdaCollectionRolloverCardOrderedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLambdaCollectionRolloverCardOrderedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>
  > = ({ signal }) =>
    getApiLambdaCollectionRolloverCardOrdered(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaCollectionRolloverCardOrderedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>
>;
export type GetApiLambdaCollectionRolloverCardOrderedQueryError = unknown;

export function useGetApiLambdaCollectionRolloverCardOrdered<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverCardOrdered<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaCollectionRolloverCardOrdered<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaCollectionRolloverCardOrdered<
  TData = Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaCollectionRolloverCardOrdered>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaCollectionRolloverCardOrderedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLambdaLoanAssignAgreement = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/lambda/loan/assignAgreement`, method: "GET", signal },
    options
  );
};

export const getGetApiLambdaLoanAssignAgreementQueryKey = () => {
  return [`/api/lambda/loan/assignAgreement`] as const;
};

export const getGetApiLambdaLoanAssignAgreementQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLambdaLoanAssignAgreementQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>
  > = ({ signal }) => getApiLambdaLoanAssignAgreement(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLambdaLoanAssignAgreementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>
>;
export type GetApiLambdaLoanAssignAgreementQueryError = unknown;

export function useGetApiLambdaLoanAssignAgreement<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanAssignAgreement<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
          TError,
          Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaLoanAssignAgreement<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaLoanAssignAgreement<
  TData = Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLambdaLoanAssignAgreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLambdaLoanAssignAgreementQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaCommunicationS3DocumentSync = (
  params: PostApiLambdaCommunicationS3DocumentSyncParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/communication/S3DocumentSync`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaCommunicationS3DocumentSyncMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>,
    TError,
    { params: PostApiLambdaCommunicationS3DocumentSyncParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>,
  TError,
  { params: PostApiLambdaCommunicationS3DocumentSyncParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaCommunicationS3DocumentSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>,
    { params: PostApiLambdaCommunicationS3DocumentSyncParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaCommunicationS3DocumentSync(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCommunicationS3DocumentSyncMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>
  >;

export type PostApiLambdaCommunicationS3DocumentSyncMutationError = unknown;

export const usePostApiLambdaCommunicationS3DocumentSync = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>,
      TError,
      { params: PostApiLambdaCommunicationS3DocumentSyncParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCommunicationS3DocumentSync>>,
  TError,
  { params: PostApiLambdaCommunicationS3DocumentSyncParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaCommunicationS3DocumentSyncMutationOptions(options),
    queryClient
  );
};

export const getApiLambdaSendIBCallInformationToCollectionCompany = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/sendIBCallInformationToCollectionCompany`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLambdaSendIBCallInformationToCollectionCompanyQueryKey =
  () => {
    return [`/api/lambda/sendIBCallInformationToCollectionCompany`] as const;
  };

export const getGetApiLambdaSendIBCallInformationToCollectionCompanyQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaSendIBCallInformationToCollectionCompany
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiLambdaSendIBCallInformationToCollectionCompanyQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
      >
    > = ({ signal }) =>
      getApiLambdaSendIBCallInformationToCollectionCompany(
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiLambdaSendIBCallInformationToCollectionCompanyQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
    >
  >;
export type GetApiLambdaSendIBCallInformationToCollectionCompanyQueryError =
  unknown;

export function useGetApiLambdaSendIBCallInformationToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaSendIBCallInformationToCollectionCompany
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaSendIBCallInformationToCollectionCompany
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaSendIBCallInformationToCollectionCompany
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaSendIBCallInformationToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaSendIBCallInformationToCollectionCompany
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLambdaSendIBCallInformationToCollectionCompany
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLambdaSendIBCallInformationToCollectionCompany
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLambdaSendIBCallInformationToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaSendIBCallInformationToCollectionCompany
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLambdaSendIBCallInformationToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLambdaSendIBCallInformationToCollectionCompany>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLambdaSendIBCallInformationToCollectionCompany
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLambdaSendIBCallInformationToCollectionCompanyQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLambdaMoneytransferProcessSourcAaccountTransactions = (
  sourceAccountTransactionDto: SourceAccountTransactionDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/moneytransfer/processSourcAaccountTransactions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sourceAccountTransactionDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferProcessSourcAaccountTransactionsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
        >
      >,
      TError,
      { data: SourceAccountTransactionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
      >
    >,
    TError,
    { data: SourceAccountTransactionDto },
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaMoneytransferProcessSourcAaccountTransactions",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
        >
      >,
      { data: SourceAccountTransactionDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaMoneytransferProcessSourcAaccountTransactions(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaMoneytransferProcessSourcAaccountTransactionsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
      >
    >
  >;
export type PostApiLambdaMoneytransferProcessSourcAaccountTransactionsMutationBody =
  SourceAccountTransactionDto;
export type PostApiLambdaMoneytransferProcessSourcAaccountTransactionsMutationError =
  unknown;

export const usePostApiLambdaMoneytransferProcessSourcAaccountTransactions = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
        >
      >,
      TError,
      { data: SourceAccountTransactionDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLambdaMoneytransferProcessSourcAaccountTransactions
    >
  >,
  TError,
  { data: SourceAccountTransactionDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferProcessSourcAaccountTransactionsMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaMoneytransferSatScrape = (
  params?: PostApiLambdaMoneytransferSatScrapeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TokenizedScrapeResponseDto[]>(
    {
      url: `/api/lambda/moneytransfer/sat/scrape`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferSatScrapeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>,
    TError,
    { params?: PostApiLambdaMoneytransferSatScrapeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>,
  TError,
  { params?: PostApiLambdaMoneytransferSatScrapeParams },
  TContext
> => {
  const mutationKey = ["postApiLambdaMoneytransferSatScrape"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>,
    { params?: PostApiLambdaMoneytransferSatScrapeParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLambdaMoneytransferSatScrape(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaMoneytransferSatScrapeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>
>;

export type PostApiLambdaMoneytransferSatScrapeMutationError = unknown;

export const usePostApiLambdaMoneytransferSatScrape = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>,
      TError,
      { params?: PostApiLambdaMoneytransferSatScrapeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferSatScrape>>,
  TError,
  { params?: PostApiLambdaMoneytransferSatScrapeParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferSatScrapeMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaMoneytransferTinkSatScrape = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/lambda/moneytransfer/tink/sat/scrape`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaMoneytransferTinkSatScrapeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaMoneytransferTinkSatScrape"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>,
    void
  > = () => {
    return postApiLambdaMoneytransferTinkSatScrape(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaMoneytransferTinkSatScrapeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>
>;

export type PostApiLambdaMoneytransferTinkSatScrapeMutationError = unknown;

export const usePostApiLambdaMoneytransferTinkSatScrape = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaMoneytransferTinkSatScrape>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaMoneytransferTinkSatScrapeMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCcEcUnassign = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/lambda/cc/ec/unassign`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaCcEcUnassignMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaCcEcUnassign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>,
    void
  > = () => {
    return postApiLambdaCcEcUnassign(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaCcEcUnassignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>
>;

export type PostApiLambdaCcEcUnassignMutationError = unknown;

export const usePostApiLambdaCcEcUnassign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaCcEcUnassign>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCcEcUnassignMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaCustomerLCUnassignmentReminderAfterOneDay = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/lambda/customer/LCUnassignmentReminderAfterOneDay`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLambdaCustomerLCUnassignmentReminderAfterOneDayMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "postApiLambdaCustomerLCUnassignmentReminderAfterOneDay",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay
        >
      >,
      void
    > = () => {
      return postApiLambdaCustomerLCUnassignmentReminderAfterOneDay(
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaCustomerLCUnassignmentReminderAfterOneDayMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay>
    >
  >;

export type PostApiLambdaCustomerLCUnassignmentReminderAfterOneDayMutationError =
  unknown;

export const usePostApiLambdaCustomerLCUnassignmentReminderAfterOneDay = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay
        >
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLambdaCustomerLCUnassignmentReminderAfterOneDay>
  >,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaCustomerLCUnassignmentReminderAfterOneDayMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaLoanAutoAssign = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/lambda/loan/auto/assign`, method: "POST", signal },
    options
  );
};

export const getPostApiLambdaLoanAutoAssignMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLambdaLoanAutoAssign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>,
    void
  > = () => {
    return postApiLambdaLoanAutoAssign(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaLoanAutoAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>
>;

export type PostApiLambdaLoanAutoAssignMutationError = unknown;

export const usePostApiLambdaLoanAutoAssign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanAutoAssign>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAutoAssignMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaDecisionManageDecisionResultMatch = (
  params: PostApiLambdaDecisionManageDecisionResultMatchParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/decision/manageDecisionResultMatch`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLambdaDecisionManageDecisionResultMatchMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>
      >,
      TError,
      { params: PostApiLambdaDecisionManageDecisionResultMatchParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>>,
    TError,
    { params: PostApiLambdaDecisionManageDecisionResultMatchParams },
    TContext
  > => {
    const mutationKey = ["postApiLambdaDecisionManageDecisionResultMatch"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>
      >,
      { params: PostApiLambdaDecisionManageDecisionResultMatchParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLambdaDecisionManageDecisionResultMatch(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaDecisionManageDecisionResultMatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>>
  >;

export type PostApiLambdaDecisionManageDecisionResultMatchMutationError =
  unknown;

export const usePostApiLambdaDecisionManageDecisionResultMatch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>
      >,
      TError,
      { params: PostApiLambdaDecisionManageDecisionResultMatchParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaDecisionManageDecisionResultMatch>>,
  TError,
  { params: PostApiLambdaDecisionManageDecisionResultMatchParams },
  TContext
> => {
  return useMutation(
    getPostApiLambdaDecisionManageDecisionResultMatchMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaAutomationLoanFtbAutoIssueProcess = (
  fTBAutoIssueAfterAgreementAssignFTBProcessDto: FTBAutoIssueAfterAgreementAssignFTBProcessDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/automation/loan/ftbAutoIssueProcess`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: fTBAutoIssueAfterAgreementAssignFTBProcessDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaAutomationLoanFtbAutoIssueProcessMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>
      >,
      TError,
      { data: FTBAutoIssueAfterAgreementAssignFTBProcessDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>>,
    TError,
    { data: FTBAutoIssueAfterAgreementAssignFTBProcessDto },
    TContext
  > => {
    const mutationKey = ["postApiLambdaAutomationLoanFtbAutoIssueProcess"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>
      >,
      { data: FTBAutoIssueAfterAgreementAssignFTBProcessDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaAutomationLoanFtbAutoIssueProcess(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaAutomationLoanFtbAutoIssueProcessMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>>
  >;
export type PostApiLambdaAutomationLoanFtbAutoIssueProcessMutationBody =
  FTBAutoIssueAfterAgreementAssignFTBProcessDto;
export type PostApiLambdaAutomationLoanFtbAutoIssueProcessMutationError =
  unknown;

export const usePostApiLambdaAutomationLoanFtbAutoIssueProcess = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>
      >,
      TError,
      { data: FTBAutoIssueAfterAgreementAssignFTBProcessDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaAutomationLoanFtbAutoIssueProcess>>,
  TError,
  { data: FTBAutoIssueAfterAgreementAssignFTBProcessDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaAutomationLoanFtbAutoIssueProcessMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaLoanAgreementAssignmentReminderQueue = (
  agreementAssignLoanAndCustomerDto: AgreementAssignLoanAndCustomerDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/lambda/loan/agreementAssignmentReminderQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: agreementAssignLoanAndCustomerDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaLoanAgreementAssignmentReminderQueueMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>
      >,
      TError,
      { data: AgreementAssignLoanAndCustomerDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>
    >,
    TError,
    { data: AgreementAssignLoanAndCustomerDto },
    TContext
  > => {
    const mutationKey = ["postApiLambdaLoanAgreementAssignmentReminderQueue"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>
      >,
      { data: AgreementAssignLoanAndCustomerDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLambdaLoanAgreementAssignmentReminderQueue(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLambdaLoanAgreementAssignmentReminderQueueMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>
    >
  >;
export type PostApiLambdaLoanAgreementAssignmentReminderQueueMutationBody =
  AgreementAssignLoanAndCustomerDto;
export type PostApiLambdaLoanAgreementAssignmentReminderQueueMutationError =
  unknown;

export const usePostApiLambdaLoanAgreementAssignmentReminderQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>
      >,
      TError,
      { data: AgreementAssignLoanAndCustomerDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaLoanAgreementAssignmentReminderQueue>>,
  TError,
  { data: AgreementAssignLoanAndCustomerDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaLoanAgreementAssignmentReminderQueueMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLambdaRescrapeCreateSession = (
  createSessionDto: CreateSessionDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCreateSessionResponseDto>(
    {
      url: `/api/lambda/rescrape/createSession`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createSessionDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeCreateSessionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>,
    TError,
    { data: CreateSessionDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>,
  TError,
  { data: CreateSessionDto[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeCreateSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>,
    { data: CreateSessionDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeCreateSession(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeCreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>
>;
export type PostApiLambdaRescrapeCreateSessionMutationBody = CreateSessionDto[];
export type PostApiLambdaRescrapeCreateSessionMutationError = unknown;

export const usePostApiLambdaRescrapeCreateSession = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>,
      TError,
      { data: CreateSessionDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateSession>>,
  TError,
  { data: CreateSessionDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeCreateSessionMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaRescrapeCreateCustomerTokenRead = (
  createCustomerTokenReadDto: CreateCustomerTokenReadDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/rescrape/createCustomerTokenRead`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomerTokenReadDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeCreateCustomerTokenReadMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>,
    TError,
    { data: CreateCustomerTokenReadDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>,
  TError,
  { data: CreateCustomerTokenReadDto[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeCreateCustomerTokenRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>,
    { data: CreateCustomerTokenReadDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeCreateCustomerTokenRead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeCreateCustomerTokenReadMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>
  >;
export type PostApiLambdaRescrapeCreateCustomerTokenReadMutationBody =
  CreateCustomerTokenReadDto[];
export type PostApiLambdaRescrapeCreateCustomerTokenReadMutationError = unknown;

export const usePostApiLambdaRescrapeCreateCustomerTokenRead = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>,
      TError,
      { data: CreateCustomerTokenReadDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateCustomerTokenRead>>,
  TError,
  { data: CreateCustomerTokenReadDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeCreateCustomerTokenReadMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaRescrapeCreateUnnaxRequest = (
  unnaxRequestDto: UnnaxRequestDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/rescrape/createUnnaxRequest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeCreateUnnaxRequestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>,
    TError,
    { data: UnnaxRequestDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>,
  TError,
  { data: UnnaxRequestDto[] },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeCreateUnnaxRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>,
    { data: UnnaxRequestDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeCreateUnnaxRequest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeCreateUnnaxRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>
>;
export type PostApiLambdaRescrapeCreateUnnaxRequestMutationBody =
  UnnaxRequestDto[];
export type PostApiLambdaRescrapeCreateUnnaxRequestMutationError = unknown;

export const usePostApiLambdaRescrapeCreateUnnaxRequest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>,
      TError,
      { data: UnnaxRequestDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxRequest>>,
  TError,
  { data: UnnaxRequestDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeCreateUnnaxRequestMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaRescrapeCreateUnnaxCallback = (
  createUnnaxCallbackRequestDto: CreateUnnaxCallbackRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxCallbackResultDto>(
    {
      url: `/api/lambda/rescrape/createUnnaxCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createUnnaxCallbackRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeCreateUnnaxCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>,
    TError,
    { data: CreateUnnaxCallbackRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>,
  TError,
  { data: CreateUnnaxCallbackRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeCreateUnnaxCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>,
    { data: CreateUnnaxCallbackRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeCreateUnnaxCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeCreateUnnaxCallbackMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>
  >;
export type PostApiLambdaRescrapeCreateUnnaxCallbackMutationBody =
  CreateUnnaxCallbackRequestDto;
export type PostApiLambdaRescrapeCreateUnnaxCallbackMutationError = unknown;

export const usePostApiLambdaRescrapeCreateUnnaxCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>,
      TError,
      { data: CreateUnnaxCallbackRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeCreateUnnaxCallback>>,
  TError,
  { data: CreateUnnaxCallbackRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeCreateUnnaxCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiLambdaRescrapeRunRescrapeDecision = (
  rescrapeDecisionRequestDto: RescrapeDecisionRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `/api/lambda/rescrape/runRescrapeDecision`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rescrapeDecisionRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLambdaRescrapeRunRescrapeDecisionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>,
    TError,
    { data: RescrapeDecisionRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>,
  TError,
  { data: RescrapeDecisionRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLambdaRescrapeRunRescrapeDecision"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>,
    { data: RescrapeDecisionRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLambdaRescrapeRunRescrapeDecision(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLambdaRescrapeRunRescrapeDecisionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>
  >;
export type PostApiLambdaRescrapeRunRescrapeDecisionMutationBody =
  RescrapeDecisionRequestDto;
export type PostApiLambdaRescrapeRunRescrapeDecisionMutationError = unknown;

export const usePostApiLambdaRescrapeRunRescrapeDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>,
      TError,
      { data: RescrapeDecisionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLambdaRescrapeRunRescrapeDecision>>,
  TError,
  { data: RescrapeDecisionRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLambdaRescrapeRunRescrapeDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiLiveChatLiveChatWebhook = (
  cardUniversalPayNotificationURLDtoBody: CardUniversalPayNotificationURLDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatMessageResponse>(
    {
      url: `/api/liveChat/liveChatWebhook`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardUniversalPayNotificationURLDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLiveChatLiveChatWebhookMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>,
    TError,
    { data: CardUniversalPayNotificationURLDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLiveChatLiveChatWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>,
    { data: CardUniversalPayNotificationURLDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLiveChatLiveChatWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLiveChatLiveChatWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>
>;
export type PostApiLiveChatLiveChatWebhookMutationBody =
  CardUniversalPayNotificationURLDtoBody;
export type PostApiLiveChatLiveChatWebhookMutationError = unknown;

export const usePostApiLiveChatLiveChatWebhook = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>,
      TError,
      { data: CardUniversalPayNotificationURLDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLiveChatLiveChatWebhook>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLiveChatLiveChatWebhookMutationOptions(options),
    queryClient
  );
};

export const getApiLiveChatSessionGet = (
  params: GetApiLiveChatSessionGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatSession>(
    { url: `/api/liveChat/session/get`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLiveChatSessionGetQueryKey = (
  params?: GetApiLiveChatSessionGetParams
) => {
  return [`/api/liveChat/session/get`, ...(params ? [params] : [])] as const;
};

export const getGetApiLiveChatSessionGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatSessionGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatSessionGet>>
  > = ({ signal }) => getApiLiveChatSessionGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatSessionGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatSessionGet>>
>;
export type GetApiLiveChatSessionGetQueryError = unknown;

export function useGetApiLiveChatSessionGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatSessionGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatSessionGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatSessionGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatSessionGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatSessionGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatSessionGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLiveChatSessionStart = (
  params: PostApiLiveChatSessionStartParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatSession>(
    { url: `/api/liveChat/session/start`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLiveChatSessionStartMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLiveChatSessionStart>>,
    TError,
    { params: PostApiLiveChatSessionStartParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLiveChatSessionStart>>,
  TError,
  { params: PostApiLiveChatSessionStartParams },
  TContext
> => {
  const mutationKey = ["postApiLiveChatSessionStart"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLiveChatSessionStart>>,
    { params: PostApiLiveChatSessionStartParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLiveChatSessionStart(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLiveChatSessionStartMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLiveChatSessionStart>>
>;

export type PostApiLiveChatSessionStartMutationError = unknown;

export const usePostApiLiveChatSessionStart = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLiveChatSessionStart>>,
      TError,
      { params: PostApiLiveChatSessionStartParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLiveChatSessionStart>>,
  TError,
  { params: PostApiLiveChatSessionStartParams },
  TContext
> => {
  return useMutation(
    getPostApiLiveChatSessionStartMutationOptions(options),
    queryClient
  );
};

export const postApiLiveChatSessionStop = (
  params: PostApiLiveChatSessionStopParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatSession>(
    { url: `/api/liveChat/session/stop`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLiveChatSessionStopMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLiveChatSessionStop>>,
    TError,
    { params: PostApiLiveChatSessionStopParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLiveChatSessionStop>>,
  TError,
  { params: PostApiLiveChatSessionStopParams },
  TContext
> => {
  const mutationKey = ["postApiLiveChatSessionStop"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLiveChatSessionStop>>,
    { params: PostApiLiveChatSessionStopParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLiveChatSessionStop(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLiveChatSessionStopMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLiveChatSessionStop>>
>;

export type PostApiLiveChatSessionStopMutationError = unknown;

export const usePostApiLiveChatSessionStop = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLiveChatSessionStop>>,
      TError,
      { params: PostApiLiveChatSessionStopParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLiveChatSessionStop>>,
  TError,
  { params: PostApiLiveChatSessionStopParams },
  TContext
> => {
  return useMutation(
    getPostApiLiveChatSessionStopMutationOptions(options),
    queryClient
  );
};

export const postApiLiveChatMessageCreate = (
  chatMessageContent: ChatMessageContent,
  params: PostApiLiveChatMessageCreateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatMessage>(
    {
      url: `/api/liveChat/message/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: chatMessageContent,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLiveChatMessageCreateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>,
    TError,
    { data: ChatMessageContent; params: PostApiLiveChatMessageCreateParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>,
  TError,
  { data: ChatMessageContent; params: PostApiLiveChatMessageCreateParams },
  TContext
> => {
  const mutationKey = ["postApiLiveChatMessageCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>,
    { data: ChatMessageContent; params: PostApiLiveChatMessageCreateParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLiveChatMessageCreate(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLiveChatMessageCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>
>;
export type PostApiLiveChatMessageCreateMutationBody = ChatMessageContent;
export type PostApiLiveChatMessageCreateMutationError = unknown;

export const usePostApiLiveChatMessageCreate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>,
      TError,
      { data: ChatMessageContent; params: PostApiLiveChatMessageCreateParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLiveChatMessageCreate>>,
  TError,
  { data: ChatMessageContent; params: PostApiLiveChatMessageCreateParams },
  TContext
> => {
  return useMutation(
    getPostApiLiveChatMessageCreateMutationOptions(options),
    queryClient
  );
};

export const getApiLiveChatAgentGet = (
  params?: GetApiLiveChatAgentGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatAgentArray>(
    { url: `/api/liveChat/agent/get`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLiveChatAgentGetQueryKey = (
  params?: GetApiLiveChatAgentGetParams
) => {
  return [`/api/liveChat/agent/get`, ...(params ? [params] : [])] as const;
};

export const getGetApiLiveChatAgentGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
  TError = unknown
>(
  params?: GetApiLiveChatAgentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatAgentGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatAgentGet>>
  > = ({ signal }) => getApiLiveChatAgentGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatAgentGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatAgentGet>>
>;
export type GetApiLiveChatAgentGetQueryError = unknown;

export function useGetApiLiveChatAgentGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
  TError = unknown
>(
  params: undefined | GetApiLiveChatAgentGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
  TError = unknown
>(
  params?: GetApiLiveChatAgentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
  TError = unknown
>(
  params?: GetApiLiveChatAgentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatAgentGet<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
  TError = unknown
>(
  params?: GetApiLiveChatAgentGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatAgentGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLiveChatAgentCreate = (
  params: GetApiLiveChatAgentCreateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatAgentArray>(
    { url: `/api/liveChat/agent/create`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLiveChatAgentCreateQueryKey = (
  params?: GetApiLiveChatAgentCreateParams
) => {
  return [`/api/liveChat/agent/create`, ...(params ? [params] : [])] as const;
};

export const getGetApiLiveChatAgentCreateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
  TError = unknown
>(
  params: GetApiLiveChatAgentCreateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatAgentCreateQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>
  > = ({ signal }) => getApiLiveChatAgentCreate(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatAgentCreateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>
>;
export type GetApiLiveChatAgentCreateQueryError = unknown;

export function useGetApiLiveChatAgentCreate<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
  TError = unknown
>(
  params: GetApiLiveChatAgentCreateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentCreate<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
  TError = unknown
>(
  params: GetApiLiveChatAgentCreateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentCreate<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
  TError = unknown
>(
  params: GetApiLiveChatAgentCreateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatAgentCreate<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
  TError = unknown
>(
  params: GetApiLiveChatAgentCreateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatAgentCreateQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLiveChatSessionAssign = (
  params: GetApiLiveChatSessionAssignParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatSessionArray>(
    { url: `/api/liveChat/session/assign`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLiveChatSessionAssignQueryKey = (
  params?: GetApiLiveChatSessionAssignParams
) => {
  return [`/api/liveChat/session/assign`, ...(params ? [params] : [])] as const;
};

export const getGetApiLiveChatSessionAssignQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionAssignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatSessionAssignQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>
  > = ({ signal }) =>
    getApiLiveChatSessionAssign(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatSessionAssignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>
>;
export type GetApiLiveChatSessionAssignQueryError = unknown;

export function useGetApiLiveChatSessionAssign<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionAssignParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatSessionAssign<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionAssignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatSessionAssign<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionAssignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatSessionAssign<
  TData = Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
  TError = unknown
>(
  params: GetApiLiveChatSessionAssignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatSessionAssign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatSessionAssignQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLiveChatDataInitialize = (
  params: GetApiLiveChatDataInitializeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLiveChatMessageResponse>(
    { url: `/api/liveChat/data/initialize`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLiveChatDataInitializeQueryKey = (
  params?: GetApiLiveChatDataInitializeParams
) => {
  return [
    `/api/liveChat/data/initialize`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLiveChatDataInitializeQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
  TError = unknown
>(
  params: GetApiLiveChatDataInitializeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatDataInitializeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>
  > = ({ signal }) =>
    getApiLiveChatDataInitialize(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatDataInitializeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>
>;
export type GetApiLiveChatDataInitializeQueryError = unknown;

export function useGetApiLiveChatDataInitialize<
  TData = Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
  TError = unknown
>(
  params: GetApiLiveChatDataInitializeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatDataInitialize<
  TData = Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
  TError = unknown
>(
  params: GetApiLiveChatDataInitializeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatDataInitialize<
  TData = Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
  TError = unknown
>(
  params: GetApiLiveChatDataInitializeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatDataInitialize<
  TData = Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
  TError = unknown
>(
  params: GetApiLiveChatDataInitializeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatDataInitialize>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatDataInitializeQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLiveChatAgentCreateAll = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/liveChat/agent/createAll`, method: "GET", signal },
    options
  );
};

export const getGetApiLiveChatAgentCreateAllQueryKey = () => {
  return [`/api/liveChat/agent/createAll`] as const;
};

export const getGetApiLiveChatAgentCreateAllQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLiveChatAgentCreateAllQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>
  > = ({ signal }) => getApiLiveChatAgentCreateAll(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatAgentCreateAllQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>
>;
export type GetApiLiveChatAgentCreateAllQueryError = unknown;

export function useGetApiLiveChatAgentCreateAll<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentCreateAll<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatAgentCreateAll<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatAgentCreateAll<
  TData = Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatAgentCreateAll>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatAgentCreateAllQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLiveChatUserGetHistorySessions = (
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUserConversationHistoryDto>(
    {
      url: `/api/liveChat/user/getHistorySessions`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLiveChatUserGetHistorySessionsQueryKey = (
  params?: GetApiLiveChatUserGetHistorySessionsParams
) => {
  return [
    `/api/liveChat/user/getHistorySessions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLiveChatUserGetHistorySessionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
  TError = unknown
>(
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLiveChatUserGetHistorySessionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>
  > = ({ signal }) =>
    getApiLiveChatUserGetHistorySessions(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLiveChatUserGetHistorySessionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>
>;
export type GetApiLiveChatUserGetHistorySessionsQueryError = unknown;

export function useGetApiLiveChatUserGetHistorySessions<
  TData = Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
  TError = unknown
>(
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatUserGetHistorySessions<
  TData = Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
  TError = unknown
>(
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
          TError,
          Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLiveChatUserGetHistorySessions<
  TData = Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
  TError = unknown
>(
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLiveChatUserGetHistorySessions<
  TData = Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
  TError = unknown
>(
  params: GetApiLiveChatUserGetHistorySessionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLiveChatUserGetHistorySessions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLiveChatUserGetHistorySessionsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanAutoIssueCheck = (
  autoIssueCheckRequestDto: AutoIssueCheckRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultAutoIssueCheckResponseDto>(
    {
      url: `/api/loan/AutoIssueCheck`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: autoIssueCheckRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanAutoIssueCheckMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>,
    TError,
    { data: AutoIssueCheckRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>,
  TError,
  { data: AutoIssueCheckRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanAutoIssueCheck"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>,
    { data: AutoIssueCheckRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanAutoIssueCheck(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAutoIssueCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>
>;
export type PostApiLoanAutoIssueCheckMutationBody = AutoIssueCheckRequestDto;
export type PostApiLoanAutoIssueCheckMutationError = unknown;

export const usePostApiLoanAutoIssueCheck = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>,
      TError,
      { data: AutoIssueCheckRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAutoIssueCheck>>,
  TError,
  { data: AutoIssueCheckRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanAutoIssueCheckMutationOptions(options),
    queryClient
  );
};

export const getApiLoanCardHints = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanJourneyDto>(
    { url: `/api/loan/cardHints`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanCardHintsQueryKey = () => {
  return [`/api/loan/cardHints`] as const;
};

export const getGetApiLoanCardHintsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCardHints>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanCardHints>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLoanCardHintsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCardHints>>
  > = ({ signal }) => getApiLoanCardHints(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCardHints>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCardHintsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCardHints>>
>;
export type GetApiLoanCardHintsQueryError = unknown;

export function useGetApiLoanCardHints<
  TData = Awaited<ReturnType<typeof getApiLoanCardHints>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCardHints>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCardHints>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCardHints>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCardHints<
  TData = Awaited<ReturnType<typeof getApiLoanCardHints>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCardHints>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCardHints>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCardHints>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCardHints<
  TData = Awaited<ReturnType<typeof getApiLoanCardHints>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCardHints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCardHints<
  TData = Awaited<ReturnType<typeof getApiLoanCardHints>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCardHints>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCardHintsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanRequestLoan = (
  makeLoanApplicationDTOBody: MakeLoanApplicationDTOBody,
  params: PostApiLoanRequestLoanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanApplicationResultDTO>(
    {
      url: `/api/loan/requestLoan`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: makeLoanApplicationDTOBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanRequestLoanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanRequestLoan>>,
    TError,
    { data: MakeLoanApplicationDTOBody; params: PostApiLoanRequestLoanParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanRequestLoan>>,
  TError,
  { data: MakeLoanApplicationDTOBody; params: PostApiLoanRequestLoanParams },
  TContext
> => {
  const mutationKey = ["postApiLoanRequestLoan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanRequestLoan>>,
    { data: MakeLoanApplicationDTOBody; params: PostApiLoanRequestLoanParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanRequestLoan(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanRequestLoanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanRequestLoan>>
>;
export type PostApiLoanRequestLoanMutationBody = MakeLoanApplicationDTOBody;
export type PostApiLoanRequestLoanMutationError = unknown;

export const usePostApiLoanRequestLoan = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanRequestLoan>>,
      TError,
      {
        data: MakeLoanApplicationDTOBody;
        params: PostApiLoanRequestLoanParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanRequestLoan>>,
  TError,
  { data: MakeLoanApplicationDTOBody; params: PostApiLoanRequestLoanParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanRequestLoanMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCheckstatus = (
  params: PostApiLoanCheckstatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanApplicationResultDTO>(
    { url: `/api/loan/checkstatus`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanCheckstatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCheckstatus>>,
    TError,
    { params: PostApiLoanCheckstatusParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCheckstatus>>,
  TError,
  { params: PostApiLoanCheckstatusParams },
  TContext
> => {
  const mutationKey = ["postApiLoanCheckstatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCheckstatus>>,
    { params: PostApiLoanCheckstatusParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanCheckstatus(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCheckstatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCheckstatus>>
>;

export type PostApiLoanCheckstatusMutationError = unknown;

export const usePostApiLoanCheckstatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCheckstatus>>,
      TError,
      { params: PostApiLoanCheckstatusParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCheckstatus>>,
  TError,
  { params: PostApiLoanCheckstatusParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanCheckstatusMutationOptions(options),
    queryClient
  );
};

export const postApiLoanApply = (
  loanApplyRequestDto: LoanApplyRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanApplicationResultDTO>(
    {
      url: `/api/loan/apply`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanApplyRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanApplyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanApply>>,
    TError,
    { data: LoanApplyRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanApply>>,
  TError,
  { data: LoanApplyRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanApply"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanApply>>,
    { data: LoanApplyRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanApply(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanApplyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanApply>>
>;
export type PostApiLoanApplyMutationBody = LoanApplyRequestDto;
export type PostApiLoanApplyMutationError = unknown;

export const usePostApiLoanApply = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanApply>>,
      TError,
      { data: LoanApplyRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanApply>>,
  TError,
  { data: LoanApplyRequestDto },
  TContext
> => {
  return useMutation(getPostApiLoanApplyMutationOptions(options), queryClient);
};

export const postApiLoanGetExternalParamLoanApr = (
  loanDtoBody: LoanDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/loan/getExternalParamLoanApr`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanGetExternalParamLoanAprMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>,
    TError,
    { data: LoanDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>,
  TError,
  { data: LoanDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanGetExternalParamLoanApr"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>,
    { data: LoanDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanGetExternalParamLoanApr(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetExternalParamLoanAprMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>
>;
export type PostApiLoanGetExternalParamLoanAprMutationBody = LoanDtoBody;
export type PostApiLoanGetExternalParamLoanAprMutationError = unknown;

export const usePostApiLoanGetExternalParamLoanApr = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>,
      TError,
      { data: LoanDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetExternalParamLoanApr>>,
  TError,
  { data: LoanDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetExternalParamLoanAprMutationOptions(options),
    queryClient
  );
};

export const postApiLoanChangeLoanToAccount = (
  changeLoanToAccountDto: ChangeLoanToAccountDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/changeLoanToAccount`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeLoanToAccountDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanChangeLoanToAccountMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>,
    TError,
    { data: ChangeLoanToAccountDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>,
  TError,
  { data: ChangeLoanToAccountDto },
  TContext
> => {
  const mutationKey = ["postApiLoanChangeLoanToAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>,
    { data: ChangeLoanToAccountDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanChangeLoanToAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanChangeLoanToAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>
>;
export type PostApiLoanChangeLoanToAccountMutationBody = ChangeLoanToAccountDto;
export type PostApiLoanChangeLoanToAccountMutationError = unknown;

export const usePostApiLoanChangeLoanToAccount = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>,
      TError,
      { data: ChangeLoanToAccountDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanChangeLoanToAccount>>,
  TError,
  { data: ChangeLoanToAccountDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanChangeLoanToAccountMutationOptions(options),
    queryClient
  );
};

export const getApiLoanRunCustomerProfitability = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/runCustomerProfitability`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanRunCustomerProfitabilityQueryKey = () => {
  return [`/api/loan/runCustomerProfitability`] as const;
};

export const getGetApiLoanRunCustomerProfitabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanRunCustomerProfitabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>
  > = ({ signal }) =>
    getApiLoanRunCustomerProfitability(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanRunCustomerProfitabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>
>;
export type GetApiLoanRunCustomerProfitabilityQueryError = unknown;

export function useGetApiLoanRunCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRunCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRunCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanRunCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRunCustomerProfitability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanRunCustomerProfitabilityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanGetCustomerProfitability = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerProfitabilityDto>(
    { url: `/api/loan/getCustomerProfitability`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanGetCustomerProfitabilityQueryKey = () => {
  return [`/api/loan/getCustomerProfitability`] as const;
};

export const getGetApiLoanGetCustomerProfitabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanGetCustomerProfitabilityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>
  > = ({ signal }) =>
    getApiLoanGetCustomerProfitability(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetCustomerProfitabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>
>;
export type GetApiLoanGetCustomerProfitabilityQueryError = unknown;

export function useGetApiLoanGetCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetCustomerProfitability<
  TData = Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetCustomerProfitability>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanGetCustomerProfitabilityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoanHookAfterPayment = (
  params: GetApiLoanLoanHookAfterPaymentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCardLoanAggregationDto>(
    { url: `/api/loan/loanHook/afterPayment`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanHookAfterPaymentQueryKey = (
  params?: GetApiLoanLoanHookAfterPaymentParams
) => {
  return [
    `/api/loan/loanHook/afterPayment`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanLoanHookAfterPaymentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
  TError = unknown
>(
  params: GetApiLoanLoanHookAfterPaymentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanLoanHookAfterPaymentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>
  > = ({ signal }) =>
    getApiLoanLoanHookAfterPayment(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanHookAfterPaymentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>
>;
export type GetApiLoanLoanHookAfterPaymentQueryError = unknown;

export function useGetApiLoanLoanHookAfterPayment<
  TData = Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
  TError = unknown
>(
  params: GetApiLoanLoanHookAfterPaymentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanHookAfterPayment<
  TData = Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
  TError = unknown
>(
  params: GetApiLoanLoanHookAfterPaymentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanHookAfterPayment<
  TData = Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
  TError = unknown
>(
  params: GetApiLoanLoanHookAfterPaymentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanHookAfterPayment<
  TData = Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
  TError = unknown
>(
  params: GetApiLoanLoanHookAfterPaymentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanHookAfterPayment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanHookAfterPaymentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanPayloanv2 = (
  payLoanRequestDtoBody: PayLoanRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/payloanv2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: payLoanRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanPayloanv2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPayloanv2>>,
    TError,
    { data: PayLoanRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPayloanv2>>,
  TError,
  { data: PayLoanRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanPayloanv2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPayloanv2>>,
    { data: PayLoanRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanPayloanv2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPayloanv2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPayloanv2>>
>;
export type PostApiLoanPayloanv2MutationBody = PayLoanRequestDtoBody;
export type PostApiLoanPayloanv2MutationError = unknown;

export const usePostApiLoanPayloanv2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPayloanv2>>,
      TError,
      { data: PayLoanRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPayloanv2>>,
  TError,
  { data: PayLoanRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanPayloanv2MutationOptions(options),
    queryClient
  );
};

export const postApiLoanRestructureByCustomer = (
  payLoanAndRestructureRequestDto: PayLoanAndRestructureRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPayLoanAndRestructureResponseDto>(
    {
      url: `/api/loan/restructureByCustomer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: payLoanAndRestructureRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanRestructureByCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>,
    TError,
    { data: PayLoanAndRestructureRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>,
  TError,
  { data: PayLoanAndRestructureRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanRestructureByCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>,
    { data: PayLoanAndRestructureRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanRestructureByCustomer(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanRestructureByCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>
>;
export type PostApiLoanRestructureByCustomerMutationBody =
  PayLoanAndRestructureRequestDto;
export type PostApiLoanRestructureByCustomerMutationError = unknown;

export const usePostApiLoanRestructureByCustomer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>,
      TError,
      { data: PayLoanAndRestructureRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanRestructureByCustomer>>,
  TError,
  { data: PayLoanAndRestructureRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanRestructureByCustomerMutationOptions(options),
    queryClient
  );
};

export const postApiLoanValidateRestructure = (
  restructurePaymentPlanRequestDtoBody: RestructurePaymentPlanRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDto>(
    {
      url: `/api/loan/validateRestructure`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: restructurePaymentPlanRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanValidateRestructureMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanValidateRestructure>>,
    TError,
    { data: RestructurePaymentPlanRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanValidateRestructure>>,
  TError,
  { data: RestructurePaymentPlanRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanValidateRestructure"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanValidateRestructure>>,
    { data: RestructurePaymentPlanRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanValidateRestructure(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanValidateRestructureMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanValidateRestructure>>
>;
export type PostApiLoanValidateRestructureMutationBody =
  RestructurePaymentPlanRequestDtoBody;
export type PostApiLoanValidateRestructureMutationError = unknown;

export const usePostApiLoanValidateRestructure = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanValidateRestructure>>,
      TError,
      { data: RestructurePaymentPlanRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanValidateRestructure>>,
  TError,
  { data: RestructurePaymentPlanRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanValidateRestructureMutationOptions(options),
    queryClient
  );
};

export const postApiLoanTestGetLoanChainAsArrayIdsOfLoan = (
  params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<number[]>(
    {
      url: `/api/loan/testGetLoanChainAsArrayIdsOfLoan`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanTestGetLoanChainAsArrayIdsOfLoanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>,
    TError,
    { params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>,
  TError,
  { params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams },
  TContext
> => {
  const mutationKey = ["postApiLoanTestGetLoanChainAsArrayIdsOfLoan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>,
    { params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanTestGetLoanChainAsArrayIdsOfLoan(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanTestGetLoanChainAsArrayIdsOfLoanMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>
  >;

export type PostApiLoanTestGetLoanChainAsArrayIdsOfLoanMutationError = unknown;

export const usePostApiLoanTestGetLoanChainAsArrayIdsOfLoan = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>,
      TError,
      { params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanTestGetLoanChainAsArrayIdsOfLoan>>,
  TError,
  { params: PostApiLoanTestGetLoanChainAsArrayIdsOfLoanParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanTestGetLoanChainAsArrayIdsOfLoanMutationOptions(options),
    queryClient
  );
};

export const getApiLoanGetLatestActiveLoanForChatbot = (
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiLoanGetLatestActiveLoanForChatbot200One
    | GetApiLoanGetLatestActiveLoanForChatbot200Two
    | Blob
  >(
    {
      url: `/api/loan/getLatestActiveLoanForChatbot`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanGetLatestActiveLoanForChatbotQueryKey = (
  params?: GetApiLoanGetLatestActiveLoanForChatbotParams
) => {
  return [
    `/api/loan/getLatestActiveLoanForChatbot`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanGetLatestActiveLoanForChatbotQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
  TError = unknown
>(
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanGetLatestActiveLoanForChatbotQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>
  > = ({ signal }) =>
    getApiLoanGetLatestActiveLoanForChatbot(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetLatestActiveLoanForChatbotQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>
>;
export type GetApiLoanGetLatestActiveLoanForChatbotQueryError = unknown;

export function useGetApiLoanGetLatestActiveLoanForChatbot<
  TData = Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
  TError = unknown
>(
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetLatestActiveLoanForChatbot<
  TData = Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
  TError = unknown
>(
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetLatestActiveLoanForChatbot<
  TData = Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
  TError = unknown
>(
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetLatestActiveLoanForChatbot<
  TData = Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
  TError = unknown
>(
  params: GetApiLoanGetLatestActiveLoanForChatbotParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetLatestActiveLoanForChatbot>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanGetLatestActiveLoanForChatbotQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanGetLatestActiveLoanForChatbot = (
  pekiWebHookRequestBody: PekiWebHookRequestBody,
  params: PostApiLoanGetLatestActiveLoanForChatbotParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLoanGetLatestActiveLoanForChatbot200One
    | PostApiLoanGetLatestActiveLoanForChatbot200Two
    | Blob
  >(
    {
      url: `/api/loan/getLatestActiveLoanForChatbot`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pekiWebHookRequestBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanGetLatestActiveLoanForChatbotMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>,
    TError,
    {
      data: PekiWebHookRequestBody;
      params: PostApiLoanGetLatestActiveLoanForChatbotParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>,
  TError,
  {
    data: PekiWebHookRequestBody;
    params: PostApiLoanGetLatestActiveLoanForChatbotParams;
  },
  TContext
> => {
  const mutationKey = ["postApiLoanGetLatestActiveLoanForChatbot"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>,
    {
      data: PekiWebHookRequestBody;
      params: PostApiLoanGetLatestActiveLoanForChatbotParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanGetLatestActiveLoanForChatbot(
      data,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetLatestActiveLoanForChatbotMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>
  >;
export type PostApiLoanGetLatestActiveLoanForChatbotMutationBody =
  PekiWebHookRequestBody;
export type PostApiLoanGetLatestActiveLoanForChatbotMutationError = unknown;

export const usePostApiLoanGetLatestActiveLoanForChatbot = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>,
      TError,
      {
        data: PekiWebHookRequestBody;
        params: PostApiLoanGetLatestActiveLoanForChatbotParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetLatestActiveLoanForChatbot>>,
  TError,
  {
    data: PekiWebHookRequestBody;
    params: PostApiLoanGetLatestActiveLoanForChatbotParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetLatestActiveLoanForChatbotMutationOptions(options),
    queryClient
  );
};

export const getApiLoanGetIssuedArrangedLoansOfCustomer = (
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<LoanDto[]>(
    {
      url: `/api/loan/getIssuedArrangedLoansOfCustomer`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanGetIssuedArrangedLoansOfCustomerQueryKey = (
  params?: GetApiLoanGetIssuedArrangedLoansOfCustomerParams
) => {
  return [
    `/api/loan/getIssuedArrangedLoansOfCustomer`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanGetIssuedArrangedLoansOfCustomerQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
  >,
  TError = unknown
>(
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanGetIssuedArrangedLoansOfCustomerQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>
  > = ({ signal }) =>
    getApiLoanGetIssuedArrangedLoansOfCustomer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetIssuedArrangedLoansOfCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>
>;
export type GetApiLoanGetIssuedArrangedLoansOfCustomerQueryError = unknown;

export function useGetApiLoanGetIssuedArrangedLoansOfCustomer<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
  >,
  TError = unknown
>(
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
          >,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetIssuedArrangedLoansOfCustomer<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
  >,
  TError = unknown
>(
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
          >,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetIssuedArrangedLoansOfCustomer<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
  >,
  TError = unknown
>(
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetIssuedArrangedLoansOfCustomer<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>
  >,
  TError = unknown
>(
  params: GetApiLoanGetIssuedArrangedLoansOfCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetIssuedArrangedLoansOfCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanGetIssuedArrangedLoansOfCustomerQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot = (
  pekiWebHookRequestBody: PekiWebHookRequestBody,
  params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot200One
    | PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot200Two
    | Blob
  >(
    {
      url: `/api/loan/getLatestActiveLoanWithCustomerInfoForChatbot`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pekiWebHookRequestBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot
        >
      >,
      TError,
      {
        data: PekiWebHookRequestBody;
        params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot
      >
    >,
    TError,
    {
      data: PekiWebHookRequestBody;
      params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams;
    },
    TContext
  > => {
    const mutationKey = [
      "postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot
        >
      >,
      {
        data: PekiWebHookRequestBody;
        params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams;
      }
    > = (props) => {
      const { data, params } = props ?? {};

      return postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot(
        data,
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot
      >
    >
  >;
export type PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotMutationBody =
  PekiWebHookRequestBody;
export type PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotMutationError =
  unknown;

export const usePostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot
        >
      >,
      TError,
      {
        data: PekiWebHookRequestBody;
        params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiLoanGetLatestActiveLoanWithCustomerInfoForChatbot>
  >,
  TError,
  {
    data: PekiWebHookRequestBody;
    params: PostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetLatestActiveLoanWithCustomerInfoForChatbotMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiLoanCreditJourney = (
  params: GetApiLoanCreditJourneyParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    GetApiLoanCreditJourney200One | GetApiLoanCreditJourney200Two | Blob
  >({ url: `/api/loan/creditJourney`, method: "GET", params, signal }, options);
};

export const getGetApiLoanCreditJourneyQueryKey = (
  params?: GetApiLoanCreditJourneyParams
) => {
  return [`/api/loan/creditJourney`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanCreditJourneyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
  TError = unknown
>(
  params: GetApiLoanCreditJourneyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanCreditJourneyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCreditJourney>>
  > = ({ signal }) => getApiLoanCreditJourney(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCreditJourneyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCreditJourney>>
>;
export type GetApiLoanCreditJourneyQueryError = unknown;

export function useGetApiLoanCreditJourney<
  TData = Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
  TError = unknown
>(
  params: GetApiLoanCreditJourneyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreditJourney>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreditJourney<
  TData = Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
  TError = unknown
>(
  params: GetApiLoanCreditJourneyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreditJourney>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreditJourney<
  TData = Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
  TError = unknown
>(
  params: GetApiLoanCreditJourneyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCreditJourney<
  TData = Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
  TError = unknown
>(
  params: GetApiLoanCreditJourneyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreditJourney>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCreditJourneyQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCreditJourney = (
  pekiWebHookRequestBody: PekiWebHookRequestBody,
  params: PostApiLoanCreditJourneyParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    PostApiLoanCreditJourney200One | PostApiLoanCreditJourney200Two | Blob
  >(
    {
      url: `/api/loan/creditJourney`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pekiWebHookRequestBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanCreditJourneyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCreditJourney>>,
    TError,
    { data: PekiWebHookRequestBody; params: PostApiLoanCreditJourneyParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCreditJourney>>,
  TError,
  { data: PekiWebHookRequestBody; params: PostApiLoanCreditJourneyParams },
  TContext
> => {
  const mutationKey = ["postApiLoanCreditJourney"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCreditJourney>>,
    { data: PekiWebHookRequestBody; params: PostApiLoanCreditJourneyParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanCreditJourney(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCreditJourneyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCreditJourney>>
>;
export type PostApiLoanCreditJourneyMutationBody = PekiWebHookRequestBody;
export type PostApiLoanCreditJourneyMutationError = unknown;

export const usePostApiLoanCreditJourney = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCreditJourney>>,
      TError,
      { data: PekiWebHookRequestBody; params: PostApiLoanCreditJourneyParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCreditJourney>>,
  TError,
  { data: PekiWebHookRequestBody; params: PostApiLoanCreditJourneyParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanCreditJourneyMutationOptions(options),
    queryClient
  );
};

export const postApiLoanRolloverv2 = (
  rolloverRequestDtoBody: RolloverRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultOfThreeDsLoanDto>(
    {
      url: `/api/loan/rolloverv2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rolloverRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanRolloverv2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanRolloverv2>>,
    TError,
    { data: RolloverRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanRolloverv2>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanRolloverv2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanRolloverv2>>,
    { data: RolloverRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanRolloverv2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanRolloverv2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanRolloverv2>>
>;
export type PostApiLoanRolloverv2MutationBody = RolloverRequestDtoBody;
export type PostApiLoanRolloverv2MutationError = unknown;

export const usePostApiLoanRolloverv2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanRolloverv2>>,
      TError,
      { data: RolloverRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanRolloverv2>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanRolloverv2MutationOptions(options),
    queryClient
  );
};

export const getApiLoanDiscount = (
  params: GetApiLoanDiscountParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDiscountDto>(
    { url: `/api/loan/discount`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanDiscountQueryKey = (
  params?: GetApiLoanDiscountParams
) => {
  return [`/api/loan/discount`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanDiscountQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanDiscount>>,
  TError = unknown
>(
  params: GetApiLoanDiscountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanDiscountQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanDiscount>>
  > = ({ signal }) => getApiLoanDiscount(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanDiscount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanDiscountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanDiscount>>
>;
export type GetApiLoanDiscountQueryError = unknown;

export function useGetApiLoanDiscount<
  TData = Awaited<ReturnType<typeof getApiLoanDiscount>>,
  TError = unknown
>(
  params: GetApiLoanDiscountParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscount>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanDiscount>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanDiscount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanDiscount<
  TData = Awaited<ReturnType<typeof getApiLoanDiscount>>,
  TError = unknown
>(
  params: GetApiLoanDiscountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscount>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanDiscount>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanDiscount>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanDiscount<
  TData = Awaited<ReturnType<typeof getApiLoanDiscount>>,
  TError = unknown
>(
  params: GetApiLoanDiscountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanDiscount<
  TData = Awaited<ReturnType<typeof getApiLoanDiscount>>,
  TError = unknown
>(
  params: GetApiLoanDiscountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscount>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanDiscountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanCustomerAddedAccountsAfterScrape = (
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultRTBFurtherBankAccountScrapeResultDto>(
    {
      url: `/api/loan/customerAddedAccountsAfterScrape`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanCustomerAddedAccountsAfterScrapeQueryKey = (
  params?: GetApiLoanCustomerAddedAccountsAfterScrapeParams
) => {
  return [
    `/api/loan/customerAddedAccountsAfterScrape`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanCustomerAddedAccountsAfterScrapeQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
  >,
  TError = unknown
>(
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanCustomerAddedAccountsAfterScrapeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>
  > = ({ signal }) =>
    getApiLoanCustomerAddedAccountsAfterScrape(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerAddedAccountsAfterScrapeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>
>;
export type GetApiLoanCustomerAddedAccountsAfterScrapeQueryError = unknown;

export function useGetApiLoanCustomerAddedAccountsAfterScrape<
  TData = Awaited<
    ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
  >,
  TError = unknown
>(
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
          >,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAddedAccountsAfterScrape<
  TData = Awaited<
    ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
  >,
  TError = unknown
>(
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
          >,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAddedAccountsAfterScrape<
  TData = Awaited<
    ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
  >,
  TError = unknown
>(
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerAddedAccountsAfterScrape<
  TData = Awaited<
    ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>
  >,
  TError = unknown
>(
  params: GetApiLoanCustomerAddedAccountsAfterScrapeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAddedAccountsAfterScrape>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanCustomerAddedAccountsAfterScrapeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCheckGetALoanByRestructured = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/checkGetALoanByRestructured`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanCheckGetALoanByRestructuredMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanCheckGetALoanByRestructured"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>,
    void
  > = () => {
    return postApiLoanCheckGetALoanByRestructured(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCheckGetALoanByRestructuredMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>
>;

export type PostApiLoanCheckGetALoanByRestructuredMutationError = unknown;

export const usePostApiLoanCheckGetALoanByRestructured = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCheckGetALoanByRestructured>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanCheckGetALoanByRestructuredMutationOptions(options),
    queryClient
  );
};

export const postApiLoanGetLoanPurpose = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDefinationPurpose>(
    { url: `/api/loan/getLoanPurpose`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanGetLoanPurposeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanGetLoanPurpose"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>,
    void
  > = () => {
    return postApiLoanGetLoanPurpose(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetLoanPurposeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>
>;

export type PostApiLoanGetLoanPurposeMutationError = unknown;

export const usePostApiLoanGetLoanPurpose = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetLoanPurpose>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanGetLoanPurposeMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCalculateInstallmentPaymentAmounts = (
  calculateInstallmentPaymentAmountsTestEndpointRequestDto: CalculateInstallmentPaymentAmountsTestEndpointRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCalculateInstallmentPaymentAmountsResponseDto>(
    {
      url: `/api/loan/calculateInstallmentPaymentAmounts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: calculateInstallmentPaymentAmountsTestEndpointRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanCalculateInstallmentPaymentAmountsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>,
    TError,
    { data: CalculateInstallmentPaymentAmountsTestEndpointRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>,
  TError,
  { data: CalculateInstallmentPaymentAmountsTestEndpointRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanCalculateInstallmentPaymentAmounts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>,
    { data: CalculateInstallmentPaymentAmountsTestEndpointRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCalculateInstallmentPaymentAmounts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCalculateInstallmentPaymentAmountsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>
  >;
export type PostApiLoanCalculateInstallmentPaymentAmountsMutationBody =
  CalculateInstallmentPaymentAmountsTestEndpointRequestDto;
export type PostApiLoanCalculateInstallmentPaymentAmountsMutationError =
  unknown;

export const usePostApiLoanCalculateInstallmentPaymentAmounts = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>,
      TError,
      { data: CalculateInstallmentPaymentAmountsTestEndpointRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCalculateInstallmentPaymentAmounts>>,
  TError,
  { data: CalculateInstallmentPaymentAmountsTestEndpointRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanCalculateInstallmentPaymentAmountsMutationOptions(options),
    queryClient
  );
};

export const postApiLoanGetEligibleProductsOfCustomers = (
  params: PostApiLoanGetEligibleProductsOfCustomersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecisionDto>(
    {
      url: `/api/loan/getEligibleProductsOfCustomers`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanGetEligibleProductsOfCustomersMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>,
    TError,
    { params: PostApiLoanGetEligibleProductsOfCustomersParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>,
  TError,
  { params: PostApiLoanGetEligibleProductsOfCustomersParams },
  TContext
> => {
  const mutationKey = ["postApiLoanGetEligibleProductsOfCustomers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>,
    { params: PostApiLoanGetEligibleProductsOfCustomersParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanGetEligibleProductsOfCustomers(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetEligibleProductsOfCustomersMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>
  >;

export type PostApiLoanGetEligibleProductsOfCustomersMutationError = unknown;

export const usePostApiLoanGetEligibleProductsOfCustomers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>,
      TError,
      { params: PostApiLoanGetEligibleProductsOfCustomersParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetEligibleProductsOfCustomers>>,
  TError,
  { params: PostApiLoanGetEligibleProductsOfCustomersParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetEligibleProductsOfCustomersMutationOptions(options),
    queryClient
  );
};

export const postApiLoanUpdateCreatedDatesWithIssueDates = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/updateCreatedDatesWithIssueDates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanUpdateCreatedDatesWithIssueDatesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiLoanUpdateCreatedDatesWithIssueDates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanUpdateCreatedDatesWithIssueDates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUpdateCreatedDatesWithIssueDatesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>
  >;
export type PostApiLoanUpdateCreatedDatesWithIssueDatesMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanUpdateCreatedDatesWithIssueDatesMutationError = unknown;

export const usePostApiLoanUpdateCreatedDatesWithIssueDates = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUpdateCreatedDatesWithIssueDates>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanUpdateCreatedDatesWithIssueDatesMutationOptions(options),
    queryClient
  );
};

export const postApiLoanUpdateIssuedDateOfLoan = (
  params: PostApiLoanUpdateIssuedDateOfLoanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/updateIssuedDateOfLoan`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanUpdateIssuedDateOfLoanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>,
    TError,
    { params: PostApiLoanUpdateIssuedDateOfLoanParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>,
  TError,
  { params: PostApiLoanUpdateIssuedDateOfLoanParams },
  TContext
> => {
  const mutationKey = ["postApiLoanUpdateIssuedDateOfLoan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>,
    { params: PostApiLoanUpdateIssuedDateOfLoanParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanUpdateIssuedDateOfLoan(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUpdateIssuedDateOfLoanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>
>;

export type PostApiLoanUpdateIssuedDateOfLoanMutationError = unknown;

export const usePostApiLoanUpdateIssuedDateOfLoan = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>,
      TError,
      { params: PostApiLoanUpdateIssuedDateOfLoanParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUpdateIssuedDateOfLoan>>,
  TError,
  { params: PostApiLoanUpdateIssuedDateOfLoanParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanUpdateIssuedDateOfLoanMutationOptions(options),
    queryClient
  );
};

export const postApiLoanMurselTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/murselTest`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanMurselTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanMurselTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanMurselTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanMurselTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanMurselTest>>,
    void
  > = () => {
    return postApiLoanMurselTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanMurselTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanMurselTest>>
>;

export type PostApiLoanMurselTestMutationError = unknown;

export const usePostApiLoanMurselTest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanMurselTest>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanMurselTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanMurselTestMutationOptions(options),
    queryClient
  );
};

export const postApiLoanLoanInstallmentWithStatussesForAutomationTesting = (
  testAutomationDtoBody: TestAutomationDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/LoanInstallmentWithStatussesForAutomationTesting`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: testAutomationDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanLoanInstallmentWithStatussesForAutomationTestingMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
        >
      >,
      TError,
      { data: TestAutomationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
      >
    >,
    TError,
    { data: TestAutomationDtoBody },
    TContext
  > => {
    const mutationKey = [
      "postApiLoanLoanInstallmentWithStatussesForAutomationTesting",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
        >
      >,
      { data: TestAutomationDtoBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLoanLoanInstallmentWithStatussesForAutomationTesting(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanLoanInstallmentWithStatussesForAutomationTestingMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
      >
    >
  >;
export type PostApiLoanLoanInstallmentWithStatussesForAutomationTestingMutationBody =
  TestAutomationDtoBody;
export type PostApiLoanLoanInstallmentWithStatussesForAutomationTestingMutationError =
  unknown;

export const usePostApiLoanLoanInstallmentWithStatussesForAutomationTesting = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
        >
      >,
      TError,
      { data: TestAutomationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof postApiLoanLoanInstallmentWithStatussesForAutomationTesting
    >
  >,
  TError,
  { data: TestAutomationDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanLoanInstallmentWithStatussesForAutomationTestingMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiLoanUpdatePaymentForAutomationTesting = (
  testAutomationDtoBody: TestAutomationDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/updatePaymentForAutomationTesting`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: testAutomationDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanUpdatePaymentForAutomationTestingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>,
    TError,
    { data: TestAutomationDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>,
  TError,
  { data: TestAutomationDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanUpdatePaymentForAutomationTesting"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>,
    { data: TestAutomationDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanUpdatePaymentForAutomationTesting(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUpdatePaymentForAutomationTestingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>
  >;
export type PostApiLoanUpdatePaymentForAutomationTestingMutationBody =
  TestAutomationDtoBody;
export type PostApiLoanUpdatePaymentForAutomationTestingMutationError = unknown;

export const usePostApiLoanUpdatePaymentForAutomationTesting = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>,
      TError,
      { data: TestAutomationDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUpdatePaymentForAutomationTesting>>,
  TError,
  { data: TestAutomationDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanUpdatePaymentForAutomationTestingMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCallApiForLimitUpdateAfterPaymentV2 = (
  params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScoreForLimitUpdateAfterPaymentV2Dto>(
    {
      url: `/api/loan/callApiForLimitUpdateAfterPaymentV2`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanCallApiForLimitUpdateAfterPaymentV2MutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>
      >,
      TError,
      { params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>>,
    TError,
    { params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params },
    TContext
  > => {
    const mutationKey = ["postApiLoanCallApiForLimitUpdateAfterPaymentV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>
      >,
      { params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params }
    > = (props) => {
      const { params } = props ?? {};

      return postApiLoanCallApiForLimitUpdateAfterPaymentV2(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanCallApiForLimitUpdateAfterPaymentV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>>
  >;

export type PostApiLoanCallApiForLimitUpdateAfterPaymentV2MutationError =
  unknown;

export const usePostApiLoanCallApiForLimitUpdateAfterPaymentV2 = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>
      >,
      TError,
      { params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCallApiForLimitUpdateAfterPaymentV2>>,
  TError,
  { params: PostApiLoanCallApiForLimitUpdateAfterPaymentV2Params },
  TContext
> => {
  return useMutation(
    getPostApiLoanCallApiForLimitUpdateAfterPaymentV2MutationOptions(options),
    queryClient
  );
};

export const postApiLoanLimitCalculate = (
  calculateNewLimitRequestDto: CalculateNewLimitRequestDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCalculateNewLimitResponseDto>(
    {
      url: `/api/loan/LimitCalculate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: calculateNewLimitRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanLimitCalculateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanLimitCalculate>>,
    TError,
    { data: CalculateNewLimitRequestDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanLimitCalculate>>,
  TError,
  { data: CalculateNewLimitRequestDto[] },
  TContext
> => {
  const mutationKey = ["postApiLoanLimitCalculate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanLimitCalculate>>,
    { data: CalculateNewLimitRequestDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanLimitCalculate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanLimitCalculateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanLimitCalculate>>
>;
export type PostApiLoanLimitCalculateMutationBody =
  CalculateNewLimitRequestDto[];
export type PostApiLoanLimitCalculateMutationError = unknown;

export const usePostApiLoanLimitCalculate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanLimitCalculate>>,
      TError,
      { data: CalculateNewLimitRequestDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanLimitCalculate>>,
  TError,
  { data: CalculateNewLimitRequestDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLoanLimitCalculateMutationOptions(options),
    queryClient
  );
};

export const postApiLoanUploadLoansAgreementS3Job = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiLoanUploadLoansAgreementS3JobParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/loan/UploadLoansAgreementS3Job`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanUploadLoansAgreementS3JobMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiLoanUploadLoansAgreementS3JobParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiLoanUploadLoansAgreementS3JobParams;
  },
  TContext
> => {
  const mutationKey = ["postApiLoanUploadLoansAgreementS3Job"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiLoanUploadLoansAgreementS3JobParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanUploadLoansAgreementS3Job(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUploadLoansAgreementS3JobMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>
>;
export type PostApiLoanUploadLoansAgreementS3JobMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanUploadLoansAgreementS3JobMutationError = unknown;

export const usePostApiLoanUploadLoansAgreementS3Job = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiLoanUploadLoansAgreementS3JobParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUploadLoansAgreementS3Job>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiLoanUploadLoansAgreementS3JobParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiLoanUploadLoansAgreementS3JobMutationOptions(options),
    queryClient
  );
};

export const getApiLoanOcrOSIR = (
  params: GetApiLoanOcrOSIRParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/loan/ocrOSIR`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanOcrOSIRQueryKey = (
  params?: GetApiLoanOcrOSIRParams
) => {
  return [`/api/loan/ocrOSIR`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanOcrOSIRQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
  TError = unknown
>(
  params: GetApiLoanOcrOSIRParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanOcrOSIRQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanOcrOSIR>>
  > = ({ signal }) => getApiLoanOcrOSIR(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanOcrOSIRQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanOcrOSIR>>
>;
export type GetApiLoanOcrOSIRQueryError = unknown;

export function useGetApiLoanOcrOSIR<
  TData = Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
  TError = unknown
>(
  params: GetApiLoanOcrOSIRParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanOcrOSIR>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanOcrOSIR<
  TData = Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
  TError = unknown
>(
  params: GetApiLoanOcrOSIRParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanOcrOSIR>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanOcrOSIR<
  TData = Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
  TError = unknown
>(
  params: GetApiLoanOcrOSIRParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanOcrOSIR<
  TData = Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
  TError = unknown
>(
  params: GetApiLoanOcrOSIRParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOcrOSIR>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanOcrOSIRQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanPrescrape = (
  params: PostApiLoanPrescrapeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<PreScrapeViewModel>(
    { url: `/api/loan/prescrape`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanPrescrapeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPrescrape>>,
    TError,
    { params: PostApiLoanPrescrapeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPrescrape>>,
  TError,
  { params: PostApiLoanPrescrapeParams },
  TContext
> => {
  const mutationKey = ["postApiLoanPrescrape"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPrescrape>>,
    { params: PostApiLoanPrescrapeParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanPrescrape(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPrescrapeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPrescrape>>
>;

export type PostApiLoanPrescrapeMutationError = unknown;

export const usePostApiLoanPrescrape = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPrescrape>>,
      TError,
      { params: PostApiLoanPrescrapeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPrescrape>>,
  TError,
  { params: PostApiLoanPrescrapeParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanPrescrapeMutationOptions(options),
    queryClient
  );
};

export const getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months = (
  params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/loan/SendReviewEmailIfDoNotSendEmailLast6Months`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryKey = (
  params?: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams
) => {
  return [
    `/api/loan/SendReviewEmailIfDoNotSendEmailLast6Months`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
    >,
    TError = unknown
  >(
    params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
      >
    > = ({ signal }) =>
      getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
    >
  >;
export type GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryError =
  unknown;

export function useGetApiLoanSendReviewEmailIfDoNotSendEmailLast6Months<
  TData = Awaited<
    ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
  >,
  TError = unknown
>(
  params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSendReviewEmailIfDoNotSendEmailLast6Months<
  TData = Awaited<
    ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
  >,
  TError = unknown
>(
  params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSendReviewEmailIfDoNotSendEmailLast6Months<
  TData = Awaited<
    ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
  >,
  TError = unknown
>(
  params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanSendReviewEmailIfDoNotSendEmailLast6Months<
  TData = Awaited<
    ReturnType<typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months>
  >,
  TError = unknown
>(
  params: GetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiLoanSendReviewEmailIfDoNotSendEmailLast6Months
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanSendReviewEmailIfDoNotSendEmailLast6MonthsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanGetPaymentOptions = (
  params: PostApiLoanGetPaymentOptionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListOptionalPaymentDto>(
    { url: `/api/loan/getPaymentOptions`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanGetPaymentOptionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>,
    TError,
    { params: PostApiLoanGetPaymentOptionsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>,
  TError,
  { params: PostApiLoanGetPaymentOptionsParams },
  TContext
> => {
  const mutationKey = ["postApiLoanGetPaymentOptions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>,
    { params: PostApiLoanGetPaymentOptionsParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanGetPaymentOptions(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetPaymentOptionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>
>;

export type PostApiLoanGetPaymentOptionsMutationError = unknown;

export const usePostApiLoanGetPaymentOptions = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>,
      TError,
      { params: PostApiLoanGetPaymentOptionsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetPaymentOptions>>,
  TError,
  { params: PostApiLoanGetPaymentOptionsParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetPaymentOptionsMutationOptions(options),
    queryClient
  );
};

export const postApiLoanTest123 = (
  params: PostApiLoanTest123Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    { url: `/api/loan/test123`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanTest123MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanTest123>>,
    TError,
    { params: PostApiLoanTest123Params },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanTest123>>,
  TError,
  { params: PostApiLoanTest123Params },
  TContext
> => {
  const mutationKey = ["postApiLoanTest123"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanTest123>>,
    { params: PostApiLoanTest123Params }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanTest123(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanTest123MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanTest123>>
>;

export type PostApiLoanTest123MutationError = unknown;

export const usePostApiLoanTest123 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanTest123>>,
      TError,
      { params: PostApiLoanTest123Params },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanTest123>>,
  TError,
  { params: PostApiLoanTest123Params },
  TContext
> => {
  return useMutation(
    getPostApiLoanTest123MutationOptions(options),
    queryClient
  );
};

export const postApiLoanUploadCalculationExcel = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLoanUploadCalculationExcel200One
    | PostApiLoanUploadCalculationExcel200Two
    | Blob
  >(
    { url: `/api/loan/uploadCalculationExcel`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanUploadCalculationExcelMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanUploadCalculationExcel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>,
    void
  > = () => {
    return postApiLoanUploadCalculationExcel(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUploadCalculationExcelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>
>;

export type PostApiLoanUploadCalculationExcelMutationError = unknown;

export const usePostApiLoanUploadCalculationExcel = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUploadCalculationExcel>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanUploadCalculationExcelMutationOptions(options),
    queryClient
  );
};

export const getApiLoanTest4444 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/loan/test4444`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanTest4444QueryKey = () => {
  return [`/api/loan/test4444`] as const;
};

export const getGetApiLoanTest4444QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanTest4444>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanTest4444>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLoanTest4444QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanTest4444>>
  > = ({ signal }) => getApiLoanTest4444(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanTest4444>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanTest4444QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanTest4444>>
>;
export type GetApiLoanTest4444QueryError = unknown;

export function useGetApiLoanTest4444<
  TData = Awaited<ReturnType<typeof getApiLoanTest4444>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTest4444>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTest4444>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTest4444>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTest4444<
  TData = Awaited<ReturnType<typeof getApiLoanTest4444>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTest4444>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTest4444>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTest4444>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTest4444<
  TData = Awaited<ReturnType<typeof getApiLoanTest4444>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTest4444>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanTest4444<
  TData = Awaited<ReturnType<typeof getApiLoanTest4444>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTest4444>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanTest4444QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanSetissuedTest = (
  params: GetApiLoanSetissuedTestParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/loan/SetissuedTest`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanSetissuedTestQueryKey = (
  params?: GetApiLoanSetissuedTestParams
) => {
  return [`/api/loan/SetissuedTest`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanSetissuedTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
  TError = unknown
>(
  params: GetApiLoanSetissuedTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanSetissuedTestQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanSetissuedTest>>
  > = ({ signal }) => getApiLoanSetissuedTest(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanSetissuedTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanSetissuedTest>>
>;
export type GetApiLoanSetissuedTestQueryError = unknown;

export function useGetApiLoanSetissuedTest<
  TData = Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
  TError = unknown
>(
  params: GetApiLoanSetissuedTestParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanSetissuedTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSetissuedTest<
  TData = Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
  TError = unknown
>(
  params: GetApiLoanSetissuedTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanSetissuedTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSetissuedTest<
  TData = Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
  TError = unknown
>(
  params: GetApiLoanSetissuedTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanSetissuedTest<
  TData = Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
  TError = unknown
>(
  params: GetApiLoanSetissuedTestParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSetissuedTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanSetissuedTestQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanCreateChargebackResponseFile = (
  params?: GetApiLoanCreateChargebackResponseFileParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/loan/CreateChargebackResponseFile`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanCreateChargebackResponseFileQueryKey = (
  params?: GetApiLoanCreateChargebackResponseFileParams
) => {
  return [
    `/api/loan/CreateChargebackResponseFile`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanCreateChargebackResponseFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
  TError = unknown
>(
  params?: GetApiLoanCreateChargebackResponseFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanCreateChargebackResponseFileQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>
  > = ({ signal }) =>
    getApiLoanCreateChargebackResponseFile(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCreateChargebackResponseFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>
>;
export type GetApiLoanCreateChargebackResponseFileQueryError = unknown;

export function useGetApiLoanCreateChargebackResponseFile<
  TData = Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
  TError = unknown
>(
  params: undefined | GetApiLoanCreateChargebackResponseFileParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreateChargebackResponseFile<
  TData = Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
  TError = unknown
>(
  params?: GetApiLoanCreateChargebackResponseFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreateChargebackResponseFile<
  TData = Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
  TError = unknown
>(
  params?: GetApiLoanCreateChargebackResponseFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCreateChargebackResponseFile<
  TData = Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
  TError = unknown
>(
  params?: GetApiLoanCreateChargebackResponseFileParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateChargebackResponseFile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCreateChargebackResponseFileQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanGetLoansReasonByCustomerIdCustomerId = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanReasonDto>(
    {
      url: `/api/loan/getLoansReasonByCustomerId/${customerId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryKey = (
  customerId: number
) => {
  return [`/api/loan/getLoansReasonByCustomerId/${customerId}`] as const;
};

export const getGetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryKey(customerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>>
  > = ({ signal }) =>
    getApiLoanGetLoansReasonByCustomerIdCustomerId(
      customerId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>>
  >;
export type GetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryError = unknown;

export function useGetApiLoanGetLoansReasonByCustomerIdCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetLoansReasonByCustomerIdCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetLoansReasonByCustomerIdCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetLoansReasonByCustomerIdCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetLoansReasonByCustomerIdCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanGetLoansReasonByCustomerIdCustomerIdQueryOptions(
      customerId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanGetRepaidLoansCountResultCustomerId = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/getRepaidLoansCountResult/${customerId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLoanGetRepaidLoansCountResultCustomerIdQueryKey = (
  customerId: number
) => {
  return [`/api/loan/getRepaidLoansCountResult/${customerId}`] as const;
};

export const getGetApiLoanGetRepaidLoansCountResultCustomerIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanGetRepaidLoansCountResultCustomerIdQueryKey(customerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>>
  > = ({ signal }) =>
    getApiLoanGetRepaidLoansCountResultCustomerId(
      customerId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetRepaidLoansCountResultCustomerIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>>
  >;
export type GetApiLoanGetRepaidLoansCountResultCustomerIdQueryError = unknown;

export function useGetApiLoanGetRepaidLoansCountResultCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetRepaidLoansCountResultCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetRepaidLoansCountResultCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetRepaidLoansCountResultCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
  >,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanGetRepaidLoansCountResultCustomerId>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanGetRepaidLoansCountResultCustomerIdQueryOptions(
      customerId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanBulkPaymentsForCollectionCompanies = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/loan/bulkPaymentsForCollectionCompanies`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLoanBulkPaymentsForCollectionCompaniesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanBulkPaymentsForCollectionCompanies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>,
    void
  > = () => {
    return postApiLoanBulkPaymentsForCollectionCompanies(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanBulkPaymentsForCollectionCompaniesMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>
  >;

export type PostApiLoanBulkPaymentsForCollectionCompaniesMutationError =
  unknown;

export const usePostApiLoanBulkPaymentsForCollectionCompanies = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanBulkPaymentsForCollectionCompanies>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanBulkPaymentsForCollectionCompaniesMutationOptions(options),
    queryClient
  );
};

export const getApiLoanArrangementHistoryLoanId = (
  loanId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultArrangementHistoryListDto>(
    { url: `/api/loan/arrangementHistory/${loanId}`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanArrangementHistoryLoanIdQueryKey = (
  loanId: number
) => {
  return [`/api/loan/arrangementHistory/${loanId}`] as const;
};

export const getGetApiLoanArrangementHistoryLoanIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanArrangementHistoryLoanIdQueryKey(loanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>
  > = ({ signal }) =>
    getApiLoanArrangementHistoryLoanId(loanId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!loanId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanArrangementHistoryLoanIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>
>;
export type GetApiLoanArrangementHistoryLoanIdQueryError = unknown;

export function useGetApiLoanArrangementHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanArrangementHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanArrangementHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanArrangementHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanArrangementHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanArrangementHistoryLoanIdQueryOptions(
    loanId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanDiscountHistoryLoanId = (
  loanId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDiscountHistoryListDto>(
    { url: `/api/loan/discountHistory/${loanId}`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanDiscountHistoryLoanIdQueryKey = (loanId: number) => {
  return [`/api/loan/discountHistory/${loanId}`] as const;
};

export const getGetApiLoanDiscountHistoryLoanIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanDiscountHistoryLoanIdQueryKey(loanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>
  > = ({ signal }) =>
    getApiLoanDiscountHistoryLoanId(loanId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!loanId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanDiscountHistoryLoanIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>
>;
export type GetApiLoanDiscountHistoryLoanIdQueryError = unknown;

export function useGetApiLoanDiscountHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanDiscountHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanDiscountHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanDiscountHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanDiscountHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanDiscountHistoryLoanIdQueryOptions(
    loanId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCanGetMultipleLoanDecisionTest = (
  loanCanGetMultipleLoanDecisionTestCustomeridBody: LoanCanGetMultipleLoanDecisionTestCustomeridBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCanGetMultipleLoanDecisionResultDto>(
    {
      url: `/api/loan/canGetMultipleLoanDecisionTest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanCanGetMultipleLoanDecisionTestCustomeridBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanCanGetMultipleLoanDecisionTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>,
    TError,
    { data: LoanCanGetMultipleLoanDecisionTestCustomeridBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>,
  TError,
  { data: LoanCanGetMultipleLoanDecisionTestCustomeridBody },
  TContext
> => {
  const mutationKey = ["postApiLoanCanGetMultipleLoanDecisionTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>,
    { data: LoanCanGetMultipleLoanDecisionTestCustomeridBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCanGetMultipleLoanDecisionTest(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCanGetMultipleLoanDecisionTestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>
  >;
export type PostApiLoanCanGetMultipleLoanDecisionTestMutationBody =
  LoanCanGetMultipleLoanDecisionTestCustomeridBody;
export type PostApiLoanCanGetMultipleLoanDecisionTestMutationError = unknown;

export const usePostApiLoanCanGetMultipleLoanDecisionTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>,
      TError,
      { data: LoanCanGetMultipleLoanDecisionTestCustomeridBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCanGetMultipleLoanDecisionTest>>,
  TError,
  { data: LoanCanGetMultipleLoanDecisionTestCustomeridBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanCanGetMultipleLoanDecisionTestMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCalculateDesistContractPlannedAmount = (
  calculateDesistContractPlannedAmountRequestDto: CalculateDesistContractPlannedAmountRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCalculateDesistContractPlannedAmountResponseDto>(
    {
      url: `/api/loan/calculateDesistContractPlannedAmount`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: calculateDesistContractPlannedAmountRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanCalculateDesistContractPlannedAmountMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>
      >,
      TError,
      { data: CalculateDesistContractPlannedAmountRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>>,
    TError,
    { data: CalculateDesistContractPlannedAmountRequestDto },
    TContext
  > => {
    const mutationKey = ["postApiLoanCalculateDesistContractPlannedAmount"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>
      >,
      { data: CalculateDesistContractPlannedAmountRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLoanCalculateDesistContractPlannedAmount(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanCalculateDesistContractPlannedAmountMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>>
  >;
export type PostApiLoanCalculateDesistContractPlannedAmountMutationBody =
  CalculateDesistContractPlannedAmountRequestDto;
export type PostApiLoanCalculateDesistContractPlannedAmountMutationError =
  unknown;

export const usePostApiLoanCalculateDesistContractPlannedAmount = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>
      >,
      TError,
      { data: CalculateDesistContractPlannedAmountRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCalculateDesistContractPlannedAmount>>,
  TError,
  { data: CalculateDesistContractPlannedAmountRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanCalculateDesistContractPlannedAmountMutationOptions(options),
    queryClient
  );
};

export const postApiLoanPopulateLoanBasedDocuments = (
  populateLoanBasedDocumentsRequestDto: PopulateLoanBasedDocumentsRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPopulateLoanBasedDocumentsResponseDto>(
    {
      url: `/api/loan/populateLoanBasedDocuments`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: populateLoanBasedDocumentsRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanPopulateLoanBasedDocumentsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>,
    TError,
    { data: PopulateLoanBasedDocumentsRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>,
  TError,
  { data: PopulateLoanBasedDocumentsRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanPopulateLoanBasedDocuments"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>,
    { data: PopulateLoanBasedDocumentsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanPopulateLoanBasedDocuments(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPopulateLoanBasedDocumentsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>
>;
export type PostApiLoanPopulateLoanBasedDocumentsMutationBody =
  PopulateLoanBasedDocumentsRequestDto;
export type PostApiLoanPopulateLoanBasedDocumentsMutationError = unknown;

export const usePostApiLoanPopulateLoanBasedDocuments = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>,
      TError,
      { data: PopulateLoanBasedDocumentsRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPopulateLoanBasedDocuments>>,
  TError,
  { data: PopulateLoanBasedDocumentsRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanPopulateLoanBasedDocumentsMutationOptions(options),
    queryClient
  );
};

export const getApiLoanCustomerAllLoansLight = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerLoansLightResponseDto>(
    { url: `/api/loan/customerAllLoansLight`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanCustomerAllLoansLightQueryKey = () => {
  return [`/api/loan/customerAllLoansLight`] as const;
};

export const getGetApiLoanCustomerAllLoansLightQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanCustomerAllLoansLightQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>
  > = ({ signal }) => getApiLoanCustomerAllLoansLight(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerAllLoansLightQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>
>;
export type GetApiLoanCustomerAllLoansLightQueryError = unknown;

export function useGetApiLoanCustomerAllLoansLight<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAllLoansLight<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAllLoansLight<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerAllLoansLight<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoansLight>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCustomerAllLoansLightQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanAgreementParameters = (
  loanDtoBody: LoanDtoBody,
  params?: PostApiLoanAgreementParametersParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanAgreementData>(
    {
      url: `/api/loan/agreement/parameters`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanDtoBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanAgreementParametersMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAgreementParameters>>,
    TError,
    { data: LoanDtoBody; params?: PostApiLoanAgreementParametersParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAgreementParameters>>,
  TError,
  { data: LoanDtoBody; params?: PostApiLoanAgreementParametersParams },
  TContext
> => {
  const mutationKey = ["postApiLoanAgreementParameters"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAgreementParameters>>,
    { data: LoanDtoBody; params?: PostApiLoanAgreementParametersParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanAgreementParameters(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAgreementParametersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAgreementParameters>>
>;
export type PostApiLoanAgreementParametersMutationBody = LoanDtoBody;
export type PostApiLoanAgreementParametersMutationError = unknown;

export const usePostApiLoanAgreementParameters = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAgreementParameters>>,
      TError,
      { data: LoanDtoBody; params?: PostApiLoanAgreementParametersParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAgreementParameters>>,
  TError,
  { data: LoanDtoBody; params?: PostApiLoanAgreementParametersParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanAgreementParametersMutationOptions(options),
    queryClient
  );
};

export const getApiLoanCreateLoanSign = (
  params: GetApiLoanCreateLoanSignParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/createLoanSign`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanCreateLoanSignQueryKey = (
  params?: GetApiLoanCreateLoanSignParams
) => {
  return [`/api/loan/createLoanSign`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanCreateLoanSignQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanCreateLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanCreateLoanSignQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>
  > = ({ signal }) => getApiLoanCreateLoanSign(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCreateLoanSignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>
>;
export type GetApiLoanCreateLoanSignQueryError = unknown;

export function useGetApiLoanCreateLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanCreateLoanSignParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreateLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanCreateLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCreateLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanCreateLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCreateLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanCreateLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCreateLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCreateLoanSignQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCheckedLoanSign = (
  loanSignDto: LoanSignDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/checkedLoanSign`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanSignDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanCheckedLoanSignMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>,
    TError,
    { data: LoanSignDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>,
  TError,
  { data: LoanSignDto },
  TContext
> => {
  const mutationKey = ["postApiLoanCheckedLoanSign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>,
    { data: LoanSignDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCheckedLoanSign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCheckedLoanSignMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>
>;
export type PostApiLoanCheckedLoanSignMutationBody = LoanSignDto;
export type PostApiLoanCheckedLoanSignMutationError = unknown;

export const usePostApiLoanCheckedLoanSign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>,
      TError,
      { data: LoanSignDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCheckedLoanSign>>,
  TError,
  { data: LoanSignDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanCheckedLoanSignMutationOptions(options),
    queryClient
  );
};

export const getApiLoanSendOtpLoanSign = (
  params: GetApiLoanSendOtpLoanSignParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/sendOtpLoanSign`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanSendOtpLoanSignQueryKey = (
  params?: GetApiLoanSendOtpLoanSignParams
) => {
  return [`/api/loan/sendOtpLoanSign`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanSendOtpLoanSignQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanSendOtpLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanSendOtpLoanSignQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>
  > = ({ signal }) => getApiLoanSendOtpLoanSign(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanSendOtpLoanSignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>
>;
export type GetApiLoanSendOtpLoanSignQueryError = unknown;

export function useGetApiLoanSendOtpLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanSendOtpLoanSignParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSendOtpLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanSendOtpLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanSendOtpLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanSendOtpLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanSendOtpLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanSendOtpLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanSendOtpLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanSendOtpLoanSignQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanOtpCheckLoanSign = (
  params: GetApiLoanOtpCheckLoanSignParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/otpCheckLoanSign`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanOtpCheckLoanSignQueryKey = (
  params?: GetApiLoanOtpCheckLoanSignParams
) => {
  return [`/api/loan/otpCheckLoanSign`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanOtpCheckLoanSignQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanOtpCheckLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanOtpCheckLoanSignQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>
  > = ({ signal }) =>
    getApiLoanOtpCheckLoanSign(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanOtpCheckLoanSignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>
>;
export type GetApiLoanOtpCheckLoanSignQueryError = unknown;

export function useGetApiLoanOtpCheckLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanOtpCheckLoanSignParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanOtpCheckLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanOtpCheckLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanOtpCheckLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanOtpCheckLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanOtpCheckLoanSign<
  TData = Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
  TError = unknown
>(
  params: GetApiLoanOtpCheckLoanSignParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanOtpCheckLoanSign>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanOtpCheckLoanSignQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanTransferDelayWarningCheck = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/transferDelayWarning/check`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanTransferDelayWarningCheckQueryKey = () => {
  return [`/api/loan/transferDelayWarning/check`] as const;
};

export const getGetApiLoanTransferDelayWarningCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanTransferDelayWarningCheckQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>
  > = ({ signal }) =>
    getApiLoanTransferDelayWarningCheck(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanTransferDelayWarningCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>
>;
export type GetApiLoanTransferDelayWarningCheckQueryError = unknown;

export function useGetApiLoanTransferDelayWarningCheck<
  TData = Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTransferDelayWarningCheck<
  TData = Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTransferDelayWarningCheck<
  TData = Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanTransferDelayWarningCheck<
  TData = Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTransferDelayWarningCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanTransferDelayWarningCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanTransferDelayWarning = (
  insertLoanWarningRequestDto: InsertLoanWarningRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/transferDelayWarning`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: insertLoanWarningRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanTransferDelayWarningMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>,
    TError,
    { data: InsertLoanWarningRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>,
  TError,
  { data: InsertLoanWarningRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanTransferDelayWarning"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>,
    { data: InsertLoanWarningRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanTransferDelayWarning(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanTransferDelayWarningMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>
>;
export type PostApiLoanTransferDelayWarningMutationBody =
  InsertLoanWarningRequestDto;
export type PostApiLoanTransferDelayWarningMutationError = unknown;

export const usePostApiLoanTransferDelayWarning = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>,
      TError,
      { data: InsertLoanWarningRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanTransferDelayWarning>>,
  TError,
  { data: InsertLoanWarningRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanTransferDelayWarningMutationOptions(options),
    queryClient
  );
};

export const getApiLoanIcHistory = (
  params: GetApiLoanIcHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInternalCollectionDto>(
    { url: `/api/loan/icHistory`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanIcHistoryQueryKey = (
  params?: GetApiLoanIcHistoryParams
) => {
  return [`/api/loan/icHistory`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanIcHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanIcHistory>>,
  TError = unknown
>(
  params: GetApiLoanIcHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanIcHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanIcHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanIcHistory>>
  > = ({ signal }) => getApiLoanIcHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanIcHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanIcHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanIcHistory>>
>;
export type GetApiLoanIcHistoryQueryError = unknown;

export function useGetApiLoanIcHistory<
  TData = Awaited<ReturnType<typeof getApiLoanIcHistory>>,
  TError = unknown
>(
  params: GetApiLoanIcHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanIcHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanIcHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanIcHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanIcHistory<
  TData = Awaited<ReturnType<typeof getApiLoanIcHistory>>,
  TError = unknown
>(
  params: GetApiLoanIcHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanIcHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanIcHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanIcHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanIcHistory<
  TData = Awaited<ReturnType<typeof getApiLoanIcHistory>>,
  TError = unknown
>(
  params: GetApiLoanIcHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanIcHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanIcHistory<
  TData = Awaited<ReturnType<typeof getApiLoanIcHistory>>,
  TError = unknown
>(
  params: GetApiLoanIcHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanIcHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanIcHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoanStatusHistoryLoanId = (
  loanId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanStatusDto>(
    { url: `/api/loan/loanStatusHistory/${loanId}`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanLoanStatusHistoryLoanIdQueryKey = (
  loanId: number
) => {
  return [`/api/loan/loanStatusHistory/${loanId}`] as const;
};

export const getGetApiLoanLoanStatusHistoryLoanIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanLoanStatusHistoryLoanIdQueryKey(loanId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>
  > = ({ signal }) =>
    getApiLoanLoanStatusHistoryLoanId(loanId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!loanId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanStatusHistoryLoanIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>
>;
export type GetApiLoanLoanStatusHistoryLoanIdQueryError = unknown;

export function useGetApiLoanLoanStatusHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanStatusHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanStatusHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanStatusHistoryLoanId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
  TError = unknown
>(
  loanId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanStatusHistoryLoanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanStatusHistoryLoanIdQueryOptions(
    loanId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanGetApplicationDetailsOfCustomerId = (
  id: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanApplicationDetailDto>(
    {
      url: `/api/loan/getApplicationDetailsOfCustomer/${id}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLoanGetApplicationDetailsOfCustomerIdQueryKey = (
  id: number
) => {
  return [`/api/loan/getApplicationDetailsOfCustomer/${id}`] as const;
};

export const getGetApiLoanGetApplicationDetailsOfCustomerIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
  >,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanGetApplicationDetailsOfCustomerIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>
  > = ({ signal }) =>
    getApiLoanGetApplicationDetailsOfCustomerId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetApplicationDetailsOfCustomerIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>
  >;
export type GetApiLoanGetApplicationDetailsOfCustomerIdQueryError = unknown;

export function useGetApiLoanGetApplicationDetailsOfCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
  >,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetApplicationDetailsOfCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
  >,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetApplicationDetailsOfCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
  >,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetApplicationDetailsOfCustomerId<
  TData = Awaited<
    ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>
  >,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetApplicationDetailsOfCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanGetApplicationDetailsOfCustomerIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiLoanHolliday = (
  hollidayDtoBody: HollidayDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/holliday`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: hollidayDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiLoanHollidayMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanHolliday>>,
    TError,
    { data: HollidayDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanHolliday>>,
  TError,
  { data: HollidayDtoBody },
  TContext
> => {
  const mutationKey = ["putApiLoanHolliday"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanHolliday>>,
    { data: HollidayDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiLoanHolliday(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanHollidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanHolliday>>
>;
export type PutApiLoanHollidayMutationBody = HollidayDtoBody;
export type PutApiLoanHollidayMutationError = unknown;

export const usePutApiLoanHolliday = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanHolliday>>,
      TError,
      { data: HollidayDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanHolliday>>,
  TError,
  { data: HollidayDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiLoanHollidayMutationOptions(options),
    queryClient
  );
};

export const postApiLoanHolliday = (
  hollidayDtoBody: HollidayDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/holliday`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: hollidayDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanHollidayMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanHolliday>>,
    TError,
    { data: HollidayDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanHolliday>>,
  TError,
  { data: HollidayDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanHolliday"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanHolliday>>,
    { data: HollidayDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanHolliday(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanHollidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanHolliday>>
>;
export type PostApiLoanHollidayMutationBody = HollidayDtoBody;
export type PostApiLoanHollidayMutationError = unknown;

export const usePostApiLoanHolliday = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanHolliday>>,
      TError,
      { data: HollidayDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanHolliday>>,
  TError,
  { data: HollidayDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanHollidayMutationOptions(options),
    queryClient
  );
};

export const deleteApiLoanHolliday = (
  params: DeleteApiLoanHollidayParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/holliday`, method: "DELETE", params, signal },
    options
  );
};

export const getDeleteApiLoanHollidayMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiLoanHolliday>>,
    TError,
    { params: DeleteApiLoanHollidayParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiLoanHolliday>>,
  TError,
  { params: DeleteApiLoanHollidayParams },
  TContext
> => {
  const mutationKey = ["deleteApiLoanHolliday"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiLoanHolliday>>,
    { params: DeleteApiLoanHollidayParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiLoanHolliday(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiLoanHollidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiLoanHolliday>>
>;

export type DeleteApiLoanHollidayMutationError = unknown;

export const useDeleteApiLoanHolliday = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiLoanHolliday>>,
      TError,
      { params: DeleteApiLoanHollidayParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiLoanHolliday>>,
  TError,
  { params: DeleteApiLoanHollidayParams },
  TContext
> => {
  return useMutation(
    getDeleteApiLoanHollidayMutationOptions(options),
    queryClient
  );
};

export const getApiLoanHollidays = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListDateTime>(
    { url: `/api/loan/hollidays`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanHollidaysQueryKey = () => {
  return [`/api/loan/hollidays`] as const;
};

export const getGetApiLoanHollidaysQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanHollidays>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanHollidays>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLoanHollidaysQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanHollidays>>
  > = ({ signal }) => getApiLoanHollidays(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanHollidays>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanHollidaysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanHollidays>>
>;
export type GetApiLoanHollidaysQueryError = unknown;

export function useGetApiLoanHollidays<
  TData = Awaited<ReturnType<typeof getApiLoanHollidays>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanHollidays>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanHollidays>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanHollidays>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanHollidays<
  TData = Awaited<ReturnType<typeof getApiLoanHollidays>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanHollidays>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanHollidays>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanHollidays>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanHollidays<
  TData = Awaited<ReturnType<typeof getApiLoanHollidays>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanHollidays>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanHollidays<
  TData = Awaited<ReturnType<typeof getApiLoanHollidays>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanHollidays>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanHollidaysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoanAgreementData = (
  params: GetApiLoanLoanAgreementDataParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanAgreementData>(
    { url: `/api/loan/loanAgreementData`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanAgreementDataQueryKey = (
  params?: GetApiLoanLoanAgreementDataParams
) => {
  return [`/api/loan/loanAgreementData`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanLoanAgreementDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanLoanAgreementDataQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>
  > = ({ signal }) =>
    getApiLoanLoanAgreementData(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanAgreementDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>
>;
export type GetApiLoanLoanAgreementDataQueryError = unknown;

export function useGetApiLoanLoanAgreementData<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementDataParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanAgreementData<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanAgreementData<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanAgreementData<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementData>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanAgreementDataQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCreatePaymentHistoryPdf = (
  createPaymentHistoryExcelRequestBody: CreatePaymentHistoryExcelRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiLoanCreatePaymentHistoryPdf200One
    | PostApiLoanCreatePaymentHistoryPdf200Two
    | Blob
  >(
    {
      url: `/api/loan/CreatePaymentHistoryPdf`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createPaymentHistoryExcelRequestBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanCreatePaymentHistoryPdfMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>,
    TError,
    { data: CreatePaymentHistoryExcelRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>,
  TError,
  { data: CreatePaymentHistoryExcelRequestBody },
  TContext
> => {
  const mutationKey = ["postApiLoanCreatePaymentHistoryPdf"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>,
    { data: CreatePaymentHistoryExcelRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCreatePaymentHistoryPdf(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCreatePaymentHistoryPdfMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>
>;
export type PostApiLoanCreatePaymentHistoryPdfMutationBody =
  CreatePaymentHistoryExcelRequestBody;
export type PostApiLoanCreatePaymentHistoryPdfMutationError = unknown;

export const usePostApiLoanCreatePaymentHistoryPdf = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>,
      TError,
      { data: CreatePaymentHistoryExcelRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCreatePaymentHistoryPdf>>,
  TError,
  { data: CreatePaymentHistoryExcelRequestBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanCreatePaymentHistoryPdfMutationOptions(options),
    queryClient
  );
};

export const postApiLoanPaymentPlans = (
  paymentPlanRequestDto: PaymentPlanRequestDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanDto>(
    {
      url: `/api/loan/paymentPlans`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: paymentPlanRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanPaymentPlansMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPaymentPlans>>,
    TError,
    { data: PaymentPlanRequestDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPaymentPlans>>,
  TError,
  { data: PaymentPlanRequestDto[] },
  TContext
> => {
  const mutationKey = ["postApiLoanPaymentPlans"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPaymentPlans>>,
    { data: PaymentPlanRequestDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanPaymentPlans(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPaymentPlansMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPaymentPlans>>
>;
export type PostApiLoanPaymentPlansMutationBody = PaymentPlanRequestDto[];
export type PostApiLoanPaymentPlansMutationError = unknown;

export const usePostApiLoanPaymentPlans = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPaymentPlans>>,
      TError,
      { data: PaymentPlanRequestDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPaymentPlans>>,
  TError,
  { data: PaymentPlanRequestDto[] },
  TContext
> => {
  return useMutation(
    getPostApiLoanPaymentPlansMutationOptions(options),
    queryClient
  );
};

export const postApiLoanUpdateloanstatus = (
  changeLoanStatusDto: ChangeLoanStatusDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/updateloanstatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeLoanStatusDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanUpdateloanstatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>,
    TError,
    { data: ChangeLoanStatusDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>,
  TError,
  { data: ChangeLoanStatusDto },
  TContext
> => {
  const mutationKey = ["postApiLoanUpdateloanstatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>,
    { data: ChangeLoanStatusDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanUpdateloanstatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUpdateloanstatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>
>;
export type PostApiLoanUpdateloanstatusMutationBody = ChangeLoanStatusDto;
export type PostApiLoanUpdateloanstatusMutationError = unknown;

export const usePostApiLoanUpdateloanstatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>,
      TError,
      { data: ChangeLoanStatusDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUpdateloanstatus>>,
  TError,
  { data: ChangeLoanStatusDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanUpdateloanstatusMutationOptions(options),
    queryClient
  );
};

export const putApiLoanLoanDefinition = (
  loanDefinitionDtoBody: LoanDefinitionDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/loanDefinition`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: loanDefinitionDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiLoanLoanDefinitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanLoanDefinition>>,
    TError,
    { data: LoanDefinitionDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanLoanDefinition>>,
  TError,
  { data: LoanDefinitionDtoBody },
  TContext
> => {
  const mutationKey = ["putApiLoanLoanDefinition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanLoanDefinition>>,
    { data: LoanDefinitionDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiLoanLoanDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanLoanDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanLoanDefinition>>
>;
export type PutApiLoanLoanDefinitionMutationBody = LoanDefinitionDtoBody;
export type PutApiLoanLoanDefinitionMutationError = unknown;

export const usePutApiLoanLoanDefinition = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanLoanDefinition>>,
      TError,
      { data: LoanDefinitionDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanLoanDefinition>>,
  TError,
  { data: LoanDefinitionDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiLoanLoanDefinitionMutationOptions(options),
    queryClient
  );
};

export const postApiLoanLoanDefinition = (
  loanDefinitionDtoBody: LoanDefinitionDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/loanDefinition`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanDefinitionDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanLoanDefinitionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanLoanDefinition>>,
    TError,
    { data: LoanDefinitionDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanLoanDefinition>>,
  TError,
  { data: LoanDefinitionDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanLoanDefinition"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanLoanDefinition>>,
    { data: LoanDefinitionDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanLoanDefinition(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanLoanDefinitionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanLoanDefinition>>
>;
export type PostApiLoanLoanDefinitionMutationBody = LoanDefinitionDtoBody;
export type PostApiLoanLoanDefinitionMutationError = unknown;

export const usePostApiLoanLoanDefinition = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanLoanDefinition>>,
      TError,
      { data: LoanDefinitionDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanLoanDefinition>>,
  TError,
  { data: LoanDefinitionDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanLoanDefinitionMutationOptions(options),
    queryClient
  );
};

export const postApiLoanPayLoanWithTokenTokenSelectedCardId = (
  token: string,
  selectedCardId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/payLoanWithToken/${token}/${selectedCardId}`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiLoanPayLoanWithTokenTokenSelectedCardIdMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>
      >,
      TError,
      { token: string; selectedCardId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>>,
    TError,
    { token: string; selectedCardId: number },
    TContext
  > => {
    const mutationKey = ["postApiLoanPayLoanWithTokenTokenSelectedCardId"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>
      >,
      { token: string; selectedCardId: number }
    > = (props) => {
      const { token, selectedCardId } = props ?? {};

      return postApiLoanPayLoanWithTokenTokenSelectedCardId(
        token,
        selectedCardId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanPayLoanWithTokenTokenSelectedCardIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>>
  >;

export type PostApiLoanPayLoanWithTokenTokenSelectedCardIdMutationError =
  unknown;

export const usePostApiLoanPayLoanWithTokenTokenSelectedCardId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>
      >,
      TError,
      { token: string; selectedCardId: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPayLoanWithTokenTokenSelectedCardId>>,
  TError,
  { token: string; selectedCardId: number },
  TContext
> => {
  return useMutation(
    getPostApiLoanPayLoanWithTokenTokenSelectedCardIdMutationOptions(options),
    queryClient
  );
};

export const postApiLoanPayloan = (
  payLoanRequestDtoBody: PayLoanRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/payloan`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: payLoanRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanPayloanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPayloan>>,
    TError,
    { data: PayLoanRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPayloan>>,
  TError,
  { data: PayLoanRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanPayloan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPayloan>>,
    { data: PayLoanRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanPayloan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPayloanMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPayloan>>
>;
export type PostApiLoanPayloanMutationBody = PayLoanRequestDtoBody;
export type PostApiLoanPayloanMutationError = unknown;

export const usePostApiLoanPayloan = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPayloan>>,
      TError,
      { data: PayLoanRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPayloan>>,
  TError,
  { data: PayLoanRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanPayloanMutationOptions(options),
    queryClient
  );
};

export const postApiLoanBulkDebitV2 = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  params: PostApiLoanBulkDebitV2Params,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryInt64Boolean>(
    {
      url: `/api/loan/bulkDebitV2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanBulkDebitV2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>,
    TError,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiLoanBulkDebitV2Params;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiLoanBulkDebitV2Params;
  },
  TContext
> => {
  const mutationKey = ["postApiLoanBulkDebitV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>,
    {
      data: BankScraperGetAccountBulkAccoundidsBody;
      params: PostApiLoanBulkDebitV2Params;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanBulkDebitV2(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanBulkDebitV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>
>;
export type PostApiLoanBulkDebitV2MutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanBulkDebitV2MutationError = unknown;

export const usePostApiLoanBulkDebitV2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>,
      TError,
      {
        data: BankScraperGetAccountBulkAccoundidsBody;
        params: PostApiLoanBulkDebitV2Params;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanBulkDebitV2>>,
  TError,
  {
    data: BankScraperGetAccountBulkAccoundidsBody;
    params: PostApiLoanBulkDebitV2Params;
  },
  TContext
> => {
  return useMutation(
    getPostApiLoanBulkDebitV2MutationOptions(options),
    queryClient
  );
};

export const getApiLoanLoansToken = (
  token: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanDto>(
    { url: `/api/loan/loans/${token}`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanLoansTokenQueryKey = (token: string) => {
  return [`/api/loan/loans/${token}`] as const;
};

export const getGetApiLoanLoansTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoansToken>>,
  TError = unknown
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoansToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanLoansTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoansToken>>
  > = ({ signal }) => getApiLoanLoansToken(token, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoansToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoansTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoansToken>>
>;
export type GetApiLoanLoansTokenQueryError = unknown;

export function useGetApiLoanLoansToken<
  TData = Awaited<ReturnType<typeof getApiLoanLoansToken>>,
  TError = unknown
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoansToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoansToken>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoansToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoansToken<
  TData = Awaited<ReturnType<typeof getApiLoanLoansToken>>,
  TError = unknown
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoansToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoansToken>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoansToken>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoansToken<
  TData = Awaited<ReturnType<typeof getApiLoanLoansToken>>,
  TError = unknown
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoansToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoansToken<
  TData = Awaited<ReturnType<typeof getApiLoanLoansToken>>,
  TError = unknown
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoansToken>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoansTokenQueryOptions(token, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoan = (
  params: GetApiLoanLoanParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDto>(
    { url: `/api/loan/loan`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanQueryKey = (params?: GetApiLoanLoanParams) => {
  return [`/api/loan/loan`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanLoanQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoan>>,
  TError = unknown
>(
  params: GetApiLoanLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiLoanLoan>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLoanLoanQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiLoanLoan>>> = ({
    signal,
  }) => getApiLoanLoan(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoan>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoan>>
>;
export type GetApiLoanLoanQueryError = unknown;

export function useGetApiLoanLoan<
  TData = Awaited<ReturnType<typeof getApiLoanLoan>>,
  TError = unknown
>(
  params: GetApiLoanLoanParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiLoanLoan>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoan>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoan>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoan<
  TData = Awaited<ReturnType<typeof getApiLoanLoan>>,
  TError = unknown
>(
  params: GetApiLoanLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiLoanLoan>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoan>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoan>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoan<
  TData = Awaited<ReturnType<typeof getApiLoanLoan>>,
  TError = unknown
>(
  params: GetApiLoanLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiLoanLoan>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoan<
  TData = Awaited<ReturnType<typeof getApiLoanLoan>>,
  TError = unknown
>(
  params: GetApiLoanLoanParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiLoanLoan>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanCustomerAllLoans = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerLoansDto>(
    { url: `/api/loan/customerAllLoans`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanCustomerAllLoansQueryKey = () => {
  return [`/api/loan/customerAllLoans`] as const;
};

export const getGetApiLoanCustomerAllLoansQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanCustomerAllLoansQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>
  > = ({ signal }) => getApiLoanCustomerAllLoans(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerAllLoansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>
>;
export type GetApiLoanCustomerAllLoansQueryError = unknown;

export function useGetApiLoanCustomerAllLoans<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAllLoans<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerAllLoans<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerAllLoans<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerAllLoans>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCustomerAllLoansQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanCustomerLoansByStatus = (
  params: GetApiLoanCustomerLoansByStatusParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCustomerLoansDto>(
    { url: `/api/loan/customerLoansByStatus`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanCustomerLoansByStatusQueryKey = (
  params?: GetApiLoanCustomerLoansByStatusParams
) => {
  return [
    `/api/loan/customerLoansByStatus`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanCustomerLoansByStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
  TError = unknown
>(
  params: GetApiLoanCustomerLoansByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanCustomerLoansByStatusQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>
  > = ({ signal }) =>
    getApiLoanCustomerLoansByStatus(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerLoansByStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>
>;
export type GetApiLoanCustomerLoansByStatusQueryError = unknown;

export function useGetApiLoanCustomerLoansByStatus<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
  TError = unknown
>(
  params: GetApiLoanCustomerLoansByStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerLoansByStatus<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
  TError = unknown
>(
  params: GetApiLoanCustomerLoansByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerLoansByStatus<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
  TError = unknown
>(
  params: GetApiLoanCustomerLoansByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerLoansByStatus<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
  TError = unknown
>(
  params: GetApiLoanCustomerLoansByStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerLoansByStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanCustomerLoansByStatusQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanPaymentDate = (
  salaryCalculationSurrogateDTO: SalaryCalculationSurrogateDTO,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListDateTime>(
    {
      url: `/api/loan/paymentDate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: salaryCalculationSurrogateDTO,
      signal,
    },
    options
  );
};

export const getPostApiLoanPaymentDateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanPaymentDate>>,
    TError,
    { data: SalaryCalculationSurrogateDTO },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanPaymentDate>>,
  TError,
  { data: SalaryCalculationSurrogateDTO },
  TContext
> => {
  const mutationKey = ["postApiLoanPaymentDate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanPaymentDate>>,
    { data: SalaryCalculationSurrogateDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanPaymentDate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanPaymentDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanPaymentDate>>
>;
export type PostApiLoanPaymentDateMutationBody = SalaryCalculationSurrogateDTO;
export type PostApiLoanPaymentDateMutationError = unknown;

export const usePostApiLoanPaymentDate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanPaymentDate>>,
      TError,
      { data: SalaryCalculationSurrogateDTO },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanPaymentDate>>,
  TError,
  { data: SalaryCalculationSurrogateDTO },
  TContext
> => {
  return useMutation(
    getPostApiLoanPaymentDateMutationOptions(options),
    queryClient
  );
};

export const getApiLoanCustomerWorkInformation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultWorkBankInformationForGroupALoanDto>(
    { url: `/api/loan/customerWorkInformation`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanCustomerWorkInformationQueryKey = () => {
  return [`/api/loan/customerWorkInformation`] as const;
};

export const getGetApiLoanCustomerWorkInformationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanCustomerWorkInformationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>
  > = ({ signal }) => getApiLoanCustomerWorkInformation(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerWorkInformationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>
>;
export type GetApiLoanCustomerWorkInformationQueryError = unknown;

export function useGetApiLoanCustomerWorkInformation<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerWorkInformation<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerWorkInformation<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerWorkInformation<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerWorkInformation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanCustomerWorkInformationQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanUpdateWorkInformationForGroupALoan = (
  workBankInformationForGroupALoanDto: WorkBankInformationForGroupALoanDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultInt64>(
    {
      url: `/api/loan/updateWorkInformationForGroupALoan`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: workBankInformationForGroupALoanDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanUpdateWorkInformationForGroupALoanMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>,
    TError,
    { data: WorkBankInformationForGroupALoanDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>,
  TError,
  { data: WorkBankInformationForGroupALoanDto },
  TContext
> => {
  const mutationKey = ["postApiLoanUpdateWorkInformationForGroupALoan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>,
    { data: WorkBankInformationForGroupALoanDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanUpdateWorkInformationForGroupALoan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanUpdateWorkInformationForGroupALoanMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>
  >;
export type PostApiLoanUpdateWorkInformationForGroupALoanMutationBody =
  WorkBankInformationForGroupALoanDto;
export type PostApiLoanUpdateWorkInformationForGroupALoanMutationError =
  unknown;

export const usePostApiLoanUpdateWorkInformationForGroupALoan = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>,
      TError,
      { data: WorkBankInformationForGroupALoanDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanUpdateWorkInformationForGroupALoan>>,
  TError,
  { data: WorkBankInformationForGroupALoanDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanUpdateWorkInformationForGroupALoanMutationOptions(options),
    queryClient
  );
};

export const postApiLoanIbanValidation = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/IbanValidation`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanIbanValidationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanIbanValidation>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanIbanValidation>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiLoanIbanValidation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanIbanValidation>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanIbanValidation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanIbanValidationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanIbanValidation>>
>;
export type PostApiLoanIbanValidationMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiLoanIbanValidationMutationError = unknown;

export const usePostApiLoanIbanValidation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanIbanValidation>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanIbanValidation>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanIbanValidationMutationOptions(options),
    queryClient
  );
};

export const postApiLoanMakeLoanApplication = (
  makeLoanApplicationDTOBody: MakeLoanApplicationDTOBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanApplicationResultDTO>(
    {
      url: `/api/loan/makeLoanApplication`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: makeLoanApplicationDTOBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanMakeLoanApplicationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>,
    TError,
    { data: MakeLoanApplicationDTOBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>,
  TError,
  { data: MakeLoanApplicationDTOBody },
  TContext
> => {
  const mutationKey = ["postApiLoanMakeLoanApplication"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>,
    { data: MakeLoanApplicationDTOBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanMakeLoanApplication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanMakeLoanApplicationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>
>;
export type PostApiLoanMakeLoanApplicationMutationBody =
  MakeLoanApplicationDTOBody;
export type PostApiLoanMakeLoanApplicationMutationError = unknown;

export const usePostApiLoanMakeLoanApplication = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>,
      TError,
      { data: MakeLoanApplicationDTOBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanMakeLoanApplication>>,
  TError,
  { data: MakeLoanApplicationDTOBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanMakeLoanApplicationMutationOptions(options),
    queryClient
  );
};

export const postApiLoanLoanApplicationScreens = (
  loanApplicationScreensDto: LoanApplicationScreensDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/loanApplicationScreens`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanApplicationScreensDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanLoanApplicationScreensMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>,
    TError,
    { data: LoanApplicationScreensDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>,
  TError,
  { data: LoanApplicationScreensDto },
  TContext
> => {
  const mutationKey = ["postApiLoanLoanApplicationScreens"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>,
    { data: LoanApplicationScreensDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanLoanApplicationScreens(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanLoanApplicationScreensMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>
>;
export type PostApiLoanLoanApplicationScreensMutationBody =
  LoanApplicationScreensDto;
export type PostApiLoanLoanApplicationScreensMutationError = unknown;

export const usePostApiLoanLoanApplicationScreens = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>,
      TError,
      { data: LoanApplicationScreensDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanLoanApplicationScreens>>,
  TError,
  { data: LoanApplicationScreensDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanLoanApplicationScreensMutationOptions(options),
    queryClient
  );
};

export const postApiLoanLoanCalculatorLog = (
  loanCalculatorLogRequestDto: LoanCalculatorLogRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/loanCalculatorLog`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanCalculatorLogRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanLoanCalculatorLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>,
    TError,
    { data: LoanCalculatorLogRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>,
  TError,
  { data: LoanCalculatorLogRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanLoanCalculatorLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>,
    { data: LoanCalculatorLogRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanLoanCalculatorLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanLoanCalculatorLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>
>;
export type PostApiLoanLoanCalculatorLogMutationBody =
  LoanCalculatorLogRequestDto;
export type PostApiLoanLoanCalculatorLogMutationError = unknown;

export const usePostApiLoanLoanCalculatorLog = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>,
      TError,
      { data: LoanCalculatorLogRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanLoanCalculatorLog>>,
  TError,
  { data: LoanCalculatorLogRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanLoanCalculatorLogMutationOptions(options),
    queryClient
  );
};

export const getApiLoanLoanCalculatorLogsCustomerId = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanCalculatorLogDto>(
    {
      url: `/api/loan/loanCalculatorLogs/${customerId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiLoanLoanCalculatorLogsCustomerIdQueryKey = (
  customerId: number
) => {
  return [`/api/loan/loanCalculatorLogs/${customerId}`] as const;
};

export const getGetApiLoanLoanCalculatorLogsCustomerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanLoanCalculatorLogsCustomerIdQueryKey(customerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>
  > = ({ signal }) =>
    getApiLoanLoanCalculatorLogsCustomerId(customerId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanCalculatorLogsCustomerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>
>;
export type GetApiLoanLoanCalculatorLogsCustomerIdQueryError = unknown;

export function useGetApiLoanLoanCalculatorLogsCustomerId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanCalculatorLogsCustomerId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanCalculatorLogsCustomerId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanCalculatorLogsCustomerId<
  TData = Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanCalculatorLogsCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanCalculatorLogsCustomerIdQueryOptions(
    customerId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanTestMailWithInstallment = (
  params: GetApiLoanTestMailWithInstallmentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/TestMailWithInstallment`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanTestMailWithInstallmentQueryKey = (
  params?: GetApiLoanTestMailWithInstallmentParams
) => {
  return [
    `/api/loan/TestMailWithInstallment`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanTestMailWithInstallmentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
  TError = unknown
>(
  params: GetApiLoanTestMailWithInstallmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanTestMailWithInstallmentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>
  > = ({ signal }) =>
    getApiLoanTestMailWithInstallment(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanTestMailWithInstallmentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>
>;
export type GetApiLoanTestMailWithInstallmentQueryError = unknown;

export function useGetApiLoanTestMailWithInstallment<
  TData = Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
  TError = unknown
>(
  params: GetApiLoanTestMailWithInstallmentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTestMailWithInstallment<
  TData = Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
  TError = unknown
>(
  params: GetApiLoanTestMailWithInstallmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanTestMailWithInstallment<
  TData = Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
  TError = unknown
>(
  params: GetApiLoanTestMailWithInstallmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanTestMailWithInstallment<
  TData = Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
  TError = unknown
>(
  params: GetApiLoanTestMailWithInstallmentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanTestMailWithInstallment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanTestMailWithInstallmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanSetLoanIssued = (
  params: PostApiLoanSetLoanIssuedParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/setLoanIssued`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanSetLoanIssuedMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>,
    TError,
    { params: PostApiLoanSetLoanIssuedParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>,
  TError,
  { params: PostApiLoanSetLoanIssuedParams },
  TContext
> => {
  const mutationKey = ["postApiLoanSetLoanIssued"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>,
    { params: PostApiLoanSetLoanIssuedParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanSetLoanIssued(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanSetLoanIssuedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>
>;

export type PostApiLoanSetLoanIssuedMutationError = unknown;

export const usePostApiLoanSetLoanIssued = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>,
      TError,
      { params: PostApiLoanSetLoanIssuedParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanSetLoanIssued>>,
  TError,
  { params: PostApiLoanSetLoanIssuedParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanSetLoanIssuedMutationOptions(options),
    queryClient
  );
};

export const postApiLoanAgreementAsType = (
  loanDtoBody: LoanDtoBody,
  params: PostApiLoanAgreementAsTypeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanAgreementDto>(
    {
      url: `/api/loan/agreementAsType`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanDtoBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanAgreementAsTypeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAgreementAsType>>,
    TError,
    { data: LoanDtoBody; params: PostApiLoanAgreementAsTypeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAgreementAsType>>,
  TError,
  { data: LoanDtoBody; params: PostApiLoanAgreementAsTypeParams },
  TContext
> => {
  const mutationKey = ["postApiLoanAgreementAsType"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAgreementAsType>>,
    { data: LoanDtoBody; params: PostApiLoanAgreementAsTypeParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanAgreementAsType(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAgreementAsTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAgreementAsType>>
>;
export type PostApiLoanAgreementAsTypeMutationBody = LoanDtoBody;
export type PostApiLoanAgreementAsTypeMutationError = unknown;

export const usePostApiLoanAgreementAsType = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAgreementAsType>>,
      TError,
      { data: LoanDtoBody; params: PostApiLoanAgreementAsTypeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAgreementAsType>>,
  TError,
  { data: LoanDtoBody; params: PostApiLoanAgreementAsTypeParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanAgreementAsTypeMutationOptions(options),
    queryClient
  );
};

export const getApiLoanLoanagreement = (
  params: GetApiLoanLoanagreementParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanAgreementDto>(
    { url: `/api/loan/loanagreement`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanagreementQueryKey = (
  params?: GetApiLoanLoanagreementParams
) => {
  return [`/api/loan/loanagreement`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanLoanagreementQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanLoanagreementQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanagreement>>
  > = ({ signal }) => getApiLoanLoanagreement(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanagreementQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanagreement>>
>;
export type GetApiLoanLoanagreementQueryError = unknown;

export function useGetApiLoanLoanagreement<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanagreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanagreement<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanagreement>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanagreement<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanagreement<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreement>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanagreementQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoanagreementDownload = (
  params: GetApiLoanLoanagreementDownloadParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiLoanLoanagreementDownload200One
    | GetApiLoanLoanagreementDownload200Two
    | Blob
  >(
    { url: `/api/loan/loanagreementDownload`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanagreementDownloadQueryKey = (
  params?: GetApiLoanLoanagreementDownloadParams
) => {
  return [
    `/api/loan/loanagreementDownload`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanLoanagreementDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanLoanagreementDownloadQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>
  > = ({ signal }) =>
    getApiLoanLoanagreementDownload(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanagreementDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>
>;
export type GetApiLoanLoanagreementDownloadQueryError = unknown;

export function useGetApiLoanLoanagreementDownload<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementDownloadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanagreementDownload<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanagreementDownload<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanagreementDownload<
  TData = Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
  TError = unknown
>(
  params: GetApiLoanLoanagreementDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanagreementDownload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanagreementDownloadQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanLoanAgreementAsPdf = (
  params: GetApiLoanLoanAgreementAsPdfParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListGeneratedFileDto>(
    { url: `/api/loan/loanAgreementAsPdf`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanLoanAgreementAsPdfQueryKey = (
  params?: GetApiLoanLoanAgreementAsPdfParams
) => {
  return [`/api/loan/loanAgreementAsPdf`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanLoanAgreementAsPdfQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementAsPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanLoanAgreementAsPdfQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>
  > = ({ signal }) =>
    getApiLoanLoanAgreementAsPdf(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanLoanAgreementAsPdfQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>
>;
export type GetApiLoanLoanAgreementAsPdfQueryError = unknown;

export function useGetApiLoanLoanAgreementAsPdf<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementAsPdfParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanAgreementAsPdf<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementAsPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanLoanAgreementAsPdf<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementAsPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanLoanAgreementAsPdf<
  TData = Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
  TError = unknown
>(
  params: GetApiLoanLoanAgreementAsPdfParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanLoanAgreementAsPdf>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanLoanAgreementAsPdfQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanAgreement = (
  loanDtoBody: LoanDtoBody,
  params?: PostApiLoanAgreementParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoanAgreementDto>(
    {
      url: `/api/loan/agreement`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanDtoBody,
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanAgreementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAgreement>>,
    TError,
    { data: LoanDtoBody; params?: PostApiLoanAgreementParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAgreement>>,
  TError,
  { data: LoanDtoBody; params?: PostApiLoanAgreementParams },
  TContext
> => {
  const mutationKey = ["postApiLoanAgreement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAgreement>>,
    { data: LoanDtoBody; params?: PostApiLoanAgreementParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiLoanAgreement(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAgreementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAgreement>>
>;
export type PostApiLoanAgreementMutationBody = LoanDtoBody;
export type PostApiLoanAgreementMutationError = unknown;

export const usePostApiLoanAgreement = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAgreement>>,
      TError,
      { data: LoanDtoBody; params?: PostApiLoanAgreementParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAgreement>>,
  TError,
  { data: LoanDtoBody; params?: PostApiLoanAgreementParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanAgreementMutationOptions(options),
    queryClient
  );
};

export const postApiLoanAssignAgreement = (
  params?: PostApiLoanAssignAgreementParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/loan/assignAgreement`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanAssignAgreementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAssignAgreement>>,
    TError,
    { params?: PostApiLoanAssignAgreementParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAssignAgreement>>,
  TError,
  { params?: PostApiLoanAssignAgreementParams },
  TContext
> => {
  const mutationKey = ["postApiLoanAssignAgreement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAssignAgreement>>,
    { params?: PostApiLoanAssignAgreementParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanAssignAgreement(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAssignAgreementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAssignAgreement>>
>;

export type PostApiLoanAssignAgreementMutationError = unknown;

export const usePostApiLoanAssignAgreement = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAssignAgreement>>,
      TError,
      { params?: PostApiLoanAssignAgreementParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAssignAgreement>>,
  TError,
  { params?: PostApiLoanAssignAgreementParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanAssignAgreementMutationOptions(options),
    queryClient
  );
};

export const postApiLoanAssignAgreementAfterForRtb = (
  params: PostApiLoanAssignAgreementAfterForRtbParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/assignAgreementAfterForRtb`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanAssignAgreementAfterForRtbMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>,
    TError,
    { params: PostApiLoanAssignAgreementAfterForRtbParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>,
  TError,
  { params: PostApiLoanAssignAgreementAfterForRtbParams },
  TContext
> => {
  const mutationKey = ["postApiLoanAssignAgreementAfterForRtb"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>,
    { params: PostApiLoanAssignAgreementAfterForRtbParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanAssignAgreementAfterForRtb(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAssignAgreementAfterForRtbMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>
>;

export type PostApiLoanAssignAgreementAfterForRtbMutationError = unknown;

export const usePostApiLoanAssignAgreementAfterForRtb = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>,
      TError,
      { params: PostApiLoanAssignAgreementAfterForRtbParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAssignAgreementAfterForRtb>>,
  TError,
  { params: PostApiLoanAssignAgreementAfterForRtbParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanAssignAgreementAfterForRtbMutationOptions(options),
    queryClient
  );
};

export const getApiLoanAgreementSent = (
  params: GetApiLoanAgreementSentParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/agreementSent`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanAgreementSentQueryKey = (
  params?: GetApiLoanAgreementSentParams
) => {
  return [`/api/loan/agreementSent`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanAgreementSentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
  TError = unknown
>(
  params: GetApiLoanAgreementSentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanAgreementSentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanAgreementSent>>
  > = ({ signal }) => getApiLoanAgreementSent(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanAgreementSentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanAgreementSent>>
>;
export type GetApiLoanAgreementSentQueryError = unknown;

export function useGetApiLoanAgreementSent<
  TData = Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
  TError = unknown
>(
  params: GetApiLoanAgreementSentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanAgreementSent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAgreementSent<
  TData = Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
  TError = unknown
>(
  params: GetApiLoanAgreementSentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanAgreementSent>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAgreementSent<
  TData = Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
  TError = unknown
>(
  params: GetApiLoanAgreementSentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanAgreementSent<
  TData = Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
  TError = unknown
>(
  params: GetApiLoanAgreementSentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAgreementSent>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanAgreementSentQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanAssignAgreementConcurrencyTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/assignAgreementConcurrencyTest`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanAssignAgreementConcurrencyTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanAssignAgreementConcurrencyTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>,
    void
  > = () => {
    return postApiLoanAssignAgreementConcurrencyTest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanAssignAgreementConcurrencyTestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>
  >;

export type PostApiLoanAssignAgreementConcurrencyTestMutationError = unknown;

export const usePostApiLoanAssignAgreementConcurrencyTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanAssignAgreementConcurrencyTest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanAssignAgreementConcurrencyTestMutationOptions(options),
    queryClient
  );
};

export const postApiLoanSetLoanAccountId = (
  params: PostApiLoanSetLoanAccountIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/setLoanAccountId`, method: "POST", params, signal },
    options
  );
};

export const getPostApiLoanSetLoanAccountIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>,
    TError,
    { params: PostApiLoanSetLoanAccountIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>,
  TError,
  { params: PostApiLoanSetLoanAccountIdParams },
  TContext
> => {
  const mutationKey = ["postApiLoanSetLoanAccountId"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>,
    { params: PostApiLoanSetLoanAccountIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanSetLoanAccountId(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanSetLoanAccountIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>
>;

export type PostApiLoanSetLoanAccountIdMutationError = unknown;

export const usePostApiLoanSetLoanAccountId = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>,
      TError,
      { params: PostApiLoanSetLoanAccountIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanSetLoanAccountId>>,
  TError,
  { params: PostApiLoanSetLoanAccountIdParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanSetLoanAccountIdMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCustomerAllLoansReport = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerLoansDto>(
    {
      url: `/api/loan/customerAllLoansReport`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanCustomerAllLoansReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiLoanCustomerAllLoansReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCustomerAllLoansReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCustomerAllLoansReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>
>;
export type PostApiLoanCustomerAllLoansReportMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanCustomerAllLoansReportMutationError = unknown;

export const usePostApiLoanCustomerAllLoansReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCustomerAllLoansReport>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanCustomerAllLoansReportMutationOptions(options),
    queryClient
  );
};

export const getApiLoanRolloverCalculate = (
  params?: GetApiLoanRolloverCalculateParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDecimal>(
    { url: `/api/loan/rolloverCalculate`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanRolloverCalculateQueryKey = (
  params?: GetApiLoanRolloverCalculateParams
) => {
  return [`/api/loan/rolloverCalculate`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanRolloverCalculateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
  TError = unknown
>(
  params?: GetApiLoanRolloverCalculateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanRolloverCalculateQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>
  > = ({ signal }) =>
    getApiLoanRolloverCalculate(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanRolloverCalculateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>
>;
export type GetApiLoanRolloverCalculateQueryError = unknown;

export function useGetApiLoanRolloverCalculate<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
  TError = unknown
>(
  params: undefined | GetApiLoanRolloverCalculateParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRolloverCalculate<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
  TError = unknown
>(
  params?: GetApiLoanRolloverCalculateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRolloverCalculate<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
  TError = unknown
>(
  params?: GetApiLoanRolloverCalculateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanRolloverCalculate<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
  TError = unknown
>(
  params?: GetApiLoanRolloverCalculateParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverCalculate>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanRolloverCalculateQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanRolloverAvailableDates = (
  params: GetApiLoanRolloverAvailableDatesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListDateTime>(
    { url: `/api/loan/rolloverAvailableDates`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanRolloverAvailableDatesQueryKey = (
  params?: GetApiLoanRolloverAvailableDatesParams
) => {
  return [
    `/api/loan/rolloverAvailableDates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanRolloverAvailableDatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
  TError = unknown
>(
  params: GetApiLoanRolloverAvailableDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanRolloverAvailableDatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>
  > = ({ signal }) =>
    getApiLoanRolloverAvailableDates(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanRolloverAvailableDatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>
>;
export type GetApiLoanRolloverAvailableDatesQueryError = unknown;

export function useGetApiLoanRolloverAvailableDates<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
  TError = unknown
>(
  params: GetApiLoanRolloverAvailableDatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRolloverAvailableDates<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
  TError = unknown
>(
  params: GetApiLoanRolloverAvailableDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRolloverAvailableDates<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
  TError = unknown
>(
  params: GetApiLoanRolloverAvailableDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanRolloverAvailableDates<
  TData = Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
  TError = unknown
>(
  params: GetApiLoanRolloverAvailableDatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRolloverAvailableDates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanRolloverAvailableDatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanRolloverSummary = (
  rolloverRequestDtoBody: RolloverRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDto>(
    {
      url: `/api/loan/rolloverSummary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rolloverRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanRolloverSummaryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanRolloverSummary>>,
    TError,
    { data: RolloverRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanRolloverSummary>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanRolloverSummary"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanRolloverSummary>>,
    { data: RolloverRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanRolloverSummary(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanRolloverSummaryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanRolloverSummary>>
>;
export type PostApiLoanRolloverSummaryMutationBody = RolloverRequestDtoBody;
export type PostApiLoanRolloverSummaryMutationError = unknown;

export const usePostApiLoanRolloverSummary = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanRolloverSummary>>,
      TError,
      { data: RolloverRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanRolloverSummary>>,
  TError,
  { data: RolloverRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanRolloverSummaryMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCreateUpdateLoanArrangement = (
  loanArrangementRequestDto: LoanArrangementRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoanDto>(
    {
      url: `/api/loan/createUpdateLoanArrangement`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanArrangementRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanCreateUpdateLoanArrangementMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>,
    TError,
    { data: LoanArrangementRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>,
  TError,
  { data: LoanArrangementRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanCreateUpdateLoanArrangement"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>,
    { data: LoanArrangementRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCreateUpdateLoanArrangement(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCreateUpdateLoanArrangementMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>
>;
export type PostApiLoanCreateUpdateLoanArrangementMutationBody =
  LoanArrangementRequestDto;
export type PostApiLoanCreateUpdateLoanArrangementMutationError = unknown;

export const usePostApiLoanCreateUpdateLoanArrangement = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>,
      TError,
      { data: LoanArrangementRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCreateUpdateLoanArrangement>>,
  TError,
  { data: LoanArrangementRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanCreateUpdateLoanArrangementMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCreateLoanImpediment = (
  createLoanImpedimentRequestDtoBody: CreateLoanImpedimentRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/createLoanImpediment`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createLoanImpedimentRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanCreateLoanImpedimentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>,
    TError,
    { data: CreateLoanImpedimentRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>,
  TError,
  { data: CreateLoanImpedimentRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanCreateLoanImpediment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>,
    { data: CreateLoanImpedimentRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCreateLoanImpediment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCreateLoanImpedimentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>
>;
export type PostApiLoanCreateLoanImpedimentMutationBody =
  CreateLoanImpedimentRequestDtoBody;
export type PostApiLoanCreateLoanImpedimentMutationError = unknown;

export const usePostApiLoanCreateLoanImpediment = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>,
      TError,
      { data: CreateLoanImpedimentRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCreateLoanImpediment>>,
  TError,
  { data: CreateLoanImpedimentRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanCreateLoanImpedimentMutationOptions(options),
    queryClient
  );
};

export const postApiLoanCreateLoanImpedimentWithTokenToken = (
  token: string,
  createLoanImpedimentRequestDtoBody: CreateLoanImpedimentRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/createLoanImpedimentWithToken/${token}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createLoanImpedimentRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanCreateLoanImpedimentWithTokenTokenMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>,
    TError,
    { token: string; data: CreateLoanImpedimentRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>,
  TError,
  { token: string; data: CreateLoanImpedimentRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiLoanCreateLoanImpedimentWithTokenToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>,
    { token: string; data: CreateLoanImpedimentRequestDtoBody }
  > = (props) => {
    const { token, data } = props ?? {};

    return postApiLoanCreateLoanImpedimentWithTokenToken(
      token,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCreateLoanImpedimentWithTokenTokenMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>
  >;
export type PostApiLoanCreateLoanImpedimentWithTokenTokenMutationBody =
  CreateLoanImpedimentRequestDtoBody;
export type PostApiLoanCreateLoanImpedimentWithTokenTokenMutationError =
  unknown;

export const usePostApiLoanCreateLoanImpedimentWithTokenToken = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>,
      TError,
      { token: string; data: CreateLoanImpedimentRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCreateLoanImpedimentWithTokenToken>>,
  TError,
  { token: string; data: CreateLoanImpedimentRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanCreateLoanImpedimentWithTokenTokenMutationOptions(options),
    queryClient
  );
};

export const getApiLoanCustomerCanCreateImpediment = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/customerCanCreateImpediment`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanCustomerCanCreateImpedimentQueryKey = () => {
  return [`/api/loan/customerCanCreateImpediment`] as const;
};

export const getGetApiLoanCustomerCanCreateImpedimentQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanCustomerCanCreateImpedimentQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>
  > = ({ signal }) =>
    getApiLoanCustomerCanCreateImpediment(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanCustomerCanCreateImpedimentQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>
>;
export type GetApiLoanCustomerCanCreateImpedimentQueryError = unknown;

export function useGetApiLoanCustomerCanCreateImpediment<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerCanCreateImpediment<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanCustomerCanCreateImpediment<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanCustomerCanCreateImpediment<
  TData = Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanCustomerCanCreateImpediment>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanCustomerCanCreateImpedimentQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanGetAllImpediments = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCreateLoanImpedimentRequestDto>(
    { url: `/api/loan/getAllImpediments`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanGetAllImpedimentsQueryKey = () => {
  return [`/api/loan/getAllImpediments`] as const;
};

export const getGetApiLoanGetAllImpedimentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanGetAllImpedimentsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>
  > = ({ signal }) => getApiLoanGetAllImpediments(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanGetAllImpedimentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>
>;
export type GetApiLoanGetAllImpedimentsQueryError = unknown;

export function useGetApiLoanGetAllImpediments<
  TData = Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetAllImpediments<
  TData = Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanGetAllImpediments<
  TData = Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanGetAllImpediments<
  TData = Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanGetAllImpediments>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanGetAllImpedimentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanGetAllImpedimentsPaged = (
  loanImpedimentRequestDto: LoanImpedimentRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultLoanImpedimentResponseDto>(
    {
      url: `/api/loan/getAllImpediments/paged`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loanImpedimentRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanGetAllImpedimentsPagedMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>,
    TError,
    { data: LoanImpedimentRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>,
  TError,
  { data: LoanImpedimentRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanGetAllImpedimentsPaged"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>,
    { data: LoanImpedimentRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanGetAllImpedimentsPaged(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanGetAllImpedimentsPagedMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>
>;
export type PostApiLoanGetAllImpedimentsPagedMutationBody =
  LoanImpedimentRequestDto;
export type PostApiLoanGetAllImpedimentsPagedMutationError = unknown;

export const usePostApiLoanGetAllImpedimentsPaged = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>,
      TError,
      { data: LoanImpedimentRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanGetAllImpedimentsPaged>>,
  TError,
  { data: LoanImpedimentRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanGetAllImpedimentsPagedMutationOptions(options),
    queryClient
  );
};

export const postApiLoanSetImpedimentStatus = (
  impedimentStatusDto: ImpedimentStatusDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/setImpedimentStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: impedimentStatusDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanSetImpedimentStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>,
    TError,
    { data: ImpedimentStatusDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>,
  TError,
  { data: ImpedimentStatusDto },
  TContext
> => {
  const mutationKey = ["postApiLoanSetImpedimentStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>,
    { data: ImpedimentStatusDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanSetImpedimentStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanSetImpedimentStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>
>;
export type PostApiLoanSetImpedimentStatusMutationBody = ImpedimentStatusDto;
export type PostApiLoanSetImpedimentStatusMutationError = unknown;

export const usePostApiLoanSetImpedimentStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>,
      TError,
      { data: ImpedimentStatusDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanSetImpedimentStatus>>,
  TError,
  { data: ImpedimentStatusDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanSetImpedimentStatusMutationOptions(options),
    queryClient
  );
};

export const postApiLoanForceTakingExternalCollectionFee = (
  params: PostApiLoanForceTakingExternalCollectionFeeParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/forceTakingExternalCollectionFee`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanForceTakingExternalCollectionFeeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>,
    TError,
    { params: PostApiLoanForceTakingExternalCollectionFeeParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>,
  TError,
  { params: PostApiLoanForceTakingExternalCollectionFeeParams },
  TContext
> => {
  const mutationKey = ["postApiLoanForceTakingExternalCollectionFee"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>,
    { params: PostApiLoanForceTakingExternalCollectionFeeParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanForceTakingExternalCollectionFee(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanForceTakingExternalCollectionFeeMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>
  >;

export type PostApiLoanForceTakingExternalCollectionFeeMutationError = unknown;

export const usePostApiLoanForceTakingExternalCollectionFee = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>,
      TError,
      { params: PostApiLoanForceTakingExternalCollectionFeeParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanForceTakingExternalCollectionFee>>,
  TError,
  { params: PostApiLoanForceTakingExternalCollectionFeeParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanForceTakingExternalCollectionFeeMutationOptions(options),
    queryClient
  );
};

export const postApiLoanBulkSetCustomerAsExternalCollection = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/loan/bulkSetCustomerAsExternalCollection`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanBulkSetCustomerAsExternalCollectionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiLoanBulkSetCustomerAsExternalCollection"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiLoanBulkSetCustomerAsExternalCollection(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiLoanBulkSetCustomerAsExternalCollectionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>>
  >;
export type PostApiLoanBulkSetCustomerAsExternalCollectionMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanBulkSetCustomerAsExternalCollectionMutationError =
  unknown;

export const usePostApiLoanBulkSetCustomerAsExternalCollection = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanBulkSetCustomerAsExternalCollection>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanBulkSetCustomerAsExternalCollectionMutationOptions(options),
    queryClient
  );
};

export const postApiLoanExternalFeeCalculationErrorFix = (
  params: PostApiLoanExternalFeeCalculationErrorFixParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/externalFeeCalculationErrorFix`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiLoanExternalFeeCalculationErrorFixMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>,
    TError,
    { params: PostApiLoanExternalFeeCalculationErrorFixParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>,
  TError,
  { params: PostApiLoanExternalFeeCalculationErrorFixParams },
  TContext
> => {
  const mutationKey = ["postApiLoanExternalFeeCalculationErrorFix"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>,
    { params: PostApiLoanExternalFeeCalculationErrorFixParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiLoanExternalFeeCalculationErrorFix(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanExternalFeeCalculationErrorFixMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>
  >;

export type PostApiLoanExternalFeeCalculationErrorFixMutationError = unknown;

export const usePostApiLoanExternalFeeCalculationErrorFix = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>,
      TError,
      { params: PostApiLoanExternalFeeCalculationErrorFixParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanExternalFeeCalculationErrorFix>>,
  TError,
  { params: PostApiLoanExternalFeeCalculationErrorFixParams },
  TContext
> => {
  return useMutation(
    getPostApiLoanExternalFeeCalculationErrorFixMutationOptions(options),
    queryClient
  );
};

export const postApiLoanComprehensiveLoanReport = (
  comprehensiveLoanReportDto: ComprehensiveLoanReportDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListComprehensiveLoanReportResponseDto>(
    {
      url: `/api/loan/comprehensiveLoanReport`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: comprehensiveLoanReportDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanComprehensiveLoanReportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>,
    TError,
    { data: ComprehensiveLoanReportDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>,
  TError,
  { data: ComprehensiveLoanReportDto },
  TContext
> => {
  const mutationKey = ["postApiLoanComprehensiveLoanReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>,
    { data: ComprehensiveLoanReportDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanComprehensiveLoanReport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanComprehensiveLoanReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>
>;
export type PostApiLoanComprehensiveLoanReportMutationBody =
  ComprehensiveLoanReportDto;
export type PostApiLoanComprehensiveLoanReportMutationError = unknown;

export const usePostApiLoanComprehensiveLoanReport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>,
      TError,
      { data: ComprehensiveLoanReportDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanComprehensiveLoanReport>>,
  TError,
  { data: ComprehensiveLoanReportDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanComprehensiveLoanReportMutationOptions(options),
    queryClient
  );
};

export const postApiLoanComprehensiveReportDailyUpdate = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/loan/comprehensiveReportDailyUpdate`, method: "POST", signal },
    options
  );
};

export const getPostApiLoanComprehensiveReportDailyUpdateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiLoanComprehensiveReportDailyUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>,
    void
  > = () => {
    return postApiLoanComprehensiveReportDailyUpdate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanComprehensiveReportDailyUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>
  >;

export type PostApiLoanComprehensiveReportDailyUpdateMutationError = unknown;

export const usePostApiLoanComprehensiveReportDailyUpdate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanComprehensiveReportDailyUpdate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiLoanComprehensiveReportDailyUpdateMutationOptions(options),
    queryClient
  );
};

export const postApiLoanLegalprocessreport = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLegalProcessReportDto>(
    {
      url: `/api/loan/legalprocessreport`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiLoanLegalprocessreportMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiLoanLegalprocessreport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanLegalprocessreport(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanLegalprocessreportMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>
>;
export type PostApiLoanLegalprocessreportMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiLoanLegalprocessreportMutationError = unknown;

export const usePostApiLoanLegalprocessreport = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanLegalprocessreport>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiLoanLegalprocessreportMutationOptions(options),
    queryClient
  );
};

export const getApiLoanAutoAssignCustomerToCollectionCompany = (
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/autoAssignCustomerToCollectionCompany`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanAutoAssignCustomerToCollectionCompanyQueryKey = (
  params?: GetApiLoanAutoAssignCustomerToCollectionCompanyParams
) => {
  return [
    `/api/loan/autoAssignCustomerToCollectionCompany`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanAutoAssignCustomerToCollectionCompanyQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
  >,
  TError = unknown
>(
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanAutoAssignCustomerToCollectionCompanyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>>
  > = ({ signal }) =>
    getApiLoanAutoAssignCustomerToCollectionCompany(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanAutoAssignCustomerToCollectionCompanyQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>>
  >;
export type GetApiLoanAutoAssignCustomerToCollectionCompanyQueryError = unknown;

export function useGetApiLoanAutoAssignCustomerToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
  >,
  TError = unknown
>(
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAutoAssignCustomerToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
  >,
  TError = unknown
>(
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAutoAssignCustomerToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
  >,
  TError = unknown
>(
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanAutoAssignCustomerToCollectionCompany<
  TData = Awaited<
    ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
  >,
  TError = unknown
>(
  params: GetApiLoanAutoAssignCustomerToCollectionCompanyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiLoanAutoAssignCustomerToCollectionCompany>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiLoanAutoAssignCustomerToCollectionCompanyQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiLoanCalculateFutureCloseAmount = (
  calculateFutureCloseAmountRequestDto: CalculateFutureCloseAmountRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCalculateFutureCloseAmountResponseDto>(
    {
      url: `/api/loan/calculateFutureCloseAmount`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: calculateFutureCloseAmountRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiLoanCalculateFutureCloseAmountMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>,
    TError,
    { data: CalculateFutureCloseAmountRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>,
  TError,
  { data: CalculateFutureCloseAmountRequestDto },
  TContext
> => {
  const mutationKey = ["postApiLoanCalculateFutureCloseAmount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>,
    { data: CalculateFutureCloseAmountRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiLoanCalculateFutureCloseAmount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiLoanCalculateFutureCloseAmountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>
>;
export type PostApiLoanCalculateFutureCloseAmountMutationBody =
  CalculateFutureCloseAmountRequestDto;
export type PostApiLoanCalculateFutureCloseAmountMutationError = unknown;

export const usePostApiLoanCalculateFutureCloseAmount = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>,
      TError,
      { data: CalculateFutureCloseAmountRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiLoanCalculateFutureCloseAmount>>,
  TError,
  { data: CalculateFutureCloseAmountRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiLoanCalculateFutureCloseAmountMutationOptions(options),
    queryClient
  );
};

export const getApiLoanWidgetInit = (
  params: GetApiLoanWidgetInitParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxWidgetDto>(
    { url: `/api/loan/WidgetInit`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanWidgetInitQueryKey = (
  params?: GetApiLoanWidgetInitParams
) => {
  return [`/api/loan/WidgetInit`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanWidgetInitQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanWidgetInitQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanWidgetInit>>
  > = ({ signal }) => getApiLoanWidgetInit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanWidgetInitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanWidgetInit>>
>;
export type GetApiLoanWidgetInitQueryError = unknown;

export function useGetApiLoanWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanWidgetInitParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanWidgetInitQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @deprecated
 */
export const getApiLoanRtbWidgetInit = (
  params: GetApiLoanRtbWidgetInitParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxWidgetDto>(
    { url: `/api/loan/RtbWidgetInit`, method: "GET", params, signal },
    options
  );
};

export const getGetApiLoanRtbWidgetInitQueryKey = (
  params?: GetApiLoanRtbWidgetInitParams
) => {
  return [`/api/loan/RtbWidgetInit`, ...(params ? [params] : [])] as const;
};

export const getGetApiLoanRtbWidgetInitQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanRtbWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiLoanRtbWidgetInitQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>
  > = ({ signal }) => getApiLoanRtbWidgetInit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanRtbWidgetInitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>
>;
export type GetApiLoanRtbWidgetInitQueryError = unknown;

export function useGetApiLoanRtbWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanRtbWidgetInitParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRtbWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanRtbWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanRtbWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanRtbWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 */

export function useGetApiLoanRtbWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanRtbWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanRtbWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanRtbWidgetInitQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiLoanAnotherBankAccountWidgetInit = (
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxWidgetDto>(
    {
      url: `/api/loan/anotherBankAccountWidgetInit`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiLoanAnotherBankAccountWidgetInitQueryKey = (
  params?: GetApiLoanAnotherBankAccountWidgetInitParams
) => {
  return [
    `/api/loan/anotherBankAccountWidgetInit`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLoanAnotherBankAccountWidgetInitQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLoanAnotherBankAccountWidgetInitQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>
  > = ({ signal }) =>
    getApiLoanAnotherBankAccountWidgetInit(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanAnotherBankAccountWidgetInitQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>
>;
export type GetApiLoanAnotherBankAccountWidgetInitQueryError = unknown;

export function useGetApiLoanAnotherBankAccountWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAnotherBankAccountWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanAnotherBankAccountWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanAnotherBankAccountWidgetInit<
  TData = Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
  TError = unknown
>(
  params: GetApiLoanAnotherBankAccountWidgetInitParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanAnotherBankAccountWidgetInit>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanAnotherBankAccountWidgetInitQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiLoanEvent = (
  params: PutApiLoanEventParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/loan/event`, method: "PUT", params, signal },
    options
  );
};

export const getPutApiLoanEventMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanEvent>>,
    TError,
    { params: PutApiLoanEventParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanEvent>>,
  TError,
  { params: PutApiLoanEventParams },
  TContext
> => {
  const mutationKey = ["putApiLoanEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanEvent>>,
    { params: PutApiLoanEventParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiLoanEvent(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanEvent>>
>;

export type PutApiLoanEventMutationError = unknown;

export const usePutApiLoanEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanEvent>>,
      TError,
      { params: PutApiLoanEventParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanEvent>>,
  TError,
  { params: PutApiLoanEventParams },
  TContext
> => {
  return useMutation(getPutApiLoanEventMutationOptions(options), queryClient);
};

export const putApiLoanFtbEvent = (
  params: PutApiLoanFtbEventParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/loan/ftbEvent`, method: "PUT", params, signal },
    options
  );
};

export const getPutApiLoanFtbEventMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanFtbEvent>>,
    TError,
    { params: PutApiLoanFtbEventParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanFtbEvent>>,
  TError,
  { params: PutApiLoanFtbEventParams },
  TContext
> => {
  const mutationKey = ["putApiLoanFtbEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanFtbEvent>>,
    { params: PutApiLoanFtbEventParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiLoanFtbEvent(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanFtbEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanFtbEvent>>
>;

export type PutApiLoanFtbEventMutationError = unknown;

export const usePutApiLoanFtbEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanFtbEvent>>,
      TError,
      { params: PutApiLoanFtbEventParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanFtbEvent>>,
  TError,
  { params: PutApiLoanFtbEventParams },
  TContext
> => {
  return useMutation(
    getPutApiLoanFtbEventMutationOptions(options),
    queryClient
  );
};

export const putApiLoanRtbEvent = (
  params: PutApiLoanRtbEventParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/loan/rtbEvent`, method: "PUT", params, signal },
    options
  );
};

export const getPutApiLoanRtbEventMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanRtbEvent>>,
    TError,
    { params: PutApiLoanRtbEventParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanRtbEvent>>,
  TError,
  { params: PutApiLoanRtbEventParams },
  TContext
> => {
  const mutationKey = ["putApiLoanRtbEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanRtbEvent>>,
    { params: PutApiLoanRtbEventParams }
  > = (props) => {
    const { params } = props ?? {};

    return putApiLoanRtbEvent(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanRtbEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanRtbEvent>>
>;

export type PutApiLoanRtbEventMutationError = unknown;

export const usePutApiLoanRtbEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanRtbEvent>>,
      TError,
      { params: PutApiLoanRtbEventParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanRtbEvent>>,
  TError,
  { params: PutApiLoanRtbEventParams },
  TContext
> => {
  return useMutation(
    getPutApiLoanRtbEventMutationOptions(options),
    queryClient
  );
};

export const putApiLoanBankNotAvailable = (
  unavailableBankScrapeRequestDto: UnavailableBankScrapeRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/loan/bankNotAvailable`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: unavailableBankScrapeRequestDto,
      signal,
    },
    options
  );
};

export const getPutApiLoanBankNotAvailableMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>,
    TError,
    { data: UnavailableBankScrapeRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>,
  TError,
  { data: UnavailableBankScrapeRequestDto },
  TContext
> => {
  const mutationKey = ["putApiLoanBankNotAvailable"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>,
    { data: UnavailableBankScrapeRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return putApiLoanBankNotAvailable(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLoanBankNotAvailableMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>
>;
export type PutApiLoanBankNotAvailableMutationBody =
  UnavailableBankScrapeRequestDto;
export type PutApiLoanBankNotAvailableMutationError = unknown;

export const usePutApiLoanBankNotAvailable = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>,
      TError,
      { data: UnavailableBankScrapeRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLoanBankNotAvailable>>,
  TError,
  { data: UnavailableBankScrapeRequestDto },
  TContext
> => {
  return useMutation(
    getPutApiLoanBankNotAvailableMutationOptions(options),
    queryClient
  );
};

export const getApiLoanJourney = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMakeLoanJourneyDto>(
    { url: `/api/loan/journey`, method: "GET", signal },
    options
  );
};

export const getGetApiLoanJourneyQueryKey = () => {
  return [`/api/loan/journey`] as const;
};

export const getGetApiLoanJourneyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLoanJourney>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiLoanJourney>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiLoanJourneyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLoanJourney>>
  > = ({ signal }) => getApiLoanJourney(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLoanJourney>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLoanJourneyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLoanJourney>>
>;
export type GetApiLoanJourneyQueryError = unknown;

export function useGetApiLoanJourney<
  TData = Awaited<ReturnType<typeof getApiLoanJourney>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanJourney>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanJourney>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanJourney>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanJourney<
  TData = Awaited<ReturnType<typeof getApiLoanJourney>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanJourney>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLoanJourney>>,
          TError,
          Awaited<ReturnType<typeof getApiLoanJourney>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLoanJourney<
  TData = Awaited<ReturnType<typeof getApiLoanJourney>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanJourney>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLoanJourney<
  TData = Awaited<ReturnType<typeof getApiLoanJourney>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLoanJourney>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLoanJourneyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipLiveChatAgentControl = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListGetMemberFullNamesDto>(
    { url: `/api/membership/liveChatAgentControl`, method: "POST", signal },
    options
  );
};

export const getPostApiMembershipLiveChatAgentControlMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiMembershipLiveChatAgentControl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>,
    void
  > = () => {
    return postApiMembershipLiveChatAgentControl(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipLiveChatAgentControlMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>
>;

export type PostApiMembershipLiveChatAgentControlMutationError = unknown;

export const usePostApiMembershipLiveChatAgentControl = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipLiveChatAgentControl>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiMembershipLiveChatAgentControlMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipLoginWithRepayTokenRepayToken = (
  repayToken: string,
  loginWithRepayTokenDto: LoginWithRepayTokenDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoginResultDto>(
    {
      url: `/api/membership/loginWithRepayToken/${repayToken}`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loginWithRepayTokenDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipLoginWithRepayTokenRepayTokenMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>
      >,
      TError,
      { repayToken: string; data: LoginWithRepayTokenDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>>,
    TError,
    { repayToken: string; data: LoginWithRepayTokenDto },
    TContext
  > => {
    const mutationKey = ["postApiMembershipLoginWithRepayTokenRepayToken"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>
      >,
      { repayToken: string; data: LoginWithRepayTokenDto }
    > = (props) => {
      const { repayToken, data } = props ?? {};

      return postApiMembershipLoginWithRepayTokenRepayToken(
        repayToken,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMembershipLoginWithRepayTokenRepayTokenMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>>
  >;
export type PostApiMembershipLoginWithRepayTokenRepayTokenMutationBody =
  LoginWithRepayTokenDto;
export type PostApiMembershipLoginWithRepayTokenRepayTokenMutationError =
  unknown;

export const usePostApiMembershipLoginWithRepayTokenRepayToken = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>
      >,
      TError,
      { repayToken: string; data: LoginWithRepayTokenDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipLoginWithRepayTokenRepayToken>>,
  TError,
  { repayToken: string; data: LoginWithRepayTokenDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipLoginWithRepayTokenRepayTokenMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipLogin = (
  loginRequestDto: LoginRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultLoginResultDto>(
    {
      url: `/api/membership/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: loginRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipLoginMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipLogin>>,
    TError,
    { data: LoginRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipLogin>>,
    { data: LoginRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipLogin>>
>;
export type PostApiMembershipLoginMutationBody = LoginRequestDto;
export type PostApiMembershipLoginMutationError = unknown;

export const usePostApiMembershipLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipLogin>>,
      TError,
      { data: LoginRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipLogin>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipLoginMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipPinValid = (
  pinValidModel: PinValidModel,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultObject>(
    {
      url: `/api/membership/pinValid`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pinValidModel,
      signal,
    },
    options
  );
};

export const getPostApiMembershipPinValidMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipPinValid>>,
    TError,
    { data: PinValidModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipPinValid>>,
  TError,
  { data: PinValidModel },
  TContext
> => {
  const mutationKey = ["postApiMembershipPinValid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipPinValid>>,
    { data: PinValidModel }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipPinValid(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipPinValidMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipPinValid>>
>;
export type PostApiMembershipPinValidMutationBody = PinValidModel;
export type PostApiMembershipPinValidMutationError = unknown;

export const usePostApiMembershipPinValid = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipPinValid>>,
      TError,
      { data: PinValidModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipPinValid>>,
  TError,
  { data: PinValidModel },
  TContext
> => {
  return useMutation(
    getPostApiMembershipPinValidMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipChangePassword = (
  changePasswordDto: ChangePasswordDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/changePassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePasswordDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipChangePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipChangePassword>>,
    TError,
    { data: ChangePasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipChangePassword>>,
  TError,
  { data: ChangePasswordDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipChangePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipChangePassword>>,
    { data: ChangePasswordDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipChangePasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipChangePassword>>
>;
export type PostApiMembershipChangePasswordMutationBody = ChangePasswordDto;
export type PostApiMembershipChangePasswordMutationError = unknown;

export const usePostApiMembershipChangePassword = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipChangePassword>>,
      TError,
      { data: ChangePasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipChangePassword>>,
  TError,
  { data: ChangePasswordDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipChangePasswordMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipValidateAndChangePassword = (
  validateAndChangePasswordDto: ValidateAndChangePasswordDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultValidatePinResponseDto>(
    {
      url: `/api/membership/validateAndChangePassword`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: validateAndChangePasswordDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipValidateAndChangePasswordMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>,
    TError,
    { data: ValidateAndChangePasswordDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>,
  TError,
  { data: ValidateAndChangePasswordDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipValidateAndChangePassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>,
    { data: ValidateAndChangePasswordDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipValidateAndChangePassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipValidateAndChangePasswordMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>
  >;
export type PostApiMembershipValidateAndChangePasswordMutationBody =
  ValidateAndChangePasswordDto;
export type PostApiMembershipValidateAndChangePasswordMutationError = unknown;

export const usePostApiMembershipValidateAndChangePassword = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>,
      TError,
      { data: ValidateAndChangePasswordDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipValidateAndChangePassword>>,
  TError,
  { data: ValidateAndChangePasswordDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipValidateAndChangePasswordMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipResetCamPassword = (
  params: PostApiMembershipResetCamPasswordParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/membership/resetCamPassword`, method: "POST", params, signal },
    options
  );
};

export const getPostApiMembershipResetCamPasswordMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>,
    TError,
    { params: PostApiMembershipResetCamPasswordParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>,
  TError,
  { params: PostApiMembershipResetCamPasswordParams },
  TContext
> => {
  const mutationKey = ["postApiMembershipResetCamPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>,
    { params: PostApiMembershipResetCamPasswordParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiMembershipResetCamPassword(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipResetCamPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>
>;

export type PostApiMembershipResetCamPasswordMutationError = unknown;

export const usePostApiMembershipResetCamPassword = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>,
      TError,
      { params: PostApiMembershipResetCamPasswordParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipResetCamPassword>>,
  TError,
  { params: PostApiMembershipResetCamPasswordParams },
  TContext
> => {
  return useMutation(
    getPostApiMembershipResetCamPasswordMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipForgotPin = (
  forgotPinRequestDtoBody: ForgotPinRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultWithActionInfoBoolean>(
    {
      url: `/api/membership/forgotPin`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: forgotPinRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiMembershipForgotPinMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipForgotPin>>,
    TError,
    { data: ForgotPinRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipForgotPin>>,
  TError,
  { data: ForgotPinRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiMembershipForgotPin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipForgotPin>>,
    { data: ForgotPinRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipForgotPin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipForgotPinMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipForgotPin>>
>;
export type PostApiMembershipForgotPinMutationBody = ForgotPinRequestDtoBody;
export type PostApiMembershipForgotPinMutationError = unknown;

export const usePostApiMembershipForgotPin = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipForgotPin>>,
      TError,
      { data: ForgotPinRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipForgotPin>>,
  TError,
  { data: ForgotPinRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiMembershipForgotPinMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipToken = (
  tokenValidModel: TokenValidModel,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultObject>(
    {
      url: `/api/membership/token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tokenValidModel,
      signal,
    },
    options
  );
};

export const getPostApiMembershipTokenMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipToken>>,
    TError,
    { data: TokenValidModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipToken>>,
  TError,
  { data: TokenValidModel },
  TContext
> => {
  const mutationKey = ["postApiMembershipToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipToken>>,
    { data: TokenValidModel }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipToken(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipToken>>
>;
export type PostApiMembershipTokenMutationBody = TokenValidModel;
export type PostApiMembershipTokenMutationError = unknown;

export const usePostApiMembershipToken = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipToken>>,
      TError,
      { data: TokenValidModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipToken>>,
  TError,
  { data: TokenValidModel },
  TContext
> => {
  return useMutation(
    getPostApiMembershipTokenMutationOptions(options),
    queryClient
  );
};

export const getApiMembershipId = (
  id: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMemberDto>(
    { url: `/api/membership/${id}`, method: "GET", signal },
    options
  );
};

export const getGetApiMembershipIdQueryKey = (id: number) => {
  return [`/api/membership/${id}`] as const;
};

export const getGetApiMembershipIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiMembershipIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipId>>
  > = ({ signal }) => getApiMembershipId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipId>>
>;
export type GetApiMembershipIdQueryError = unknown;

export function useGetApiMembershipId<
  TData = Awaited<ReturnType<typeof getApiMembershipId>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipId>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipId<
  TData = Awaited<ReturnType<typeof getApiMembershipId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipId>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipId<
  TData = Awaited<ReturnType<typeof getApiMembershipId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipId<
  TData = Awaited<ReturnType<typeof getApiMembershipId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMembershipIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipMembers = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMemberDto>(
    {
      url: `/api/membership/members`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiMembershipMembersMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipMembers>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipMembers>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiMembershipMembers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipMembers>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipMembers(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipMembersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipMembers>>
>;
export type PostApiMembershipMembersMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiMembershipMembersMutationError = unknown;

export const usePostApiMembershipMembers = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipMembers>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipMembers>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiMembershipMembersMutationOptions(options),
    queryClient
  );
};

export const getApiMembershipMemberSuspectedLogins = (
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListLoginInfoDto>(
    {
      url: `/api/membership/memberSuspectedLogins`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMembershipMemberSuspectedLoginsQueryKey = (
  params?: GetApiMembershipMemberSuspectedLoginsParams
) => {
  return [
    `/api/membership/memberSuspectedLogins`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMembershipMemberSuspectedLoginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMembershipMemberSuspectedLoginsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>
  > = ({ signal }) =>
    getApiMembershipMemberSuspectedLogins(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipMemberSuspectedLoginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>
>;
export type GetApiMembershipMemberSuspectedLoginsQueryError = unknown;

export function useGetApiMembershipMemberSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipMemberSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipMemberSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipMemberSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipMemberSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipMemberSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMembershipMemberSuspectedLoginsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMembershipAllSuspectedMemberLogins = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListMemberDto>(
    { url: `/api/membership/allSuspectedMemberLogins`, method: "GET", signal },
    options
  );
};

export const getGetApiMembershipAllSuspectedMemberLoginsQueryKey = () => {
  return [`/api/membership/allSuspectedMemberLogins`] as const;
};

export const getGetApiMembershipAllSuspectedMemberLoginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMembershipAllSuspectedMemberLoginsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>
  > = ({ signal }) =>
    getApiMembershipAllSuspectedMemberLogins(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipAllSuspectedMemberLoginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>
>;
export type GetApiMembershipAllSuspectedMemberLoginsQueryError = unknown;

export function useGetApiMembershipAllSuspectedMemberLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipAllSuspectedMemberLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipAllSuspectedMemberLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipAllSuspectedMemberLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipAllSuspectedMemberLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMembershipAllSuspectedMemberLoginsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMembershipCheckSuspectedLogins = (
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/checkSuspectedLogins`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMembershipCheckSuspectedLoginsQueryKey = (
  params?: GetApiMembershipCheckSuspectedLoginsParams
) => {
  return [
    `/api/membership/checkSuspectedLogins`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMembershipCheckSuspectedLoginsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMembershipCheckSuspectedLoginsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>
  > = ({ signal }) =>
    getApiMembershipCheckSuspectedLogins(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipCheckSuspectedLoginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>
>;
export type GetApiMembershipCheckSuspectedLoginsQueryError = unknown;

export function useGetApiMembershipCheckSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipCheckSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipCheckSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipCheckSuspectedLogins<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
  TError = unknown
>(
  params: GetApiMembershipCheckSuspectedLoginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckSuspectedLogins>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMembershipCheckSuspectedLoginsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipSetAvailabilityForTicketAssign = (
  params: PostApiMembershipSetAvailabilityForTicketAssignParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/setAvailabilityForTicketAssign`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiMembershipSetAvailabilityForTicketAssignMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>
      >,
      TError,
      { params: PostApiMembershipSetAvailabilityForTicketAssignParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>>,
    TError,
    { params: PostApiMembershipSetAvailabilityForTicketAssignParams },
    TContext
  > => {
    const mutationKey = ["postApiMembershipSetAvailabilityForTicketAssign"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>
      >,
      { params: PostApiMembershipSetAvailabilityForTicketAssignParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiMembershipSetAvailabilityForTicketAssign(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMembershipSetAvailabilityForTicketAssignMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>>
  >;

export type PostApiMembershipSetAvailabilityForTicketAssignMutationError =
  unknown;

export const usePostApiMembershipSetAvailabilityForTicketAssign = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>
      >,
      TError,
      { params: PostApiMembershipSetAvailabilityForTicketAssignParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipSetAvailabilityForTicketAssign>>,
  TError,
  { params: PostApiMembershipSetAvailabilityForTicketAssignParams },
  TContext
> => {
  return useMutation(
    getPostApiMembershipSetAvailabilityForTicketAssignMutationOptions(options),
    queryClient
  );
};

export const getApiMembershipGetCamBusinessOperationPermission = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBusinessOperationPermissionDto>(
    {
      url: `/api/membership/getCamBusinessOperationPermission`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiMembershipGetCamBusinessOperationPermissionQueryKey =
  () => {
    return [`/api/membership/getCamBusinessOperationPermission`] as const;
  };

export const getGetApiMembershipGetCamBusinessOperationPermissionQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiMembershipGetCamBusinessOperationPermissionQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
      >
    > = ({ signal }) =>
      getApiMembershipGetCamBusinessOperationPermission(requestOptions, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiMembershipGetCamBusinessOperationPermissionQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
    >
  >;
export type GetApiMembershipGetCamBusinessOperationPermissionQueryError =
  unknown;

export function useGetApiMembershipGetCamBusinessOperationPermission<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetCamBusinessOperationPermission<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetCamBusinessOperationPermission<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipGetCamBusinessOperationPermission<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMembershipGetCamBusinessOperationPermission>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMembershipGetCamBusinessOperationPermissionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMembershipGetAllCamBusinessOperationPermissions = (
  params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultBusinessOperationPermissionDto>(
    {
      url: `/api/membership/getAllCamBusinessOperationPermissions`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMembershipGetAllCamBusinessOperationPermissionsQueryKey =
  (params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams) => {
    return [
      `/api/membership/getAllCamBusinessOperationPermissions`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetApiMembershipGetAllCamBusinessOperationPermissionsQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
    >,
    TError = unknown
  >(
    params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetAllCamBusinessOperationPermissions
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiMembershipGetAllCamBusinessOperationPermissionsQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
      >
    > = ({ signal }) =>
      getApiMembershipGetAllCamBusinessOperationPermissions(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiMembershipGetAllCamBusinessOperationPermissionsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
    >
  >;
export type GetApiMembershipGetAllCamBusinessOperationPermissionsQueryError =
  unknown;

export function useGetApiMembershipGetAllCamBusinessOperationPermissions<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
  >,
  TError = unknown
>(
  params:
    | undefined
    | GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetAllCamBusinessOperationPermissions
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetAllCamBusinessOperationPermissions
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiMembershipGetAllCamBusinessOperationPermissions
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetAllCamBusinessOperationPermissions<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
  >,
  TError = unknown
>(
  params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetAllCamBusinessOperationPermissions
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetAllCamBusinessOperationPermissions
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiMembershipGetAllCamBusinessOperationPermissions
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetAllCamBusinessOperationPermissions<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
  >,
  TError = unknown
>(
  params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetAllCamBusinessOperationPermissions
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipGetAllCamBusinessOperationPermissions<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetAllCamBusinessOperationPermissions>
  >,
  TError = unknown
>(
  params?: GetApiMembershipGetAllCamBusinessOperationPermissionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetAllCamBusinessOperationPermissions
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMembershipGetAllCamBusinessOperationPermissionsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipSetCamBusinessOperationPermissionOld = (
  businessOperationPermissionRequestDto: BusinessOperationPermissionRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBusinessOperationPermissionDto>(
    {
      url: `/api/membership/setCamBusinessOperationPermissionOld`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: businessOperationPermissionRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipSetCamBusinessOperationPermissionOldMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
      >,
      TError,
      { data: BusinessOperationPermissionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
    >,
    TError,
    { data: BusinessOperationPermissionRequestDto },
    TContext
  > => {
    const mutationKey = [
      "postApiMembershipSetCamBusinessOperationPermissionOld",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
      >,
      { data: BusinessOperationPermissionRequestDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiMembershipSetCamBusinessOperationPermissionOld(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMembershipSetCamBusinessOperationPermissionOldMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
    >
  >;
export type PostApiMembershipSetCamBusinessOperationPermissionOldMutationBody =
  BusinessOperationPermissionRequestDto;
export type PostApiMembershipSetCamBusinessOperationPermissionOldMutationError =
  unknown;

export const usePostApiMembershipSetCamBusinessOperationPermissionOld = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
      >,
      TError,
      { data: BusinessOperationPermissionRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiMembershipSetCamBusinessOperationPermissionOld>
  >,
  TError,
  { data: BusinessOperationPermissionRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipSetCamBusinessOperationPermissionOldMutationOptions(
      options
    ),
    queryClient
  );
};

export const getApiMembershipGetSuspectedLoginRelationMemberHistory = (
  params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSuspectedLoginMemberRelationHistoryDto>(
    {
      url: `/api/membership/getSuspectedLoginRelationMemberHistory`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryKey =
  (params?: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams) => {
    return [
      `/api/membership/getSuspectedLoginRelationMemberHistory`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
    >,
    TError = unknown
  >(
    params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof customInstance>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
        >
      >
    > = ({ signal }) =>
      getApiMembershipGetSuspectedLoginRelationMemberHistory(
        params,
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
    >
  >;
export type GetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryError =
  unknown;

export function useGetApiMembershipGetSuspectedLoginRelationMemberHistory<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
  >,
  TError = unknown
>(
  params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetSuspectedLoginRelationMemberHistory<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
  >,
  TError = unknown
>(
  params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipGetSuspectedLoginRelationMemberHistory<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
  >,
  TError = unknown
>(
  params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipGetSuspectedLoginRelationMemberHistory<
  TData = Awaited<
    ReturnType<typeof getApiMembershipGetSuspectedLoginRelationMemberHistory>
  >,
  TError = unknown
>(
  params: GetApiMembershipGetSuspectedLoginRelationMemberHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiMembershipGetSuspectedLoginRelationMemberHistory
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMembershipGetSuspectedLoginRelationMemberHistoryQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipSendNewPin = (
  sendNewPinRequestDto: SendNewPinRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultWithActionInfoBoolean>(
    {
      url: `/api/membership/sendNewPin`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendNewPinRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipSendNewPinMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipSendNewPin>>,
    TError,
    { data: SendNewPinRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipSendNewPin>>,
  TError,
  { data: SendNewPinRequestDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipSendNewPin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipSendNewPin>>,
    { data: SendNewPinRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipSendNewPin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipSendNewPinMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipSendNewPin>>
>;
export type PostApiMembershipSendNewPinMutationBody = SendNewPinRequestDto;
export type PostApiMembershipSendNewPinMutationError = unknown;

export const usePostApiMembershipSendNewPin = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipSendNewPin>>,
      TError,
      { data: SendNewPinRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipSendNewPin>>,
  TError,
  { data: SendNewPinRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipSendNewPinMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipResendVerificationMail = (
  resendVerificationMailRequestDto: ResendVerificationMailRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultResendVerificationMailResultDto>(
    {
      url: `/api/membership/resendVerificationMail`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resendVerificationMailRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipResendVerificationMailMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>,
    TError,
    { data: ResendVerificationMailRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>,
  TError,
  { data: ResendVerificationMailRequestDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipResendVerificationMail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>,
    { data: ResendVerificationMailRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipResendVerificationMail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipResendVerificationMailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>
>;
export type PostApiMembershipResendVerificationMailMutationBody =
  ResendVerificationMailRequestDto;
export type PostApiMembershipResendVerificationMailMutationError = unknown;

export const usePostApiMembershipResendVerificationMail = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>,
      TError,
      { data: ResendVerificationMailRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipResendVerificationMail>>,
  TError,
  { data: ResendVerificationMailRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipResendVerificationMailMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipReSendOTP = (
  forgotPinRequestDtoBody: ForgotPinRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/reSendOTP`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: forgotPinRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiMembershipReSendOTPMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipReSendOTP>>,
    TError,
    { data: ForgotPinRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipReSendOTP>>,
  TError,
  { data: ForgotPinRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiMembershipReSendOTP"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipReSendOTP>>,
    { data: ForgotPinRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipReSendOTP(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipReSendOTPMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipReSendOTP>>
>;
export type PostApiMembershipReSendOTPMutationBody = ForgotPinRequestDtoBody;
export type PostApiMembershipReSendOTPMutationError = unknown;

export const usePostApiMembershipReSendOTP = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipReSendOTP>>,
      TError,
      { data: ForgotPinRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipReSendOTP>>,
  TError,
  { data: ForgotPinRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiMembershipReSendOTPMutationOptions(options),
    queryClient
  );
};

export const postApiMembershipGetPintryStatus = (
  checkMemberPinTryCount: CheckMemberPinTryCount,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/GetPintryStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: checkMemberPinTryCount,
      signal,
    },
    options
  );
};

export const getPostApiMembershipGetPintryStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>,
    TError,
    { data: CheckMemberPinTryCount },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>,
  TError,
  { data: CheckMemberPinTryCount },
  TContext
> => {
  const mutationKey = ["postApiMembershipGetPintryStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>,
    { data: CheckMemberPinTryCount }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipGetPintryStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipGetPintryStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>
>;
export type PostApiMembershipGetPintryStatusMutationBody =
  CheckMemberPinTryCount;
export type PostApiMembershipGetPintryStatusMutationError = unknown;

export const usePostApiMembershipGetPintryStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>,
      TError,
      { data: CheckMemberPinTryCount },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipGetPintryStatus>>,
  TError,
  { data: CheckMemberPinTryCount },
  TContext
> => {
  return useMutation(
    getPostApiMembershipGetPintryStatusMutationOptions(options),
    queryClient
  );
};

export const getApiMembershipCheckPasswordFlag = (
  params: GetApiMembershipCheckPasswordFlagParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultNullableMemberOtpRegister>(
    { url: `/api/membership/CheckPasswordFlag`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMembershipCheckPasswordFlagQueryKey = (
  params?: GetApiMembershipCheckPasswordFlagParams
) => {
  return [
    `/api/membership/CheckPasswordFlag`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMembershipCheckPasswordFlagQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
  TError = unknown
>(
  params: GetApiMembershipCheckPasswordFlagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMembershipCheckPasswordFlagQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>
  > = ({ signal }) =>
    getApiMembershipCheckPasswordFlag(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipCheckPasswordFlagQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>
>;
export type GetApiMembershipCheckPasswordFlagQueryError = unknown;

export function useGetApiMembershipCheckPasswordFlag<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
  TError = unknown
>(
  params: GetApiMembershipCheckPasswordFlagParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipCheckPasswordFlag<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
  TError = unknown
>(
  params: GetApiMembershipCheckPasswordFlagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipCheckPasswordFlag<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
  TError = unknown
>(
  params: GetApiMembershipCheckPasswordFlagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipCheckPasswordFlag<
  TData = Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
  TError = unknown
>(
  params: GetApiMembershipCheckPasswordFlagParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipCheckPasswordFlag>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMembershipCheckPasswordFlagQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMembershipPageViewInsert = (
  pageViewInsertDto: PageViewInsertDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/membership/pageViewInsert`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pageViewInsertDto,
      signal,
    },
    options
  );
};

export const getPostApiMembershipPageViewInsertMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>,
    TError,
    { data: PageViewInsertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>,
  TError,
  { data: PageViewInsertDto },
  TContext
> => {
  const mutationKey = ["postApiMembershipPageViewInsert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>,
    { data: PageViewInsertDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMembershipPageViewInsert(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMembershipPageViewInsertMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>
>;
export type PostApiMembershipPageViewInsertMutationBody = PageViewInsertDto;
export type PostApiMembershipPageViewInsertMutationError = unknown;

export const usePostApiMembershipPageViewInsert = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>,
      TError,
      { data: PageViewInsertDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMembershipPageViewInsert>>,
  TError,
  { data: PageViewInsertDto },
  TContext
> => {
  return useMutation(
    getPostApiMembershipPageViewInsertMutationOptions(options),
    queryClient
  );
};

export const getApiMembershipEmailLoginVerify = (
  params: GetApiMembershipEmailLoginVerifyParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | GetApiMembershipEmailLoginVerify200One
    | GetApiMembershipEmailLoginVerify200Two
    | Blob
  >(
    { url: `/api/membership/emailLoginVerify`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMembershipEmailLoginVerifyQueryKey = (
  params?: GetApiMembershipEmailLoginVerifyParams
) => {
  return [
    `/api/membership/emailLoginVerify`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMembershipEmailLoginVerifyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
  TError = unknown
>(
  params: GetApiMembershipEmailLoginVerifyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMembershipEmailLoginVerifyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>
  > = ({ signal }) =>
    getApiMembershipEmailLoginVerify(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMembershipEmailLoginVerifyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>
>;
export type GetApiMembershipEmailLoginVerifyQueryError = unknown;

export function useGetApiMembershipEmailLoginVerify<
  TData = Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
  TError = unknown
>(
  params: GetApiMembershipEmailLoginVerifyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipEmailLoginVerify<
  TData = Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
  TError = unknown
>(
  params: GetApiMembershipEmailLoginVerifyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
          TError,
          Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMembershipEmailLoginVerify<
  TData = Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
  TError = unknown
>(
  params: GetApiMembershipEmailLoginVerifyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMembershipEmailLoginVerify<
  TData = Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
  TError = unknown
>(
  params: GetApiMembershipEmailLoginVerifyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMembershipEmailLoginVerify>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMembershipEmailLoginVerifyQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMiscThrowexception = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/misc/throwexception`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscThrowexceptionQueryKey = () => {
  return [`/api/misc/throwexception`] as const;
};

export const getGetApiMiscThrowexceptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscThrowexception>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscThrowexception>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscThrowexceptionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscThrowexception>>
  > = ({ signal }) => getApiMiscThrowexception(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscThrowexception>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscThrowexceptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscThrowexception>>
>;
export type GetApiMiscThrowexceptionQueryError = unknown;

export function useGetApiMiscThrowexception<
  TData = Awaited<ReturnType<typeof getApiMiscThrowexception>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscThrowexception>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscThrowexception>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscThrowexception>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscThrowexception<
  TData = Awaited<ReturnType<typeof getApiMiscThrowexception>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscThrowexception>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscThrowexception>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscThrowexception>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscThrowexception<
  TData = Awaited<ReturnType<typeof getApiMiscThrowexception>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscThrowexception>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscThrowexception<
  TData = Awaited<ReturnType<typeof getApiMiscThrowexception>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscThrowexception>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscThrowexceptionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMiscLog = (
  params?: GetApiMiscLogParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultFrontLogModel>(
    { url: `/api/misc/log`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMiscLogQueryKey = (params?: GetApiMiscLogParams) => {
  return [`/api/misc/log`, ...(params ? [params] : [])] as const;
};

export const getGetApiMiscLogQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscLog>>,
  TError = unknown
>(
  params?: GetApiMiscLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiMiscLog>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiMiscLogQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMiscLog>>> = ({
    signal,
  }) => getApiMiscLog(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscLog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscLog>>
>;
export type GetApiMiscLogQueryError = unknown;

export function useGetApiMiscLog<
  TData = Awaited<ReturnType<typeof getApiMiscLog>>,
  TError = unknown
>(
  params: undefined | GetApiMiscLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiMiscLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscLog>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscLog>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscLog<
  TData = Awaited<ReturnType<typeof getApiMiscLog>>,
  TError = unknown
>(
  params?: GetApiMiscLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiMiscLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscLog>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscLog>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscLog<
  TData = Awaited<ReturnType<typeof getApiMiscLog>>,
  TError = unknown
>(
  params?: GetApiMiscLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiMiscLog>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscLog<
  TData = Awaited<ReturnType<typeof getApiMiscLog>>,
  TError = unknown
>(
  params?: GetApiMiscLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiMiscLog>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscLogQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscLog = (
  frontLogModel: FrontLogModel,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/log`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: frontLogModel,
      signal,
    },
    options
  );
};

export const getPostApiMiscLogMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscLog>>,
    TError,
    { data: FrontLogModel },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscLog>>,
  TError,
  { data: FrontLogModel },
  TContext
> => {
  const mutationKey = ["postApiMiscLog"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscLog>>,
    { data: FrontLogModel }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscLog(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscLogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscLog>>
>;
export type PostApiMiscLogMutationBody = FrontLogModel;
export type PostApiMiscLogMutationError = unknown;

export const usePostApiMiscLog = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscLog>>,
      TError,
      { data: FrontLogModel },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscLog>>,
  TError,
  { data: FrontLogModel },
  TContext
> => {
  return useMutation(getPostApiMiscLogMutationOptions(options), queryClient);
};

export const getApiMiscIpLocations = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/misc/ipLocations`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscIpLocationsQueryKey = () => {
  return [`/api/misc/ipLocations`] as const;
};

export const getGetApiMiscIpLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscIpLocations>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscIpLocations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiMiscIpLocationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscIpLocations>>
  > = ({ signal }) => getApiMiscIpLocations(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscIpLocations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscIpLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscIpLocations>>
>;
export type GetApiMiscIpLocationsQueryError = unknown;

export function useGetApiMiscIpLocations<
  TData = Awaited<ReturnType<typeof getApiMiscIpLocations>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscIpLocations>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscIpLocations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscIpLocations<
  TData = Awaited<ReturnType<typeof getApiMiscIpLocations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpLocations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscIpLocations>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscIpLocations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscIpLocations<
  TData = Awaited<ReturnType<typeof getApiMiscIpLocations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpLocations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscIpLocations<
  TData = Awaited<ReturnType<typeof getApiMiscIpLocations>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpLocations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscIpLocationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscIpLocations = (
  postApiMiscIpLocationsBody: PostApiMiscIpLocationsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  if (postApiMiscIpLocationsBody.File !== undefined) {
    formData.append(`File`, postApiMiscIpLocationsBody.File);
  }

  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/ipLocations`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options
  );
};

export const getPostApiMiscIpLocationsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscIpLocations>>,
    TError,
    { data: PostApiMiscIpLocationsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscIpLocations>>,
  TError,
  { data: PostApiMiscIpLocationsBody },
  TContext
> => {
  const mutationKey = ["postApiMiscIpLocations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscIpLocations>>,
    { data: PostApiMiscIpLocationsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscIpLocations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscIpLocationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscIpLocations>>
>;
export type PostApiMiscIpLocationsMutationBody = PostApiMiscIpLocationsBody;
export type PostApiMiscIpLocationsMutationError = unknown;

export const usePostApiMiscIpLocations = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscIpLocations>>,
      TError,
      { data: PostApiMiscIpLocationsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscIpLocations>>,
  TError,
  { data: PostApiMiscIpLocationsBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscIpLocationsMutationOptions(options),
    queryClient
  );
};

export const getApiMiscTranslationsByCultureAndKey = (
  params?: GetApiMiscTranslationsByCultureAndKeyParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTranslationDto>(
    {
      url: `/api/misc/translationsByCultureAndKey`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMiscTranslationsByCultureAndKeyQueryKey = (
  params?: GetApiMiscTranslationsByCultureAndKeyParams
) => {
  return [
    `/api/misc/translationsByCultureAndKey`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMiscTranslationsByCultureAndKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationsByCultureAndKeyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMiscTranslationsByCultureAndKeyQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>
  > = ({ signal }) =>
    getApiMiscTranslationsByCultureAndKey(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscTranslationsByCultureAndKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>
>;
export type GetApiMiscTranslationsByCultureAndKeyQueryError = unknown;

export function useGetApiMiscTranslationsByCultureAndKey<
  TData = Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
  TError = unknown
>(
  params: undefined | GetApiMiscTranslationsByCultureAndKeyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscTranslationsByCultureAndKey<
  TData = Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationsByCultureAndKeyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscTranslationsByCultureAndKey<
  TData = Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationsByCultureAndKeyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscTranslationsByCultureAndKey<
  TData = Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationsByCultureAndKeyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslationsByCultureAndKey>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscTranslationsByCultureAndKeyQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMiscTranslation = (
  params?: GetApiMiscTranslationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTranslationDto>(
    { url: `/api/misc/translation`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMiscTranslationQueryKey = (
  params?: GetApiMiscTranslationParams
) => {
  return [`/api/misc/translation`, ...(params ? [params] : [])] as const;
};

export const getGetApiMiscTranslationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscTranslation>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscTranslationQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscTranslation>>
  > = ({ signal }) => getApiMiscTranslation(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscTranslation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscTranslationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscTranslation>>
>;
export type GetApiMiscTranslationQueryError = unknown;

export function useGetApiMiscTranslation<
  TData = Awaited<ReturnType<typeof getApiMiscTranslation>>,
  TError = unknown
>(
  params: undefined | GetApiMiscTranslationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscTranslation>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscTranslation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscTranslation<
  TData = Awaited<ReturnType<typeof getApiMiscTranslation>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscTranslation>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscTranslation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscTranslation<
  TData = Awaited<ReturnType<typeof getApiMiscTranslation>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscTranslation<
  TData = Awaited<ReturnType<typeof getApiMiscTranslation>>,
  TError = unknown
>(
  params?: GetApiMiscTranslationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscTranslation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscTranslationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscMockStatusCode = (
  code:
    | "continue"
    | "switchingProtocols"
    | "oK"
    | "created"
    | "accepted"
    | "nonAuthoritativeInformation"
    | "noContent"
    | "resetContent"
    | "partialContent"
    | "multipleChoices"
    | "ambiguous"
    | "movedPermanently"
    | "moved"
    | "found"
    | "redirect"
    | "seeOther"
    | "redirectMethod"
    | "notModified"
    | "useProxy"
    | "unused"
    | "temporaryRedirect"
    | "redirectKeepVerb"
    | "badRequest"
    | "unauthorized"
    | "paymentRequired"
    | "forbidden"
    | "notFound"
    | "methodNotAllowed"
    | "notAcceptable"
    | "proxyAuthenticationRequired"
    | "requestTimeout"
    | "conflict"
    | "gone"
    | "lengthRequired"
    | "preconditionFailed"
    | "requestEntityTooLarge"
    | "requestUriTooLong"
    | "unsupportedMediaType"
    | "requestedRangeNotSatisfiable"
    | "expectationFailed"
    | "upgradeRequired"
    | "internalServerError"
    | "notImplemented"
    | "badGateway"
    | "serviceUnavailable"
    | "gatewayTimeout"
    | "httpVersionNotSupported",
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    PostApiMiscMockStatusCode200One | PostApiMiscMockStatusCode200Two | Blob
  >(
    {
      url: `/api/misc/mock/status/${code}`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscMockStatusCodeMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscMockStatusCode>>,
    TError,
    {
      code:
        | "continue"
        | "switchingProtocols"
        | "oK"
        | "created"
        | "accepted"
        | "nonAuthoritativeInformation"
        | "noContent"
        | "resetContent"
        | "partialContent"
        | "multipleChoices"
        | "ambiguous"
        | "movedPermanently"
        | "moved"
        | "found"
        | "redirect"
        | "seeOther"
        | "redirectMethod"
        | "notModified"
        | "useProxy"
        | "unused"
        | "temporaryRedirect"
        | "redirectKeepVerb"
        | "badRequest"
        | "unauthorized"
        | "paymentRequired"
        | "forbidden"
        | "notFound"
        | "methodNotAllowed"
        | "notAcceptable"
        | "proxyAuthenticationRequired"
        | "requestTimeout"
        | "conflict"
        | "gone"
        | "lengthRequired"
        | "preconditionFailed"
        | "requestEntityTooLarge"
        | "requestUriTooLong"
        | "unsupportedMediaType"
        | "requestedRangeNotSatisfiable"
        | "expectationFailed"
        | "upgradeRequired"
        | "internalServerError"
        | "notImplemented"
        | "badGateway"
        | "serviceUnavailable"
        | "gatewayTimeout"
        | "httpVersionNotSupported";
      data: BankScraperNotifySmsValueBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscMockStatusCode>>,
  TError,
  {
    code:
      | "continue"
      | "switchingProtocols"
      | "oK"
      | "created"
      | "accepted"
      | "nonAuthoritativeInformation"
      | "noContent"
      | "resetContent"
      | "partialContent"
      | "multipleChoices"
      | "ambiguous"
      | "movedPermanently"
      | "moved"
      | "found"
      | "redirect"
      | "seeOther"
      | "redirectMethod"
      | "notModified"
      | "useProxy"
      | "unused"
      | "temporaryRedirect"
      | "redirectKeepVerb"
      | "badRequest"
      | "unauthorized"
      | "paymentRequired"
      | "forbidden"
      | "notFound"
      | "methodNotAllowed"
      | "notAcceptable"
      | "proxyAuthenticationRequired"
      | "requestTimeout"
      | "conflict"
      | "gone"
      | "lengthRequired"
      | "preconditionFailed"
      | "requestEntityTooLarge"
      | "requestUriTooLong"
      | "unsupportedMediaType"
      | "requestedRangeNotSatisfiable"
      | "expectationFailed"
      | "upgradeRequired"
      | "internalServerError"
      | "notImplemented"
      | "badGateway"
      | "serviceUnavailable"
      | "gatewayTimeout"
      | "httpVersionNotSupported";
    data: BankScraperNotifySmsValueBody;
  },
  TContext
> => {
  const mutationKey = ["postApiMiscMockStatusCode"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscMockStatusCode>>,
    {
      code:
        | "continue"
        | "switchingProtocols"
        | "oK"
        | "created"
        | "accepted"
        | "nonAuthoritativeInformation"
        | "noContent"
        | "resetContent"
        | "partialContent"
        | "multipleChoices"
        | "ambiguous"
        | "movedPermanently"
        | "moved"
        | "found"
        | "redirect"
        | "seeOther"
        | "redirectMethod"
        | "notModified"
        | "useProxy"
        | "unused"
        | "temporaryRedirect"
        | "redirectKeepVerb"
        | "badRequest"
        | "unauthorized"
        | "paymentRequired"
        | "forbidden"
        | "notFound"
        | "methodNotAllowed"
        | "notAcceptable"
        | "proxyAuthenticationRequired"
        | "requestTimeout"
        | "conflict"
        | "gone"
        | "lengthRequired"
        | "preconditionFailed"
        | "requestEntityTooLarge"
        | "requestUriTooLong"
        | "unsupportedMediaType"
        | "requestedRangeNotSatisfiable"
        | "expectationFailed"
        | "upgradeRequired"
        | "internalServerError"
        | "notImplemented"
        | "badGateway"
        | "serviceUnavailable"
        | "gatewayTimeout"
        | "httpVersionNotSupported";
      data: BankScraperNotifySmsValueBody;
    }
  > = (props) => {
    const { code, data } = props ?? {};

    return postApiMiscMockStatusCode(code, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscMockStatusCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscMockStatusCode>>
>;
export type PostApiMiscMockStatusCodeMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiMiscMockStatusCodeMutationError = unknown;

export const usePostApiMiscMockStatusCode = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscMockStatusCode>>,
      TError,
      {
        code:
          | "continue"
          | "switchingProtocols"
          | "oK"
          | "created"
          | "accepted"
          | "nonAuthoritativeInformation"
          | "noContent"
          | "resetContent"
          | "partialContent"
          | "multipleChoices"
          | "ambiguous"
          | "movedPermanently"
          | "moved"
          | "found"
          | "redirect"
          | "seeOther"
          | "redirectMethod"
          | "notModified"
          | "useProxy"
          | "unused"
          | "temporaryRedirect"
          | "redirectKeepVerb"
          | "badRequest"
          | "unauthorized"
          | "paymentRequired"
          | "forbidden"
          | "notFound"
          | "methodNotAllowed"
          | "notAcceptable"
          | "proxyAuthenticationRequired"
          | "requestTimeout"
          | "conflict"
          | "gone"
          | "lengthRequired"
          | "preconditionFailed"
          | "requestEntityTooLarge"
          | "requestUriTooLong"
          | "unsupportedMediaType"
          | "requestedRangeNotSatisfiable"
          | "expectationFailed"
          | "upgradeRequired"
          | "internalServerError"
          | "notImplemented"
          | "badGateway"
          | "serviceUnavailable"
          | "gatewayTimeout"
          | "httpVersionNotSupported";
        data: BankScraperNotifySmsValueBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscMockStatusCode>>,
  TError,
  {
    code:
      | "continue"
      | "switchingProtocols"
      | "oK"
      | "created"
      | "accepted"
      | "nonAuthoritativeInformation"
      | "noContent"
      | "resetContent"
      | "partialContent"
      | "multipleChoices"
      | "ambiguous"
      | "movedPermanently"
      | "moved"
      | "found"
      | "redirect"
      | "seeOther"
      | "redirectMethod"
      | "notModified"
      | "useProxy"
      | "unused"
      | "temporaryRedirect"
      | "redirectKeepVerb"
      | "badRequest"
      | "unauthorized"
      | "paymentRequired"
      | "forbidden"
      | "notFound"
      | "methodNotAllowed"
      | "notAcceptable"
      | "proxyAuthenticationRequired"
      | "requestTimeout"
      | "conflict"
      | "gone"
      | "lengthRequired"
      | "preconditionFailed"
      | "requestEntityTooLarge"
      | "requestUriTooLong"
      | "unsupportedMediaType"
      | "requestedRangeNotSatisfiable"
      | "expectationFailed"
      | "upgradeRequired"
      | "internalServerError"
      | "notImplemented"
      | "badGateway"
      | "serviceUnavailable"
      | "gatewayTimeout"
      | "httpVersionNotSupported";
    data: BankScraperNotifySmsValueBody;
  },
  TContext
> => {
  return useMutation(
    getPostApiMiscMockStatusCodeMutationOptions(options),
    queryClient
  );
};

export const postApiMiscTranslationBusinessException = (
  translationGetDto: TranslationGetDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTranslationDto>(
    {
      url: `/api/misc/translation/businessException`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: translationGetDto,
      signal,
    },
    options
  );
};

export const getPostApiMiscTranslationBusinessExceptionMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>,
    TError,
    { data: TranslationGetDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>,
  TError,
  { data: TranslationGetDto },
  TContext
> => {
  const mutationKey = ["postApiMiscTranslationBusinessException"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>,
    { data: TranslationGetDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscTranslationBusinessException(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscTranslationBusinessExceptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>
>;
export type PostApiMiscTranslationBusinessExceptionMutationBody =
  TranslationGetDto;
export type PostApiMiscTranslationBusinessExceptionMutationError = unknown;

export const usePostApiMiscTranslationBusinessException = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>,
      TError,
      { data: TranslationGetDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscTranslationBusinessException>>,
  TError,
  { data: TranslationGetDto },
  TContext
> => {
  return useMutation(
    getPostApiMiscTranslationBusinessExceptionMutationOptions(options),
    queryClient
  );
};

export const getApiMiscAzureEnvironmentVariables = (
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryStringDictionaryStringString>(
    {
      url: `/api/misc/azure/environmentVariables`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMiscAzureEnvironmentVariablesQueryKey = (
  params?: GetApiMiscAzureEnvironmentVariablesParams
) => {
  return [
    `/api/misc/azure/environmentVariables`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMiscAzureEnvironmentVariablesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
  TError = unknown
>(
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMiscAzureEnvironmentVariablesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>
  > = ({ signal }) =>
    getApiMiscAzureEnvironmentVariables(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscAzureEnvironmentVariablesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>
>;
export type GetApiMiscAzureEnvironmentVariablesQueryError = unknown;

export function useGetApiMiscAzureEnvironmentVariables<
  TData = Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
  TError = unknown
>(
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscAzureEnvironmentVariables<
  TData = Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
  TError = unknown
>(
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscAzureEnvironmentVariables<
  TData = Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
  TError = unknown
>(
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscAzureEnvironmentVariables<
  TData = Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
  TError = unknown
>(
  params: GetApiMiscAzureEnvironmentVariablesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscAzureEnvironmentVariables>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscAzureEnvironmentVariablesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscAzureRemoveOldBranches = (
  params?: PostApiMiscAzureRemoveOldBranchesParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/misc/azure/removeOldBranches`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiMiscAzureRemoveOldBranchesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>,
    TError,
    { params?: PostApiMiscAzureRemoveOldBranchesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>,
  TError,
  { params?: PostApiMiscAzureRemoveOldBranchesParams },
  TContext
> => {
  const mutationKey = ["postApiMiscAzureRemoveOldBranches"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>,
    { params?: PostApiMiscAzureRemoveOldBranchesParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiMiscAzureRemoveOldBranches(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscAzureRemoveOldBranchesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>
>;

export type PostApiMiscAzureRemoveOldBranchesMutationError = unknown;

export const usePostApiMiscAzureRemoveOldBranches = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>,
      TError,
      { params?: PostApiMiscAzureRemoveOldBranchesParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscAzureRemoveOldBranches>>,
  TError,
  { params?: PostApiMiscAzureRemoveOldBranchesParams },
  TContext
> => {
  return useMutation(
    getPostApiMiscAzureRemoveOldBranchesMutationOptions(options),
    queryClient
  );
};

export const getApiMiscScamalytics = (
  params: GetApiMiscScamalyticsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultScamalyticsResult>(
    { url: `/api/misc/scamalytics`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMiscScamalyticsQueryKey = (
  params?: GetApiMiscScamalyticsParams
) => {
  return [`/api/misc/scamalytics`, ...(params ? [params] : [])] as const;
};

export const getGetApiMiscScamalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscScamalytics>>,
  TError = unknown
>(
  params: GetApiMiscScamalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscScamalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscScamalyticsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscScamalytics>>
  > = ({ signal }) => getApiMiscScamalytics(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscScamalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscScamalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscScamalytics>>
>;
export type GetApiMiscScamalyticsQueryError = unknown;

export function useGetApiMiscScamalytics<
  TData = Awaited<ReturnType<typeof getApiMiscScamalytics>>,
  TError = unknown
>(
  params: GetApiMiscScamalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscScamalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscScamalytics>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscScamalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscScamalytics<
  TData = Awaited<ReturnType<typeof getApiMiscScamalytics>>,
  TError = unknown
>(
  params: GetApiMiscScamalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscScamalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscScamalytics>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscScamalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscScamalytics<
  TData = Awaited<ReturnType<typeof getApiMiscScamalytics>>,
  TError = unknown
>(
  params: GetApiMiscScamalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscScamalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscScamalytics<
  TData = Awaited<ReturnType<typeof getApiMiscScamalytics>>,
  TError = unknown
>(
  params: GetApiMiscScamalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscScamalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscScamalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscScamalytics = (
  scamalyticsResult: ScamalyticsResult,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/scamalytics`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: scamalyticsResult,
      signal,
    },
    options
  );
};

export const getPostApiMiscScamalyticsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscScamalytics>>,
    TError,
    { data: ScamalyticsResult },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscScamalytics>>,
  TError,
  { data: ScamalyticsResult },
  TContext
> => {
  const mutationKey = ["postApiMiscScamalytics"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscScamalytics>>,
    { data: ScamalyticsResult }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscScamalytics(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscScamalyticsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscScamalytics>>
>;
export type PostApiMiscScamalyticsMutationBody = ScamalyticsResult;
export type PostApiMiscScamalyticsMutationError = unknown;

export const usePostApiMiscScamalytics = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscScamalytics>>,
      TError,
      { data: ScamalyticsResult },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscScamalytics>>,
  TError,
  { data: ScamalyticsResult },
  TContext
> => {
  return useMutation(
    getPostApiMiscScamalyticsMutationOptions(options),
    queryClient
  );
};

export const postApiMiscScamalyticsList = (
  postApiMiscScamalyticsListBody:
    | PostApiMiscScamalyticsListBodyOneItem[]
    | PostApiMiscScamalyticsListBodyTwoItem[]
    | PostApiMiscScamalyticsListBodyThreeItem[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListScamalyticsResult>(
    {
      url: `/api/misc/scamalytics/list`,
      method: "POST",
      data: postApiMiscScamalyticsListBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscScamalyticsListMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscScamalyticsList>>,
    TError,
    {
      data:
        | PostApiMiscScamalyticsListBodyOneItem[]
        | PostApiMiscScamalyticsListBodyTwoItem[]
        | PostApiMiscScamalyticsListBodyThreeItem[];
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscScamalyticsList>>,
  TError,
  {
    data:
      | PostApiMiscScamalyticsListBodyOneItem[]
      | PostApiMiscScamalyticsListBodyTwoItem[]
      | PostApiMiscScamalyticsListBodyThreeItem[];
  },
  TContext
> => {
  const mutationKey = ["postApiMiscScamalyticsList"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscScamalyticsList>>,
    {
      data:
        | PostApiMiscScamalyticsListBodyOneItem[]
        | PostApiMiscScamalyticsListBodyTwoItem[]
        | PostApiMiscScamalyticsListBodyThreeItem[];
    }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscScamalyticsList(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscScamalyticsListMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscScamalyticsList>>
>;
export type PostApiMiscScamalyticsListMutationBody =
  | PostApiMiscScamalyticsListBodyOneItem[]
  | PostApiMiscScamalyticsListBodyTwoItem[]
  | PostApiMiscScamalyticsListBodyThreeItem[];
export type PostApiMiscScamalyticsListMutationError = unknown;

export const usePostApiMiscScamalyticsList = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscScamalyticsList>>,
      TError,
      {
        data:
          | PostApiMiscScamalyticsListBodyOneItem[]
          | PostApiMiscScamalyticsListBodyTwoItem[]
          | PostApiMiscScamalyticsListBodyThreeItem[];
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscScamalyticsList>>,
  TError,
  {
    data:
      | PostApiMiscScamalyticsListBodyOneItem[]
      | PostApiMiscScamalyticsListBodyTwoItem[]
      | PostApiMiscScamalyticsListBodyThreeItem[];
  },
  TContext
> => {
  return useMutation(
    getPostApiMiscScamalyticsListMutationOptions(options),
    queryClient
  );
};

export const postApiMiscIpbannerLocalSet = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/ipbanner/local/set`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscIpbannerLocalSetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  const mutationKey = ["postApiMiscIpbannerLocalSet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscIpbannerLocalSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscIpbannerLocalSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>
>;
export type PostApiMiscIpbannerLocalSetMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiMiscIpbannerLocalSetMutationError = unknown;

export const usePostApiMiscIpbannerLocalSet = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalSet>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscIpbannerLocalSetMutationOptions(options),
    queryClient
  );
};

export const getApiMiscIpbannerLocalList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultStringArray>(
    { url: `/api/misc/ipbanner/local/list`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscIpbannerLocalListQueryKey = () => {
  return [`/api/misc/ipbanner/local/list`] as const;
};

export const getGetApiMiscIpbannerLocalListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscIpbannerLocalListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>
  > = ({ signal }) => getApiMiscIpbannerLocalList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscIpbannerLocalListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>
>;
export type GetApiMiscIpbannerLocalListQueryError = unknown;

export function useGetApiMiscIpbannerLocalList<
  TData = Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscIpbannerLocalList<
  TData = Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscIpbannerLocalList<
  TData = Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscIpbannerLocalList<
  TData = Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscIpbannerLocalList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscIpbannerLocalListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscIpbannerLocalRemove = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/ipbanner/local/remove`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscIpbannerLocalRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  const mutationKey = ["postApiMiscIpbannerLocalRemove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscIpbannerLocalRemove(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscIpbannerLocalRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>
>;
export type PostApiMiscIpbannerLocalRemoveMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiMiscIpbannerLocalRemoveMutationError = unknown;

export const usePostApiMiscIpbannerLocalRemove = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscIpbannerLocalRemove>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscIpbannerLocalRemoveMutationOptions(options),
    queryClient
  );
};

export const postApiMiscIpbannerElbSet = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListIRestResponse>(
    {
      url: `/api/misc/ipbanner/elb/set`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscIpbannerElbSetMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  const mutationKey = ["postApiMiscIpbannerElbSet"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscIpbannerElbSet(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscIpbannerElbSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>
>;
export type PostApiMiscIpbannerElbSetMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiMiscIpbannerElbSetMutationError = unknown;

export const usePostApiMiscIpbannerElbSet = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbSet>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscIpbannerElbSetMutationOptions(options),
    queryClient
  );
};

export const postApiMiscIpbannerElbRemove = (
  communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListIRestResponse>(
    {
      url: `/api/misc/ipbanner/elb/remove`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: communicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscIpbannerElbRemoveMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>,
    TError,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  const mutationKey = ["postApiMiscIpbannerElbRemove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>,
    { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscIpbannerElbRemove(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscIpbannerElbRemoveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>
>;
export type PostApiMiscIpbannerElbRemoveMutationBody =
  CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody;
export type PostApiMiscIpbannerElbRemoveMutationError = unknown;

export const usePostApiMiscIpbannerElbRemove = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>,
      TError,
      { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscIpbannerElbRemove>>,
  TError,
  { data: CommunicationRunAgainVoiscopeCallReportErrorsByIdsIdsBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscIpbannerElbRemoveMutationOptions(options),
    queryClient
  );
};

export const getApiMiscOnlineUsers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultHashSetOnlineUserDto>(
    { url: `/api/misc/onlineUsers`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscOnlineUsersQueryKey = () => {
  return [`/api/misc/onlineUsers`] as const;
};

export const getGetApiMiscOnlineUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiMiscOnlineUsersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscOnlineUsers>>
  > = ({ signal }) => getApiMiscOnlineUsers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscOnlineUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscOnlineUsers>>
>;
export type GetApiMiscOnlineUsersQueryError = unknown;

export function useGetApiMiscOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscOnlineUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscOnlineUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscOnlineUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscOnlineUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMiscWorkcalendar = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListWorkCalendarDto>(
    { url: `/api/misc/workcalendar`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscWorkcalendarQueryKey = () => {
  return [`/api/misc/workcalendar`] as const;
};

export const getGetApiMiscWorkcalendarQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscWorkcalendarQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscWorkcalendar>>
  > = ({ signal }) => getApiMiscWorkcalendar(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscWorkcalendarQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscWorkcalendar>>
>;
export type GetApiMiscWorkcalendarQueryError = unknown;

export function useGetApiMiscWorkcalendar<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendar>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendar<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendar>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendar<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscWorkcalendar<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendar>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscWorkcalendarQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const putApiMiscWorkcalendar = (
  workCalendarDtoBody: WorkCalendarDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/workcalendar`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: workCalendarDtoBody,
      signal,
    },
    options
  );
};

export const getPutApiMiscWorkcalendarMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiMiscWorkcalendar>>,
    TError,
    { data: WorkCalendarDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  const mutationKey = ["putApiMiscWorkcalendar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiMiscWorkcalendar>>,
    { data: WorkCalendarDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return putApiMiscWorkcalendar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiMiscWorkcalendarMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiMiscWorkcalendar>>
>;
export type PutApiMiscWorkcalendarMutationBody = WorkCalendarDtoBody;
export type PutApiMiscWorkcalendarMutationError = unknown;

export const usePutApiMiscWorkcalendar = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiMiscWorkcalendar>>,
      TError,
      { data: WorkCalendarDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  return useMutation(
    getPutApiMiscWorkcalendarMutationOptions(options),
    queryClient
  );
};

export const postApiMiscWorkcalendar = (
  workCalendarDtoBody: WorkCalendarDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/workcalendar`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: workCalendarDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscWorkcalendarMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscWorkcalendar>>,
    TError,
    { data: WorkCalendarDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  const mutationKey = ["postApiMiscWorkcalendar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscWorkcalendar>>,
    { data: WorkCalendarDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscWorkcalendar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscWorkcalendarMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscWorkcalendar>>
>;
export type PostApiMiscWorkcalendarMutationBody = WorkCalendarDtoBody;
export type PostApiMiscWorkcalendarMutationError = unknown;

export const usePostApiMiscWorkcalendar = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscWorkcalendar>>,
      TError,
      { data: WorkCalendarDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscWorkcalendarMutationOptions(options),
    queryClient
  );
};

export const deleteApiMiscWorkcalendar = (
  workCalendarDtoBody: WorkCalendarDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/workcalendar`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: workCalendarDtoBody,
      signal,
    },
    options
  );
};

export const getDeleteApiMiscWorkcalendarMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>,
    TError,
    { data: WorkCalendarDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  const mutationKey = ["deleteApiMiscWorkcalendar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>,
    { data: WorkCalendarDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteApiMiscWorkcalendar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiMiscWorkcalendarMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>
>;
export type DeleteApiMiscWorkcalendarMutationBody = WorkCalendarDtoBody;
export type DeleteApiMiscWorkcalendarMutationError = unknown;

export const useDeleteApiMiscWorkcalendar = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>,
      TError,
      { data: WorkCalendarDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiMiscWorkcalendar>>,
  TError,
  { data: WorkCalendarDtoBody },
  TContext
> => {
  return useMutation(
    getDeleteApiMiscWorkcalendarMutationOptions(options),
    queryClient
  );
};

export const postApiMiscConektaWebHook = (
  cardUniversalPayNotificationURLDtoBody: CardUniversalPayNotificationURLDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/Conekta/WebHook`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cardUniversalPayNotificationURLDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiMiscConektaWebHookMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscConektaWebHook>>,
    TError,
    { data: CardUniversalPayNotificationURLDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscConektaWebHook>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  const mutationKey = ["postApiMiscConektaWebHook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscConektaWebHook>>,
    { data: CardUniversalPayNotificationURLDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscConektaWebHook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscConektaWebHookMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscConektaWebHook>>
>;
export type PostApiMiscConektaWebHookMutationBody =
  CardUniversalPayNotificationURLDtoBody;
export type PostApiMiscConektaWebHookMutationError = unknown;

export const usePostApiMiscConektaWebHook = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscConektaWebHook>>,
      TError,
      { data: CardUniversalPayNotificationURLDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscConektaWebHook>>,
  TError,
  { data: CardUniversalPayNotificationURLDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiMiscConektaWebHookMutationOptions(options),
    queryClient
  );
};

export const postApiMiscCreateChargebackCsv = (
  createChargebackCsvRequestDto: CreateChargebackCsvRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<boolean>(
    {
      url: `/api/misc/createChargebackCsv`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createChargebackCsvRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMiscCreateChargebackCsvMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>,
    TError,
    { data: CreateChargebackCsvRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>,
  TError,
  { data: CreateChargebackCsvRequestDto },
  TContext
> => {
  const mutationKey = ["postApiMiscCreateChargebackCsv"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>,
    { data: CreateChargebackCsvRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscCreateChargebackCsv(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscCreateChargebackCsvMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>
>;
export type PostApiMiscCreateChargebackCsvMutationBody =
  CreateChargebackCsvRequestDto;
export type PostApiMiscCreateChargebackCsvMutationError = unknown;

export const usePostApiMiscCreateChargebackCsv = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>,
      TError,
      { data: CreateChargebackCsvRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscCreateChargebackCsv>>,
  TError,
  { data: CreateChargebackCsvRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMiscCreateChargebackCsvMutationOptions(options),
    queryClient
  );
};

export const getApiMiscWorkcalendarId = (
  id: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultWorkCalendarDto>(
    { url: `/api/misc/workcalendar/${id}`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscWorkcalendarIdQueryKey = (id: number) => {
  return [`/api/misc/workcalendar/${id}`] as const;
};

export const getGetApiMiscWorkcalendarIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscWorkcalendarIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>
  > = ({ signal }) => getApiMiscWorkcalendarId(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscWorkcalendarIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>
>;
export type GetApiMiscWorkcalendarIdQueryError = unknown;

export function useGetApiMiscWorkcalendarId<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
  TError = unknown
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendarId<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendarId<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscWorkcalendarId<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
  TError = unknown
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscWorkcalendarIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMiscWorkcalendarReload = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/misc/workcalendar/reload`, method: "GET", signal },
    options
  );
};

export const getGetApiMiscWorkcalendarReloadQueryKey = () => {
  return [`/api/misc/workcalendar/reload`] as const;
};

export const getGetApiMiscWorkcalendarReloadQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMiscWorkcalendarReloadQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>
  > = ({ signal }) => getApiMiscWorkcalendarReload(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMiscWorkcalendarReloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>
>;
export type GetApiMiscWorkcalendarReloadQueryError = unknown;

export function useGetApiMiscWorkcalendarReload<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendarReload<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
          TError,
          Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMiscWorkcalendarReload<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMiscWorkcalendarReload<
  TData = Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMiscWorkcalendarReload>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMiscWorkcalendarReloadQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMiscUserClickHistory = (
  userClickHistoryInsertDto: UserClickHistoryInsertDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/misc/userClickHistory`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userClickHistoryInsertDto,
      signal,
    },
    options
  );
};

export const getPostApiMiscUserClickHistoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMiscUserClickHistory>>,
    TError,
    { data: UserClickHistoryInsertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMiscUserClickHistory>>,
  TError,
  { data: UserClickHistoryInsertDto },
  TContext
> => {
  const mutationKey = ["postApiMiscUserClickHistory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMiscUserClickHistory>>,
    { data: UserClickHistoryInsertDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMiscUserClickHistory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMiscUserClickHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMiscUserClickHistory>>
>;
export type PostApiMiscUserClickHistoryMutationBody = UserClickHistoryInsertDto;
export type PostApiMiscUserClickHistoryMutationError = unknown;

export const usePostApiMiscUserClickHistory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMiscUserClickHistory>>,
      TError,
      { data: UserClickHistoryInsertDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMiscUserClickHistory>>,
  TError,
  { data: UserClickHistoryInsertDto },
  TContext
> => {
  return useMutation(
    getPostApiMiscUserClickHistoryMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferTransferMoney = (
  transferMoneyRequestDto: NonReadonly<TransferMoneyRequestDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/transferMoney`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: transferMoneyRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferTransferMoneyMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>,
    TError,
    { data: NonReadonly<TransferMoneyRequestDto> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>,
  TError,
  { data: NonReadonly<TransferMoneyRequestDto> },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferTransferMoney"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>,
    { data: NonReadonly<TransferMoneyRequestDto> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferTransferMoney(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferTransferMoneyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>
>;
export type PostApiMoneytransferTransferMoneyMutationBody =
  NonReadonly<TransferMoneyRequestDto>;
export type PostApiMoneytransferTransferMoneyMutationError = unknown;

export const usePostApiMoneytransferTransferMoney = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>,
      TError,
      { data: NonReadonly<TransferMoneyRequestDto> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferTransferMoney>>,
  TError,
  { data: NonReadonly<TransferMoneyRequestDto> },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferTransferMoneyMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferMockerInit = (
  moneyTransferMockerRequestDto: MoneyTransferMockerRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/mocker/init`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: moneyTransferMockerRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferMockerInitMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>,
    TError,
    { data: MoneyTransferMockerRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>,
  TError,
  { data: MoneyTransferMockerRequestDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferMockerInit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>,
    { data: MoneyTransferMockerRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferMockerInit(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferMockerInitMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>
>;
export type PostApiMoneytransferMockerInitMutationBody =
  MoneyTransferMockerRequestDto;
export type PostApiMoneytransferMockerInitMutationError = unknown;

export const usePostApiMoneytransferMockerInit = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>,
      TError,
      { data: MoneyTransferMockerRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferMockerInit>>,
  TError,
  { data: MoneyTransferMockerRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferMockerInitMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferMockerSourceAccountUpdateCallback = (
  sourceAccountUpdateCallbackMockerDto: SourceAccountUpdateCallbackMockerDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSourceAccountUpdateCallbackDto>(
    {
      url: `/api/moneytransfer/mocker/sourceAccountUpdateCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sourceAccountUpdateCallbackMockerDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferMockerSourceAccountUpdateCallbackMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
      >,
      TError,
      { data: SourceAccountUpdateCallbackMockerDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
    >,
    TError,
    { data: SourceAccountUpdateCallbackMockerDto },
    TContext
  > => {
    const mutationKey = [
      "postApiMoneytransferMockerSourceAccountUpdateCallback",
    ];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
      >,
      { data: SourceAccountUpdateCallbackMockerDto }
    > = (props) => {
      const { data } = props ?? {};

      return postApiMoneytransferMockerSourceAccountUpdateCallback(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMoneytransferMockerSourceAccountUpdateCallbackMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
    >
  >;
export type PostApiMoneytransferMockerSourceAccountUpdateCallbackMutationBody =
  SourceAccountUpdateCallbackMockerDto;
export type PostApiMoneytransferMockerSourceAccountUpdateCallbackMutationError =
  unknown;

export const usePostApiMoneytransferMockerSourceAccountUpdateCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
      >,
      TError,
      { data: SourceAccountUpdateCallbackMockerDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiMoneytransferMockerSourceAccountUpdateCallback>
  >,
  TError,
  { data: SourceAccountUpdateCallbackMockerDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferMockerSourceAccountUpdateCallbackMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiMoneytransferSearch = (
  searchMoneyTransferRequestBody: SearchMoneyTransferRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultGetTransferMoneyDto>(
    {
      url: `/api/moneytransfer/search`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchMoneyTransferRequestBody,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferSearchMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferSearch>>,
    TError,
    { data: SearchMoneyTransferRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferSearch>>,
  TError,
  { data: SearchMoneyTransferRequestBody },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferSearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferSearch>>,
    { data: SearchMoneyTransferRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferSearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferSearch>>
>;
export type PostApiMoneytransferSearchMutationBody =
  SearchMoneyTransferRequestBody;
export type PostApiMoneytransferSearchMutationError = unknown;

export const usePostApiMoneytransferSearch = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferSearch>>,
      TError,
      { data: SearchMoneyTransferRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferSearch>>,
  TError,
  { data: SearchMoneyTransferRequestBody },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferSearchMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferCancelTransfer = (
  params: PostApiMoneytransferCancelTransferParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultCancelTransferResponseDto>(
    {
      url: `/api/moneytransfer/cancelTransfer`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferCancelTransferMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>,
    TError,
    { params: PostApiMoneytransferCancelTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>,
  TError,
  { params: PostApiMoneytransferCancelTransferParams },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferCancelTransfer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>,
    { params: PostApiMoneytransferCancelTransferParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiMoneytransferCancelTransfer(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferCancelTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>
>;

export type PostApiMoneytransferCancelTransferMutationError = unknown;

export const usePostApiMoneytransferCancelTransfer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>,
      TError,
      { params: PostApiMoneytransferCancelTransferParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferCancelTransfer>>,
  TError,
  { params: PostApiMoneytransferCancelTransferParams },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferCancelTransferMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferRetryTransfer = (
  params: PostApiMoneytransferRetryTransferParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/moneytransfer/retryTransfer`, method: "POST", params, signal },
    options
  );
};

export const getPostApiMoneytransferRetryTransferMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>,
    TError,
    { params: PostApiMoneytransferRetryTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>,
  TError,
  { params: PostApiMoneytransferRetryTransferParams },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferRetryTransfer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>,
    { params: PostApiMoneytransferRetryTransferParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiMoneytransferRetryTransfer(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferRetryTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>
>;

export type PostApiMoneytransferRetryTransferMutationError = unknown;

export const usePostApiMoneytransferRetryTransfer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>,
      TError,
      { params: PostApiMoneytransferRetryTransferParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferRetryTransfer>>,
  TError,
  { params: PostApiMoneytransferRetryTransferParams },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferRetryTransferMutationOptions(options),
    queryClient
  );
};

export const getApiMoneytransferRetryHistory = (
  params: GetApiMoneytransferRetryHistoryParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultMoneyTransferRetryHistoryDto>(
    { url: `/api/moneytransfer/retryHistory`, method: "GET", params, signal },
    options
  );
};

export const getGetApiMoneytransferRetryHistoryQueryKey = (
  params?: GetApiMoneytransferRetryHistoryParams
) => {
  return [
    `/api/moneytransfer/retryHistory`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMoneytransferRetryHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
  TError = unknown
>(
  params: GetApiMoneytransferRetryHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMoneytransferRetryHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>
  > = ({ signal }) =>
    getApiMoneytransferRetryHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferRetryHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>
>;
export type GetApiMoneytransferRetryHistoryQueryError = unknown;

export function useGetApiMoneytransferRetryHistory<
  TData = Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
  TError = unknown
>(
  params: GetApiMoneytransferRetryHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferRetryHistory<
  TData = Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
  TError = unknown
>(
  params: GetApiMoneytransferRetryHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferRetryHistory<
  TData = Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
  TError = unknown
>(
  params: GetApiMoneytransferRetryHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferRetryHistory<
  TData = Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
  TError = unknown
>(
  params: GetApiMoneytransferRetryHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferRetryHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMoneytransferRetryHistoryQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMoneytransferCreatedCallback = (
  transferCreatedCallbackDto: TransferCreatedCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/createdCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: transferCreatedCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferCreatedCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>,
    TError,
    { data: TransferCreatedCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>,
  TError,
  { data: TransferCreatedCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferCreatedCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>,
    { data: TransferCreatedCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferCreatedCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferCreatedCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>
>;
export type PostApiMoneytransferCreatedCallbackMutationBody =
  TransferCreatedCallbackDto;
export type PostApiMoneytransferCreatedCallbackMutationError = unknown;

export const usePostApiMoneytransferCreatedCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>,
      TError,
      { data: TransferCreatedCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferCreatedCallback>>,
  TError,
  { data: TransferCreatedCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferCreatedCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferReTryUnnaxTransferReceipts = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/ReTryUnnaxTransferReceipts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferReTryUnnaxTransferReceiptsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  > => {
    const mutationKey = ["postApiMoneytransferReTryUnnaxTransferReceipts"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>
      >,
      { data: BankScraperGetAccountBulkAccoundidsBody }
    > = (props) => {
      const { data } = props ?? {};

      return postApiMoneytransferReTryUnnaxTransferReceipts(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMoneytransferReTryUnnaxTransferReceiptsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>>
  >;
export type PostApiMoneytransferReTryUnnaxTransferReceiptsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiMoneytransferReTryUnnaxTransferReceiptsMutationError =
  unknown;

export const usePostApiMoneytransferReTryUnnaxTransferReceipts = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>
      >,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferReTryUnnaxTransferReceipts>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferReTryUnnaxTransferReceiptsMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferProcessedCallback = (
  transferProcessedCallbackDto: TransferProcessedCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/processedCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: transferProcessedCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferProcessedCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>,
    TError,
    { data: TransferProcessedCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>,
  TError,
  { data: TransferProcessedCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferProcessedCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>,
    { data: TransferProcessedCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferProcessedCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferProcessedCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>
>;
export type PostApiMoneytransferProcessedCallbackMutationBody =
  TransferProcessedCallbackDto;
export type PostApiMoneytransferProcessedCallbackMutationError = unknown;

export const usePostApiMoneytransferProcessedCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>,
      TError,
      { data: TransferProcessedCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferProcessedCallback>>,
  TError,
  { data: TransferProcessedCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferProcessedCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferExportMoneyTransferCSV = (
  searchMoneyTransferRequestBody: SearchMoneyTransferRequestBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<
    | PostApiMoneytransferExportMoneyTransferCSV200One
    | PostApiMoneytransferExportMoneyTransferCSV200Two
    | Blob
  >(
    {
      url: `/api/moneytransfer/exportMoneyTransferCSV`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: searchMoneyTransferRequestBody,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferExportMoneyTransferCSVMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>,
    TError,
    { data: SearchMoneyTransferRequestBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>,
  TError,
  { data: SearchMoneyTransferRequestBody },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferExportMoneyTransferCSV"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>,
    { data: SearchMoneyTransferRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferExportMoneyTransferCSV(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferExportMoneyTransferCSVMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>
  >;
export type PostApiMoneytransferExportMoneyTransferCSVMutationBody =
  SearchMoneyTransferRequestBody;
export type PostApiMoneytransferExportMoneyTransferCSVMutationError = unknown;

export const usePostApiMoneytransferExportMoneyTransferCSV = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>,
      TError,
      { data: SearchMoneyTransferRequestBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferExportMoneyTransferCSV>>,
  TError,
  { data: SearchMoneyTransferRequestBody },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferExportMoneyTransferCSVMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferGetDeletedTransactions = (
  bankScraperGetAccountBulkAccoundidsBody: BankScraperGetAccountBulkAccoundidsBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListDeletedSourceAccountTransactionsResponseDto>(
    {
      url: `/api/moneytransfer/getDeletedTransactions`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bankScraperGetAccountBulkAccoundidsBody,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferGetDeletedTransactionsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>,
    TError,
    { data: BankScraperGetAccountBulkAccoundidsBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferGetDeletedTransactions"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>,
    { data: BankScraperGetAccountBulkAccoundidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferGetDeletedTransactions(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferGetDeletedTransactionsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>
  >;
export type PostApiMoneytransferGetDeletedTransactionsMutationBody =
  BankScraperGetAccountBulkAccoundidsBody;
export type PostApiMoneytransferGetDeletedTransactionsMutationError = unknown;

export const usePostApiMoneytransferGetDeletedTransactions = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>,
      TError,
      { data: BankScraperGetAccountBulkAccoundidsBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferGetDeletedTransactions>>,
  TError,
  { data: BankScraperGetAccountBulkAccoundidsBody },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferGetDeletedTransactionsMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferSourceAccountUpdateCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/moneytransfer/sourceAccountUpdateCallback`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferSourceAccountUpdateCallbackMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>>,
    TError,
    void,
    TContext
  > => {
    const mutationKey = ["postApiMoneytransferSourceAccountUpdateCallback"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>
      >,
      void
    > = () => {
      return postApiMoneytransferSourceAccountUpdateCallback(requestOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMoneytransferSourceAccountUpdateCallbackMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>>
  >;

export type PostApiMoneytransferSourceAccountUpdateCallbackMutationError =
  unknown;

export const usePostApiMoneytransferSourceAccountUpdateCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>
      >,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferSourceAccountUpdateCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferSourceAccountUpdateCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiMoneytransferGetManualPaymentApprovals = (
  manualPaymentApprovalSearchDto: ManualPaymentApprovalSearchDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultPagedSearchResultManualPaymentApprovalDto>(
    {
      url: `/api/moneytransfer/getManualPaymentApprovals`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: manualPaymentApprovalSearchDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferGetManualPaymentApprovalsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>,
    TError,
    { data: ManualPaymentApprovalSearchDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>,
  TError,
  { data: ManualPaymentApprovalSearchDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferGetManualPaymentApprovals"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>,
    { data: ManualPaymentApprovalSearchDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferGetManualPaymentApprovals(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferGetManualPaymentApprovalsMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>
  >;
export type PostApiMoneytransferGetManualPaymentApprovalsMutationBody =
  ManualPaymentApprovalSearchDto;
export type PostApiMoneytransferGetManualPaymentApprovalsMutationError =
  unknown;

export const usePostApiMoneytransferGetManualPaymentApprovals = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>,
      TError,
      { data: ManualPaymentApprovalSearchDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferGetManualPaymentApprovals>>,
  TError,
  { data: ManualPaymentApprovalSearchDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferGetManualPaymentApprovalsMutationOptions(options),
    queryClient
  );
};

export const getApiMoneytransferGetAbbrsForSearch = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSourceAccountTransactionAbbrDto>(
    { url: `/api/moneytransfer/getAbbrsForSearch`, method: "GET", signal },
    options
  );
};

export const getGetApiMoneytransferGetAbbrsForSearchQueryKey = () => {
  return [`/api/moneytransfer/getAbbrsForSearch`] as const;
};

export const getGetApiMoneytransferGetAbbrsForSearchQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMoneytransferGetAbbrsForSearchQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>
  > = ({ signal }) =>
    getApiMoneytransferGetAbbrsForSearch(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferGetAbbrsForSearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>
>;
export type GetApiMoneytransferGetAbbrsForSearchQueryError = unknown;

export function useGetApiMoneytransferGetAbbrsForSearch<
  TData = Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferGetAbbrsForSearch<
  TData = Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferGetAbbrsForSearch<
  TData = Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferGetAbbrsForSearch<
  TData = Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferGetAbbrsForSearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMoneytransferGetAbbrsForSearchQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiMoneytransferGetSourceAccountTransaction = (
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultSourceAccountTransactionReadDto>(
    {
      url: `/api/moneytransfer/getSourceAccountTransaction`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMoneytransferGetSourceAccountTransactionQueryKey = (
  params?: GetApiMoneytransferGetSourceAccountTransactionParams
) => {
  return [
    `/api/moneytransfer/getSourceAccountTransaction`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMoneytransferGetSourceAccountTransactionQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
  >,
  TError = unknown
>(
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMoneytransferGetSourceAccountTransactionQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>>
  > = ({ signal }) =>
    getApiMoneytransferGetSourceAccountTransaction(
      params,
      requestOptions,
      signal
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferGetSourceAccountTransactionQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>>
  >;
export type GetApiMoneytransferGetSourceAccountTransactionQueryError = unknown;

export function useGetApiMoneytransferGetSourceAccountTransaction<
  TData = Awaited<
    ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
  >,
  TError = unknown
>(
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferGetSourceAccountTransaction<
  TData = Awaited<
    ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
  >,
  TError = unknown
>(
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferGetSourceAccountTransaction<
  TData = Awaited<
    ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
  >,
  TError = unknown
>(
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferGetSourceAccountTransaction<
  TData = Awaited<
    ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
  >,
  TError = unknown
>(
  params: GetApiMoneytransferGetSourceAccountTransactionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getApiMoneytransferGetSourceAccountTransaction>
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiMoneytransferGetSourceAccountTransactionQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMoneytransferDeleteSourceAccountTransaction = (
  params: PostApiMoneytransferDeleteSourceAccountTransactionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/deleteSourceAccountTransaction`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferDeleteSourceAccountTransactionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
      >,
      TError,
      { params: PostApiMoneytransferDeleteSourceAccountTransactionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
    >,
    TError,
    { params: PostApiMoneytransferDeleteSourceAccountTransactionParams },
    TContext
  > => {
    const mutationKey = ["postApiMoneytransferDeleteSourceAccountTransaction"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
      >,
      { params: PostApiMoneytransferDeleteSourceAccountTransactionParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiMoneytransferDeleteSourceAccountTransaction(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiMoneytransferDeleteSourceAccountTransactionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
    >
  >;

export type PostApiMoneytransferDeleteSourceAccountTransactionMutationError =
  unknown;

export const usePostApiMoneytransferDeleteSourceAccountTransaction = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
      >,
      TError,
      { params: PostApiMoneytransferDeleteSourceAccountTransactionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof postApiMoneytransferDeleteSourceAccountTransaction>
  >,
  TError,
  { params: PostApiMoneytransferDeleteSourceAccountTransactionParams },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferDeleteSourceAccountTransactionMutationOptions(
      options
    ),
    queryClient
  );
};

export const postApiMoneytransferCallbackUnnaxPending = (
  unnaxPendingCallbackDto: UnnaxPendingCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/moneytransfer/callback/unnax/pending`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxPendingCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferCallbackUnnaxPendingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>,
    TError,
    { data: UnnaxPendingCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>,
  TError,
  { data: UnnaxPendingCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferCallbackUnnaxPending"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>,
    { data: UnnaxPendingCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferCallbackUnnaxPending(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferCallbackUnnaxPendingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>
  >;
export type PostApiMoneytransferCallbackUnnaxPendingMutationBody =
  UnnaxPendingCallbackDto;
export type PostApiMoneytransferCallbackUnnaxPendingMutationError = unknown;

export const usePostApiMoneytransferCallbackUnnaxPending = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>,
      TError,
      { data: UnnaxPendingCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxPending>>,
  TError,
  { data: UnnaxPendingCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferCallbackUnnaxPendingMutationOptions(options),
    queryClient
  );
};

export const getApiMoneytransferMockerUnnaxPending = (
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxPendingCallbackDto>(
    {
      url: `/api/moneytransfer/mocker/unnax/pending`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMoneytransferMockerUnnaxPendingQueryKey = (
  params?: GetApiMoneytransferMockerUnnaxPendingParams
) => {
  return [
    `/api/moneytransfer/mocker/unnax/pending`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMoneytransferMockerUnnaxPendingQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMoneytransferMockerUnnaxPendingQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>
  > = ({ signal }) =>
    getApiMoneytransferMockerUnnaxPending(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferMockerUnnaxPendingQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>
>;
export type GetApiMoneytransferMockerUnnaxPendingQueryError = unknown;

export function useGetApiMoneytransferMockerUnnaxPending<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferMockerUnnaxPending<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferMockerUnnaxPending<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferMockerUnnaxPending<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxPendingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxPending>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMoneytransferMockerUnnaxPendingQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMoneytransferCallbackUnnaxRefund = (
  unnaxRefundCallbackDto: UnnaxRefundCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/callback/unnax/refund`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxRefundCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferCallbackUnnaxRefundMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>,
    TError,
    { data: UnnaxRefundCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>,
  TError,
  { data: UnnaxRefundCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferCallbackUnnaxRefund"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>,
    { data: UnnaxRefundCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferCallbackUnnaxRefund(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferCallbackUnnaxRefundMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>
>;
export type PostApiMoneytransferCallbackUnnaxRefundMutationBody =
  UnnaxRefundCallbackDto;
export type PostApiMoneytransferCallbackUnnaxRefundMutationError = unknown;

export const usePostApiMoneytransferCallbackUnnaxRefund = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>,
      TError,
      { data: UnnaxRefundCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferCallbackUnnaxRefund>>,
  TError,
  { data: UnnaxRefundCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferCallbackUnnaxRefundMutationOptions(options),
    queryClient
  );
};

export const getApiMoneytransferMockerUnnaxRefund = (
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxRefundCallbackDto>(
    {
      url: `/api/moneytransfer/mocker/unnax/refund`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiMoneytransferMockerUnnaxRefundQueryKey = (
  params?: GetApiMoneytransferMockerUnnaxRefundParams
) => {
  return [
    `/api/moneytransfer/mocker/unnax/refund`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiMoneytransferMockerUnnaxRefundQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiMoneytransferMockerUnnaxRefundQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>
  > = ({ signal }) =>
    getApiMoneytransferMockerUnnaxRefund(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferMockerUnnaxRefundQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>
>;
export type GetApiMoneytransferMockerUnnaxRefundQueryError = unknown;

export function useGetApiMoneytransferMockerUnnaxRefund<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferMockerUnnaxRefund<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferMockerUnnaxRefund<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferMockerUnnaxRefund<
  TData = Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
  TError = unknown
>(
  params: GetApiMoneytransferMockerUnnaxRefundParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferMockerUnnaxRefund>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMoneytransferMockerUnnaxRefundQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiMoneytransferCancelTransferStatus = (
  cancelTransferStatusDto: CancelTransferStatusDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/moneytransfer/cancelTransferStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: cancelTransferStatusDto,
      signal,
    },
    options
  );
};

export const getPostApiMoneytransferCancelTransferStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>,
    TError,
    { data: CancelTransferStatusDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>,
  TError,
  { data: CancelTransferStatusDto },
  TContext
> => {
  const mutationKey = ["postApiMoneytransferCancelTransferStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>,
    { data: CancelTransferStatusDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiMoneytransferCancelTransferStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiMoneytransferCancelTransferStatusMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>
  >;
export type PostApiMoneytransferCancelTransferStatusMutationBody =
  CancelTransferStatusDto;
export type PostApiMoneytransferCancelTransferStatusMutationError = unknown;

export const usePostApiMoneytransferCancelTransferStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>,
      TError,
      { data: CancelTransferStatusDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiMoneytransferCancelTransferStatus>>,
  TError,
  { data: CancelTransferStatusDto },
  TContext
> => {
  return useMutation(
    getPostApiMoneytransferCancelTransferStatusMutationOptions(options),
    queryClient
  );
};

export const getApiMoneytransferTest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/moneytransfer/test`, method: "GET", signal },
    options
  );
};

export const getGetApiMoneytransferTestQueryKey = () => {
  return [`/api/moneytransfer/test`] as const;
};

export const getGetApiMoneytransferTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiMoneytransferTest>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiMoneytransferTest>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiMoneytransferTestQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiMoneytransferTest>>
  > = ({ signal }) => getApiMoneytransferTest(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiMoneytransferTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiMoneytransferTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiMoneytransferTest>>
>;
export type GetApiMoneytransferTestQueryError = unknown;

export function useGetApiMoneytransferTest<
  TData = Awaited<ReturnType<typeof getApiMoneytransferTest>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferTest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferTest>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferTest<
  TData = Awaited<ReturnType<typeof getApiMoneytransferTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferTest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiMoneytransferTest>>,
          TError,
          Awaited<ReturnType<typeof getApiMoneytransferTest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiMoneytransferTest<
  TData = Awaited<ReturnType<typeof getApiMoneytransferTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiMoneytransferTest<
  TData = Awaited<ReturnType<typeof getApiMoneytransferTest>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiMoneytransferTest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiMoneytransferTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiOutboundpaymentQueryStatus = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/outboundpayment/queryStatus`, method: "POST", signal },
    options
  );
};

export const getPostApiOutboundpaymentQueryStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiOutboundpaymentQueryStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>,
    void
  > = () => {
    return postApiOutboundpaymentQueryStatus(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOutboundpaymentQueryStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>
>;

export type PostApiOutboundpaymentQueryStatusMutationError = unknown;

export const usePostApiOutboundpaymentQueryStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOutboundpaymentQueryStatus>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiOutboundpaymentQueryStatusMutationOptions(options),
    queryClient
  );
};

export const postApiOutboundpaymentSubmitStatusCallback = (
  bankScraperNotifySmsValueBody: BankScraperNotifySmsValueBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<string>(
    {
      url: `/api/outboundpayment/submitStatusCallback`,
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      data: bankScraperNotifySmsValueBody,
      signal,
    },
    options
  );
};

export const getPostApiOutboundpaymentSubmitStatusCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>,
    TError,
    { data: BankScraperNotifySmsValueBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  const mutationKey = ["postApiOutboundpaymentSubmitStatusCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>,
    { data: BankScraperNotifySmsValueBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiOutboundpaymentSubmitStatusCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiOutboundpaymentSubmitStatusCallbackMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>
  >;
export type PostApiOutboundpaymentSubmitStatusCallbackMutationBody =
  BankScraperNotifySmsValueBody;
export type PostApiOutboundpaymentSubmitStatusCallbackMutationError = unknown;

export const usePostApiOutboundpaymentSubmitStatusCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>,
      TError,
      { data: BankScraperNotifySmsValueBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiOutboundpaymentSubmitStatusCallback>>,
  TError,
  { data: BankScraperNotifySmsValueBody },
  TContext
> => {
  return useMutation(
    getPostApiOutboundpaymentSubmitStatusCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiParametersCreate = (
  parameterDtoBody: ParameterDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/parameters/create`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: parameterDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiParametersCreateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiParametersCreate>>,
    TError,
    { data: ParameterDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiParametersCreate>>,
  TError,
  { data: ParameterDtoBody },
  TContext
> => {
  const mutationKey = ["postApiParametersCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiParametersCreate>>,
    { data: ParameterDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiParametersCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiParametersCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiParametersCreate>>
>;
export type PostApiParametersCreateMutationBody = ParameterDtoBody;
export type PostApiParametersCreateMutationError = unknown;

export const usePostApiParametersCreate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiParametersCreate>>,
      TError,
      { data: ParameterDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiParametersCreate>>,
  TError,
  { data: ParameterDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiParametersCreateMutationOptions(options),
    queryClient
  );
};

export const postApiParametersParameter = (
  parameterDtoBaseBody: ParameterDtoBaseBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultParameterDto>(
    {
      url: `/api/parameters/parameter`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: parameterDtoBaseBody,
      signal,
    },
    options
  );
};

export const getPostApiParametersParameterMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiParametersParameter>>,
    TError,
    { data: ParameterDtoBaseBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiParametersParameter>>,
  TError,
  { data: ParameterDtoBaseBody },
  TContext
> => {
  const mutationKey = ["postApiParametersParameter"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiParametersParameter>>,
    { data: ParameterDtoBaseBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiParametersParameter(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiParametersParameterMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiParametersParameter>>
>;
export type PostApiParametersParameterMutationBody = ParameterDtoBaseBody;
export type PostApiParametersParameterMutationError = unknown;

export const usePostApiParametersParameter = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiParametersParameter>>,
      TError,
      { data: ParameterDtoBaseBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiParametersParameter>>,
  TError,
  { data: ParameterDtoBaseBody },
  TContext
> => {
  return useMutation(
    getPostApiParametersParameterMutationOptions(options),
    queryClient
  );
};

export const deleteApiParametersDelete = (
  parameterDtoBaseBody: ParameterDtoBaseBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/parameters/delete`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
      data: parameterDtoBaseBody,
      signal,
    },
    options
  );
};

export const getDeleteApiParametersDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiParametersDelete>>,
    TError,
    { data: ParameterDtoBaseBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiParametersDelete>>,
  TError,
  { data: ParameterDtoBaseBody },
  TContext
> => {
  const mutationKey = ["deleteApiParametersDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiParametersDelete>>,
    { data: ParameterDtoBaseBody }
  > = (props) => {
    const { data } = props ?? {};

    return deleteApiParametersDelete(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiParametersDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiParametersDelete>>
>;
export type DeleteApiParametersDeleteMutationBody = ParameterDtoBaseBody;
export type DeleteApiParametersDeleteMutationError = unknown;

export const useDeleteApiParametersDelete = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiParametersDelete>>,
      TError,
      { data: ParameterDtoBaseBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiParametersDelete>>,
  TError,
  { data: ParameterDtoBaseBody },
  TContext
> => {
  return useMutation(
    getDeleteApiParametersDeleteMutationOptions(options),
    queryClient
  );
};

export const postApiParametersHistory = (
  parameterHistoryRequestDto: ParameterHistoryRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListParameterHistoryDto>(
    {
      url: `/api/parameters/history`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: parameterHistoryRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiParametersHistoryMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiParametersHistory>>,
    TError,
    { data: ParameterHistoryRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiParametersHistory>>,
  TError,
  { data: ParameterHistoryRequestDto },
  TContext
> => {
  const mutationKey = ["postApiParametersHistory"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiParametersHistory>>,
    { data: ParameterHistoryRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiParametersHistory(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiParametersHistoryMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiParametersHistory>>
>;
export type PostApiParametersHistoryMutationBody = ParameterHistoryRequestDto;
export type PostApiParametersHistoryMutationError = unknown;

export const usePostApiParametersHistory = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiParametersHistory>>,
      TError,
      { data: ParameterHistoryRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiParametersHistory>>,
  TError,
  { data: ParameterHistoryRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiParametersHistoryMutationOptions(options),
    queryClient
  );
};

export const postApiPaylandsDevengoCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/paylands/devengo/callback`, method: "POST", signal },
    options
  );
};

export const getPostApiPaylandsDevengoCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiPaylandsDevengoCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>,
    void
  > = () => {
    return postApiPaylandsDevengoCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiPaylandsDevengoCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>
>;

export type PostApiPaylandsDevengoCallbackMutationError = unknown;

export const usePostApiPaylandsDevengoCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiPaylandsDevengoCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiPaylandsDevengoCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiPaylandsDevengoMocker = (
  devengoMockCallbackRequestDto: DevengoMockCallbackRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/paylands/devengo/mocker`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: devengoMockCallbackRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiPaylandsDevengoMockerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>,
    TError,
    { data: DevengoMockCallbackRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>,
  TError,
  { data: DevengoMockCallbackRequestDto },
  TContext
> => {
  const mutationKey = ["postApiPaylandsDevengoMocker"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>,
    { data: DevengoMockCallbackRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiPaylandsDevengoMocker(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiPaylandsDevengoMockerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>
>;
export type PostApiPaylandsDevengoMockerMutationBody =
  DevengoMockCallbackRequestDto;
export type PostApiPaylandsDevengoMockerMutationError = unknown;

export const usePostApiPaylandsDevengoMocker = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>,
      TError,
      { data: DevengoMockCallbackRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiPaylandsDevengoMocker>>,
  TError,
  { data: DevengoMockCallbackRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiPaylandsDevengoMockerMutationOptions(options),
    queryClient
  );
};

export const postApiQueueMoneyTransfer = (
  params: PostApiQueueMoneyTransferParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/queue/moneyTransfer`, method: "POST", params, signal },
    options
  );
};

export const getPostApiQueueMoneyTransferMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>,
    TError,
    { params: PostApiQueueMoneyTransferParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>,
  TError,
  { params: PostApiQueueMoneyTransferParams },
  TContext
> => {
  const mutationKey = ["postApiQueueMoneyTransfer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>,
    { params: PostApiQueueMoneyTransferParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiQueueMoneyTransfer(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueMoneyTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>
>;

export type PostApiQueueMoneyTransferMutationError = unknown;

export const usePostApiQueueMoneyTransfer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>,
      TError,
      { params: PostApiQueueMoneyTransferParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueMoneyTransfer>>,
  TError,
  { params: PostApiQueueMoneyTransferParams },
  TContext
> => {
  return useMutation(
    getPostApiQueueMoneyTransferMutationOptions(options),
    queryClient
  );
};

export const postApiQueueMoneyTransferReal = (
  params: PostApiQueueMoneyTransferRealParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/queue/moneyTransferReal`, method: "POST", params, signal },
    options
  );
};

export const getPostApiQueueMoneyTransferRealMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>,
    TError,
    { params: PostApiQueueMoneyTransferRealParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>,
  TError,
  { params: PostApiQueueMoneyTransferRealParams },
  TContext
> => {
  const mutationKey = ["postApiQueueMoneyTransferReal"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>,
    { params: PostApiQueueMoneyTransferRealParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiQueueMoneyTransferReal(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueMoneyTransferRealMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>
>;

export type PostApiQueueMoneyTransferRealMutationError = unknown;

export const usePostApiQueueMoneyTransferReal = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>,
      TError,
      { params: PostApiQueueMoneyTransferRealParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueMoneyTransferReal>>,
  TError,
  { params: PostApiQueueMoneyTransferRealParams },
  TContext
> => {
  return useMutation(
    getPostApiQueueMoneyTransferRealMutationOptions(options),
    queryClient
  );
};

export const postApiQueueMessenteBulkSms = (
  params?: PostApiQueueMessenteBulkSmsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    { url: `/api/queue/messenteBulkSms`, method: "POST", params, signal },
    options
  );
};

export const getPostApiQueueMessenteBulkSmsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>,
    TError,
    { params?: PostApiQueueMessenteBulkSmsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>,
  TError,
  { params?: PostApiQueueMessenteBulkSmsParams },
  TContext
> => {
  const mutationKey = ["postApiQueueMessenteBulkSms"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>,
    { params?: PostApiQueueMessenteBulkSmsParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiQueueMessenteBulkSms(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueMessenteBulkSmsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>
>;

export type PostApiQueueMessenteBulkSmsMutationError = unknown;

export const usePostApiQueueMessenteBulkSms = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>,
      TError,
      { params?: PostApiQueueMessenteBulkSmsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueMessenteBulkSms>>,
  TError,
  { params?: PostApiQueueMessenteBulkSmsParams },
  TContext
> => {
  return useMutation(
    getPostApiQueueMessenteBulkSmsMutationOptions(options),
    queryClient
  );
};

export const postApiQueueBulkSMSMarketingSameContent = (
  bulkSmsMarketingSameContentRequestDto: BulkSmsMarketingSameContentRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/queue/bulkSMSMarketingSameContent`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: bulkSmsMarketingSameContentRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiQueueBulkSMSMarketingSameContentMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>,
    TError,
    { data: BulkSmsMarketingSameContentRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>,
  TError,
  { data: BulkSmsMarketingSameContentRequestDto },
  TContext
> => {
  const mutationKey = ["postApiQueueBulkSMSMarketingSameContent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>,
    { data: BulkSmsMarketingSameContentRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiQueueBulkSMSMarketingSameContent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueBulkSMSMarketingSameContentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>
>;
export type PostApiQueueBulkSMSMarketingSameContentMutationBody =
  BulkSmsMarketingSameContentRequestDto;
export type PostApiQueueBulkSMSMarketingSameContentMutationError = unknown;

export const usePostApiQueueBulkSMSMarketingSameContent = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>,
      TError,
      { data: BulkSmsMarketingSameContentRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueBulkSMSMarketingSameContent>>,
  TError,
  { data: BulkSmsMarketingSameContentRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiQueueBulkSMSMarketingSameContentMutationOptions(options),
    queryClient
  );
};

export const getApiQueueRemarketingOurOldCustomer = (
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/queue/RemarketingOurOldCustomer`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiQueueRemarketingOurOldCustomerQueryKey = (
  params?: GetApiQueueRemarketingOurOldCustomerParams
) => {
  return [
    `/api/queue/RemarketingOurOldCustomer`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiQueueRemarketingOurOldCustomerQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
  TError = unknown
>(
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiQueueRemarketingOurOldCustomerQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>
  > = ({ signal }) =>
    getApiQueueRemarketingOurOldCustomer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQueueRemarketingOurOldCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>
>;
export type GetApiQueueRemarketingOurOldCustomerQueryError = unknown;

export function useGetApiQueueRemarketingOurOldCustomer<
  TData = Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
  TError = unknown
>(
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueRemarketingOurOldCustomer<
  TData = Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
  TError = unknown
>(
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueRemarketingOurOldCustomer<
  TData = Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
  TError = unknown
>(
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQueueRemarketingOurOldCustomer<
  TData = Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
  TError = unknown
>(
  params: GetApiQueueRemarketingOurOldCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueRemarketingOurOldCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQueueRemarketingOurOldCustomerQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiQueueScheduleAffilatePixelCallbacks = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/queue/ScheduleAffilatePixelCallbacks`, method: "GET", signal },
    options
  );
};

export const getGetApiQueueScheduleAffilatePixelCallbacksQueryKey = () => {
  return [`/api/queue/ScheduleAffilatePixelCallbacks`] as const;
};

export const getGetApiQueueScheduleAffilatePixelCallbacksQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiQueueScheduleAffilatePixelCallbacksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>
  > = ({ signal }) =>
    getApiQueueScheduleAffilatePixelCallbacks(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQueueScheduleAffilatePixelCallbacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>
>;
export type GetApiQueueScheduleAffilatePixelCallbacksQueryError = unknown;

export function useGetApiQueueScheduleAffilatePixelCallbacks<
  TData = Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueScheduleAffilatePixelCallbacks<
  TData = Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueScheduleAffilatePixelCallbacks<
  TData = Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQueueScheduleAffilatePixelCallbacks<
  TData = Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueScheduleAffilatePixelCallbacks>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiQueueScheduleAffilatePixelCallbacksQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiQueueReviewReminder = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    { url: `/api/queue/reviewReminder`, method: "GET", signal },
    options
  );
};

export const getGetApiQueueReviewReminderQueryKey = () => {
  return [`/api/queue/reviewReminder`] as const;
};

export const getGetApiQueueReviewReminderQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQueueReviewReminderQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQueueReviewReminder>>
  > = ({ signal }) => getApiQueueReviewReminder(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQueueReviewReminderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQueueReviewReminder>>
>;
export type GetApiQueueReviewReminderQueryError = unknown;

export function useGetApiQueueReviewReminder<
  TData = Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueReviewReminder>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueReviewReminder<
  TData = Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
          TError,
          Awaited<ReturnType<typeof getApiQueueReviewReminder>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQueueReviewReminder<
  TData = Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQueueReviewReminder<
  TData = Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQueueReviewReminder>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQueueReviewReminderQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiQueueAddToIVRQueue = (
  customerCommunicationDto: NonReadonly<CustomerCommunicationDto>,
  params: PostApiQueueAddToIVRQueueParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/queue/addToIVRQueue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerCommunicationDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiQueueAddToIVRQueueMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>,
    TError,
    {
      data: NonReadonly<CustomerCommunicationDto>;
      params: PostApiQueueAddToIVRQueueParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>,
  TError,
  {
    data: NonReadonly<CustomerCommunicationDto>;
    params: PostApiQueueAddToIVRQueueParams;
  },
  TContext
> => {
  const mutationKey = ["postApiQueueAddToIVRQueue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>,
    {
      data: NonReadonly<CustomerCommunicationDto>;
      params: PostApiQueueAddToIVRQueueParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiQueueAddToIVRQueue(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueAddToIVRQueueMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>
>;
export type PostApiQueueAddToIVRQueueMutationBody =
  NonReadonly<CustomerCommunicationDto>;
export type PostApiQueueAddToIVRQueueMutationError = unknown;

export const usePostApiQueueAddToIVRQueue = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>,
      TError,
      {
        data: NonReadonly<CustomerCommunicationDto>;
        params: PostApiQueueAddToIVRQueueParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueAddToIVRQueue>>,
  TError,
  {
    data: NonReadonly<CustomerCommunicationDto>;
    params: PostApiQueueAddToIVRQueueParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiQueueAddToIVRQueueMutationOptions(options),
    queryClient
  );
};

export const postApiQueueScheduleBulkCardValidator = (
  scheduleBulkCardValidatorDto: ScheduleBulkCardValidatorDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultString>(
    {
      url: `/api/queue/scheduleBulkCardValidator`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: scheduleBulkCardValidatorDto,
      signal,
    },
    options
  );
};

export const getPostApiQueueScheduleBulkCardValidatorMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>,
    TError,
    { data: ScheduleBulkCardValidatorDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>,
  TError,
  { data: ScheduleBulkCardValidatorDto },
  TContext
> => {
  const mutationKey = ["postApiQueueScheduleBulkCardValidator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>,
    { data: ScheduleBulkCardValidatorDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiQueueScheduleBulkCardValidator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiQueueScheduleBulkCardValidatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>
>;
export type PostApiQueueScheduleBulkCardValidatorMutationBody =
  ScheduleBulkCardValidatorDto;
export type PostApiQueueScheduleBulkCardValidatorMutationError = unknown;

export const usePostApiQueueScheduleBulkCardValidator = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>,
      TError,
      { data: ScheduleBulkCardValidatorDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiQueueScheduleBulkCardValidator>>,
  TError,
  { data: ScheduleBulkCardValidatorDto },
  TContext
> => {
  return useMutation(
    getPostApiQueueScheduleBulkCardValidatorMutationOptions(options),
    queryClient
  );
};

export const getApiReportingGetEkomiReviews = (
  params?: GetApiReportingGetEkomiReviewsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListEkomiReviewsDto>(
    { url: `/api/reporting/getEkomiReviews`, method: "GET", params, signal },
    options
  );
};

export const getGetApiReportingGetEkomiReviewsQueryKey = (
  params?: GetApiReportingGetEkomiReviewsParams
) => {
  return [
    `/api/reporting/getEkomiReviews`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiReportingGetEkomiReviewsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
  TError = unknown
>(
  params?: GetApiReportingGetEkomiReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiReportingGetEkomiReviewsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>
  > = ({ signal }) =>
    getApiReportingGetEkomiReviews(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiReportingGetEkomiReviewsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>
>;
export type GetApiReportingGetEkomiReviewsQueryError = unknown;

export function useGetApiReportingGetEkomiReviews<
  TData = Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
  TError = unknown
>(
  params: undefined | GetApiReportingGetEkomiReviewsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
          TError,
          Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiReportingGetEkomiReviews<
  TData = Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
  TError = unknown
>(
  params?: GetApiReportingGetEkomiReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
          TError,
          Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiReportingGetEkomiReviews<
  TData = Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
  TError = unknown
>(
  params?: GetApiReportingGetEkomiReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiReportingGetEkomiReviews<
  TData = Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
  TError = unknown
>(
  params?: GetApiReportingGetEkomiReviewsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiReportingGetEkomiReviews>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiReportingGetEkomiReviewsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiSefideCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/sefide/callback`, method: "POST", signal },
    options
  );
};

export const getPostApiSefideCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSefideCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSefideCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiSefideCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSefideCallback>>,
    void
  > = () => {
    return postApiSefideCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSefideCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSefideCallback>>
>;

export type PostApiSefideCallbackMutationError = unknown;

export const usePostApiSefideCallback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiSefideCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiSefideCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiSefideCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiSefideOperationNotification = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/sefide/operation-notification`, method: "POST", signal },
    options
  );
};

export const getPostApiSefideOperationNotificationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiSefideOperationNotification>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiSefideOperationNotification>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiSefideOperationNotification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiSefideOperationNotification>>,
    void
  > = () => {
    return postApiSefideOperationNotification(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiSefideOperationNotificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiSefideOperationNotification>>
>;

export type PostApiSefideOperationNotificationMutationError = unknown;

export const usePostApiSefideOperationNotification = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiSefideOperationNotification>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiSefideOperationNotification>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiSefideOperationNotificationMutationOptions(options),
    queryClient
  );
};

export const getApiTelemarketingInactiveRtbList = (
  params: GetApiTelemarketingInactiveRtbListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/inactiveRtbList`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiTelemarketingInactiveRtbListQueryKey = (
  params?: GetApiTelemarketingInactiveRtbListParams
) => {
  return [
    `/api/telemarketing/inactiveRtbList`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiTelemarketingInactiveRtbListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
  TError = unknown
>(
  params: GetApiTelemarketingInactiveRtbListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTelemarketingInactiveRtbListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>
  > = ({ signal }) =>
    getApiTelemarketingInactiveRtbList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingInactiveRtbListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>
>;
export type GetApiTelemarketingInactiveRtbListQueryError = unknown;

export function useGetApiTelemarketingInactiveRtbList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
  TError = unknown
>(
  params: GetApiTelemarketingInactiveRtbListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingInactiveRtbList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
  TError = unknown
>(
  params: GetApiTelemarketingInactiveRtbListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingInactiveRtbList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
  TError = unknown
>(
  params: GetApiTelemarketingInactiveRtbListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingInactiveRtbList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
  TError = unknown
>(
  params: GetApiTelemarketingInactiveRtbListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveRtbList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTelemarketingInactiveRtbListQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTelemarketingSystemApprovedCustomersWithoutLoan = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/systemApprovedCustomersWithoutLoan`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryKey =
  () => {
    return [`/api/telemarketing/systemApprovedCustomersWithoutLoan`] as const;
  };

export const getGetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
      >
    > = ({ signal }) =>
      getApiTelemarketingSystemApprovedCustomersWithoutLoan(
        requestOptions,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
    >
  >;
export type GetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryError =
  unknown;

export function useGetApiTelemarketingSystemApprovedCustomersWithoutLoan<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingSystemApprovedCustomersWithoutLoan<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingSystemApprovedCustomersWithoutLoan<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingSystemApprovedCustomersWithoutLoan<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getApiTelemarketingSystemApprovedCustomersWithoutLoan
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiTelemarketingSystemApprovedCustomersWithoutLoanQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTelemarketingAdd = (
  telemarketingDto: TelemarketingDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/add`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: telemarketingDto,
      signal,
    },
    options
  );
};

export const getPostApiTelemarketingAddMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelemarketingAdd>>,
    TError,
    { data: TelemarketingDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelemarketingAdd>>,
  TError,
  { data: TelemarketingDto },
  TContext
> => {
  const mutationKey = ["postApiTelemarketingAdd"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelemarketingAdd>>,
    { data: TelemarketingDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTelemarketingAdd(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelemarketingAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelemarketingAdd>>
>;
export type PostApiTelemarketingAddMutationBody = TelemarketingDto;
export type PostApiTelemarketingAddMutationError = unknown;

export const usePostApiTelemarketingAdd = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTelemarketingAdd>>,
      TError,
      { data: TelemarketingDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelemarketingAdd>>,
  TError,
  { data: TelemarketingDto },
  TContext
> => {
  return useMutation(
    getPostApiTelemarketingAddMutationOptions(options),
    queryClient
  );
};

export const getApiTelemarketingGet = (
  params: GetApiTelemarketingGetParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTelemarketingDto>(
    { url: `/api/telemarketing/get`, method: "GET", params, signal },
    options
  );
};

export const getGetApiTelemarketingGetQueryKey = (
  params?: GetApiTelemarketingGetParams
) => {
  return [`/api/telemarketing/get`, ...(params ? [params] : [])] as const;
};

export const getGetApiTelemarketingGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTelemarketingGet>>,
  TError = unknown
>(
  params: GetApiTelemarketingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTelemarketingGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingGet>>
  > = ({ signal }) => getApiTelemarketingGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingGet>>
>;
export type GetApiTelemarketingGetQueryError = unknown;

export function useGetApiTelemarketingGet<
  TData = Awaited<ReturnType<typeof getApiTelemarketingGet>>,
  TError = unknown
>(
  params: GetApiTelemarketingGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingGet>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingGet<
  TData = Awaited<ReturnType<typeof getApiTelemarketingGet>>,
  TError = unknown
>(
  params: GetApiTelemarketingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingGet>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingGet<
  TData = Awaited<ReturnType<typeof getApiTelemarketingGet>>,
  TError = unknown
>(
  params: GetApiTelemarketingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingGet<
  TData = Awaited<ReturnType<typeof getApiTelemarketingGet>>,
  TError = unknown
>(
  params: GetApiTelemarketingGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTelemarketingGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTelemarketingList = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTelemarketingDto>(
    { url: `/api/telemarketing/list`, method: "GET", signal },
    options
  );
};

export const getGetApiTelemarketingListQueryKey = () => {
  return [`/api/telemarketing/list`] as const;
};

export const getGetApiTelemarketingListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTelemarketingList>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTelemarketingList>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTelemarketingListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingList>>
  > = ({ signal }) => getApiTelemarketingList(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingList>>
>;
export type GetApiTelemarketingListQueryError = unknown;

export function useGetApiTelemarketingList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingList>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingList>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingList>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingList<
  TData = Awaited<ReturnType<typeof getApiTelemarketingList>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTelemarketingListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const deleteApiTelemarketingDelete = (
  params: DeleteApiTelemarketingDeleteParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/telemarketing/delete`, method: "DELETE", params, signal },
    options
  );
};

export const getDeleteApiTelemarketingDeleteMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>,
    TError,
    { params: DeleteApiTelemarketingDeleteParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>,
  TError,
  { params: DeleteApiTelemarketingDeleteParams },
  TContext
> => {
  const mutationKey = ["deleteApiTelemarketingDelete"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>,
    { params: DeleteApiTelemarketingDeleteParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiTelemarketingDelete(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTelemarketingDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>
>;

export type DeleteApiTelemarketingDeleteMutationError = unknown;

export const useDeleteApiTelemarketingDelete = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>,
      TError,
      { params: DeleteApiTelemarketingDeleteParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTelemarketingDelete>>,
  TError,
  { params: DeleteApiTelemarketingDeleteParams },
  TContext
> => {
  return useMutation(
    getDeleteApiTelemarketingDeleteMutationOptions(options),
    queryClient
  );
};

export const postApiTelemarketingChangeStatus = (
  changeTelemarketingStatusDto: ChangeTelemarketingStatusDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/changeStatus`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changeTelemarketingStatusDto,
      signal,
    },
    options
  );
};

export const getPostApiTelemarketingChangeStatusMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>,
    TError,
    { data: ChangeTelemarketingStatusDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>,
  TError,
  { data: ChangeTelemarketingStatusDto },
  TContext
> => {
  const mutationKey = ["postApiTelemarketingChangeStatus"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>,
    { data: ChangeTelemarketingStatusDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTelemarketingChangeStatus(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelemarketingChangeStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>
>;
export type PostApiTelemarketingChangeStatusMutationBody =
  ChangeTelemarketingStatusDto;
export type PostApiTelemarketingChangeStatusMutationError = unknown;

export const usePostApiTelemarketingChangeStatus = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>,
      TError,
      { data: ChangeTelemarketingStatusDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelemarketingChangeStatus>>,
  TError,
  { data: ChangeTelemarketingStatusDto },
  TContext
> => {
  return useMutation(
    getPostApiTelemarketingChangeStatusMutationOptions(options),
    queryClient
  );
};

export const getApiTelemarketingCheck = (
  params: GetApiTelemarketingCheckParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/telemarketing/check`, method: "GET", params, signal },
    options
  );
};

export const getGetApiTelemarketingCheckQueryKey = (
  params?: GetApiTelemarketingCheckParams
) => {
  return [`/api/telemarketing/check`, ...(params ? [params] : [])] as const;
};

export const getGetApiTelemarketingCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
  TError = unknown
>(
  params: GetApiTelemarketingCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTelemarketingCheckQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingCheck>>
  > = ({ signal }) => getApiTelemarketingCheck(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingCheck>>
>;
export type GetApiTelemarketingCheckQueryError = unknown;

export function useGetApiTelemarketingCheck<
  TData = Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
  TError = unknown
>(
  params: GetApiTelemarketingCheckParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingCheck<
  TData = Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
  TError = unknown
>(
  params: GetApiTelemarketingCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingCheck<
  TData = Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
  TError = unknown
>(
  params: GetApiTelemarketingCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingCheck<
  TData = Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
  TError = unknown
>(
  params: GetApiTelemarketingCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingCheck>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTelemarketingCheckQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTelemarketingUpdateWorkDays = (
  camWorkDaysDto: CamWorkDaysDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/updateWorkDays`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: camWorkDaysDto,
      signal,
    },
    options
  );
};

export const getPostApiTelemarketingUpdateWorkDaysMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>,
    TError,
    { data: CamWorkDaysDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>,
  TError,
  { data: CamWorkDaysDto[] },
  TContext
> => {
  const mutationKey = ["postApiTelemarketingUpdateWorkDays"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>,
    { data: CamWorkDaysDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTelemarketingUpdateWorkDays(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelemarketingUpdateWorkDaysMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>
>;
export type PostApiTelemarketingUpdateWorkDaysMutationBody = CamWorkDaysDto[];
export type PostApiTelemarketingUpdateWorkDaysMutationError = unknown;

export const usePostApiTelemarketingUpdateWorkDays = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>,
      TError,
      { data: CamWorkDaysDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelemarketingUpdateWorkDays>>,
  TError,
  { data: CamWorkDaysDto[] },
  TContext
> => {
  return useMutation(
    getPostApiTelemarketingUpdateWorkDaysMutationOptions(options),
    queryClient
  );
};

export const getApiTelemarketingInactiveMarketingRecords = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/inactiveMarketingRecords`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetApiTelemarketingInactiveMarketingRecordsQueryKey = () => {
  return [`/api/telemarketing/inactiveMarketingRecords`] as const;
};

export const getGetApiTelemarketingInactiveMarketingRecordsQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTelemarketingInactiveMarketingRecordsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>
  > = ({ signal }) =>
    getApiTelemarketingInactiveMarketingRecords(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingInactiveMarketingRecordsQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>
  >;
export type GetApiTelemarketingInactiveMarketingRecordsQueryError = unknown;

export function useGetApiTelemarketingInactiveMarketingRecords<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingInactiveMarketingRecords<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
          >,
          TError,
          Awaited<
            ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingInactiveMarketingRecords<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingInactiveMarketingRecords<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingInactiveMarketingRecords>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiTelemarketingInactiveMarketingRecordsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTelemarketingStatusHistoryByCustomer = (
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListTelemarketingStatusDto>(
    {
      url: `/api/telemarketing/statusHistoryByCustomer`,
      method: "GET",
      params,
      signal,
    },
    options
  );
};

export const getGetApiTelemarketingStatusHistoryByCustomerQueryKey = (
  params?: GetApiTelemarketingStatusHistoryByCustomerParams
) => {
  return [
    `/api/telemarketing/statusHistoryByCustomer`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiTelemarketingStatusHistoryByCustomerQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
  >,
  TError = unknown
>(
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTelemarketingStatusHistoryByCustomerQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>
  > = ({ signal }) =>
    getApiTelemarketingStatusHistoryByCustomer(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingStatusHistoryByCustomerQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>
>;
export type GetApiTelemarketingStatusHistoryByCustomerQueryError = unknown;

export function useGetApiTelemarketingStatusHistoryByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
  >,
  TError = unknown
>(
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
          >,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingStatusHistoryByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
  >,
  TError = unknown
>(
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
          >,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingStatusHistoryByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
  >,
  TError = unknown
>(
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingStatusHistoryByCustomer<
  TData = Awaited<
    ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>
  >,
  TError = unknown
>(
  params: GetApiTelemarketingStatusHistoryByCustomerParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingStatusHistoryByCustomer>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiTelemarketingStatusHistoryByCustomerQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTelemarketingAbuzer = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/telemarketing/abuzer`, method: "POST", signal },
    options
  );
};

export const getPostApiTelemarketingAbuzerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTelemarketingAbuzer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>,
    void
  > = () => {
    return postApiTelemarketingAbuzer(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelemarketingAbuzerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>
>;

export type PostApiTelemarketingAbuzerMutationError = unknown;

export const usePostApiTelemarketingAbuzer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelemarketingAbuzer>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTelemarketingAbuzerMutationOptions(options),
    queryClient
  );
};

export const postApiTelemarketingUnassignCamsTelemarketing = (
  params: PostApiTelemarketingUnassignCamsTelemarketingParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/telemarketing/unassignCamsTelemarketing`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiTelemarketingUnassignCamsTelemarketingMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>,
    TError,
    { params: PostApiTelemarketingUnassignCamsTelemarketingParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>,
  TError,
  { params: PostApiTelemarketingUnassignCamsTelemarketingParams },
  TContext
> => {
  const mutationKey = ["postApiTelemarketingUnassignCamsTelemarketing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>,
    { params: PostApiTelemarketingUnassignCamsTelemarketingParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiTelemarketingUnassignCamsTelemarketing(
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTelemarketingUnassignCamsTelemarketingMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>
  >;

export type PostApiTelemarketingUnassignCamsTelemarketingMutationError =
  unknown;

export const usePostApiTelemarketingUnassignCamsTelemarketing = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>,
      TError,
      { params: PostApiTelemarketingUnassignCamsTelemarketingParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTelemarketingUnassignCamsTelemarketing>>,
  TError,
  { params: PostApiTelemarketingUnassignCamsTelemarketingParams },
  TContext
> => {
  return useMutation(
    getPostApiTelemarketingUnassignCamsTelemarketingMutationOptions(options),
    queryClient
  );
};

export const getApiTelemarketingDefaultFlowCallBack = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/telemarketing/defaultFlowCallBack`, method: "GET", signal },
    options
  );
};

export const getGetApiTelemarketingDefaultFlowCallBackQueryKey = () => {
  return [`/api/telemarketing/defaultFlowCallBack`] as const;
};

export const getGetApiTelemarketingDefaultFlowCallBackQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTelemarketingDefaultFlowCallBackQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>
  > = ({ signal }) =>
    getApiTelemarketingDefaultFlowCallBack(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTelemarketingDefaultFlowCallBackQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>
>;
export type GetApiTelemarketingDefaultFlowCallBackQueryError = unknown;

export function useGetApiTelemarketingDefaultFlowCallBack<
  TData = Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingDefaultFlowCallBack<
  TData = Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
          TError,
          Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTelemarketingDefaultFlowCallBack<
  TData = Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTelemarketingDefaultFlowCallBack<
  TData = Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTelemarketingDefaultFlowCallBack>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiTelemarketingDefaultFlowCallBackQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTicketSockets = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionarySocketKeyListWebSocket>(
    { url: `/api/ticket/sockets`, method: "GET", signal },
    options
  );
};

export const getGetApiTicketSocketsQueryKey = () => {
  return [`/api/ticket/sockets`] as const;
};

export const getGetApiTicketSocketsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketSockets>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketSockets>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTicketSocketsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketSockets>>
  > = ({ signal }) => getApiTicketSockets(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketSockets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketSocketsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketSockets>>
>;
export type GetApiTicketSocketsQueryError = unknown;

export function useGetApiTicketSockets<
  TData = Awaited<ReturnType<typeof getApiTicketSockets>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSockets>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketSockets>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketSockets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketSockets<
  TData = Awaited<ReturnType<typeof getApiTicketSockets>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSockets>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketSockets>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketSockets>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketSockets<
  TData = Awaited<ReturnType<typeof getApiTicketSockets>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSockets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketSockets<
  TData = Awaited<ReturnType<typeof getApiTicketSockets>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSockets>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTicketSocketsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTicketLogOnlineCams = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/ticket/logOnlineCams`, method: "POST", signal },
    options
  );
};

export const getPostApiTicketLogOnlineCamsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTicketLogOnlineCams"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>,
    void
  > = () => {
    return postApiTicketLogOnlineCams(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTicketLogOnlineCamsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>
>;

export type PostApiTicketLogOnlineCamsMutationError = unknown;

export const usePostApiTicketLogOnlineCams = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTicketLogOnlineCams>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTicketLogOnlineCamsMutationOptions(options),
    queryClient
  );
};

export const getApiTicketSocketsdetailed = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListSocketDetailedResultDto>(
    { url: `/api/ticket/socketsdetailed`, method: "GET", signal },
    options
  );
};

export const getGetApiTicketSocketsdetailedQueryKey = () => {
  return [`/api/ticket/socketsdetailed`] as const;
};

export const getGetApiTicketSocketsdetailedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketSocketsdetailedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>
  > = ({ signal }) => getApiTicketSocketsdetailed(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketSocketsdetailedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>
>;
export type GetApiTicketSocketsdetailedQueryError = unknown;

export function useGetApiTicketSocketsdetailed<
  TData = Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketSocketsdetailed<
  TData = Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketSocketsdetailed<
  TData = Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketSocketsdetailed<
  TData = Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketSocketsdetailed>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTicketSocketsdetailedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTicket = (
  createTicketRequestDto: CreateTicketRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultTicketDto>(
    {
      url: `/api/ticket`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTicketRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTicketMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTicket>>,
    TError,
    { data: CreateTicketRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTicket>>,
  TError,
  { data: CreateTicketRequestDto },
  TContext
> => {
  const mutationKey = ["postApiTicket"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTicket>>,
    { data: CreateTicketRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTicket(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTicketMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTicket>>
>;
export type PostApiTicketMutationBody = CreateTicketRequestDto;
export type PostApiTicketMutationError = unknown;

export const usePostApiTicket = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTicket>>,
      TError,
      { data: CreateTicketRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTicket>>,
  TError,
  { data: CreateTicketRequestDto },
  TContext
> => {
  return useMutation(getPostApiTicketMutationOptions(options), queryClient);
};

export const getApiTicketOnlineUsers = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInt64>(
    { url: `/api/ticket/onlineUsers`, method: "GET", signal },
    options
  );
};

export const getGetApiTicketOnlineUsersQueryKey = () => {
  return [`/api/ticket/onlineUsers`] as const;
};

export const getGetApiTicketOnlineUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketOnlineUsersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketOnlineUsers>>
  > = ({ signal }) => getApiTicketOnlineUsers(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketOnlineUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketOnlineUsers>>
>;
export type GetApiTicketOnlineUsersQueryError = unknown;

export function useGetApiTicketOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketOnlineUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketOnlineUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketOnlineUsers<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineUsers>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTicketOnlineUsersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTicketOnlineCams = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInt64>(
    { url: `/api/ticket/onlineCams`, method: "GET", signal },
    options
  );
};

export const getGetApiTicketOnlineCamsQueryKey = () => {
  return [`/api/ticket/onlineCams`] as const;
};

export const getGetApiTicketOnlineCamsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketOnlineCamsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketOnlineCams>>
  > = ({ signal }) => getApiTicketOnlineCams(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketOnlineCamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketOnlineCams>>
>;
export type GetApiTicketOnlineCamsQueryError = unknown;

export function useGetApiTicketOnlineCams<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketOnlineCams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketOnlineCams<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketOnlineCams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketOnlineCams<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketOnlineCams<
  TData = Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketOnlineCams>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTicketOnlineCamsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTicketWorkingHour = (
  params?: GetApiTicketWorkingHourParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/ticket/workingHour`, method: "GET", params, signal },
    options
  );
};

export const getGetApiTicketWorkingHourQueryKey = (
  params?: GetApiTicketWorkingHourParams
) => {
  return [`/api/ticket/workingHour`, ...(params ? [params] : [])] as const;
};

export const getGetApiTicketWorkingHourQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
  TError = unknown
>(
  params?: GetApiTicketWorkingHourParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketWorkingHourQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketWorkingHour>>
  > = ({ signal }) => getApiTicketWorkingHour(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketWorkingHourQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketWorkingHour>>
>;
export type GetApiTicketWorkingHourQueryError = unknown;

export function useGetApiTicketWorkingHour<
  TData = Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
  TError = unknown
>(
  params: undefined | GetApiTicketWorkingHourParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketWorkingHour>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketWorkingHour<
  TData = Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
  TError = unknown
>(
  params?: GetApiTicketWorkingHourParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketWorkingHour>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketWorkingHour<
  TData = Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
  TError = unknown
>(
  params?: GetApiTicketWorkingHourParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketWorkingHour<
  TData = Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
  TError = unknown
>(
  params?: GetApiTicketWorkingHourParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketWorkingHour>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTicketWorkingHourQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTicketMessage = (
  createTicketMessageRequestDto: CreateTicketMessageRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/ticket/message`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTicketMessageRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTicketMessageMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTicketMessage>>,
    TError,
    { data: CreateTicketMessageRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTicketMessage>>,
  TError,
  { data: CreateTicketMessageRequestDto },
  TContext
> => {
  const mutationKey = ["postApiTicketMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTicketMessage>>,
    { data: CreateTicketMessageRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTicketMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTicketMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTicketMessage>>
>;
export type PostApiTicketMessageMutationBody = CreateTicketMessageRequestDto;
export type PostApiTicketMessageMutationError = unknown;

export const usePostApiTicketMessage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTicketMessage>>,
      TError,
      { data: CreateTicketMessageRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTicketMessage>>,
  TError,
  { data: CreateTicketMessageRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiTicketMessageMutationOptions(options),
    queryClient
  );
};

export const getApiTicketGetAutoPreAssignedTicket = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListInt64>(
    { url: `/api/ticket/getAutoPreAssignedTicket`, method: "GET", signal },
    options
  );
};

export const getGetApiTicketGetAutoPreAssignedTicketQueryKey = () => {
  return [`/api/ticket/getAutoPreAssignedTicket`] as const;
};

export const getGetApiTicketGetAutoPreAssignedTicketQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTicketGetAutoPreAssignedTicketQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>
  > = ({ signal }) =>
    getApiTicketGetAutoPreAssignedTicket(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTicketGetAutoPreAssignedTicketQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>
>;
export type GetApiTicketGetAutoPreAssignedTicketQueryError = unknown;

export function useGetApiTicketGetAutoPreAssignedTicket<
  TData = Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketGetAutoPreAssignedTicket<
  TData = Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
          TError,
          Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTicketGetAutoPreAssignedTicket<
  TData = Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTicketGetAutoPreAssignedTicket<
  TData = Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTicketGetAutoPreAssignedTicket>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiTicketGetAutoPreAssignedTicketQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTinkTinkCallback = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/tink/tinkCallback`, method: "POST", signal },
    options
  );
};

export const getPostApiTinkTinkCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTinkTinkCallback>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTinkTinkCallback>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTinkTinkCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTinkTinkCallback>>,
    void
  > = () => {
    return postApiTinkTinkCallback(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTinkTinkCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTinkTinkCallback>>
>;

export type PostApiTinkTinkCallbackMutationError = unknown;

export const usePostApiTinkTinkCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTinkTinkCallback>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTinkTinkCallback>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTinkTinkCallbackMutationOptions(options),
    queryClient
  );
};

export const getApiTinkTinkCallbackTokenized = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/tink/tinkCallbackTokenized`, method: "GET", signal },
    options
  );
};

export const getGetApiTinkTinkCallbackTokenizedQueryKey = () => {
  return [`/api/tink/tinkCallbackTokenized`] as const;
};

export const getGetApiTinkTinkCallbackTokenizedQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTinkTinkCallbackTokenizedQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>
  > = ({ signal }) => getApiTinkTinkCallbackTokenized(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTinkTinkCallbackTokenizedQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>
>;
export type GetApiTinkTinkCallbackTokenizedQueryError = unknown;

export function useGetApiTinkTinkCallbackTokenized<
  TData = Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
          TError,
          Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTinkTinkCallbackTokenized<
  TData = Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
          TError,
          Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTinkTinkCallbackTokenized<
  TData = Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTinkTinkCallbackTokenized<
  TData = Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTinkCallbackTokenized>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTinkTinkCallbackTokenizedQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiTinkTest11 = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/tink/test11`, method: "GET", signal },
    options
  );
};

export const getGetApiTinkTest11QueryKey = () => {
  return [`/api/tink/test11`] as const;
};

export const getGetApiTinkTest11QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTinkTest11>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiTinkTest11>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTinkTest11QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTinkTest11>>
  > = ({ signal }) => getApiTinkTest11(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTinkTest11>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTinkTest11QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTinkTest11>>
>;
export type GetApiTinkTest11QueryError = unknown;

export function useGetApiTinkTest11<
  TData = Awaited<ReturnType<typeof getApiTinkTest11>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTest11>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTinkTest11>>,
          TError,
          Awaited<ReturnType<typeof getApiTinkTest11>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTinkTest11<
  TData = Awaited<ReturnType<typeof getApiTinkTest11>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTest11>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTinkTest11>>,
          TError,
          Awaited<ReturnType<typeof getApiTinkTest11>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTinkTest11<
  TData = Awaited<ReturnType<typeof getApiTinkTest11>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTest11>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTinkTest11<
  TData = Awaited<ReturnType<typeof getApiTinkTest11>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTinkTest11>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTinkTest11QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiTinkTinkAggregationCertificate = (
  tinkAggregationCerticateDto: TinkAggregationCerticateDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListString>(
    {
      url: `/api/tink/tinkAggregationCertificate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tinkAggregationCerticateDto,
      signal,
    },
    options
  );
};

export const getPostApiTinkTinkAggregationCertificateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>,
    TError,
    { data: TinkAggregationCerticateDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>,
  TError,
  { data: TinkAggregationCerticateDto },
  TContext
> => {
  const mutationKey = ["postApiTinkTinkAggregationCertificate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>,
    { data: TinkAggregationCerticateDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTinkTinkAggregationCertificate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTinkTinkAggregationCertificateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>
>;
export type PostApiTinkTinkAggregationCertificateMutationBody =
  TinkAggregationCerticateDto;
export type PostApiTinkTinkAggregationCertificateMutationError = unknown;

export const usePostApiTinkTinkAggregationCertificate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>,
      TError,
      { data: TinkAggregationCerticateDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTinkTinkAggregationCertificate>>,
  TError,
  { data: TinkAggregationCerticateDto },
  TContext
> => {
  return useMutation(
    getPostApiTinkTinkAggregationCertificateMutationOptions(options),
    queryClient
  );
};

export const postApiTinkIframeEvent = (
  tinkIframeEventRequestDto: TinkIframeEventRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/tink/iframeEvent`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: tinkIframeEventRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiTinkIframeEventMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTinkIframeEvent>>,
    TError,
    { data: TinkIframeEventRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTinkIframeEvent>>,
  TError,
  { data: TinkIframeEventRequestDto },
  TContext
> => {
  const mutationKey = ["postApiTinkIframeEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTinkIframeEvent>>,
    { data: TinkIframeEventRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTinkIframeEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTinkIframeEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTinkIframeEvent>>
>;
export type PostApiTinkIframeEventMutationBody = TinkIframeEventRequestDto;
export type PostApiTinkIframeEventMutationError = unknown;

export const usePostApiTinkIframeEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTinkIframeEvent>>,
      TError,
      { data: TinkIframeEventRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTinkIframeEvent>>,
  TError,
  { data: TinkIframeEventRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiTinkIframeEventMutationOptions(options),
    queryClient
  );
};

export const getApiTodoGetToDoItem = (
  params: GetApiTodoGetToDoItemParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultToDoItemResponseDto>(
    { url: `/api/todo/getToDoItem`, method: "GET", params, signal },
    options
  );
};

export const getGetApiTodoGetToDoItemQueryKey = (
  params?: GetApiTodoGetToDoItemParams
) => {
  return [`/api/todo/getToDoItem`, ...(params ? [params] : [])] as const;
};

export const getGetApiTodoGetToDoItemQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
  TError = unknown
>(
  params: GetApiTodoGetToDoItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTodoGetToDoItemQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTodoGetToDoItem>>
  > = ({ signal }) => getApiTodoGetToDoItem(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTodoGetToDoItemQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTodoGetToDoItem>>
>;
export type GetApiTodoGetToDoItemQueryError = unknown;

export function useGetApiTodoGetToDoItem<
  TData = Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
  TError = unknown
>(
  params: GetApiTodoGetToDoItemParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
          TError,
          Awaited<ReturnType<typeof getApiTodoGetToDoItem>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTodoGetToDoItem<
  TData = Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
  TError = unknown
>(
  params: GetApiTodoGetToDoItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
          TError,
          Awaited<ReturnType<typeof getApiTodoGetToDoItem>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTodoGetToDoItem<
  TData = Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
  TError = unknown
>(
  params: GetApiTodoGetToDoItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTodoGetToDoItem<
  TData = Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
  TError = unknown
>(
  params: GetApiTodoGetToDoItemParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTodoGetToDoItem>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTodoGetToDoItemQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const deleteApiTodoDeleteToDoItem = (
  params: DeleteApiTodoDeleteToDoItemParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/todo/deleteToDoItem`, method: "DELETE", params, signal },
    options
  );
};

export const getDeleteApiTodoDeleteToDoItemMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>,
    TError,
    { params: DeleteApiTodoDeleteToDoItemParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>,
  TError,
  { params: DeleteApiTodoDeleteToDoItemParams },
  TContext
> => {
  const mutationKey = ["deleteApiTodoDeleteToDoItem"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>,
    { params: DeleteApiTodoDeleteToDoItemParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiTodoDeleteToDoItem(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTodoDeleteToDoItemMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>
>;

export type DeleteApiTodoDeleteToDoItemMutationError = unknown;

export const useDeleteApiTodoDeleteToDoItem = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>,
      TError,
      { params: DeleteApiTodoDeleteToDoItemParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTodoDeleteToDoItem>>,
  TError,
  { params: DeleteApiTodoDeleteToDoItemParams },
  TContext
> => {
  return useMutation(
    getDeleteApiTodoDeleteToDoItemMutationOptions(options),
    queryClient
  );
};

export const postApiTodoAddCustomerCallTimingDefination = (
  customerCallTimingDefDto: CustomerCallTimingDefDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/todo/addCustomerCallTimingDefination`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: customerCallTimingDefDto,
      signal,
    },
    options
  );
};

export const getPostApiTodoAddCustomerCallTimingDefinationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>,
    TError,
    { data: CustomerCallTimingDefDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>,
  TError,
  { data: CustomerCallTimingDefDto },
  TContext
> => {
  const mutationKey = ["postApiTodoAddCustomerCallTimingDefination"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>,
    { data: CustomerCallTimingDefDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTodoAddCustomerCallTimingDefination(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTodoAddCustomerCallTimingDefinationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>
  >;
export type PostApiTodoAddCustomerCallTimingDefinationMutationBody =
  CustomerCallTimingDefDto;
export type PostApiTodoAddCustomerCallTimingDefinationMutationError = unknown;

export const usePostApiTodoAddCustomerCallTimingDefination = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>,
      TError,
      { data: CustomerCallTimingDefDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTodoAddCustomerCallTimingDefination>>,
  TError,
  { data: CustomerCallTimingDefDto },
  TContext
> => {
  return useMutation(
    getPostApiTodoAddCustomerCallTimingDefinationMutationOptions(options),
    queryClient
  );
};

export const postApiTodoGetAvailableCallTimesByDates = (
  postApiTodoGetAvailableCallTimesByDatesBody: string[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultListCustomerCallTimingDefDto>(
    {
      url: `/api/todo/getAvailableCallTimesByDates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postApiTodoGetAvailableCallTimesByDatesBody,
      signal,
    },
    options
  );
};

export const getPostApiTodoGetAvailableCallTimesByDatesMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>,
    TError,
    { data: string[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>,
  TError,
  { data: string[] },
  TContext
> => {
  const mutationKey = ["postApiTodoGetAvailableCallTimesByDates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>,
    { data: string[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTodoGetAvailableCallTimesByDates(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTodoGetAvailableCallTimesByDatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>
>;
export type PostApiTodoGetAvailableCallTimesByDatesMutationBody = string[];
export type PostApiTodoGetAvailableCallTimesByDatesMutationError = unknown;

export const usePostApiTodoGetAvailableCallTimesByDates = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>,
      TError,
      { data: string[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTodoGetAvailableCallTimesByDates>>,
  TError,
  { data: string[] },
  TContext
> => {
  return useMutation(
    getPostApiTodoGetAvailableCallTimesByDatesMutationOptions(options),
    queryClient
  );
};

export const postApiTodoChooseCallTimeForCustomer = (
  chooseCallTimeForCustomerRequestDto: ChooseCallTimeForCustomerRequestDto,
  params: PostApiTodoChooseCallTimeForCustomerParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/todo/chooseCallTimeForCustomer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: chooseCallTimeForCustomerRequestDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiTodoChooseCallTimeForCustomerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>,
    TError,
    {
      data: ChooseCallTimeForCustomerRequestDto;
      params: PostApiTodoChooseCallTimeForCustomerParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>,
  TError,
  {
    data: ChooseCallTimeForCustomerRequestDto;
    params: PostApiTodoChooseCallTimeForCustomerParams;
  },
  TContext
> => {
  const mutationKey = ["postApiTodoChooseCallTimeForCustomer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>,
    {
      data: ChooseCallTimeForCustomerRequestDto;
      params: PostApiTodoChooseCallTimeForCustomerParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiTodoChooseCallTimeForCustomer(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTodoChooseCallTimeForCustomerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>
>;
export type PostApiTodoChooseCallTimeForCustomerMutationBody =
  ChooseCallTimeForCustomerRequestDto;
export type PostApiTodoChooseCallTimeForCustomerMutationError = unknown;

export const usePostApiTodoChooseCallTimeForCustomer = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>,
      TError,
      {
        data: ChooseCallTimeForCustomerRequestDto;
        params: PostApiTodoChooseCallTimeForCustomerParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTodoChooseCallTimeForCustomer>>,
  TError,
  {
    data: ChooseCallTimeForCustomerRequestDto;
    params: PostApiTodoChooseCallTimeForCustomerParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiTodoChooseCallTimeForCustomerMutationOptions(options),
    queryClient
  );
};

export const postApiTodoRemoveCallTimingDefinationById = (
  params: PostApiTodoRemoveCallTimingDefinationByIdParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/todo/removeCallTimingDefinationById`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiTodoRemoveCallTimingDefinationByIdMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>,
    TError,
    { params: PostApiTodoRemoveCallTimingDefinationByIdParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>,
  TError,
  { params: PostApiTodoRemoveCallTimingDefinationByIdParams },
  TContext
> => {
  const mutationKey = ["postApiTodoRemoveCallTimingDefinationById"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>,
    { params: PostApiTodoRemoveCallTimingDefinationByIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiTodoRemoveCallTimingDefinationById(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTodoRemoveCallTimingDefinationByIdMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>
  >;

export type PostApiTodoRemoveCallTimingDefinationByIdMutationError = unknown;

export const usePostApiTodoRemoveCallTimingDefinationById = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>,
      TError,
      { params: PostApiTodoRemoveCallTimingDefinationByIdParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTodoRemoveCallTimingDefinationById>>,
  TError,
  { params: PostApiTodoRemoveCallTimingDefinationByIdParams },
  TContext
> => {
  return useMutation(
    getPostApiTodoRemoveCallTimingDefinationByIdMutationOptions(options),
    queryClient
  );
};

export const postApiTodoAutoInsertCallTimingDefination = (
  params: PostApiTodoAutoInsertCallTimingDefinationParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/todo/autoInsertCallTimingDefination`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiTodoAutoInsertCallTimingDefinationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>,
    TError,
    { params: PostApiTodoAutoInsertCallTimingDefinationParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>,
  TError,
  { params: PostApiTodoAutoInsertCallTimingDefinationParams },
  TContext
> => {
  const mutationKey = ["postApiTodoAutoInsertCallTimingDefination"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>,
    { params: PostApiTodoAutoInsertCallTimingDefinationParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiTodoAutoInsertCallTimingDefination(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTodoAutoInsertCallTimingDefinationMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>
  >;

export type PostApiTodoAutoInsertCallTimingDefinationMutationError = unknown;

export const usePostApiTodoAutoInsertCallTimingDefination = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>,
      TError,
      { params: PostApiTodoAutoInsertCallTimingDefinationParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTodoAutoInsertCallTimingDefination>>,
  TError,
  { params: PostApiTodoAutoInsertCallTimingDefinationParams },
  TContext
> => {
  return useMutation(
    getPostApiTodoAutoInsertCallTimingDefinationMutationOptions(options),
    queryClient
  );
};

export const postApiTransactionDescriptionInvalidate = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/transactionDescription/invalidate`, method: "POST", signal },
    options
  );
};

export const getPostApiTransactionDescriptionInvalidateMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiTransactionDescriptionInvalidate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>,
    void
  > = () => {
    return postApiTransactionDescriptionInvalidate(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTransactionDescriptionInvalidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>
>;

export type PostApiTransactionDescriptionInvalidateMutationError = unknown;

export const usePostApiTransactionDescriptionInvalidate = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTransactionDescriptionInvalidate>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiTransactionDescriptionInvalidateMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxTokenCreation = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/unnax/tokenCreation`, method: "POST", signal },
    options
  );
};

export const getPostApiUnnaxTokenCreationMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiUnnaxTokenCreation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>,
    void
  > = () => {
    return postApiUnnaxTokenCreation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxTokenCreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>
>;

export type PostApiUnnaxTokenCreationMutationError = unknown;

export const usePostApiUnnaxTokenCreation = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxTokenCreation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiUnnaxTokenCreationMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxBulkReceipts = (
  unnaxBulkReceiptsRequest: UnnaxBulkReceiptsRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/unnax/bulkReceipts`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxBulkReceiptsRequest,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxBulkReceiptsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>,
    TError,
    { data: UnnaxBulkReceiptsRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>,
  TError,
  { data: UnnaxBulkReceiptsRequest },
  TContext
> => {
  const mutationKey = ["postApiUnnaxBulkReceipts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>,
    { data: UnnaxBulkReceiptsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxBulkReceipts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxBulkReceiptsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>
>;
export type PostApiUnnaxBulkReceiptsMutationBody = UnnaxBulkReceiptsRequest;
export type PostApiUnnaxBulkReceiptsMutationError = unknown;

export const usePostApiUnnaxBulkReceipts = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>,
      TError,
      { data: UnnaxBulkReceiptsRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxBulkReceipts>>,
  TError,
  { data: UnnaxBulkReceiptsRequest },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxBulkReceiptsMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxCallback = (
  unnaxCallbackDto: UnnaxCallbackDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/unnax/callback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxCallbackDto,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxCallback>>,
    TError,
    { data: UnnaxCallbackDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxCallback>>,
  TError,
  { data: UnnaxCallbackDto },
  TContext
> => {
  const mutationKey = ["postApiUnnaxCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxCallback>>,
    { data: UnnaxCallbackDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxCallback>>
>;
export type PostApiUnnaxCallbackMutationBody = UnnaxCallbackDto;
export type PostApiUnnaxCallbackMutationError = unknown;

export const usePostApiUnnaxCallback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxCallback>>,
      TError,
      { data: UnnaxCallbackDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxCallback>>,
  TError,
  { data: UnnaxCallbackDto },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxReScrapeCustomersRejectedByDecision = (
  params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultDictionaryStringObject>(
    {
      url: `/api/unnax/reScrapeCustomersRejectedByDecision`,
      method: "POST",
      params,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxReScrapeCustomersRejectedByDecisionMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>
      >,
      TError,
      { params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>>,
    TError,
    { params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams },
    TContext
  > => {
    const mutationKey = ["postApiUnnaxReScrapeCustomersRejectedByDecision"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>
      >,
      { params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams }
    > = (props) => {
      const { params } = props ?? {};

      return postApiUnnaxReScrapeCustomersRejectedByDecision(
        params,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiUnnaxReScrapeCustomersRejectedByDecisionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>>
  >;

export type PostApiUnnaxReScrapeCustomersRejectedByDecisionMutationError =
  unknown;

export const usePostApiUnnaxReScrapeCustomersRejectedByDecision = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>
      >,
      TError,
      { params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxReScrapeCustomersRejectedByDecision>>,
  TError,
  { params?: PostApiUnnaxReScrapeCustomersRejectedByDecisionParams },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxReScrapeCustomersRejectedByDecisionMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxReScrapeV2ByCustomerIds = (
  rejectedCustomersByUnnaxDto: RejectedCustomersByUnnaxDto[],
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/unnax/reScrapeV2ByCustomerIds`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: rejectedCustomersByUnnaxDto,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxReScrapeV2ByCustomerIdsMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>,
    TError,
    { data: RejectedCustomersByUnnaxDto[] },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>,
  TError,
  { data: RejectedCustomersByUnnaxDto[] },
  TContext
> => {
  const mutationKey = ["postApiUnnaxReScrapeV2ByCustomerIds"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>,
    { data: RejectedCustomersByUnnaxDto[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxReScrapeV2ByCustomerIds(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxReScrapeV2ByCustomerIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>
>;
export type PostApiUnnaxReScrapeV2ByCustomerIdsMutationBody =
  RejectedCustomersByUnnaxDto[];
export type PostApiUnnaxReScrapeV2ByCustomerIdsMutationError = unknown;

export const usePostApiUnnaxReScrapeV2ByCustomerIds = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>,
      TError,
      { data: RejectedCustomersByUnnaxDto[] },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxReScrapeV2ByCustomerIds>>,
  TError,
  { data: RejectedCustomersByUnnaxDto[] },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxReScrapeV2ByCustomerIdsMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxCallbackCollectionTriggerTest = (
  collectionRequestDto: CollectionRequestDto,
  params: PostApiUnnaxCallbackCollectionTriggerTestParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/unnax/callbackCollectionTriggerTest`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: collectionRequestDto,
      params,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxCallbackCollectionTriggerTestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>,
    TError,
    {
      data: CollectionRequestDto;
      params: PostApiUnnaxCallbackCollectionTriggerTestParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>,
  TError,
  {
    data: CollectionRequestDto;
    params: PostApiUnnaxCallbackCollectionTriggerTestParams;
  },
  TContext
> => {
  const mutationKey = ["postApiUnnaxCallbackCollectionTriggerTest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>,
    {
      data: CollectionRequestDto;
      params: PostApiUnnaxCallbackCollectionTriggerTestParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiUnnaxCallbackCollectionTriggerTest(
      data,
      params,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxCallbackCollectionTriggerTestMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>
  >;
export type PostApiUnnaxCallbackCollectionTriggerTestMutationBody =
  CollectionRequestDto;
export type PostApiUnnaxCallbackCollectionTriggerTestMutationError = unknown;

export const usePostApiUnnaxCallbackCollectionTriggerTest = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>,
      TError,
      {
        data: CollectionRequestDto;
        params: PostApiUnnaxCallbackCollectionTriggerTestParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxCallbackCollectionTriggerTest>>,
  TError,
  {
    data: CollectionRequestDto;
    params: PostApiUnnaxCallbackCollectionTriggerTestParams;
  },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxCallbackCollectionTriggerTestMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxCallbackEventEventName = (
  eventName:
    | "event_pdfs_uploaded_link"
    | "event_fullid_result"
    | "fitnance_start"
    | "event_credential_token_login"
    | "aggregation_login"
    | "event_aggregation_status"
    | "reader_lockstep_complete",
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/unnax/callback-event/${eventName}`, method: "POST", signal },
    options
  );
};

export const getPostApiUnnaxCallbackEventEventNameMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>,
    TError,
    {
      eventName:
        | "event_pdfs_uploaded_link"
        | "event_fullid_result"
        | "fitnance_start"
        | "event_credential_token_login"
        | "aggregation_login"
        | "event_aggregation_status"
        | "reader_lockstep_complete";
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>,
  TError,
  {
    eventName:
      | "event_pdfs_uploaded_link"
      | "event_fullid_result"
      | "fitnance_start"
      | "event_credential_token_login"
      | "aggregation_login"
      | "event_aggregation_status"
      | "reader_lockstep_complete";
  },
  TContext
> => {
  const mutationKey = ["postApiUnnaxCallbackEventEventName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>,
    {
      eventName:
        | "event_pdfs_uploaded_link"
        | "event_fullid_result"
        | "fitnance_start"
        | "event_credential_token_login"
        | "aggregation_login"
        | "event_aggregation_status"
        | "reader_lockstep_complete";
    }
  > = (props) => {
    const { eventName } = props ?? {};

    return postApiUnnaxCallbackEventEventName(eventName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxCallbackEventEventNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>
>;

export type PostApiUnnaxCallbackEventEventNameMutationError = unknown;

export const usePostApiUnnaxCallbackEventEventName = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>,
      TError,
      {
        eventName:
          | "event_pdfs_uploaded_link"
          | "event_fullid_result"
          | "fitnance_start"
          | "event_credential_token_login"
          | "aggregation_login"
          | "event_aggregation_status"
          | "reader_lockstep_complete";
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxCallbackEventEventName>>,
  TError,
  {
    eventName:
      | "event_pdfs_uploaded_link"
      | "event_fullid_result"
      | "fitnance_start"
      | "event_credential_token_login"
      | "aggregation_login"
      | "event_aggregation_status"
      | "reader_lockstep_complete";
  },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxCallbackEventEventNameMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxMocker = (
  unnaxMockerRequestDto: UnnaxMockerRequestDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxCallbackDto>(
    {
      url: `/api/unnax/mocker`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxMockerRequestDto,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxMockerMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxMocker>>,
    TError,
    { data: UnnaxMockerRequestDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxMocker>>,
  TError,
  { data: UnnaxMockerRequestDto },
  TContext
> => {
  const mutationKey = ["postApiUnnaxMocker"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxMocker>>,
    { data: UnnaxMockerRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxMocker(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxMockerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxMocker>>
>;
export type PostApiUnnaxMockerMutationBody = UnnaxMockerRequestDto;
export type PostApiUnnaxMockerMutationError = unknown;

export const usePostApiUnnaxMocker = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxMocker>>,
      TError,
      { data: UnnaxMockerRequestDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxMocker>>,
  TError,
  { data: UnnaxMockerRequestDto },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxMockerMutationOptions(options),
    queryClient
  );
};

export const getApiUnnaxUnnaxResultCheckCustomerId = (
  customerId: number,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/unnax/unnaxResultCheck/${customerId}`, method: "GET", signal },
    options
  );
};

export const getGetApiUnnaxUnnaxResultCheckCustomerIdQueryKey = (
  customerId: number
) => {
  return [`/api/unnax/unnaxResultCheck/${customerId}`] as const;
};

export const getGetApiUnnaxUnnaxResultCheckCustomerIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiUnnaxUnnaxResultCheckCustomerIdQueryKey(customerId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>
  > = ({ signal }) =>
    getApiUnnaxUnnaxResultCheckCustomerId(customerId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!customerId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUnnaxUnnaxResultCheckCustomerIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>
>;
export type GetApiUnnaxUnnaxResultCheckCustomerIdQueryError = unknown;

export function useGetApiUnnaxUnnaxResultCheckCustomerId<
  TData = Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUnnaxUnnaxResultCheckCustomerId<
  TData = Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
          TError,
          Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUnnaxUnnaxResultCheckCustomerId<
  TData = Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiUnnaxUnnaxResultCheckCustomerId<
  TData = Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
  TError = unknown
>(
  customerId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxUnnaxResultCheckCustomerId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiUnnaxUnnaxResultCheckCustomerIdQueryOptions(
    customerId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getApiUnnaxLoadBulkUnnaxReceipts = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    { url: `/api/unnax/loadBulkUnnaxReceipts`, method: "GET", signal },
    options
  );
};

export const getGetApiUnnaxLoadBulkUnnaxReceiptsQueryKey = () => {
  return [`/api/unnax/loadBulkUnnaxReceipts`] as const;
};

export const getGetApiUnnaxLoadBulkUnnaxReceiptsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiUnnaxLoadBulkUnnaxReceiptsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>
  > = ({ signal }) => getApiUnnaxLoadBulkUnnaxReceipts(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUnnaxLoadBulkUnnaxReceiptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>
>;
export type GetApiUnnaxLoadBulkUnnaxReceiptsQueryError = unknown;

export function useGetApiUnnaxLoadBulkUnnaxReceipts<
  TData = Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
          TError,
          Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUnnaxLoadBulkUnnaxReceipts<
  TData = Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
          TError,
          Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiUnnaxLoadBulkUnnaxReceipts<
  TData = Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiUnnaxLoadBulkUnnaxReceipts<
  TData = Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiUnnaxLoadBulkUnnaxReceipts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiUnnaxLoadBulkUnnaxReceiptsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const postApiUnnaxEventAggregationStatusCallback = (
  unnaxEventAggregationStatusDto: UnnaxEventAggregationStatusDto,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultBoolean>(
    {
      url: `/api/unnax/eventAggregationStatusCallback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxEventAggregationStatusDto,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxEventAggregationStatusCallbackMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>,
    TError,
    { data: UnnaxEventAggregationStatusDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>,
  TError,
  { data: UnnaxEventAggregationStatusDto },
  TContext
> => {
  const mutationKey = ["postApiUnnaxEventAggregationStatusCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>,
    { data: UnnaxEventAggregationStatusDto }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxEventAggregationStatusCallback(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxEventAggregationStatusCallbackMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>
  >;
export type PostApiUnnaxEventAggregationStatusCallbackMutationBody =
  UnnaxEventAggregationStatusDto;
export type PostApiUnnaxEventAggregationStatusCallbackMutationError = unknown;

export const usePostApiUnnaxEventAggregationStatusCallback = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>,
      TError,
      { data: UnnaxEventAggregationStatusDto },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxEventAggregationStatusCallback>>,
  TError,
  { data: UnnaxEventAggregationStatusDto },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxEventAggregationStatusCallbackMutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxMocker2 = (
  unnaxAccountCardMockRequestDtoBody: UnnaxAccountCardMockRequestDtoBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ResultUnnaxCallbackDto>(
    {
      url: `/api/unnax/mocker2`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: unnaxAccountCardMockRequestDtoBody,
      signal,
    },
    options
  );
};

export const getPostApiUnnaxMocker2MutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxMocker2>>,
    TError,
    { data: UnnaxAccountCardMockRequestDtoBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxMocker2>>,
  TError,
  { data: UnnaxAccountCardMockRequestDtoBody },
  TContext
> => {
  const mutationKey = ["postApiUnnaxMocker2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxMocker2>>,
    { data: UnnaxAccountCardMockRequestDtoBody }
  > = (props) => {
    const { data } = props ?? {};

    return postApiUnnaxMocker2(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxMocker2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxMocker2>>
>;
export type PostApiUnnaxMocker2MutationBody =
  UnnaxAccountCardMockRequestDtoBody;
export type PostApiUnnaxMocker2MutationError = unknown;

export const usePostApiUnnaxMocker2 = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxMocker2>>,
      TError,
      { data: UnnaxAccountCardMockRequestDtoBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxMocker2>>,
  TError,
  { data: UnnaxAccountCardMockRequestDtoBody },
  TContext
> => {
  return useMutation(
    getPostApiUnnaxMocker2MutationOptions(options),
    queryClient
  );
};

export const postApiUnnaxTestest = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    { url: `/api/unnax/testest`, method: "POST", signal },
    options
  );
};

export const getPostApiUnnaxTestestMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiUnnaxTestest>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiUnnaxTestest>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["postApiUnnaxTestest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiUnnaxTestest>>,
    void
  > = () => {
    return postApiUnnaxTestest(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiUnnaxTestestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiUnnaxTestest>>
>;

export type PostApiUnnaxTestestMutationError = unknown;

export const usePostApiUnnaxTestest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiUnnaxTestest>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiUnnaxTestest>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getPostApiUnnaxTestestMutationOptions(options),
    queryClient
  );
};
